import { Component, OnInit,ViewChild, NgZone, HostListener, AfterViewInit, ElementRef,OnDestroy,Input, Output,EventEmitter,SimpleChanges, ɵɵsetComponentScope } from '@angular/core';
import { Router, NavigationEnd,ActivatedRoute } from '@angular/router';
import {FormBuilder, FormControl, FormGroup, FormArray, Validators} from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {environment} from '../../environments/environment';
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {} from 'googlemaps';
import { TreeNode } from 'primeng/api';
import { Table } from 'primeng/table';
import {FilterService} from "primeng/api";
import { MapOptions} from '../../config/mapOptions';
/*import { MouseEvent } from '@agm/core';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';*/
declare const google: any;
import Swal from 'sweetalert2';
import { TreeTable, TreeTableModule } from 'primeng/treetable';
import { ChangeDetectorRef } from '@angular/core';
import { BrowserModule, DomSanitizer, Title } from '@angular/platform-browser';
import * as XLSX from 'xlsx'
import { DatePipe } from '@angular/common'
import { Md5 } from 'ts-md5/dist/md5';
import * as fileSaver from 'file-saver';
declare var $: any;
declare var REP: any;
interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit,  OnDestroy{
	form;
	autoOptions={
		componentRestrictions:{
			country:["us",'ca']
		},
		types: ["address"]
	}
	@ViewChild("tableView", { static: false }) tableView: ElementRef;
	//@ViewChild("modalheight", { static: false }) modalHeight: ElementRef;
	@ViewChild('mapcanvas') mapElement: any;
	@ViewChild('googleMap2') mapElement2: any;
	mapcanvas: google.maps.Map;

	email= new FormControl('',[
		Validators.required,
		Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
	  ]);
	public logOutFlag=0;
	public showLogo=0;
	logoInfo:any;
	readonly options = MapOptions.map;
	readonly tools = MapOptions.tools;
	map: any;
	address:string;
	private geoCoder;
	drawingMode:string;
	drawingManager: any;
	drawColor='blue';
	new=false;
	userToAdd;
	projectToDelete;
	save=true;
	usersToAdd=[];
	justAddedID=-1;
	projectID;
	expanded=false;	
	totalrecords=0;
	lat: number = 37.09024;
	default_lat: number = this.lat;
	lng: number = -95.712891;
	default_lng: number = this.lng;
	zoom:number = 3;
	tableTemplates;
	public latitude: number;
	public longitude: number;
	public fillInAddress: '';
	public searchControl: any;
	public street1="";
	public street2="";
	public city=""; 
	public country="";
	public postCode=""; 
	public state=""; 

	tableViewHeight: any;
	newEditClient=false;
	markers: marker[] = [
	  /*{
		  lat: 51.673858,
		  lng: 7.815982,
		  label: 'A',
		  draggable: true
	  },
	  {
		  lat: 51.373858,
		  lng: 7.215982,
		  label: 'B',
		  draggable: false
	  },
	  {
		  lat: 51.723858,
		  lng: 7.895982,
		  label: 'C',
		  draggable: true
	  }*/
	];
	//tilesLoadedListener: any;
	public inputData={
		"data":[]
	};	
	consultantNames = [];
	clientAddressBook = [];
	userData:any[];
	files: TreeNode[];
	pfiles: any[];
	tfiles: any[];
    cols: any[];
	cols2:any[];
	cols3:any[];
	cols4:any[];
	cols5:any[];
	portfolioCols:any[];
	portfolioFilterCols:any[];
	selectedDisplayCols:any[];
	loading=false;
	//selectedColumns: any[];
	userInfo:any;
	userId:string;
	userName:string;
	r:string;
	portView=true;
	tabView=true;
	curPortfolio:any;
	curOrder:any;
	templates=[];
	covers=[];
	reports=[];
	isExpanded=true;
	searchMessage='';
	fieldArray=[{'label':'Project No.','field':'PROJECT_NO'},{'label':'Site Name','field':'SITE_NAME'}];
	seledtedSection='project';
	users=['sabrina','nancy','andrew']
	public expandedRows = {};
	public temDataLength:number = 0;
	types:any[];
	selectedTypes:string[] = [];
	transactions:any[] = [];
	protocols:any[] = [];
	checkall=true;
	parcelID;
	curProject={
		'USER_ID':null, 
		'PROJECT_ID':null,//or null for new, 
		'PORTFOLIO_ID':null, 
		'PROJECT_NAME': '', 
		'PROJECT_NUMBER': '', 
		'PRIVATE_FLAG': false,
		'ADDRESS': null, 
		'CITY': null, 
		'PROVSTATE': null,
		'POSTALZIP': null,
		'COUNTRY': null, 
		'LONGITUDE':null, 
		'LATITUDE':null, 
		'PROPERTY_COUNTY': '',
		'FLOOD_ZONE': '',
		'MSA': '',
		'PGA': '',
		'ZONING': '',
		'PROTOCOL': '', 
		'SOW': '', 
		'TRANSACTION_TYPE': '',
		"SITE_CONTACT_NAME":"",
		"SITE_CONTACT_RELATIONSHIP":"",
		"SITE_CONTACT_PHONE":"",
		"SITE_CONTACT_EMAIL":"",
		"ADD_SITE_CONTACT_NAME":"",
		"ADD_SITE_CONTACT_RELATIONSHIP":"",
		"ADD_SITE_CONTACT_PHONE":"",
		"ADD_SITE_CONTACT_EMAIL":"",
		"SITE_INSPECTION_INSTRUCTIONS":"",
		"CLIENT_ID": "",
		"CO_CLIENT_ID": "",
		"TURN_TIME": "",
    	"REPORT_DUE_DATE": "",
    	"REVISED_REPORT_DATE": "",
    	"REVIEWER_DUE_DATE": "",
    	"ASSESSOR_DUE_DATE": "",
    	"INSPECTION_DATE": "",
		'RW_REPORTS':[],
		"CLIENT_COMPANY_NAME":"",
		"CLIENT_CO_COMPANY_NAME":"",
		"PO_NUMBER": "",
		"CLIENT_ADDRESS":"",
		"CLIENT_CITY":"",
		"CLIENT_PROVSTATE":"",
		"CLIENT_COUNTRY":"",
		"CLIENT_POSTALZIP":"",
		"CLIENT_CONTACT_NAME":"",
		"CLIENT_CONTACT_TITLE":"",
		"CLIENT_CONTACT_PHONE":"",
		"CLIENT_CONTACT_EMAIL":"",
		"CLIENT_PROVIDED_INFORMATION":"",
		'erisOrder':'',
		"CHARGE_AMOUNT":"",
		"EXPENSE_AMOUNT":"",
		"TOTAL_AMOUNT":"",
	};

	curRptPara={
		'TRANSACTION_TYPE':'',
		'PROTOCOLS':'',
		'ASSIGNED_USERS':"",
		'SOW':{'FILE_URL':''},
		'name':'Choose File',
	};
	allTypeRpt=[];
	reportTreeData:TreeNode[];
	largeMap=false;
	statusList=[];
	userList=[];
	emptyCol = false;
	newLabel="";
	date1: Date = null;
	date2: Date = null;
	date3: Date = null;
	// date4: Date = null;
	date5: Date = null;
	//date6: Date = null;
	//date7: String;
	date1Text:  String;
	date2Text:  String;
	date3Text:  String;
	// date4: Date = null;
	date5Text:  String;
	//date6Text:  String;
	dragPosition = {x: 200, y: 10};
	displaySections = new Array(8).fill(false);
	enabledDisplayInfo = false;
	curTempCategories=[];
	categoryList=[];
	openInvite=[];
	role = 3;
	roles =[];
	cateKey=[{'label':'ASSESSOR_DUE_DATE', 'value':'Writer Due Date'},
	{'label':'REVIEWER_DUE_DATE', 'value':'Reviewer Due Date'},
	{'label':'REPORT_DUE_DATE', 'value':'Report Due Date'},
	{'label':'PROJECT_NUMBER', 'value':'Project'},
	{'label':'RECENT_DATE', 'value':'My Recent Work'},
	{'label':'ASSIGNED_TO_ME', 'value':'Assigned to Me'},
	];
	groupkey={'label':'PROJECT_NUMBER', 'value':'Project'};
	_selectedColumns: any[];
	curTypeIndex=-1;
	erisOrderURL = environment.order_URL;
	statusShow=false;
	copyShow=false;	
	rowHeight='0px'
	acceptType=[];
	@ViewChild('search') searchElementRef: ElementRef;
	@ViewChild('mapContainer') mapContainer: ElementRef;
	@ViewChild('rptFile') rptFile: ElementRef;
	@ViewChild('excelFile') excelFile: ElementRef;
	constructor(public datepipe: DatePipe, private titleService :Title, public sanitizer: DomSanitizer, private FilterUtils: FilterService, private ref: ChangeDetectorRef, private modalService: NgbModal, private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private ngZone: NgZone, private cookieService: CookieService, private reportService:ReportService) {
		
		this.reportService.stream$.subscribe(this.receiveMessage.bind(this))
		this.getUserDetail();
		this.acceptType=this.reportService.acceptFileType.split(',');
		this.FilterUtils.register('protocol', (value: any[], filters) => {
			console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value || !value[0]){
				return false;
			}
			return value[0].PROTOCOL==filters;
		  });
		  this.FilterUtils.register('projectnumname', (value, filters) => {
			
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value || ! value.PROJECT_NUMBER ||!value.PROJECT_NAME ){
				return false;
			}
			return value.PROJECT_NUMBER.toUpperCase().includes(filters.toUpperCase()) || value.PROJECT_NAME.toUpperCase().includes(filters.toUpperCase());
		  });
		  this.FilterUtils.register('user', (value, filters) => {
			// console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value || !value.USER_EMAIL){
				return false;
			}
			if(!value.FULL_NAME){
				return value.USER_EMAIL.toUpperCase().includes(filters.toUpperCase())
			}
			return value.USER_EMAIL.toUpperCase().includes(filters.toUpperCase()) || value.FULL_NAME.toUpperCase().includes(filters.toUpperCase());
		  });
		  this.FilterUtils.register('transaction', (value, filters) => {
			// console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value || !value.TRANSACTION_TYPE || !value.PROTOCOL){
				return false;
			}
			return value.TRANSACTION_TYPE.toUpperCase().includes(filters.toUpperCase()) || value.PROTOCOL.toUpperCase().includes(filters.toUpperCase());
		  });
		  this.FilterUtils.register('address',(value, filters) => {
			// console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value){
				return false;
			}
			let x= value.ADDRESS_LINE1+ ", "+ value.ADDRESS_LINE2+ ", "+ value.CITY +", "+value.PROVSTATE + ", " +value.POSTALZIP;
			return x.toUpperCase().includes(filters.toUpperCase())
		  });
		  this.FilterUtils.register('additional_users',(value, filters) => {
			// console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value){
				return false;
			}
			if(value.ASSIGNED_USERS === undefined){
				return false;
			}
			// only filters for full name, may need to add more fields to filter from
			let index = value.ASSIGNED_USERS.findIndex(name => name.toUpperCase().includes(filters.toUpperCase()))
			// index will be -1 if it can't find a user that matches.
			// let x= value.ADDRESS_LINE1+ ", "+ value.CITY +", "+value.PROVSTATE + ", " +value.POSTALZIP;
			return index > -1;
		  });
		  
		  this.FilterUtils.register('assignedtome',(value, filters) => {
			console.log("value", value, filters);
			if (filters === undefined || filters === null || filters.length === 0) {
				return true;
			}
			if(!value){
				return false;
			}
			
			if (value.ASSESSOR_ID !== undefined && value.ASSESSOR_ID == filters) {
				return true;
			}
			if (value.REVIEWER_ID !== undefined && value.REVIEWER_ID == filters) {
				return true;
			}
			if (value.ASSIGNED_USERS_ID !== undefined && value.ASSIGNED_USERS_ID.includes(parseInt(filters))) {
				return true;
			}
			if (value.PROJECT_MANAGER_ID !== undefined && value.PROJECT_MANAGER_ID == filters) {
				return true;
			}
			
			return false;
		  });
		  this.rowHeight = (window.innerHeight -230)+'px';
	}
	taskBoxRight = 0
	receiveMessage(msg : string) {
		console.log(msg); // your message from component A

	 }
	/*onMapReady(map) {
		 console.log("map", $('#mapContainer'))
		 console.log("pacpac", $('.pac-container'))

    this.map = map;
    //this.tilesLoadedListener = this.map.addListener('tilesloaded', this.tiles_Loaded.bind(this));
    if (!this.drawColor) {
      this.drawColor = MapOptions.tools.colors[0];
    }
    //this.initDrawingManager();
   
	}*/

	// Standard Error Message Window:
	/*throwError(msg) {
		Swal.fire({
			html: '<p style="font-size:16px; color:red">' + msg + '</p>',
		})
	}*/

	private throwError(data, id?){
		if(this.loading7&&id){
			this.deliverError(id, data.MESSAGE)
			return
		}
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			this.cookieService.clearAll();
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
		
			confirmButtonText:'OK',
      		showCloseButton:false,
      		showCancelButton:false,
			allowOutsideClick:false,
      		//focusConfirm:false,
      		preConfirm:()=>{
       			 window.location.reload();
        
      		}})
			//this.cookieService.clearAll();
			//window.location.reload();
			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
	toggleNew(){
		this.new=!this.new;
	}
	mapClicked($event: MouseEvent) {
		// console.log("mapClicked");
		// this.markers[0]={
		//   lat: $event.coords.lat,
		//   lng: $event.coords.lng,
		//   draggable: true
		// };
		
		// this.getAddress($event.coords.lat, $event.coords.lng, true);
	}
	clickedMarker(label: string, index: number) {
		console.log(`clicked the marker: ${label || index}`)
	}
	markerDragEnd(m: marker, $event: MouseEvent) {
		console.log('dragEnd', m, $event);
		//this.lat = $event.coords.lat;
		//this.lng = $event.coords.lng;
		this.getAddress(this.lat, this.lng, true);
	}
	addUser(){
		this.usersToAdd.push(this.userToAdd);
	}
	expandcollapse() {
		this.expanded =! this.expanded;
	}
	/*private tiles_Loaded() {
		//this.tilesLoaded.emit(this.map.tilesloading);
	}*/

	getCompanyRoles(){
		// this.insertCompanyRoles();
		// if(this.roles.length==0){
			let inputJson={"PROCEDURE":"getcompanyroles","USER_ID":parseInt(this.userId),"COMPANY_ID":this.userInfo.COMPANY_ID.toString()}
			console.log("getcompanyroles", inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log('companyroles', data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				this.role = data.RW_ROLES.find(role => role.ROLE_TYPE == 'EXTERNAL' && role.DEFAULT_ROLE_TYPE == 'Y').ROLE_ID;
				this.roles = data.RW_ROLES.filter(role => role.ROLE_TYPE == 'EXTERNAL');
				this.companyRolesHolder = data.RW_ROLES
				console.log(this.companyRolesHolder)
			});
		// }
	}


	erisCols;
	getUserDetail(){
		
		//console.log("getting user detail",this.cookieService.getCookie("userID"))
		if(this.cookieService.getCookie("userID")) {
			//this.receiveMessage('')
			//console.log(this.cookieService.getCookie("userID"));
			this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
			//console.log("UserInfo", this.userInfo)
			//this.getErisInfo()
			this.userId = this.cookieService.getCookie("userID");//console.log(this.userId);
			this.r = this.cookieService.getCookie("r");
			this.userName = this.cookieService.getCookie("userName");//console.log(this.userName);
			
			//this.getAllReportByGroup(this.groupkey); IMPORTANT IMPORTANT
			if (this.portfolioCols) {
				this.loadSelectedColumns(this.userInfo['DASHBOARD_COLUMNS']);
			}
			this.getActiveReports()
			this.setTable()

			this.getAllPortfolios1(); // pre-load portfolio list
			// this.getAssignedToMe() // remove all assignedtome
			//this.getData();
			//this.getAllTemplate(this.userId);
			//this.getAllCover(this.userId);

			//this.getAllReport(this.userId);
			//this.getAllReportByGroup("PROJECT_ID");
			// this.getStatusCounts(); disabled for now since it is called by getActiveReports()
			this.getTitles();
			this.getStatus(-1);
			// this.getAllType(this.userId);
			this.getAllCode(this.userId);
			this.getAllTemplateCategory(this.userId);
			this.getAllClientInfo(this.userId);
			this.getConsultantNames();
			// this.getAllTempBySubCat(this.userId, "Environmental"); // For testing only
			// this.getAllTempByTypeID(this.userId, 23); // For testing only
			//this.getAllUser(this.userId);
			//this.getAllStatus(this.userId);
			//this.es.currentUser=this.cookieService.getCookie("userName");
			//this.getLogo();
			//this.getDefaultPCA()
			//this.getAllPortfolios();
			this.getPropertyTypes();
			//	;
			// setTimeout(	()=>{
					
			// 	this.getErisInfo();
			// }, 2000);
			if(!this.mapcanvas){
				setTimeout(	()=>{
					
					this.initialize();
					//this.tableViewHeight = this.tableView.nativeElement.offsetHeight;
					//this.tableHeight= window.innerHeight - 1.537 * this.tableViewHeight
					//console.log("HEIGHT", this.tableViewHeight, this.tableHeight+'px')
				}, 2000);
			}
					
			this._getCompanyGroupIndicator().then(() => {
				this.getAllReportUsers(-1, -1, ""); // For testing only
				
				if (this.companyGroupIndicator) {
					this.portfolioCols.push({ field: 'REPORT_GROUP', searchfield: 'REPORT_GROUP.GROUP_NAME', sortfield: 'REPORT_GROUP.GROUP_NAME', header: 'Group', width: "auto", filterMatchMode:'contains'});
					this.selectedDisplayCols.push({ field: 'REPORT_GROUP', searchfield: 'REPORT_GROUP.GROUP_NAME', sortfield: 'REPORT_GROUP.GROUP_NAME', header: 'Group', width: "auto", filterMatchMode:'contains'});
					this.portfolioFilterCols.push('REPORT_GROUP');
					this.keySearchCols.push({ field: 'REPORT_GROUP', searchfield: 'REPORT_GROUP', sortfield: 'REPORT_GROUP', header: 'Report Group', width: '5%' });
				}

				if (this.userInfo) {
					this.loadSelectedColumns(this.userInfo['DASHBOARD_COLUMNS']); // this is for the select columns multiselect
				}
			});
		} else {
			this.userId=null;			
		}
		
	}

	// setMap(){
		infoWindow = null;
		mapFeatures = [];
		currentZoom=3;
		markers2: google.maps.Marker[]
		resetMap(){
			this.lat=null;
			this.lng=null;
			this.markers2.forEach((marker) => {
				marker.setMap(null);
			});
			this.markers2 = [];
			//this.mapcanvas.fitBounds(new google.maps.LatLngBounds());
			this.mapcanvas.setCenter(new google.maps.LatLng(41.850033, -87.6500523));
			this.mapcanvas.setZoom(3);
		}
		parcelOn=false;
		initialize() {
			this.currentZoom=3;
			let that=this;
		var mapOptions = {
			mapTypeControl:false,
			center: new google.maps.LatLng(that.default_lat, that.default_lng),
			zoom: that.currentZoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: true,
		};
		this.mapcanvas = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
		
		//console.log("map",  this.mapcanvas)
		//console.log(this.mapElement.nativeElement)
		//  REP.Layer.Google.Initialize(  this.mapcanvas, {'Return_Buildings': true});
	
		// Cause click on map to show attribute popup and highlight parcel.
		google.maps.event.addListener(  this.mapcanvas, 'click', function(event) {
			//console.log(that.parcelOn);
			if(that.parcelOn){

		
			//console.log("event", event)
			if (  that.mapcanvas.getZoom() < REP.Layer.Google.MIN_ZOOM) return;
	
			// Close any previous InfoWindow and hide any previous features.
			if (that.infoWindow !== null) that.infoWindow.close();
			that.infoWindow = null;
			for (var i = 0; i < that.mapFeatures.length; i++) that.mapFeatures[i].setMap(null);
			that.mapFeatures = [];
	
			var latLng = event.latLng;
	
			REP.Layer.Google.IdentifyByPoint(  that.mapcanvas, latLng, function(resp) {
				console.log("resp", resp)
			  var wText = '';
			  if (resp.results.length) {
				var respRow0 = resp.results[0];
			
		
				for(var respKey in respRow0) {
					console.log(respKey)
				  var respVal = respRow0[respKey];
				  if (respVal === null) continue;
				  if (respKey === 'geom') {
					// Add parcel geometry (possibly multiple if multipart) to map.
					for (var i = 0; i < respVal.length; i++) {
					  respVal[i].setOptions({fillColor: 'rgb(144,238,144)', strokeColor: 'rgb(200,0,0)'});
					  respVal[i].setMap(  that.mapcanvas);
					  that.mapFeatures.push(respVal[i]);
					}
				  } else if (respKey === 'buildings_poly') {
					// Iterate through each building record.
					for (var bldgRecIdx = 0; bldgRecIdx < respVal.length; bldgRecIdx++) {
					  var bldgRec = respVal[bldgRecIdx];
					  if (typeof(bldgRec['geom']) === 'undefined' || bldgRec['geom'] === null) continue;
					  var bldgRecGeoms = bldgRec['geom'];
					  // Add each building geometry to map.
					  for (var i = 0; i < bldgRecGeoms.length; i++) {
						bldgRecGeoms[i].setOptions({strokeColor: 'rgb(255,128,255)', fillOpacity: 0.0, clickable: false});
						bldgRecGeoms[i].setMap(  that.mapcanvas);
						that.mapFeatures.push(bldgRecGeoms[i]);
					  }
					}
				} else if(respKey==="parcel_id"){
					console.log("reached")
					if (wText !== '') { console.log("reached ''");
						wText += '\n<br>';}
					wText += respKey + ': ' + respVal + '<button style="float:right; font-size:12px; padding:2px" id="parcelButton" data-val="'+ respRow0['county_name'] + " " +'"data-id="'+ respRow0['parcel_id']+' '+'"data-acre="'+ respRow0['acreage_calc'] +'" class="btn btn btn-dark btn-sm pt-0 mt-1 pb-0 pl-2 pr-2"> Select</button>';
				}
				   else {
					if (wText !== '') wText += '\n<br>';
					wText += respKey + ': ' + respVal;
				  }
				}
				that.infoWindow = new google.maps.InfoWindow({position: latLng, content: wText});
				that.infoWindow.open(  that.mapcanvas);

				// var button= document.getElementsByClassName('parcelbutton')[0];
				// console.log(button);
				// button.addEventListener("click", ()=>{
				// 	console.log("clicked");
				// 	that.parcelID= respRow0.parcel_id;
				// 	that.setDisplaySections(2);
				// });    
			  }
			}, function(errObj) {
			  alert('REP Overlays error: ' + errObj.message);
			});
		}else{
			if (that.infoWindow !== null) that.infoWindow.close();
			that.infoWindow = null;
			for (var i = 0; i < that.mapFeatures.length; i++) that.mapFeatures[i].setMap(null);
			that.mapFeatures = [];
		}
		  });
		  document.addEventListener('click',function(e){
			if(e.target && (<HTMLElement>e.target).id== 'parcelButton'){
				  //do something
				  console.log("pressed");
				 	that.parcelID= (<HTMLElement>e.target).getAttribute('data-id');//.classList[1];
					that.curProject.PROPERTY_COUNTY = (<HTMLElement>e.target).getAttribute('data-val');
					that.answers[that.questions[10]] = (<HTMLElement>e.target).getAttribute('data-acre');//.classList[2];
				 	that.setDisplaySections(2);
					 that.show('collapse1');that.hide('inner-collapse3'); that.hide('inner-collapse2'); that.show('inner-collapse1');
			 }
		 });
		  google.maps.event.addListener(this.mapcanvas, 'zoom_changed', function(event) {
			console.log(that.parcelOn);
			if(that.parcelOn){
			that.currentZoom = that.mapcanvas.getZoom();
			console.log(that.currentZoom);
		//	that.cookieService.setCookieSession("homeZome", JSON.stringify(currentZoom));
			//console.log(JSON.parse(that.cookieService.getCookie('homeZome')));
			if (that.currentZoom>=17){
				REP.Layer.Google.Initialize(that.mapcanvas);	
			}else{
				for (var i = 0; i < that.mapFeatures.length; i++) that.mapFeatures[i].setMap(null);
			//remove parcel tile
				that.mapcanvas.overlayMapTypes.clear();
			
			}
		}else{
			for (var i = 0; i < that.mapFeatures.length; i++) that.mapFeatures[i].setMap(null);
			//remove parcel tile
				that.mapcanvas.overlayMapTypes.clear();
		}
		})
		  // Update counter on page showing number of parcel tiles requested.
		//   google.maps.event.addListener(  this.mapcanvas, 'idle', function() {
		// 	var ptr = document.getElementById('parcel_tiles_req');
		// 	ptr.innerHTML = REP.Layer.Google.ParcelTilesRequestedCount();
	
		//   });
		const input = document.getElementById("mapinput") as HTMLInputElement; 
		const searchBox = new google.maps.places.SearchBox(input);
		that.mapcanvas.controls[google.maps.ControlPosition.LEFT_TOP].push(input);
		var addressInputElement = $('#mapinput');
		addressInputElement.on('focus', function () {
		  var pacContainer = $('.pac-container');
		  $(addressInputElement.parent()).append(pacContainer);
		})
		// Bias the SearchBox results towards current map's viewport.
		that.mapcanvas.addListener("bounds_changed", () => {
		  searchBox.setBounds(that.mapcanvas.getBounds() as google.maps.LatLngBounds);
		});
	  
		 this.markers2 = [];
		 
		// Listen for the event fired when the user selects a prediction and retrieve
		// more details for that place.
		searchBox.addListener("places_changed", () => {
			let isGeocode=this.ifLatLng();console.log(isGeocode)
			if(isGeocode){
				this.reversegeoCoder();
				return
			}			
			const places = searchBox.getPlaces();
			console.log("places", places)
			
		 	if (places.length == 0) {
				Swal.fire({
					icon:'info',
					title: 'Please check your input.',
				})
				return;
		  	}
	  		this.placeParse(places[0]);
		  // Clear out the old markers.
		  this.markers2.forEach((marker) => {
			marker.setMap(null);
		  });
		  this.markers2 = [];
	  
		  // For each place, get the icon, name and location.
		  const bounds = new google.maps.LatLngBounds();
		  places.forEach((place) => {
			if (!place.geometry || !place.geometry.location) {
			  console.log("Returned place contains no geometry");
			  return;
			}
			const icon = {
			  url: place.icon as string,
			  size: new google.maps.Size(71, 71),
			  origin: new google.maps.Point(0, 0),
			  anchor: new google.maps.Point(17, 34),
			  scaledSize: new google.maps.Size(25, 25),
			};
	  
			// Create a marker for each place.

			let map= that.mapcanvas
			this.markers2.push(
			  new google.maps.Marker({
				map,
				//icon:'../../assets/images/Site_Marker.png',
				title: place.name,
				position: place.geometry.location,
			  })
			);
	  
			if (place.geometry.viewport) {
			  // Only geocodes have viewport.
			  bounds.union(place.geometry.viewport);
			} else {
			  bounds.extend(place.geometry.location);
			}
		  });
		  that.mapcanvas.fitBounds(bounds);
		});
		}

	propertyTypes=[];
	getPropertyTypes(){
		let inputJson={"PROCEDURE":"getpropertytypes"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getPropertyTypes", data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.propertyTypes=data.RW_PROPERTY_TYPES
		})
		console.log(this.alphaOrder(this.questionHeaders))

	}
	testFunction(){
		Swal.fire({
			showCloseButton : true,
			title: "<p style='color: red'> How to use the Batch Project or Portfolio Upload: <p/>",
			html: "<div style='font-size: 18; text-align: justify;'>Batch Project - <ul><li>Upload any number of individual projects that are not in a Portfolio (of any size).</li><li>SCRIVA will read the project number and create a separate project for each location.</li><li>Project Number field must be unique. If you upload a duplicate, you will receive an error message.</li><li>You must select a header for each column before you upload.</li></ul></div> <div style='font-size: 18; text-align: justify;'>Portfolio -<ul><li>Upload a batch of projects within a portfolio.</li><li>Enter the name of the portfolio in the Portfolio Name field at the top of the Import Excel window or your locations will not be assigned to a portfolio.</li><li>Only upload one portfolio of locations at a time.</li><li>To add locations to the portfolio be sure to enter the same portfolio name during upload.</li><li>You must select a header for each column before you upload.</li></ul></div>",  
			width: '800px'
		})	}
	alphaOrder(arr){

		return(arr.sort(function(a, b){
			return a === b ? 0 : a > b ? 1: -1;
		}));
	}
	// questionsold1= ['PROPERTY_TYPE','NUMBER_OTHER_STRUCTURES', 'SITE_ACREAGE','BUILDING_SQFT_GROSS','BUILDING_SQFT_NET_RENTABLE','NUMBER_BUILDINGS','NUMBER_TOTAL_PARKING_SPACES','YEARS_CONSTRUCTED',
	// 'YEARS_SUBSTANTIAL_RENOVATION','NUMBER_PARKING_SPACES','NUMBER_PARKING_SPACES_ADA','NUMBER_STORIES','NUMBER_BEDS','NUMBER_GUESTROOMS','NUMBER_PADS','NUMBER_TENANT_SPACES', "NUMBER_UNITS"]

	//questionsold2=['PROPERTY_TYPE','SITE_ACREAGE','NUMBER_BUILDINGS','NUMBER_STORIES','NUMBER_OTHER_STRUCTURES','YEARS_CONSTRUCTED',
	//'YEARS_SUBSTANTIAL_RENOVATION',"NUMBER_UNITS",'NUMBER_BEDS','NUMBER_GUESTROOMS','NUMBER_PADS','NUMBER_TENANT_SPACES', 'BUILDING_SQFT_GROSS','BUILDING_SQFT_NET_RENTABLE','NUMBER_PARKING_SPACES','NUMBER_PARKING_SPACES_ADA','NUMBER_TOTAL_PARKING_SPACES']
	questions=['BUILDING_SQFT_GROSS', 'BUILDING_SQFT_NET_RENTABLE', 'NUMBER_BEDS', 'NUMBER_BUILDINGS', 'NUMBER_GUESTROOMS', 'NUMBER_PADS', 'NUMBER_STORIES', 'NUMBER_TENANT_SPACES',  'NUMBER_UNITS',  'PROPERTY_TYPE', 'SITE_ACREAGE', 'YEARS_CONSTRUCTED']
	questionsInCard=['BUILDING_SQFT_GROSS','BUILDING_SQFT_NET_RENTABLE','NUMBER_BEDS','NUMBER_BUILDINGS', 'NUMBER_GUESTROOMS', 'NUMBER_PADS','NUMBER_STORIES', 'NUMBER_TENANT_SPACES', 'NUMBER_UNITS',  'PROPERTY_TYPE',  'SITE_ACREAGE', 'YEARS_CONSTRUCTED']
	answers={};
	// 	questionHeadersOLD1=["Property Type", "Number of Other Structures","Site Acreage", "Building Square Feet (Gross)", "Building Square Feet (Net Rentable)", "Number of Buildings", "Number of Total Parking Spaces(Reg + ADA)", "Year(s) Constructed", 
	// 	"Year(s) of Substantial Renovation", "Number of Parking Spaces", "Number of Parking Spaces (ADA Accessible)", "Number of Stories", "Number of Beds", "Number of Guestrooms", "Number of Pads", 
	// "Number of Tenant Spaces", "Number of Units"]

	// questionHeadersOLD2=["Property Type","Site Acreage","Number of Buildings","Number of Stories","Number of Other Structures","Year(s) Constructed", 
	// "Year(s) of Substantial Renovation", "Number of Units" ,"Number of Beds", "Number of Guestrooms", "Number of Pads", "Number of Tenant Spaces", "Building Square Feet (Gross)", "Building Square Feet (Net Rentable)","Number of Parking Spaces (Non-ADA)", "Number of Parking Spaces (ADA Accessible)",
	// "Number of Total Parking Spaces(Reg + ADA)",

	// ]
	questionHeaders=['Building Area (Gross)', 'Building Area (Net Rentable)', 'Number of Beds', 'Number of Buildings',  'Number of Guestrooms', 'Number of Pads',  'Number of Stories', 'Number of Tenant Spaces', 'Number of Units', 'Property Type', 'Site Acreage/Area', 'Year(s) Constructed',
	]

		
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		return false;
		}
		return true;
		
	}
	
	setTableHeight(){
		setTimeout(	()=>{
			this.initialize();
			this.tableViewHeight = this.tableView.nativeElement.offsetHeight;
			console.log("HEIGHT1", this.tableViewHeight)
			this.tableHeight= window.innerHeight - 0.5 * this.tableViewHeight
			console.log("HEIGHT2", this.tableHeight)
		}, 1000);
	}
	protocolList;
	tableHeight
	statusModel = "All";
	statusModelDisplay
	getStatusCounts(){
		let inputJson={"PROCEDURE":"getstatuscounts","USER_ID":parseInt(this.userId)};
		console.log("getStatusCounts", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			// assume count of All has stayed the same:
			let temp;
			if (this.statusList[0] !== undefined) {
				temp = this.statusList[0].TOTAL;
			} else {
				// in this case, the page hasn't loaded yet. 
				temp = this.numActiveReports;
			}
			// this is because i currently have no way to access all total reports,
			// since numActiveReports changes with the filter.
			// this is hacky, maybe change it later

			this.statusList=data.REPORT_STATUS;
			this.protocolList=data.REPORT_PROTOCOL;
			let j;
			for(let i=0;i<this.protocolList.length;i++){
				if(this.protocolList[i].PROTOCOL=='No Protocol'){
					j=i;
				}
			}
			this.protocolList.splice(j, 1)
			console.log("statusCounts", data);
			
			// count assignedtome:
			let assignedtomecount = 0;
			for (let report of this.activeData) {
				// console.log('count assignedtome', report);
				if (report.ASSESSOR.length!=0 && report.ASSESSOR[0].USER_ID == this.userId) {
					assignedtomecount++;
				} else if (report.REVIEWER.length!=0 && report.REVIEWER[0].USER_ID == this.userId) {
					assignedtomecount++;
				} else if (report.PROJECT_MANAGER!==undefined && report.PROJECT_MANAGER.length!=0 && report.PROJECT_MANAGER[0].USER_ID == this.userId) {
					assignedtomecount++;
				} else {
					for (let addluser of report.ASSIGNED_USERS) {
						if (addluser.USER_ID == this.userId) {
							assignedtomecount++;
						}
					}	
				}
			}
			this.statusList.unshift({STATUS: 'Assigned to me', TOTAL: assignedtomecount}) 
			this.statusList.unshift({STATUS: 'All', TOTAL: temp})

		});

	}
	// getAllType(id){
	// 	let inputJson={"PROCEDURE":"getreporttypes", "USER_ID":id};
	// 	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
	// 		console.log("reporttypes", data);
	// 		this.types=data.RW_RPT_TYPES;
	// 		this.allTypeRpt=[];
	// 		console.log("TYPES", this.types)
	// 		for(let type of this.types){
	// 			let rpt={
	// 				REPORT_ID:null,// or null for new, 
	// 				types:type,
	// 				REPORT_TITLE:"", 
	// 				TEMPLATE_ID:"", 
	// 				COVERPAGE_ID:"", 
	// 				REPORT_URL:"", 
	// 				REPORT_DATA: "", 
	// 				STATUS:"", 
	// 				REPORT_ROLE: "", 
	// 				ORDER_NUM: "", 
	// 				ASSIGNED_USERS: "",
	// 				PERCENT_COMPLETE:null,					
	// 				SHARED: "",
	// 				REPORT_SLOT:"",					
	// 				APPENDIX_LIST:"",
	// 				TRANSACTION_TYPE: null, 
	// 				DATE_CREATED: null,
	// 				selected:false
	// 			}
	// 			this.allTypeRpt.push(rpt);
	// 		}
	// 		console.log(this.allTypeRpt);
	// 	})
	// }
	getAllCode(id){
		let inputJson={"PROCEDURE":"getcodes", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.protocols=data.PROTOCOL;
			this.transactions=data.TRANSACTION_TYPE;
		})
	}
	statusList2;
	getStatus(id){
		this.statusList2=[];
		let inputJson={"PROCEDURE":"getreportstatuslist", "USER_ID":parseInt(this.userId), "REPORT_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log("Status", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			 this.statusList2=data.RW_STATUS_LIST ;
			
		})
	}
	getUser(id){
		let inputJson={"PROCEDURE":"getreportuserlist", "USER_ID":parseInt(this.userId), "REPORT_ID":id}
		console.log("getreportuserlist", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("reportuserlist", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.ngZone.run(()=>{this.userList=data.RW_USERS});
			
		})
	}	
	/*private getLogo(){
		let inputJson={"PROCEDURE":"getcompanylogo","CUSTOMER_ID":parseInt(this.userId)};
		this.reportService.logouniveralService(inputJson).subscribe(data => {console.log(data);
			
			this.logoInfo=data;
		})
	}*/
	curSelectConsultant=null
	getConsultantNames(){
		let inputJson={"PROCEDURE":"getcompanylocations", "USER_ID":parseInt(this.userId)};
		console.log("getcompanylocations", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("companylocations", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for(let location of data.RW_LOCATIONS){
				this.consultantNames.push (location )
			}
			this.consultantNames=[...this.consultantNames]			
			console.log("consultantNames",this.consultantNames)
		})
	}
	getAllClientInfo(id) {
		this.clientAddressBook = [this.emptyClient];
		let inputJson={"PROCEDURE":"getclientsbycompany", "USER_ID":parseInt(this.userId),"ACTIVE_ONLY":"Y"};
		//console.log("getclientsbycompany", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log("clientsbycompany", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let client of data.RW_CLIENTS) {
	
				this.clientAddressBook.push( client);
			}
			this.clientAddressBook=[...this.clientAddressBook]
			console.log("clientAddressBook",this.clientAddressBook);
		})
	}
	curSelectClient=null;
	curCoSelectClient=null;

	updateClientID() {
		console.log(this.curSelectClient)
		// console.log(client);
		this.curProject.CLIENT_ID = this.curSelectClient.CLIENT_ID;
		
	}
	updateCoClientID() {
		// console.log(coClient);
		this.curProject.CO_CLIENT_ID = this.curCoSelectClient.CLIENT_ID;
	}
	getTemplate(id){
		// let inputJson= {"PROCEDURE":"gettemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		// this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		// 	console.log("getTemplate", data);
			this.tableTemplates=this.getAllTempByTypeID(this.userId, id);
		// });

	}
	dismissConfirm(event, bool){
		$('#confirmModal').modal('hide');
		if(bool){
			$('#reportsModal').modal('hide');
		}
	}
	dismissConfirm2(event){
		$('#deleteModal').modal('hide');
	}
	dismissConfirm3(event){
		$('#deleteReportModal').modal('hide');
	}
	dismissCloseModal(event, bool){
		if (this.infoWindow !== null) this.infoWindow.close();
		this.infoWindow = null;
		$('#closeReportsModal').modal('hide');
		if(bool){
			$('#reportsModal').modal('hide');
		}		
	}
	deleteProjectModal(){
		this.deleteProject(this.projectToDelete);
	}
	 copy(rowdata) {
		let $temp = $("<input>");
		$("body").append($temp);
		$temp.val(rowdata.REPORT_URL).select();
		document.execCommand("copy");
		$temp.remove();
	}
	updateTemplate(template, data){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":data.REPORT_ID, "FUNCTION_ID": 6};
		console.log(checkUserInputJson)
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				let content=`<div style="text-align:left"><b>WARNING!! WARNING!!</b>
					<ul><li>You will overwrite your report if the new template contains pre-populated text or blank sections/tables.</li>
					<li>Please be sure Users are out of the report before changing the template.</li>
					<li>You should only change a template at the start of a project before the writing starts or you will lose your work.
					</li></ul></div>`
				Swal.fire({
					// title: 'Do you want to save the changes?',
					icon:'warning',
					html: content,
					showConfirmButton: true,
					showCancelButton: true,
					confirmButtonText: 'Confirm',
					// cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
					//   Swal.fire('Saved!', '', 'success')
						console.log(template);

						data.TEMPLATE[0].TEMPLATE_TITLE=template.TEMPLATE_TITLE; 
		
						data.flat.TEMPLATE=data.TEMPLATE[0].TEMPLATE_TITLE
						let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, 'TEMPLATE_ID':template.TEMPLATE_ID};
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
							console.log(data);
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)
																		
							}
							// this.getAllReportByGroup(this.groupkey);
						})
					} else {
					//   Swal.fire('Changes are not saved', '', 'info')
					}
				})

			}

		});

	}
	getAllTemplateCategory(id) {
		let inputJson={"PROCEDURE":"gettemplatetypecategory", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("templatetypecategory",data);
			// console.log(data.RW_CATEGORY_LIST);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.categoryList = data.RW_CATEGORY_LIST;
			this.curTempCategories=[];
			for (let obj of data.RW_CATEGORY_LIST) {
				//console.log("category: "+obj.CATEGORY);
				let rpt={
					category:obj.CATEGORY,
					subCategories:null,
					typeIdTemplates:null,
					selectedSubCat:null,
					selectedTemplate:null,
					userList: {
						assessor:"",
						assessortitle:{},
						reviewertitle:{},
						reviewer:"",
						assigned_user:"",
					},
					selected:false,
					...(this.companyGroupIndicator ? {selectedGroup: null} : {})
				}
				this.curTempCategories.push(rpt);
			}
			console.log(this.curTempCategories);
			this.curTypeIndex=-1;
		})
	}	

	getAllTempBySubCat(id, category) {
		let inputJson={"PROCEDURE":"gettemplatetypesubcategory", "USER_ID":id, "CATEGORY":category};
		let subCategoryTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			 console.log("AllTempBySubCat", data);
			 if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let obj of data.RW_SUBCATEGORY_LIST) {
				let rpt={
					subCategory: obj.SUB_CATEGORY,
					typeId: obj.TEMPLATE_TYPE_ID,
					selected:false,
				}
				subCategoryTemplates.push(rpt)
			}
			
		});
		return subCategoryTemplates;
	}
	
	getAllTempBySubCat2(id, category, callback) {
		let inputJson={"PROCEDURE":"gettemplatetypesubcategory", "USER_ID":id, "CATEGORY":category};
		let subCategoryTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			 console.log("AllTempBySubCat", data);
			 if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let obj of data.RW_SUBCATEGORY_LIST) {
				let rpt={
					subCategory: obj.SUB_CATEGORY,
					typeId: obj.TEMPLATE_TYPE_ID,
					selected:false,
				}
				subCategoryTemplates.push(rpt)
			}
			callback();
			//this.allTypeRpt=JSON.parse(JSON.stringify(this.allTypeRpt));
		});
		return subCategoryTemplates;
	}

	setCurTypeIndex(i){
		this.displayAddSingleRptErrorMessage = false
		if(this.curTypeIndex==i){
			this.curTypeIndex = null
		} else {
			this.curTypeIndex = i
		}
	}

	setSubCat(cat) {
		if (cat.subCategories == null) {
			cat.subCategories = this.getAllTempBySubCat(this.userId, cat.category); console.log('subcats', cat.subCategories)
		} 
	}

	setSubCat2(cat, callback) {
		if (cat.subCategories == null) {
			cat.subCategories = this.getAllTempBySubCat2(this.userId, cat.category, callback);
		}
	}
	getAllTempByTypeID(id, typeID) {
		let inputJson={"PROCEDURE":"gettemplatesbytemplatetype", "USER_ID":id, "TEMPLATE_TYPE_ID":typeID, "ACTIVE_ONLY":'Y'};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			console.log("getAllTempByTypeID",data);
			for (let obj of data.RW_TEMPLATES) {
				typeIdTemplates.push(obj);
			}

		});
		console.log(typeIdTemplates);
		return typeIdTemplates;
	}
	getAllTempByTypeIDSimple(id, typeID, groupID?) {
		let inputJson={"PROCEDURE":"gettemplatesbytypesimple", "USER_ID":id, "TEMPLATE_TYPE_ID":typeID};
		if(this.companyGroupIndicator&&groupID){
			inputJson['GROUP_ID']=groupID;
		}
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getAllTempByTypeIDSimple",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let obj of data.RW_TEMPLATES) {
				typeIdTemplates.push(obj);
			}

		});
		console.log('typeIdtemplatesSimple',typeIdTemplates);
		return typeIdTemplates;
	}

	getAllTempByTypeID2(id, typeID, callback) {
		let inputJson={"PROCEDURE":"gettemplatesbytemplatetype", "USER_ID":id, "TEMPLATE_TYPE_ID":typeID, "ACTIVE_ONLY":'Y'};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getAllTempByTypeID",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let obj of data.RW_TEMPLATES) {
				typeIdTemplates.push(obj);
			}
			callback();

		});
		console.log(typeIdTemplates);
		return typeIdTemplates;
	}
	
	// afaik this is not used at all:
	setByTypeId1(cat) {
		console.log("selectedsubcar", cat.selectedSubCat);
		Swal.fire({
			icon:'warning',
			title: 'Change Template Identifier will wipe out all reports in this project, Please confirm!',
			confirmButtonText: 'Change',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				if (cat.selectedSubCat.typeId != null) {
					console.log("typeId: " + cat.selectedSubCat.typeId);
					let index1=cat.subCategories.findIndex(sub=>sub.typeId==cat.typeId);
					if(index1>-1){
						cat.selectedSubCat.SUBCATEGORY_NAME=cat.catToChange.subCategories[index1].SUBCATEGORY_NAME;
					}
					console.log(cat.selectedSubCat);
					let templates = this.getAllTempByTypeID(this.userId, cat.selectedSubCat.typeId);
					//cat.selectedSubCat.typeIdTemplates = templates;
					cat.typeIdTemplates = templates; 
					console.log(templates);
					console.log(this.allTypeRpt);
					let index=this.allTypeRpt.findIndex(rpt=>rpt.selectedSubCat.typeId==cat.selectedSubCat.typeId); console.log(index);
					cat.selectedTemplate.TEMPLATE_ID=null;
					if(index==-1){
						cat['added']=false;
						console.log('FLAG')
					}else{
						cat['added']=true;
					}
				}
			}	
		})
		console.log("selectedsubcar", cat.selectedSubCat);
		
		//else{
		//	cat.selectedSubCat.typeIdTemplates = [];
		//	cat.typeIdTemplates = []; 
		//}
	}
	setByTypeId(cat) { //get sub templates here
		console.log(cat)
		console.log("selectedsubcar", cat.selectedSubCat);
		let groupId:number;
		cat.typeIdTemplates=[];
		if(this.companyGroupIndicator){
			if(!cat.selectedGroup&&(!cat.selectedGroup?.GROUP_ID)){				
				return
			}else{
				groupId=cat.selectedGroup.GROUP_ID;
			}			
		}
		if (cat.selectedSubCat&&cat.selectedSubCat.typeId != null) {
			console.log("typeId: " + cat.selectedSubCat.typeId);
			console.log(cat.selectedSubCat);
			// let templates = this.getAllTempByTypeID(this.userId, cat.selectedSubCat.typeId); //this one too much data
			let templates = this.getAllTempByTypeIDSimple(this.userId, cat.selectedSubCat.typeId);
			if(this.companyGroupIndicator){
				templates = this.getAllTempByTypeIDSimple(this.userId, cat.selectedSubCat.typeId, groupId);
			}
			cat.selectedSubCat.typeIdTemplates = templates;
			cat.typeIdTemplates = templates; 
			console.log(templates);
			console.log(this.allTypeRpt);
			if(this.allTypeRpt.length>0){
				let index=this.allTypeRpt.findIndex(rpt=>rpt.selectedSubCat!==null && rpt.selectedSubCat.typeId==cat.selectedSubCat.typeId); console.log(index);
				cat.selectedTemplate=null;
				if(index==-1){
					cat['added']=false;
				}else{
					cat['added']=true;
				}
			}else{
				cat['added']=false;
			}
		}
		//else{
		//	cat.selectedSubCat.typeIdTemplates = [];
		//	cat.typeIdTemplates = []; 
		//}
	}
	setByTypeId2(cat, callback) {
		console.log("selectedsubcar", cat.selectedSubCat);
		if (cat.selectedSubCat.typeId != null) {
			console.log("typeId: " + cat.selectedSubCat.typeId);
			console.log(cat.selectedSubCat);
			let templates = this.getAllTempByTypeID2(this.userId, cat.selectedSubCat.typeId, callback);
			cat.selectedSubCat.typeIdTemplates = templates;
			cat.typeIdTemplates = templates; 
			console.log(templates);		
		}
	}
	/*getAllTemplate(id){
		let inputJson={"PROCEDURE":"getalltemplates", "USER_ID":id};console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			this.templates=data.RW_TEMPLATES;
			this.templates=[
			{'TEMPLATE_ID':'1','TEMPLATE_TITLE':'CPM1'},
			{'TEMPLATE_ID':'2','TEMPLATE_TITLE':'CPM2'}]
		})
	}
	getAllCover(id){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			this.covers=data.RW_COVERPAGES;
		})
	}*/
	/*getAllReport(id){
		let inputJson={"PROCEDURE":"getallreports", "USER_ID":parseInt(this.userId)};
		console.log("getallreports", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("allreports", data);
			
			this.reports=data.RW_PROJECTS;console.log(this.reports);//RW_REPORTS;
			// console.log(this.reports[0]);
			if(this.reports.length>0){
				this.toTreeData();
			}	
		})
	}*/
	getAllReportByGroup(groupname){console.log(groupname);
		this.ngZone.run(()=>{this.loading=true;})
		//this.ref.detectChanges();
		this.groupkey=groupname;
		
		console.log("loading now")
		let inputJson={"PROCEDURE":"getreportlistbygroupname", "USER_ID":parseInt(this.userId), "GROUP_NAME":groupname.label};
		console.log("getreportlistbygroupname", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			this.ngZone.run(()=>{			this.loading=false;		console.log("treedatatime")})
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getStatusCounts();
			//this.getAllPortfolios();
			//this.getProjectforPortfolio();
			
			console.log("reportlistbygroupname", data);
			
			 this.reports=data.REPORT_LIST;
			 this.totalrecords=data.REPORT_TOTAL;	
			// // console.log(this.reports[0]);
			//if(this.reports.length>0){
				//console.log("seting tableheight");
				// this.setTableHeight();
				this.toTreeData();
			//}	
			this.autoRefresh();

		})
		// this.getStatusCounts();
	}
	customSearchFn(term: string, item: any) {
		term = term.toLocaleLowerCase();
		if(!item){
			return false;
		}
		return item.FULL_NAME.toLocaleLowerCase().indexOf(term) > -1 ||  item.USER_EMAIL.toLocaleLowerCase().indexOf(term) > -1 || 
			   item.FIRST_NAME.toLocaleLowerCase().indexOf(term) > -1;
	}
	customSearchFn2(term: string, item: any) {
		term = term.toLocaleLowerCase();
		return item.CLIENT_CONTACT_NAME.toLocaleLowerCase().indexOf(term) > -1 ||  item.CLIENT_COMPANY_NAME.toLocaleLowerCase().indexOf(term) > -1 || item.CLIENT_ADDRESS_LINE1.toLocaleLowerCase().indexOf(term) > -1 || 
			   item.CLIENT_CONTACT_PHONE.toLocaleLowerCase().indexOf(term) > -1;
	}
	inviteUser(i, type){
		let inputJson= {"PROCEDURE":"inviterwuser","USER_ID":parseInt(this.userId),"USER_EMAIL":this.userToAdd, "EXTERNAL_USER": "Y", "ROLE_ID":Number(this.role)}
		console.log("inviteUser", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("inviteUser", data);
			this.getAllReportUsers(i, data.USER_ID, type)
			// this.curTempCategories[i].userList.assigned_user={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
			// console.log("afterinvite", this.curTempCategories);
			// this.userToAdd="";
			if(data.RESPONSE_STATUS=='Y'){
				Swal.fire({
					icon:'success',
					title: data.MESSAGE,
				})
			}else if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
			}
		})


	}
	inviteUser4(i, type, element, event){
		console.log(type)
		console.log(this.curTempCategories)

		if(!this.userToAdd||!this.firstname||!this.lastname){
			this.inviteUserErrorMessage = 'Missing Fields'
		}else if(this.userToAdd.indexOf('@')==-1||this.userToAdd.indexOf('.')==-1){
			this.inviteUserErrorMessage = 'Email is invalid';
		}else {
				let inputJson= {
					"PROCEDURE":"inviterwuser",
					"USER_ID":parseInt(this.userId),
					"USER_EMAIL":this.userToAdd, 
					"ROLE_ID":Number(this.role), 			
					"FIRST_NAME": this.firstname, 
					"LAST_NAME": this.lastname,
					"EXTERNAL_USER": this.userExternal ? "Y" : "N",
		
			}
		console.log("inviteUser", inputJson);
		this.inviteUserLoading = true
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			this.inviteUserLoading = false
			console.log("inviteUser", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			//this.getAllReportUsers(i, data.USER_ID, type)
			if(type=='assigned_user'){
				this.curTempCategories[i].userList.assigned_user={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
			}
			if(type=='assessor'){
				this.curTempCategories[i].userList.assessor={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
			}
			if(type=='reviewer'){
				this.curTempCategories[i].userList.reviewer={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
			}
			// console.log("afterinvite", this.curTempCategories);
			// this.userToAdd="";
			element.hide(event)
			if(data.RESPONSE_STATUS=='Y'){
				Swal.fire({
					icon:'success',
					title: data.MESSAGE,
				})
			}
		})
	}

	}
	clearInvite2(user){
		if(!user.reviewer){
			user.reviewertitle=''
		}
		if(!user.assessor){
			user.assessortitle=''
		}
	}
	clearInvite1(rowData, user){
		console.log('clear')
		// console.log(rowData)
		// console.log(user)
		// if(rowData.ASSESSOR_TITLE.TITLE==undefined){
		// 	rowData.ASSESSOR_TITLE.TITLE = ''
		// }
		if(!user[0]){
			rowData.ASSESSOR_TITLE[0] = ''
		}
		
		this.userToAdd = ''
		this.firstname = ""
		this.lastname = ""
		this.userExternal = true
		this.role = this.companyRolesHolder.find(role => role.ROLE_TYPE == 'EXTERNAL' && role.DEFAULT_ROLE_TYPE == 'Y').ROLE_ID;
		this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE == 'EXTERNAL');
		// this.role = 3
		// this.roles = [{ROLE_DESCRIPTION: "1099/Outside user",
		// 			ROLE_ID: 3,
		// 			ROLE_NAME: "Contractor"}]
		this.inviteUserErrorMessage = ''
		this.inviteUserLoading = false
	}
	clearInvite(){
		this.userToAdd = ''
		this.firstname = ""
		this.lastname = ""
		this.userExternal = true
		this.role = this.companyRolesHolder.find(role => role.ROLE_TYPE == 'EXTERNAL' && role.DEFAULT_ROLE_TYPE == 'Y').ROLE_ID;
		this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE == 'EXTERNAL');
		// this.role = 3
		// this.roles = [{ROLE_DESCRIPTION: "1099/Outside user",
		// 			ROLE_ID: 3,
		// 			ROLE_NAME: "Contractor"}]
		this.inviteUserErrorMessage = ''
		this.inviteUserLoading = false

	}
	firstname = ""
	lastname = ""
	userExternal = true
	companyRolesHolder = []
	inviteUserErrorMessage = ''
	inviteUserLoading = false
	changeRole() {
		if (this.userExternal) {
			// this.role = 3
			// this.roles = [{ROLE_DESCRIPTION: "1099/Outside user",
			// 				ROLE_ID: 3,
			// 				ROLE_NAME: "Contractor"}]
			this.role = this.companyRolesHolder.find(role => role.ROLE_TYPE == 'EXTERNAL' && role.DEFAULT_ROLE_TYPE == 'Y').ROLE_ID;
			this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE == 'EXTERNAL');
		} else {
			this.role = this.companyRolesHolder.find(role => role.ROLE_TYPE == 'INTERNAL' && role.DEFAULT_ROLE_TYPE == 'Y').ROLE_ID;
			this.roles = this.companyRolesHolder.filter(role => role.ROLE_TYPE == 'INTERNAL');
		}
	}
	inviteUser3(rowData, field, element, event ){
		console.log(this.userToAdd)
		if(!this.userToAdd||!this.firstname||!this.lastname){
			this.inviteUserErrorMessage = 'Missing Fields';
		}else if(this.userToAdd.indexOf('@')==-1||this.userToAdd.indexOf('.')==-1){
			this.inviteUserErrorMessage = 'Email is invalid';
		}else{
			let inputJson= {
				"PROCEDURE":"inviterwuser",
				"USER_ID":parseInt(this.userId),
				"USER_EMAIL":this.userToAdd, 
				"ROLE_ID":Number(this.role),
				"FIRST_NAME": this.firstname, 
				"LAST_NAME": this.lastname,
				"EXTERNAL_USER": this.userExternal ? "Y" : "N",
			}
		
			this.inviteUserLoading = true
			console.log("inviteUser", inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				
				console.log("inviteUser", data);
				this.getAllReportUsers2(rowData, data.USER_ID, field)
				// this.curTempCategories[i].userList.assigned_user={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
				// console.log("afterinvite", this.curTempCategories);
				// this.userToAdd="";
				element.hide(event)
				if(data.RESPONSE_STATUS=='Y'){
					Swal.fire({
						icon:'success',
						title: data.MESSAGE,
					})
				}

				else if(data.RESPONSE_STATUS=='N'){
					this.throwError(data);
				}
				this.inviteUserLoading = false
			})
		
		}
		

	}

	// This is not used anywhere:
	inviteUser2(rowData, field){
		console.log(this.userToAdd)
		if(!this.userToAdd){
			let data={'MESSAGE':'Please Enter Email'};
			this.throwError(data);
		}else if(this.userToAdd.indexOf('@')==-1||this.userToAdd.indexOf('.')==-1){
			let data = 'Email is invalid';
			this.throwError(data);
		}else{
		let inputJson= {
			"PROCEDURE":"inviterwuser",
			"USER_ID":parseInt(this.userId),
			"USER_EMAIL":this.userToAdd, 
			"ROLE_ID":Number(this.role), 			
			"FIRST_NAME": this.firstname, 
			"LAST_NAME": this.lastname,
			"EXTERNAL_USER": this.userExternal ? "Y" : "N",

	}
		console.log("inviteUser", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("inviteUser", data);
			this.getAllReportUsers2(rowData, data.USER_ID, field)
			// this.curTempCategories[i].userList.assigned_user={"USER_ID":data.USER_ID, 'USER_EMAIL':this.userToAdd}
			// console.log("afterinvite", this.curTempCategories);
			// this.userToAdd="";
			if(data.RESPONSE_STATUS=='Y'){
				Swal.fire({
					icon:'success',
					title: data.MESSAGE,
				})
			}

			else if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
			}
		})
		
		}
		

	}
	usersList=[]; // this is in the add report modal
	allusersList=[]; // this is in the main dashboard add users
	getAllReportUsers(i, id, type) {
		console.log(i, id, type)
		let inputJson = {
			"PROCEDURE": this.companyGroupIndicator ? "getgroupreportuserlist" : "getcompanyuserlist",
			"USER_ID": parseInt(this.userId),
			"ACTIVE_ONLY": "Y"
		}; // hardcoded for now 

		this.usersList=[""]; // empty string to include the blank option to allow user to reset user in dropdown
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			// console.log("usersList", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let user of data.RW_USERS) {
				this.usersList.push(user);
			}
			console.log("userlist", this.usersList);
		});

		let newinputJson={
			"PROCEDURE": this.companyGroupIndicator ? "getgroupreportuserlist" : "getcompanyuserlist",
			"USER_ID": parseInt(this.userId),
			"INCLUDE_EXTERNAL": "Y",
			"ACTIVE_ONLY": "Y"
		}; // hardcoded for now 
		
		let acc=[];
		this.reportService.univeralService(JSON.stringify(newinputJson)).subscribe(data => {
			console.log("usersList", data);
			// acc.push({"USER_ID":null,"FIRST_NAME":""});
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let user of data.RW_USERS) {
				if(user.USER_ID==id && this.curTempCategories[i]){
					this.ngZone.run(()=>{this.curTempCategories[i].userList[type]=user;});
					console.log("assigned user is ", this.curTempCategories[i].userList[type]);
				}
				acc.push(user);
			}
			this.ngZone.run(()=>{this.allusersList=acc;});
			console.log("alluserlist", this.allusersList);
		});
	}
	getAllReportUsers2(rowData, id, field) {
		let inputJson={"PROCEDURE":"getcompanyuserlist", "USER_ID":parseInt(this.userId), "ACTIVE_ONLY":"Y"}; // hardcoded for now 
		this.usersList=[""]; // empty string to include the blank option to allow user to reset user in dropdown
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("usersList", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let user of data.RW_USERS) {
				this.usersList.push(user);
			}
		});
		console.log("userlist", this.usersList);

		let newinputJson={"PROCEDURE":"getcompanyuserlist", "USER_ID":parseInt(this.userId), "INCLUDE_EXTERNAL":"Y", "ACTIVE_ONLY":"Y"}; // hardcoded for now 
		let acc=[];
		// acc.push({"USER_ID":null, "FIRST_NAME":""});
		this.reportService.univeralService(JSON.stringify(newinputJson)).subscribe(data => {
			console.log("usersList", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			for (let user of data.RW_USERS) {
				if(field=="ASSIGNED_USERS"){
					if(user.USER_ID==id){
						this.ngZone.run(()=>{
							this.addAssignedUser(rowData, user);
						}
						
						);
					}
				}
				else if(user.USER_ID==id && rowData[field][0]){
					this.ngZone.run(()=>{rowData[field][0]=user;});
					this.changeUser(rowData, rowData[field], field)
					console.log("assigned user is ",rowData);
				}
				else if(user.USER_ID==id){
					this.ngZone.run(()=>{rowData[field]=[user];});
					this.changeUser(rowData, rowData[field], field)
					console.log("assigned user is ",rowData);
				}
				acc.push(user);
				// this.usersList=[...this.userList,user];
			}
			this.ngZone.run(()=>{this.allusersList=acc;});
			console.log("alluserlist", this.allusersList);
		});
	}

	selectExisting=true;
	togglePortfolio(){
		if(this.selectExisting){
			this.curProject.PORTFOLIO_ID=null;
			this.selectExisting=false;
		}else{
			this.newReportPortfolio='';
			this.selectExisting=true;
		}
	}
	deleteFile(item, type){
		console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					console.log(JSON.parse(response))
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.uploadedFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
						this.throwError(JSON.parse(response))
					}
					this.getAllBk(item.PROJECT_ID, item.REPORT_ID)
				})
			}
		})
	}
	erisData;
	uploadType;
	erisDataLoading;
	numErisOrders = 0
	getErisInfo(){
		let inputJson={"PROCEDURE":"geterisorders","USER_ID":parseInt(this.userId)};
		this.erisDataLoading = true
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getErisInfo", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			if(data.ORDERS!=undefined){
				this.erisData=data.ORDERS
				this.numErisOrders=this.erisData.length
			} if(data.ORDERS == undefined){
				this.numErisOrders = 0
				this.erisData = []
			}
			this.erisDataLoading = false

		});
	}

	appOp='O';
	currentRowData;

	public upload(type?) {console.log(type)
		//$("#uploadModal").modal('show');
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			$("#"+ this.currentRowData.REPORT_ID.toString()).click();
		}else if(this.uploadType=='FILE'){
			this.appOp='U';
			$("#"+this.currentRowData.REPORT_ID.toString()+"x").click();
		}
	}
	// @ViewChild('file') file: ElementRef;
	// @ViewChild('file1') file1: ElementRef;
	  photos=[];;
	  others=[];
	  logos=[];
	  bks=[];
	  imgGroup='other';
	  uploadFiles=0;
	  uploadTotal=0;
	  uploadNo=0;
	  uploadedFiles=[];
	  updateFile(item, type, e? ){console.log(item);
		let data=$(e.target).prev('textarea').val();console.log(data);
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response)
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(file)
				return										
			}
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		})
	}
	erisColsDashboard
	showPhotosTab = false;
	getAllBk(pid, reportID){
		//let inputJson={"PROCEDURE":"getallbkimages", "USER_ID":id};console.log(inputJson);
		// let inputJson2={"PROCEDURE":"getprojectphotos","USER_ID":parseInt(this.userId),"PROJECT_ID":pid}
		// this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
		// 	console.log(data);
		// 	this.photos=data.RW_UPLOAD_FILES;
		// })
		// only show photos tab if it is a report:
		if (reportID !== undefined) {
			let inputJson2={"PROCEDURE":"GetPhotosByReport","USER_ID":parseInt(this.userId),"REPORT_ID":reportID}
			this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				this.photos=data.RW_UPLOAD_FILES;
			})
			this.showPhotosTab = true;
		} else {
			this.photos=[];
			this.showPhotosTab = false;
		}
		let inputJson3={"PROCEDURE":"getfilesbyproject","USER_ID":parseInt(this.userId),"PROJECT_ID":pid};
		//let inputJson1={"PROCEDURE":"getallcompanyimages", "COMPANY_ID":this.userInfo.COMPANY_ID.toString(), "BK_IMAGE_IND":"N"};
		this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.uploadedFiles=data.RW_UPLOAD_FILES;
		})
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":parseInt(this.userId),"FILE_TYPE":"BKIMAGE"}
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.bks=data.RW_UPLOAD_FILES;
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":parseInt(this.userId),"FILE_TYPE":"IMAGE"}
		console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.others=data.RW_UPLOAD_FILES;
		})
	} 
	cols6=[];
	cols62=[];
	erisCols2=[];
	largeWidth = '120px'
	medWidth = '90px'
  ngOnInit(): void {
	//this.getActiveReports()
	//this.receiveMessage('test')
	//this.getErisInfo()
	//this.getUserInfo()
	// console.log("JUST MAKING SURE");
	
	this.tabFrom('ACTIVE')
	this.presetCols.push(...this.questions);
	//console.log(this.alphaOrder(this.presetCols))
	this.presetCols = this.alphaOrder(this.presetCols)
	//console.log("REP",REP);
	this.titleService.setTitle("SCRIVA-Dashboard");

	this.form = this.fb.group({
		// siteemailAddress: ['', [ Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
		// additionalsiteemailAddress: ['', [Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
		// siteContactPhone:['', [ Validators.pattern("^[0-9]*$"), Validators.minLength(10)]],
		// additionalsiteContactPhone:['', [ Validators.pattern("^[0-9]*$"), Validators.minLength(10)]],
		siteemailAddress: ['', []],
		additionalsiteemailAddress: ['', []],
		siteContactPhone:['', []],
		additionalsiteContactPhone:['', []],
		companyName:['',[]],
		clientEmail: ['', [Validators.email]],//, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
		// clientPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
		clientPhone: ['', []],
		cocompanyName:['',[]],
		coclientEmail: ['', [Validators.email]],//, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')
		// coclientPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
		coclientPhone: ['', []],
	  });
	this.files=this.inputData.data;
	this.erisCols=[

	{ field: 'ORDER_NUM', searchfield: 'ORDER_NUM',header: 'Order Number', width: '10%'},
	{ field: 'PROJECT_NUM',  searchfield: 'PROJECT_NUM', header: 'Project Number', width: '10%'},
	{ field: 'ADDRESS1', searchfield: 'ADDRESS1',header: 'Address City', width: '10%'},
	{ field: 'PROVSTATE', searchfield:'PROVSTATE', header: 'State/Province', width: '10%'},
	{ field: 'STATUS', searchfield:'STATUS',header: 'Status', width: '10%'},
	{ field: 'PRODUCTS',searchfield: 'PRODUCTS',header: 'Products', width: '10%'}

	]
	this.erisColsDashboard = [
		{ field: 'CHECKBOX', searchfield: '', header: '', width: '2%'},
		{ field: 'ORDER_NUM', searchfield: 'ORDER_NUM',header: 'Order Number', width: '10%'},
		{ field: 'PROJECT_NUM',  searchfield: 'PROJECT_NUM', header: 'Project Number', width: '10%'},
		{ field: 'ADDRESS1', searchfield: 'ADDRESS1',header: 'Address City', width: '10%'},
		{ field: 'PROVSTATE', searchfield:'PROVSTATE', header: 'State/Prov.', width: '10%'},
		{ field: 'STATUS', searchfield:'STATUS',header: 'Status', width: '5%'},
	]
	this.erisCols2=[
		"ORDER_NUM",
		"PROJECT_NUM",
		"ADDRESS1",
		"PROVSTATE",
		"STATUS",
		"CITY"
	]
	this.cols = [
		{ field: 'Portfolio', header: 'Portfolio'},
		//{ field: 'type', header: 'Type' },	
		//{ field: 'ORDER_NUM', header: 'Order No.' },
		{ field: 'ORDER_ADDRESS', header: 'Address'},
		//{ field: 'ORDER_ID', header: 'Order Id' },
		{ field: 'PROJECT_NO', header: 'Project No.'},
		{ field: 'SITE_NAME', header: 'Site Name'},
		//{ field: 'REPORT_NAME', header: 'Rpt Name' },
		{ field: 'REPORT_TAG', header: 'Rpt Tag'},
		{ field: 'status', header: 'Status'},
		{ field: 'user', header: 'Assign'},
		{ field: '', header: 'Action'},
				
	];

	this.expandAll();
	this.cols2 = [
			{ field: 'PORTFOLIO_NAME', header: 'Portfolio' },
			{ field: 'ORDER_NUM', header: 'Order No.' },
			{ field: 'ORDER_ADDRESS', header: 'Address' },
            //{ field: 'ORDER_ID', header: 'Order Id' },			
			{ field: 'PROJECT_NO', header: 'Project No.' },
			{ field: 'SITE_NAME', header: 'Site Name' },
			{ field: 'REPORTS', header: 'Reports' },
				
        ];
	this.cols3 = [
			{ field: 'ORDER_NUM', header: 'Order No.' },
			{ field: 'ORDER_ADDRESS', header: 'Address' },
         	{ field: 'PROJECT_NO', header: 'Project No.' },
			{ field: 'SITE_NAME', header: 'Site Name' },
			{ field: 'REPORTS', header: 'Reports' },
			{ field: '', header: 'Action' },
				
        ];
	this.cols4 = [
			{ field: 'ORDER_NUM', header: 'Order No.', width: '8%' },
			//{ field: 'REPORT_DATA', header: 'Report Data'},
			{ field: 'REPORT_ID', header: 'Report ID', width: '8%'},
			{ field: 'REPORT_ROLE', header: 'Report Role', width: '8%' },
         	{ field: 'REPORT_TITLE', header: 'Report Title', width: '8%' },
			//{ field: 'REPORT_URL', header: 'Report URL' },
			{ field: 'PORTFOLIO_ID', header: 'Portfolio', width: '8%'},
			{ field: 'ORDER_REPORTS', header: 'Ordered Reports', width: '8%'},
			{ field: 'STATUS', header: 'Status', width: '8%' },
			{ field: 'TEMPLATE_ID', header: 'Template ID', width: '8%' },
			{ field: 'COVERPAGE_ID', header: 'Cover ID', width: '8%'},
			{ field: '', header: 'Action' },			
        ];
	this.cols5=[
		{ field: 'GROUP_LABEL', searchfield: 'GROUP_LABEL', header: 'Project - Address - Reports', width: this.largeWidth, filterMatchMode:'contains' }, //0
		{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', header: 'Project Number', width: this.largeWidth, filterMatchMode:'contains'}, //1
		{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', header: 'Access Report(s)', width: this.largeWidth , filterMatchMode:'contains'}, //2
		{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', header: 'Property Name', width: this.largeWidth, filterMatchMode:'contains' }, //3
		{ field: 'FULL_ADDRESS',  searchfield: 'ADDRESS_LINE1', header: 'Property Address', width: this.largeWidth , filterMatchMode:'contains'}, //4
		{ field: 'TEMPLATE_ID',searchfield: 'flat.TEMPLATE',  header: 'Template', width: this.largeWidth , filterMatchMode:'contains'}, //5
		{ field: 'ASSESSOR_DATE', searchfield: 'ASSESSOR_DUE_DATE',header: 'Writer Due Date', width: this.medWidth , filterMatchMode:'contains'}, //6
		//--------------------------------------------------------------------------------------------------
		{ field: 'REPORT_RECEIVED_DATE', searchfield: 'REPORT_RECEIVED_DATE',header: 'Report Received', width: this.medWidth , filterMatchMode:'contains'}, //7
		//--------------------------------------------------------------------------------------------------
		{ field: 'REVIEWER_DATE',searchfield: 'REVIEWER_DUE_DATE', header: 'Reviewer Due Date', width: this.medWidth , filterMatchMode:'contains'}, //8
		{ field: 'REPORT_DATE',searchfield: 'REPORT_DUE_DATE', header: 'Report Due Date', width: this.medWidth , filterMatchMode:'contains'}, //9
		{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', header: 'Writer', width: this.largeWidth , filterMatchMode:'contains'}, //10
		{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', header: 'Reviewer', width: this.largeWidth , filterMatchMode:'contains'}, //11
		{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: this.largeWidth , filterMatchMode:'contains'}, //12
		{ field: 'TRANSACTION_TYPE',searchfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: this.largeWidth , filterMatchMode:'contains'}, //13
		{ field: 'STATUS',searchfield: 'STATUS', header: 'Status', width: this.largeWidth , filterMatchMode:'contains'}, //14
		{ field: 'ORDER_REPORTS', searchfield: 'ORDER_NUM',header: 'ERIS Data', width: this.largeWidth , filterMatchMode:'contains'}, //15
		{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED',header: 'Last Edited', width: this.medWidth , filterMatchMode:'contains'}, //16
		{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED',header: 'Created Date', width: this.medWidth , filterMatchMode:'contains'}, //17
		{ field: 'REPORT_COMPANY_NAME', searchfield: 'REPORT_COMPANY_NAME',header: 'Company Name', width: this.largeWidth , filterMatchMode:'contains'}, //18

	];
	// this.portfolioCols=[
	// 	{ field: 'GROUP_LABEL', searchfield: 'GROUP_LABEL', header: 'Project - Address - Reports', width: this.largeWidth, filterMatchMode:'contains' }, //0
	// 	{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', header: 'Project No. /Name', width: this.largeWidth, filterMatchMode:'contains'}, //1
	// 	{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', header: 'Access Report(s)', width: this.largeWidth , filterMatchMode:'contains'}, //2
	// 	{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', header: 'Property Name', width: this.largeWidth, filterMatchMode:'contains' }, //3
	// 	{ field: 'FULL_ADDRESS',  searchfield: 'ADDRESS_LINE1', header: 'Property Address', width: this.largeWidth , filterMatchMode:'contains'}, //4
	// 	{ field: 'TEMPLATE_ID',searchfield: 'flat.TEMPLATE',  header: 'Template', width: this.largeWidth , filterMatchMode:'contains'}, //5
	// 	{ field: 'ASSESSOR_DATE', searchfield: 'ASSESSOR_DUE_DATE',header: 'Writer Due Date', width: this.medWidth , filterMatchMode:'contains'}, //6

	// 	{ field: 'REPORT_RECEIVED_DATE', searchfield: 'REPORT_RECEIVED_DATE',header: 'Report Recieved', width: this.medWidth , filterMatchMode:'contains'}, //7

	// 	{ field: 'REVIEWER_DATE',searchfield: 'REVIEWER_DUE_DATE', header: 'Reviewer Due Date', width: this.medWidth , filterMatchMode:'contains'}, //8
	// 	{ field: 'REPORT_DATE',searchfield: 'REPORT_DUE_DATE', header: 'Report Due Date', width: this.medWidth , filterMatchMode:'contains'}, //9
	// 	{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', header: 'Writer', width: this.largeWidth , filterMatchMode:'contains'}, //10
	// 	{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', header: 'Reviewer', width: this.largeWidth , filterMatchMode:'contains'}, //11
	// 	{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: this.largeWidth , filterMatchMode:'contains'}, //12
	// 	{ field: 'TRANSACTION_TYPE',searchfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: this.largeWidth , filterMatchMode:'contains'}, //13
	// 	{ field: 'STATUS',searchfield: 'STATUS', header: 'Status', width: this.largeWidth , filterMatchMode:'contains'}, //14
	// 	{ field: 'ORDER_REPORTS', searchfield: 'ORDER_NUM',header: 'ERIS Data', width: this.medWidth , filterMatchMode:'contains'}, //15
	// 	{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED',header: 'Last Edited', width: this.medWidth , filterMatchMode:'contains'}, //16
	// 	{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED',header: 'Created Date', width: this.medWidth , filterMatchMode:'contains'}, //17
	// 	{ field: 'REPORT_COMPANY_NAME', searchfield: 'REPORT_COMPANY_NAME',header: 'Company Name', width: this.largeWidth , filterMatchMode:'contains'}, //18
	// ];

	// this is also used for active reports as well for some reason
	// info: 
	// field is used to access the data that is displayed on the table
	// searchfield is used to access the data that will be used for searching (which needed since the dates are stored as Date objects, which can be sorted but can't be searched)
	// sortfield is used to access the data that will be used for sorting 
	// width of first column is determined by total number of columns, if you add/remove a column remember to change the width of the 1st column
	this.setPortfolioCols();

	if (this.userInfo) {
		this.loadSelectedColumns(this.userInfo['DASHBOARD_COLUMNS']); // this is for the select columns multiselect
	}

	this.cols6=[
	//	{ field: 'GROUP_LABEL', searchfield: 'GROUP_LABEL', header: 'Project - Address - Reports', width: '6%' }, //0
		{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', sortfield: 'PROJECT_NUMBER', header: 'Project Number', width: '6%' }, //1
		{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', sortfield: 'REPORT_TITLE', header: 'Access Report(s)', width: '7%' }, //2
		{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', sortfield: 'PROPERTY_NAME', header: 'Property Name', width: '6%' }, //3

		{ field: 'ADDRESS_LINE1',  searchfield: 'ADDRESS_LINE1', sortfield: 'ADDRESS_LINE1', header: 'Address 1', width: '6%' }, //4
		{ field: 'ADDRESS_LINE2',  searchfield: 'ADDRESS_LINE2', sortfield: 'ADDRESS_LINE1', header: 'Address 2', width: '6%' }, //4
	//	{ field: 'ADDRESS_LINE2',  searchfield: 'ADDRESS_LINE2', header: 'Address 2', width: '6%' }, //4
		{ field: 'CITY',  searchfield: 'CITY', sortfield: 'CITY', header: 'City', width: '6%' }, //4
		{ field: 'PROVSTATE',  searchfield: 'PROVSTATE', sortfield: 'PROVSTATE', header: 'Province/State', width: '6%' }, //4
		{ field: 'POSTALZIP',  searchfield: 'POSTALZIP', sortfield: 'POSTALZIP', header: 'Postal Code/Zip', width: '6%' }, //4
		{ field: 'COUNTY',  searchfield: 'COUNTY', sortfield: 'COUNTY', header: 'County', width: '6%' }, //4
		{ field: 'COUNTRY',  searchfield: 'COUNTRY', sortfield: 'COUNTRY', header: 'Country', width: '6%' }, //4
		{ field: 'TEMPLATE_ID',searchfield: 'flat.TEMPLATE', sortfield: 'flat.TEMPLATE', header: 'Template', width: '5%' }, //5
		{ field: 'ASSESSOR_DATE', searchfield: 'ASSESSOR_DUE_DATE', sortfield: 'ASSESSOR_DATE', header: 'Writer Due Date', width: '3%' }, //6
		{ field: 'REVIEWER_DATE',searchfield: 'REVIEWER_DUE_DATE', sortfield: 'REVIEWER_DATE', header: 'Reviewer Due Date', width: '3%' }, //7
		{ field: 'REPORT_DATE',searchfield: 'REPORT_DUE_DATE', sortfield: 'REPORT_DATE', header: 'Report Due Date', width: '3%' }, //8
		{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', sortfield: 'flat.ASSESSOR', header: 'Writer', width: '5%' }, //9
		{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', sortfield: 'flat.REVIEWER', header: 'Reviewer', width: '5%' }, //10
		{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', sortfield: 'flat.ASSIGNED_USERS', header: 'Assigned User', width: '5%' }, //11
		{ field: 'SOW',searchfield: 'flat.TRANSACTION_TYPE', sortfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: '4%' }, //12
		{ field: 'STATUS',searchfield: 'STATUS', sortfield: 'STATUS', header: 'Status', width: '5%' }, 
	//	{ field: 'ORDER_REPORTS', searchfield: 'ORDER_NUM',header: 'ERIS Data', width: '4%' }, //13
		{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED', sortfield: 'DATE_UPDATED', header: 'Last Edited', width: '4%' }, //13
	//	{ field: 'PCA_QUESTIONS', searchfield: 'PCA_QUESTIONS',header: 'PCA', width: '4%' }, //13
		//{ field: 'CLIENT_COMPANY_NAME', searchfield: 'CLIENT_COMPANY_NAME', sortfield: 'CLIENT_COMPANY_NAME', header: 'Client', width: "auto", filterMatchMode:'contains'}, //20
		// { field: 'PROTOCOL', header: '', width: '0%' },//14
        // { field: '', header: 'Action', width: '8%' },
	];
	this.cols62 = [			
		//{ field: 'SLOT_ID', header: 'Id' },
		 { field: 'FILE_NAME', header: 'File Name', width: '20%' },
		{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
		{ field: 'PROJECT_ID', header: 'Project Name', width: '15%' },
		{ field: 'REPORT_CATEGORY', header: 'Report Type ' , width: '14%' },
		{ field: 'UPDATED_BY', header: 'Upload By ' , width: '12%' },
		{ field: 'DATE_UPDATED', header: 'Date ' , width: '8%' },
			
	];

	this.FilterUtils.register('custom',(value, filter): boolean => {
			if (value === undefined || value === null || value.length === 0){
				return false
			}
			let name='';
			for(let item of value){
			   if (item.ASSIGNED=='Y'){
				   name=item.NAME;
			   }
			}
            
            return filter == name;
        })
		
	this.types = [
            {name: 'New York', code: 'NY'},
            {name: 'Rome', code: 'RM'},
            {name: 'London', code: 'LDN'},
            {name: 'Istanbul', code: 'IST'},
            {name: 'Paris', code: 'PRS'}
        ];
		$(document).ready(function () {
			$('#reportModal').draggable();			
		});
  }
  	setPortfolioCols() {
		this.portfolioCols=[
			{ field: 'GROUP_LABEL', searchfield: 'GROUP_LABEL', sortfield: 'GROUP_LABEL', header: '', width: `${100/19}%`, filterMatchMode:'contains' }, //0
			{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', sortfield: 'PROJECT_NUMBER', header: 'Project Number', width: "auto", filterMatchMode:'contains' }, //1
			{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', sortfield: 'REPORT_TITLE', header: 'Access Report(s)', width: "auto", filterMatchMode:'contains' }, //2
			{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', sortfield: 'PROPERTY_NAME', header: 'Property Name', width: "auto", filterMatchMode:'contains' }, //3
			{ field: 'FULL_ADDRESS',  searchfield: 'FULL_ADDRESS', sortfield: 'FULL_ADDRESS', header: 'Property Address', width: "auto", filterMatchMode:'contains'}, //4
			{ field: 'TEMPLATE_ID',searchfield: 'flat.TEMPLATE', sortfield: 'flat.TEMPLATE', header: 'Template', width: "auto", filterMatchMode:'contains'}, //5
			{ field: 'ASSESSOR_DATE', searchfield: 'ASSESSOR_DUE_DATE', sortfield: 'ASSESSOR_DATE', header: 'Writer Due Date', width: "auto", filterMatchMode:'contains'}, //6
			//--------------------------------------------------------------------------------------------------
			{ field: 'REPORT_RECEIVED_DATE_DATE', searchfield: 'REPORT_RECEIVED_DATE', sortfield: 'REPORT_RECEIVED_DATE_DATE', header: 'Report Received', width: "auto", filterMatchMode:'contains'}, //7
			//--------------------------------------------------------------------------------------------------
			{ field: 'REVIEWER_DATE',searchfield: 'REVIEWER_DUE_DATE', sortfield: 'REVIEWER_DATE', header: 'Reviewer Due Date', width: "auto", filterMatchMode:'contains'}, //8
			{ field: 'REPORT_DATE',searchfield: 'REPORT_DUE_DATE', sortfield: 'REPORT_DATE', header: 'Report Due Date', width: "auto", filterMatchMode:'contains'}, //9
			{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', sortfield: 'flat.ASSESSOR', header: 'Writer', width: "auto", filterMatchMode:'contains'}, //10
			{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', sortfield: 'flat.REVIEWER', header: 'Reviewer', width: "auto", filterMatchMode:'contains'}, //11
			{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', sortfield: 'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: "auto", filterMatchMode:'contains'}, //12
			{ field: 'TRANSACTION_TYPE',searchfield: 'flat.TRANSACTION_TYPE', sortfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: "auto", filterMatchMode:'contains'}, //13
			{ field: 'STATUS',searchfield: 'STATUS', sortfield: 'STATUS', header: 'Status', width: "auto", filterMatchMode:'contains'}, //14
			{ field: 'ORDER_REPORTS', searchfield: 'ORDER_NUM', sortfield: 'ORDER_NUM', header: 'ERIS Data', width: "auto", filterMatchMode:'contains'}, //15
			{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED', sortfield: 'DATE_UPDATED', header: 'Last Edited', width: "auto", filterMatchMode:'contains'}, //16
			{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED', sortfield: 'DATE_CREATED', header: 'Created Date', width: "auto", filterMatchMode:'contains'}, //17
			{ field: 'CONSULTANT_LOCATION', searchfield: 'CONSULTANT_LOCATION', sortfield: 'CONSULTANT_LOCATION', header: 'Company Name', width: "auto", filterMatchMode:'contains'}, //18
			// { field: 'REPORT_COMPANY_NAME', searchfield: 'REPORT_COMPANY_NAME', sortfield: 'REPORT_COMPANY_NAME', header: 'Owned By', width: "5%", filterMatchMode:'contains'}, //19
			{ field: 'CLIENT_COMPANY_NAME', searchfield: 'CLIENT_COMPANY_NAME', sortfield: 'CLIENT_COMPANY_NAME', header: 'Client', width: "auto", filterMatchMode:'contains'}, //20
		];
		this.portfolioFilterCols=this.portfolioCols.map(entry => entry.searchfield);
		this.portfolioFilterCols.push('flat.PROTOCOL');
	
		// we don't want user to be able to disable the first three columns:
		this.selectedDisplayCols = this.portfolioCols.filter(col => !['GROUP_LABEL','PROJECT_NUMBER','REPORT_TITLE'].includes(col.field));
  	}
  /*ngAfterViewInit(): void {
	  //this.setCurrentLocation();
	let that=this;
	this.mapsAPILoader.load().then(() => {
		console.log("mapsAPILoader1");
     // this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
	console.log("searchElementRef:",this.searchElementRef.nativeElement);
		let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);console.log("autocomplete",autocomplete)
		autocomplete.setComponentRestrictions({
			country: ["us", "ca"],
		});
		autocomplete.addListener("place_changed", () => {console.log("place_changed 1")
        this.ngZone.run(() => {console.log("place_changed")
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();console.log(place)
				
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }	
			this.placeParse(place);
			
        });
      });
    });	
  }*/
  ngAfterViewInit(): void{
	//  console.log(modalHeight);
	// if(this.userId){
	// 	this.initialize();
	// }
	  console.log("test");
	this.geoCoder = new google.maps.Geocoder;

	// this.setTableHeight();
	// this.tableViewHeight = this.tableView.nativeElement.offsetHeight;
  }
//   setTableHeight(){
// 	  if(this.tableView){
// 		this.tableViewHeight = this.tableView.nativeElement.offsetHeight;
// 		console.log("HEIGHT", this.tableViewHeight)
// 	  }

//   }
  /*ngOnChanges(changes: SimpleChanges): void {
      
		//if ('user' in changes) {
		//	this.loginInfo=this.user;
		//}
	}*/
	ngOnDestroy(): void {
		//document.removeEventListener('contextmenu', this.handleContextMenu);
		//this.reportService.univeralService.unsubscribe();
	}

	// this happens on logout/log out
	public onInfo(e){
		console.log('SELECTED FLAG111111')

		// reset all the cache, may need to add more things to reset later on......
		this.activeData = [];
		this.activeDataHolder = [];
		this.numActiveReports = 0;
		this.portfolioList = [];
		this.portfolioDataV2 = [];
		this.numPortfolioReports = 0;
		this.erisData = null;
		this.numErisOrders = 0;
		this.clientAddressBook = [];
		this.consultantNames = [];
		this.setPortfolioCols();
		
		this.getUserDetail();
	}
	 expandAll(){
        this.files.forEach( node => {
           this.expandCollapseRecursive(node, true);
        } );
    }

    collapseAll(){
        this.files.forEach( node => {
            this.expandCollapseRecursive(node, false);
        } );
    }
	private expandCollapseRecursive(node: TreeNode, isExpand: boolean): void {
		node.expanded = isExpand;
		if (node.children) {
			node.children.forEach(childNode => {
				this.expandCollapseRecursive(childNode, isExpand);
			});
		}
	}
	excelData;
	setExcel(event){
		console.log(event);
		if(event.filteredValue){
			this.excelData=event.filteredValue;
		}
	}
	getExcel(){
		if(!this.excelData){
			this.excelData=this.reportTreeData;
		}
	}
	setExcel2(event){
		console.log(event);
		if(event.filteredValue){
			this.excelData2=event.filteredValue;
		}
	}
	getExcel2(){
		if(!this.excelData2){
			this.excelData2=this.reportTreeData;
		}
	}
	 index(obj,i) {return obj[i]}

	// afaik not used:
	async exportExcel(){
		let response=await this.checkUser();
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response);
			return
		}else if(response.USER_PERMISSION=='N'){
				Swal.fire({
					icon:'warning',
					title: response.MESSAGE,
				})
			return
		}
		if(!this.excelData){
			this.excelData=this.reportTreeData;
		}
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		let i=1;
		for(let col of this.cols6){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let project of this.excelData){
			let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				for(let report of project.children){
					let arr=[];
					let i=1;
	
					for(let col of this.cols6){
					let obj={"col":i.toString(), "datavalue": 
				col.searchfield.split('.').reduce(this.index, report.data)
					, "dtype":"string"};

					if(col.field=="ASSIGNED_USERS"){
			
						let arr=[]
						for(let user of report.data[col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}
						if(col.field=="GROUP_LABEL" && first){
							obj.datavalue=project.data.GROUP_LABEL;
							first=false;
						}
					//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
						}
					
						i++
					}
					table.data.push({"row":arr});
					
				}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":"Project and Reports", "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
		})


	}
	// afaik not used:
	excelData2;
	async exportExcel2(){
		let response=await this.checkUser();
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response);
			return
		}else if(response.USER_PERMISSION=='N'){
				Swal.fire({
					icon:'warning',
					title: response.MESSAGE,
				})
			return
		}
		this.excelData2=this.portfolioTreeData;
		console.log(this.excelData2)
		
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		let i=1;
		for(let col of this.cols6){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let project of this.excelData2){
			let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				for(let report of project.children){
					let arr=[];
					let i=1;
					console.log(report.data)
					for(let col of this.cols6){
					let obj={"col":i.toString(), "datavalue": 
				col.searchfield.split('.').reduce(this.index, report.data)
					, "dtype":"string"};

					console.log(obj)

					if(col.field=="ASSIGNED_USERS"){
			
						let arr=[]
						for(let user of report.data[col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}
						// if(col.field=="GROUP_LABEL" && first){
						// 	obj.datavalue=project.data.GROUP_LABEL;
						// 	first=false;
						// }
					//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
							//console.log(obj)
						}
					
						i++
					}
					table.data.push({"row":arr});
					
				}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":"Project and Reports (Portfolio)", "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
			
		})


	}
	proOnly1=false;
	proOnly2=false;
	projectCols=[
		{field: 'PROJECT_NUMBER', searchfield: '', header: 'Project Number'},
		{field: 'PROPERTY_NAME', searchfield: '', header: 'Property Name'},
		{field: 'FULL_ADDRESS', searchfield: '', header: 'Property Address'},
		{field: 'CHARGE_AMOUNT', searchfield: '', header: 'Project Cost'},
		{field: 'EXPENSE_AMOUNT', searchfield: '', header: 'Project Expense'},
		{field: 'TOTAL_AMOUNT', searchfield: '', header: 'Project Total'},
		{field: 'CLIENT_COMPANY_NAME', searchfield: '', header: 'Client Company Name'},
	]
	async exportExcel3(from, proOnly?){
		let response=await this.checkUser();
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response);
			return
		}else if(response.USER_PERMISSION=='N'){
				Swal.fire({
					icon:'warning',
					title: response.MESSAGE,
				})
			return
		}
		if(from=='P'){
			// this.excelData2=this.portfolioDataV2;

			// we want to preserve any sorting/filtering on export
			// portfolioTable.filteredValue is only defined if there is a filter active,
			// so we need to check this first:
			if (this.portfolioTable.filteredValue) {
				this.excelData2 = this.portfolioTable.filteredValue;
			} else {
				this.excelData2 = this.portfolioTable.value;
			}
			
		} else if(from=='A'){
			// this.excelData2=this.activeData

			if (this.activeTable2.filteredValue) {
				this.excelData2 = this.activeTable2.filteredValue;
			} else {
				this.excelData2 = this.activeTable2.value;
			}
			
		}

		console.log(this.excelData2)
		
		let table = {
			"header": [],
			"data": []
		}
		let filetitle="Project and Reports";// (Portfolio)
		if(proOnly){
			filetitle="Project Only";// (Portfolio
			let i = 1;
			for(let col of this.projectCols){
				table.header.push({"headername":col.header, "col": i.toString()})
				i++
			}
			let allPro=[];
			for(let i=0;i<this.excelData2.length+1;i++){
				if(this.excelData2[i]){
					let proIndex=allPro.indexOf(this.excelData2[i].PROJECT_ID);
					if(proIndex>-1){
						continue
					}else{
						allPro.push(this.excelData2[i].PROJECT_ID)
					}
				
					let arr=[];
					let j = 1
					for(let col of this.projectCols){
						let obj={"col":j.toString(), "datavalue": this.excelData2[i][col.field], "dtype":"string"};
						// console.log(obj)
						if(obj.datavalue){
							arr.push(obj);
						}
						
						j++
					}
					table.data.push({"row":arr});
				}
			}
			
		}else{
		let i = 1;
		for(let col of this.portfolioCols){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let i=1;i<this.excelData2.length+1;i++){
			let arr=[];
			let j = 1
					// console.log(this.excelData2[i-1])
	
					for(let col of this.portfolioCols){
						if(this.companyGroupIndicator && col.field=="REPORT_GROUP"){
							if (!this.excelData2[i-1][col.field]) {
								this.excelData2[i-1][col.field] = {GROUP_NAME: ''}; // for old data that doesn't have a group
							}
						}
					let obj={"col":j.toString(), "datavalue": 
				col.searchfield.split('.').reduce(this.index, this.excelData2[i-1])
					, "dtype":"string"};
					// console.log(obj)
					if(col.field=="ASSIGNED_USERS"){
			
						let arr=[]
						for(let user of this.excelData2[i-1][col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}
					if(col.field=="REVIEWER"){
			
						let arr=[]
						for(let user of this.excelData2[i-1][col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}	
					if(col.field=="ASSESSOR"){
						// console.log('test1',this.excelData2[i-1], col.field, this.excelData2[i-1][col.field])
						// console.log('test2',this.excelData2[i-1][col.field])
						let arr=[]
						for(let user of this.excelData2[i-1][col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}	
					if(col.field=="CONSULTANT_LOCATION"){
						obj.datavalue = this.excelData2[i-1][col.field].LOCATION_NAME
					}
					if(col.field=="REPORT_GROUP"){
						obj.datavalue = this.excelData2[i-1][col.field] ? this.excelData2[i-1][col.field].GROUP_NAME : '';
					}
					if(col.field=="TRANSACTION_TYPE"){
						if(this.excelData2[i-1][col.field][0]){
							obj.datavalue = this.excelData2[i-1][col.field][0].TRANSACTION_TYPE
							if(this.excelData2[i-1]["PROTOCOL"][0]){
								obj.datavalue += ', '+this.excelData2[i-1]["PROTOCOL"][0].PROTOCOL;
							}
						}else if(this.excelData2[i-1]["PROTOCOL"][0]){
							obj.datavalue = this.excelData2[i-1]["PROTOCOL"][0].PROTOCOL;
						}
						
					}
						if(obj.datavalue){
							arr.push(obj);
						}
					
						j++
					}
					table.data.push({"row":arr});
		}
	}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":filetitle, "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
			
		})
	}
	async checkUser(){
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":1};
		const response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		return response;
	}
	async exportKeySearchExcel(){
		let response=await this.checkUser();
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response);
			return
		}else if(response.USER_PERMISSION=='N'){
				Swal.fire({
					icon:'warning',
					title: response.MESSAGE,
				})
			return
		}
		let excelData = this.keySearchReports;
		// console.log(excelData)
		
		let table={
			"header":[],
			"data":[]
		}

		let i = 1;
		for(let col of this.keySearchCols){
			table.header.push({"headername":col.header, "col": i.toString()});
			i++;
		}
		for(let i=1; i<excelData.length+1; i++){
			let arr=[];
			let j = 1;
			// console.log(excelData[i-1])

			for(let col of this.keySearchCols){
				let obj = {
					"col": j.toString(),
					"datavalue": col.searchfield.split('.').reduce(this.index, excelData[i-1]),
					"dtype":"string"
				};
				// console.log(obj);
				if (col.field == "ASSESSOR" || col.field == "REVIEWER" || col.field == "ASSIGNED_USERS") {
					if (excelData[i-1][col.field]) {
						let arr=[]
						for(let user of excelData[i-1][col.field]){
							arr.push(user.FULL_NAME? user.FULL_NAME : user.USER_EMAIL);
						}
						obj.datavalue=arr.join(", ")
					}
				}
				if (col.field == "CONSULTANT_LOCATION") {
					obj.datavalue = excelData[i-1][col.field].LOCATION_NAME
				}
				if (this.companyGroupIndicator && col.field == "REPORT_GROUP") {
					obj.datavalue = excelData[i-1][col.field] ? excelData[i-1][col.field].GROUP_NAME : '';
				}
				if (obj.datavalue) {
					arr.push(obj);
				}
				
				j++;
			}
			table.data.push({"row":arr});
		}

		console.log('table', table);

		let inputJson = {
			"USER_ID": parseInt(this.userId),
			"COMPANY_ID":this.userInfo.COMPANY_ID.toString(),
			"filetitle": "Project and Reports (Complete Search)",
			"exceljson":JSON.stringify(table)
		};
		// console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson)).subscribe(data => {
			// console.log(data);
			window.open(data.fileurl);
		})
	}
	

	

  	keyInput='';
	keySearchLoading;
	keywordSearchButtonColor = 'rgb(9 17 33)';
	keySearchReports = []
	hoverKeywordSearchButton(){
		this.keywordSearchButtonColor = '#C2D63F'
	}
	leaveKeywordSearchButton(){
		this.keywordSearchButtonColor = 'rgb(9 17 33)'
	}
	keySearch(){
		//console.log(this.keyInput);
		if(this.keyInput.length>0){
			//let inputJson={"PROCEDURE":"searchcompletedreports","USER_ID":parseInt(this.userId),"SEARCH_BY":this.keyInput};
			let inputJson={"PROCEDURE":"searchreportsv2","USER_ID":parseInt(this.userId),"SEARCH_BY":this.keyInput};
			this.keySearchLoading = true
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				this.keySearchLoading = false
				console.log(response);
				if(response.RESPONSE_STATUS=='Y'){
					//this.reports=response.COMPLETED_REPORT_LIST;

					this.keySearchReports=response.REPORT_LIST;

					for(const [j, rpt]  of response.REPORT_LIST.entries()){
				
						let flat = {};			
						/*if(rpt.PERCENT_COMPLETE){
							rpt.PERCENT_COMPLETE=parseFloat(rpt.PERCENT_COMPLETE.replace('%','')).toFixed(2)
						}
						if(rpt.REVIEWER_PROGRESS){
							rpt.REVIEWER_PROGRESS=parseFloat(rpt.REVIEWER_PROGRESS.replace('%','')).toFixed(2)
						}*/		
						//rpt.ASSESSORTITLE={"TITLE":rpt.ASSESSOR_TITLE};
						//rpt.REVIEWERTITLE={"TITLE":rpt.REVIEWER_TITLE};
						// if(rpt.PROTOCOL&& rpt.PROTOCOL[0]){
						// 	flat['PROTOCOL']=rpt.PROTOCOL[0].PROTOCOL;
						// }
						if(rpt.TRANSACTION_TYPE && rpt.TRANSACTION_TYPE[0]){
							//rpt.flat.TRANSACTION_TYPE=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE;
							flat['TRANSACTION_TYPE']=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE+","+rpt.PROTOCOL[0].PROTOCOL;;
						}
						if(rpt.ASSESSOR && rpt.ASSESSOR[0]){
							flat['ASSESSOR']=rpt.ASSESSOR[0].FULL_NAME? rpt.ASSESSOR[0].FULL_NAME : rpt.ASSESSOR[0].USER_EMAIL;
						}
						if(rpt.REVIEWER && rpt.REVIEWER[0]){
							flat['REVIEWER']=rpt.REVIEWER[0].FULL_NAME? rpt.REVIEWER[0].FULL_NAME : rpt.REVIEWER[0].USER_EMAIL;
						}
						if(rpt.ASSIGNED_USERS && rpt.ASSIGNED_USERS[0]){
							flat['ASSIGNED_USERS']=rpt.ASSIGNED_USERS[0].FULL_NAME;
						}
						if(rpt.TEMPLATE && rpt.TEMPLATE[0]){
							flat['TEMPLATE']=rpt.TEMPLATE[0].TEMPLATE_TITLE
						}

						this.keySearchReports[j]['flat'] = JSON.parse(JSON.stringify(flat));
						// console.log(this.keySearchReports[j]);
					}

					// console.log(this.keySearchReports)
					//this.keyInput='';
				}else{
					this.throwError(response)
				}
			})
		}else{
			// this.getReports();
		}
	}
	keySearchCols=[
		// { field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', header: 'Project No. /Name', width: this.largeWidth}, //1
		// { field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', header: 'Access Report(s)', width: this.largeWidth, field3:'REPORT'}, //2
		// { field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', header: 'Property Name', width: this.largeWidth}, //3
		// { field: 'FULL_ADDRESS',  searchfield: 'FULL_ADDRESS', header: 'Property Address', width: this.largeWidth ,}, //4
		// { field: 'TEMPLATE',searchfield: 'flat.TEMPLATE', header: 'Template', width: this.largeWidth, field3:'TEMPLATE'}, //5
		// { field: 'ASSESSOR_DUE_DATE', searchfield: 'ASSESSOR_DUE_DATE',header: 'Writer Due Date', width: this.medWidth ,}, //6
		// { field: 'REVIEWER_DUE_DATE',searchfield: 'REVIEWER_DUE_DATE', header: 'Reviewer Due Date', width: this.medWidth ,}, //7
		// { field: 'REPORT_DUE_DATE',searchfield: 'REPORT_DUE_DATE', header: 'Report Due Date', width: this.medWidth ,}, //8
		// { field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', header: 'Writer', width: this.largeWidth, field2:'FULL_NAME'}, //9
		// { field: 'REVIEWER',searchfield: 'flat.REVIEWER', header: 'Reviewer', width: this.largeWidth, field2:'FULL_NAME'}, //10
		// { field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: this.largeWidth, field2:'FULL_NAME'}, //11
		// { field: 'TRANSACTION_TYPE',searchfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: this.largeWidth, field2:'TRANSACTION_TYPE'}, //12
		// { field: 'STATUS',searchfield: 'STATUS', header: 'Status', width: this.largeWidth ,}, //13
		// { field: 'ORDER_REPORTS', searchfield: 'ORDER_NUM',header: 'ERIS Data', width: this.largeWidth ,}, //14
		// { field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED',header: 'Last Edited', width: this.medWidth ,}, //15
		// { field: 'DATE_CREATED', searchfield: 'DATE_CREATED',header: 'Created Date', width: this.medWidth ,}, //16
		{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', sortfield: 'PROJECT_NUMBER', header: 'Project Number', width: '5%'}, //1
		{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', sortfield: 'REPORT_TITLE', header: 'Access Report(s)', width: '5%', field3:'REPORT'}, //2
		{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', sortfield: 'PROPERTY_NAME', header: 'Property Name', width: '5%'}, //3
		{ field: 'FULL_ADDRESS',  searchfield: 'FULL_ADDRESS', sortfield: 'FULL_ADDRESS', header: 'Property Address', width: '5%' ,}, //4
		{ field: 'TEMPLATE',searchfield: 'flat.TEMPLATE', sortfield: 'flat.TEMPLATE', header: 'Template', width: '5%', field3:'TEMPLATE'}, //5
		{ field: 'ASSESSOR_DUE_DATE', searchfield: 'ASSESSOR_DUE_DATE', sortfield: 'ASSESSOR_DATE', header: 'Writer Due Date', width: '5%' ,}, //6
		{ field: 'REVIEWER_DUE_DATE',searchfield: 'REVIEWER_DUE_DATE', sortfield: 'REVIEWER_DATE', header: 'Reviewer Due Date', width: '5%' ,}, //7
		{ field: 'REPORT_DUE_DATE',searchfield: 'REPORT_DUE_DATE', sortfield: 'REPORT_DATE', header: 'Report Due Date', width: '5%' ,}, //8
		{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', sortfield: 'flat.ASSESSOR', header: 'Writer', width: '5%', field2:'FULL_NAME'}, //9
		{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', sortfield: 'flat.REVIEWER', header: 'Reviewer', width: '5%', field2:'FULL_NAME'}, //10
		{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', sortfield: 'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: '5%', field2:'FULL_NAME'}, //11
		{ field: 'TRANSACTION_TYPE',searchfield: 'flat.TRANSACTION_TYPE', sortfield: 'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: '5%', field2:'TRANSACTION_TYPE'}, //12
		{ field: 'STATUS',searchfield: 'STATUS', sortfield: 'STATUS', header: 'Status', width: '5%' ,}, //13
		{ field: 'ORDER_NUM', searchfield: 'ORDER_NUM', sortfield: 'ORDER_NUM', header: 'ERIS Data', width: '5%' ,}, //14
		{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED', sortfield: 'DATE_UPDATED', header: 'Last Edited', width: '5%' ,}, //15
		{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED', sortfield: 'DATE_CREATED', header: 'Created Date', width: '5%' ,}, //16
		// { field: 'CONSULTANT_LOCATION.LOCATION_NAME', searchfield: 'CONSULTANT_LOCATION', sortfield: 'CONSULTANT_LOCATION', header: 'Company Name', width: "5%" ,} //17
	];

  getData(){
	 
	let id = this.cookieService.getCookie("userID");
	let inputJson={"PROCEDURE":"getportfoliolist", "USER_ID":id, "PORTFOLIO_FLAG":"Y"}	;						
	this.reportService.univeralService(JSON.stringify(inputJson))
        .subscribe(data => {
			$('#spin1').css('display','none');
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.userData=data.PORTFOLIOS;console.log(this.userData);
			this.curPortfolio=data.PORTFOLIOS[0];
			for(let r of this.curPortfolio.ORDERS){
				for(let t of r.RW_REPORTS){
					t.selected=true; //flag1
					console.log('SELECTED FLAG')
				}
			}
			this.inputData={'data':[]};
			this.tfiles=[];
			for(let p of data.PORTFOLIOS){
				let ch={
					"data":{
						"Portfolio":p.PORTFOLIO_NAME,
						"type":"Portfolio",
						"PORTFOLIO_ID":p.PORTFOLIO_ID,						
					},
					
					"children":[],
				}
				let x={'PORTFOLIO_ID':p.PORTFOLIO_ID ,'PORTFOLIO_NAME': p.PORTFOLIO_NAME, 'treeData':[]};
				for(let c of p.ORDERS){
					//c.type="Order";
					//ch.children.push({"data":c});
					//if(c.REPORTS.length>0){
						let rptArray=[];
						let o={	
						"Portfolio":c.ORDER_NUM,
							//"ORDER_NUM":c.ORDER_NUM,
							"ORDER_ADDRESS":c.ORDER_ADDRESS ,
								//"ORDER_ID":c.ORDER_ID ,
								
								"PROJECT_NO":c.PROJECT_NO,
								"SITE_NAME":c.SITE_NAME,
								"REPORTS":c.REPORTS,
								"type":"Order",
								}
			
						//let sampleReport=[{"Portfolio":"my report1","ORDER_ADDRESS":"Toronto",'REPORT_NAME':'my report1', 'REPORT_TAG':'custom1', 'type':"Report"},
						//{"Portfolio":"my report2","ORDER_ADDRESS":"Toronto",'REPORT_NAME':'my report2', 'REPORT_TAG':'custom2', 'type':"Report"}]
						let sampleReport=c.RW_REPORTS; //console.log(sampleReport);
						for(let r of sampleReport){//console.log(r)
							r.Portfolio=r.REPORT_TITLE//REPORT_NAME;
							rptArray.push({"data":r});
														
						}
						ch.children.push({"data":o,"children":rptArray});
						x.treeData.push({"data":o,"children":rptArray});					
					//}else{
					//	ch.children.push({"data":c});
					//}
					
				}
				this.inputData.data.push(ch);
				console.log(x);
				console.log(this.tfiles);
				this.tfiles.push(x);
			}
			this.files=this.inputData.data;
			console.log(this.inputData)
			console.log(this.tfiles);
		})
		let inputJson2={"PROCEDURE":"getportfoliolist", "USER_ID":id, "PORTFOLIO_FLAG":"N"}	;						
	this.reportService.univeralService(JSON.stringify(inputJson2))
        .subscribe(data => {
			$('#spin1').css('display','none');
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.pfiles=data.ORDERS;console.log(this.pfiles)
		})
  }
  portToggle(){console.log(this.portView);
	  if(this.portView){
		  this.portView=false;
	  }else{
		  this.portView=true;
	  }
  }
  parcelToggle(){
	this.parcelOn=!this.parcelOn
	console.log(this.parcelOn);
	if(!this.parcelOn){
		for (var i = 0; i < this.mapFeatures.length; i++) this.mapFeatures[i].setMap(null);
		//remove parcel tile
			this.mapcanvas.overlayMapTypes.clear();
	}
	if(this.parcelOn){
		this.currentZoom = this.mapcanvas.getZoom();
		console.log(this.currentZoom);
	//	that.cookieService.setCookieSession("homeZome", JSON.stringify(currentZoom));
		//console.log(JSON.parse(that.cookieService.getCookie('homeZome')));
		if (this.currentZoom>=17){
			REP.Layer.Google.Initialize(this.mapcanvas);	
		}else{
			for (var i = 0; i < this.mapFeatures.length; i++) this.mapFeatures[i].setMap(null);
		//remove parcel tile
		this.mapcanvas.overlayMapTypes.clear();
		
		}
	}

	// if(this.parcelOn){
	// 	this.parcelOn=false;
	// }else{
	// 	this.parcelOn=true;
	// }

  }
  public setRptStatus(){
	  console.log('set status')
  }

  public reportsToggle(e){
	//console.log($(e.target).next());
	$(e.target).toggleClass('active');
	$(e.target).parent().parent().next().children().first().children().first().toggle(); // testing, clean up later
  }
  public portAsc(){console.log("asc")
	this.userData.sort(this.dynamicSort("PORTFOLIO_NAME"));
	//this.curPortfolio.ORDERS.sort(this.dynamicSort("ORDER_NUM"));
  }
  public portDsc(){console.log("dsc")
	this.userData.sort(this.dynamicSort("-PORTFOLIO_NAME"));
	//this.curPortfolio.ORDERS.sort(this.dynamicSort("-ORDER_NUM"));	
  }
  public rptSort(data, direction){
	  console.log(data);
	  if(direction>0){
		 data.RW_REPORTS.sort(this.dynamicSort("REPORT_ID")); 
	  }else{
		data.RW_REPORTS.sort(this.dynamicSort("-REPORT_ID"));
	  }
  }
  public selectPortfolio(item){console.log(item);
	 //$(event.target).toggleClass('active'); 
	 this.curPortfolio=item;
	 for(let r of this.curPortfolio.ORDERS){
		for(let t of r.RW_REPORTS){
			t.selected=true;
			console.log('SELECTED FLAG')
		}
	}
  }
  public createExcel(pid){
	  let inputJson={"PROCEDURE":"CreatePortfolioExcelCSV","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":pid};
	  console.log(inputJson);
	  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
		  console.log(response);
		  if (response.RESPONSE_STATUS=='N') {
			this.throwError(response)
			return										
		}
		  let url=response.PORTFOLIO[0].URL;
		  window.open(url, "_blank");
	  })
  }
  public searchPortfolio(e){
	  console.log($(e.target).siblings('input'))
	  let val1=$(e.target).siblings('input')[0].value;console.log(val1);
	  let val2=$(e.target).siblings('input')[1].value;console.log(val2);
	  let val3=$(e.target).siblings('input')[2].value;console.log(val3);
	  //let inputJson={"PROCEDURE":"SearchReplacePortfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":152, "ORIG_WORD":"", "REPLACE_WORD":"", "FIELD_NAME":""};
	  //console.log(inputJson);
	 // this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
	//	  console.log(response);
	 // })
  }
  /*public addReport(e){
	  let that=this;
	  $(e.target).siblings('p').css('display','none');
	  let title=$(e.target).siblings('input').val();//console.log(title);
	  let tid=$(e.target).siblings('select')[0].value;//console.log(tid);
	  let cid=$(e.target).siblings('select')[1].value;//console.log(cid);
	  if(title.length>0&&tid.length>0&&cid.length>0){
		let inputJson={"PROCEDURE":"insertproject","USER_ID":parseInt(this.userId),"ORDER_NUM":parseInt(this.curOrder), "TEMPLATE_ID":tid,"REPORT_TITLE":title,"COVERPAGE_ID":cid,"STATUS":"new","REPORT_URL":"","REPORT_DATA":"","REPORT_ROLE":"","PORTFOLIO_ID":parseInt(this.curPortfolio.PORTFOLIO_ID)};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log(data);
			let report={'ASSIGNED_USERS': "",'COVER_PAGE': data.COVERPAGE_ID,'REPORT_DATA': data.REPORT_DATA,'REPORT_ID': data.REPORT_ID,'REPORT_ROLE': data.REPORT_ROLE,'REPORT_TITLE': data.REPORT_TITLE,'REPORT_URL': data.REPORT_URL,'STATUS': data.STATUS,'TEMPLATE': data.TEMPLATE_ID,'RW_TAGS':[]};
			let index=that.curPortfolio.ORDERS.findIndex(order=>order.ORDER_NUM==data.ORDER_NUM.toString()&&that.curPortfolio.PORTFOLIO_ID==data.PORTFOLIO_ID.toString());
			that.curPortfolio.ORDERS[index].RW_REPORTS.push(report);
		  $('#reportsModal').modal('hide');
		})
	  }else{
		   $(e.target).siblings('p').css('display','block');
	  }
  }*/
  public addRpt(from){
	  console.log(from)
	  this.new=true;
	  this.resetForm(from);
	  this.changed=false;
	
  }
  public addRpt2(callback){
	this.new=true;
	this.resetForm2(callback);
  
}
	public changeStatus(e, orderno, id){
		let status=$(e.target).val();console.log(status);	  
		let inputJson={"PROCEDURE":"SetReportStatus","USER_ID":parseInt(this.userId),"ORDER_NUM":orderno, "REPORT_ID":id, "STATUS":status};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
			this.getStatusCounts();
		})
	}
	public assignUser(e, orderno, id){
		let user=$(e.target).val();console.log(user);
		let inputJson={"PROCEDURE":"AssignUser","USER_ID":parseInt(this.userId),"ORDER_NUM":orderno, "REPORT_ID":id, "ASSIGNED_USERS":user};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
		})
	}
	public changeStatus1(rowdata, status){

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":rowdata.REPORT_ID, "FUNCTION_ID": status!='Final'? 12 : 13};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				if(status=='Inactive'){
					Swal.fire({
						icon:'warning',
						html: '<span style="font-size:20px; font-weight:bold">Warning!</span><br>Once a report is INACTIVE, you may not change the status again. You will lose access to the report.<br>Only change a report to INACTIVE if you need to set up a new report using the same Template Identifier.',
						confirmButtonText: 'Confirm',
						showLoaderOnConfirm: true,
						showCancelButton: true,
						backdrop:false,
						preConfirm: () => {
							this.setStatus(rowdata, status);							
						}
					})
				}else{
					this.setStatus(rowdata, status)
				}				
			}

		});
	}
	setStatus(rowdata, status){
		let inputJson={"PROCEDURE":"setreportstatus","USER_ID":parseInt(this.userId),"REPORT_ID":rowdata.REPORT_ID, "STATUS":status};
				console.log(inputJson);
				
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
					console.log(response);
					if(response.RESPONSE_STATUS=='N'){
						this.throwError(response)
					}else{
					this.getStatusCounts();
					rowdata.STATUS=status;
					}
				})
	}
	updateReportGroup(rowdata, group) {
		let checkuserpermissionJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":rowdata.REPORT_ID, "FUNCTION_ID": 47};
		this.reportService.univeralService(JSON.stringify(checkuserpermissionJson)).subscribe(checkResponse => {
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return;
			}
			
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				return;
			}

			let updatereportJson={"PROCEDURE":"updatereport", "USER_ID":parseInt(this.userId), "REPORT_ID":rowdata.REPORT_ID, "GROUP_ID":group.GROUP_ID};
			this.reportService.univeralService(JSON.stringify(updatereportJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data);
					return;								
				}

				rowdata.REPORT_GROUP = group;
			});
		});
	}
	public assignUser1(id, user){
		let inputJson={"PROCEDURE":"assignuser","USER_ID":parseInt(this.userId),"REPORT_ID":id, "ASSIGNED_USERS":user};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
			let index=this.reports.findIndex(proj=>proj.PROJECT_ID==response.PROJECT_ID);console.log(index)
			if(index>-1){
				let rpts=this.reports[index].RW_REPORTS;
				let index2=rpts.findIndex(rpt=>rpt.REPORT_ID==response.REPORT_ID);//console.log(index2)
				this.reports[index].RW_REPORTS[index2].ASSIGNED_USERS=response.ASSIGNED_USERS;//console.log(this.reports)
				this.reportTreeData[index].children[index2].data.ASSIGNED_USERS=response.ASSIGNED_USERS;

			}
		})
	}
	
	public addLabel(id) {
		console.log('addLabel');
		let inputJson={"PROCEDURE":"InsertTag","USER_ID":parseInt(this.userId),"REPORT_ID":id,"TAG_REF_CD":"","TAG_VALUE":this.newLabel};
		let para=JSON.stringify(inputJson);console.log(para);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => { console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			if(data.REPORT_ID){
				let index1=this.reports.findIndex(proj=>proj.PROJECT_ID==data.PROJECT_ID);
				//let reports=that.curPortfolio.ORDERS[index1];
				let index2=this.reports[index1].RW_REPORTS.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);
				this.reports[index1].RW_REPORTS[index2].RW_TAGS=data.RW_TAGS;
				this.reportTreeData[index1].children[index2].data.RW_TAGS=data.RW_TAGS;
	  		} else {
				let info={'MESSAGE':'Failed'};
				this.throwError(info);
	 		}
	  
	})
	} 

	public addTag(id){
		console.log('addtag');
		let that=this;
		Swal.fire({
			title: 'Label Name',
			input:'text',
			confirmButtonText: 'Save',
			showCancelButton: true,
			preConfirm:(result) => {
				let tagname=result;
				console.log(tagname)
				if (tagname === '') {
					Swal.showValidationMessage(`Tag is empty`)
				}
				let resultdata:any;
				let inputJson={"PROCEDURE":"InsertTag","USER_ID":parseInt(this.userId),"REPORT_ID":id,"TAG_REF_CD":"","TAG_VALUE":tagname};
				let para=JSON.stringify(inputJson);console.log(para);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => { console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				if(data.REPORT_ID){
					let index1=this.reports.findIndex(proj=>proj.PROJECT_ID==data.PROJECT_ID);
					//let reports=that.curPortfolio.ORDERS[index1];
					let index2=this.reports[index1].RW_REPORTS.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);
					this.reports[index1].RW_REPORTS[index2].RW_TAGS=data.RW_TAGS;
					this.reportTreeData[index1].children[index2].data.RW_TAGS=data.RW_TAGS;
				/*let index1=that.curPortfolio.ORDERS.findIndex(order=>order.ORDER_NUM==data.ORDER_NUM)
				let reports=that.curPortfolio.ORDERS[index1];
				let index2=reports.RW_REPORTS.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);
				reports.RW_REPORTS[index2].RW_TAGS=data.RW_TAGS;*/
				Swal.fire({
					title:"Saved",
					timer: 2000,
					showConfirmButton:false,
				})
            
          }else {
			let info={'MESSAGE':'Failed'}
			this.throwError(info);
          }
          
        })
				return true;//this.userInfo
			}
		
		})
	}
	private dynamicSort(property) {
		let sortOrder = 1;

		if(property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}

		return function (a,b) {
			if(sortOrder == -1){
				return b[property]-a[property];
			}else{
				return a[property]-b[property];
			}        
		}
	}
	//MyData.sort(dynamicSort("name"));
	//MyData.sort(dynamicSort("-name"));
	expandAll1() {
    if(!this.isExpanded){
      this.curPortfolio.ORDERS.forEach(data =>{
        this.expandedRows[data.ORDER_NUM] = true;
      })
	  console.log(this.expandedRows);
    } else {
      this.expandedRows={};
    }
    this.isExpanded = !this.isExpanded;
  }

  public expandAllReports() {
	if(!this.isExpanded){
		this.reportTreeData.forEach(data =>{
			data.expanded = true;
		})
	}else{
		this.reportTreeData.forEach(data =>{
			data.expanded = false;
		})
	}
	this.isExpanded = !this.isExpanded;
	console.log("Expanded?:", this.isExpanded)
	this.reportTreeData=[...this.reportTreeData];
}
public expandAllPortfolios() {
	if(!this.isExpanded2){
		this.portfolioTreeData.forEach(data =>{
			data.expanded = true;
		})
	}else{
		this.portfolioTreeData.forEach(data =>{
			data.expanded = false;
		})
	}
	this.isExpanded2 = !this.isExpanded2;
	console.log("Expanded?:", this.isExpanded2)
	this.portfolioTreeData=[...this.portfolioTreeData];
}
  /*onRowExpand() {
    console.log("row expanded", Object.keys(this.expandedRows).length);
    if(Object.keys(this.expandedRows).length === this.temDataLength){
      this.isExpanded = true;
    }
  }
  onRowCollapse() {
    console.log("row collapsed",Object.keys(this.expandedRows).length);
    if(Object.keys(this.expandedRows).length === 0){
      this.isExpanded = false;
    }
  }
  onPage(event: any) {
    this.temDataLength = this.curPortfolio.ORDERS.slice(event.first, event.first + 10).length;
    console.log(this.temDataLength);
    this.isExpanded = false;
    this.expandedRows={};
  }*/
	public searchReplace(){
		this.searchMessage='';
		console.log(this.curPortfolio);
		let inputs=[];
		$('.tInput').each(function(){console.log($(this).val())
			inputs.push($(this).val());			
		})
		console.log(inputs);
		if(inputs[0].length>0&&inputs[2].length>0){
			Swal.fire({
				title:'Change can not be restore, Start Replace?',
				//confirmButtonText:'Change can not be restore',
				showCloseButton:true,
				showCancelButton:true,
      			preConfirm:()=>{
					let inputJson={"PROCEDURE":"SearchReplacePortfolio", "USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.curPortfolio.PORTFOLIO_ID,"ORIG_WORD":inputs[0],"REPLACE_WORD":inputs[1],"FIELD_NAME":inputs[2],};
					console.log(inputJson)
					//Parameters out – PORTFOLIO_ID, PORTFOLIO_NAME, List of Orders- ORDER_NUM, ORDER_ADDRESS, SITE_NAME, PROJECT_NO
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						console.log(data);
						if (data.RESPONSE_STATUS=='N') {
							this.throwError(data)
							return										
						}
			
					})
				}
			})		   
		}else{
			this.searchMessage='All *input required'
		}
	}
	public removeRpt(item){
		Swal.fire({
			title: 'Delet report?',
			showCancelButton: true,
			confirmButtonText: `Delete`,			
		}).then((result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				Swal.fire('Deleted!', '', 'success')
			} 
		})
	}
	public removeTag(id, item){
		Swal.fire({
			title: 'Delete Label?',
			showCancelButton: true,
			confirmButtonText: `Delete`,			
		}).then((result) => {
			/* Read more about isConfirmed, isDenied below */
			if (result.isConfirmed) {
				//let inputJson={"PROCEDURE":"inserttag", "USER_ID":123456, "ORDER_NUM":"20201358212", "REPORT_ID":2, "TAG_ID":1}
				let inputJson={"PROCEDURE":"deletetag", "USER_ID":parseInt(this.userId), "REPORT_ID":id, "TAG_ID":item.TAG_ID}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{console.log(data)
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					if(data.REPORT_ID){
					let index1=this.reports.findIndex(proj=>proj.PROJECT_ID==data.PROJECT_ID);
					//let reports=that.curPortfolio.ORDERS[index1];
					let index2=this.reports[index1].RW_REPORTS.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);
					this.reports[index1].RW_REPORTS[index2].RW_TAGS=data.RW_TAGS;
					this.reportTreeData[index1].children[index2].data.RW_TAGS=data.RW_TAGS;
					/*let index1=that.curPortfolio.ORDERS.findIndex(order=>order.ORDER_NUM==data.ORDER_NUM)
					let reports=that.curPortfolio.ORDERS[index1];
					let index2=reports.RW_REPORTS.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);
					reports.RW_REPORTS[index2].RW_TAGS=data.RW_TAGS;*/
					Swal.fire({
						title:"Deleted",
						timer: 2000,
						showConfirmButton:false,
					})	
            
					} else {
						let info={'MESSAGE':'Failed'}
						this.throwError(info);
					}
          
				})
				//Return fields – "USER_ID":123258, "REPORT_ID":2 "PROJECT_ID":2, RW_TAGS (list of all existing tags for this report)
				Swal.fire('Deleted!', '', 'success');
			} 	
		})
	}
	public tabToggle(e){
		if($('#tabList').css('display')=='none'){
			$('#tabList').css('display','block');
			$('#tabTable').css('width','89%');
			$(e.target)[0].src="assets/images/left.png"
		}else{
			$('#tabList').css('display','none');
			$('#tabTable').css('width','99%');
			$(e.target)[0].src="assets/images/right.png"
		}
	}
	public filterByTag(e, data){console.log($(e.target).val())
		console.log(data);
		let key=$(e.target).val();
		if(key.length>0){
			for(let item of data.RW_REPORTS){
				let filtered = item.RW_TAGS.filter(a => a.TAG_VALUE == key); console.log(filtered)
				if(filtered.length>0){
					item.selected=true;
					console.log('SELECTED FLAG')
				}else{
					item.selected=false;
				}
			}
		}else{
			for(let item of data.RW_REPORTS){
				item.selected=true;		
				console.log('SELECTED FLAG')
			}
		}
		console.log(data.RW_REPORTS);
	}
	onSavedLogo(e){
		//this.tick = +(new Date());
		this.showLogo = e;
		
	}
	onEditReport(e){
		
	} 
	logOut(){
		this.logOutFlag++; console.log(this.logOutFlag);
	}
	show4(x){
		console.log(this.curProject.PROJECT_NUMBER)
	}
	public toTreeData(){
		this.ngZone.run(()=>{this.loading=true;})
		this.reportTreeData=[];
		
		let metaData={'data':[]};
		for(const [i, report] of this.reports.entries()){//this.reports=data.RW_PROJECTS;console.log(this.reports);//RW_REPORTS;
			// console.log(report, i);
			
			let data={
				"data":{
					"GROUP_LABEL":report.GROUP_LABEL,
					"PROJECT_ID":report.RW_REPORTS[0].PROJECT_ID,
					"highlight":report.RW_REPORTS[0].PROJECT_ID==this.justAddedID,
					"size":report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
					'project':true,
					"added":report.added?true:false,
				},

				"children":[],
				expanded: true,
			}
			// console.log(data);
			if(true){
				for(const [j, rpt]  of report.RW_REPORTS.entries()){
					
					//let inputJson={"PROCEDURE":"getrwstatus","USER_ID":parseInt(this.userId),"REPORT_ID":report.REPORT_ID}
					//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						//console.log("RwStatus", data)
					//});
					rpt['flat']={};
					//rpt.flat.PERCENT_COMPLETE=rpt.PERCENT_COMPLETE
					//rpt.flat.PERCENT_COMPLETE_1 = parseInt(rpt.PERCENT_COMPLETE.replace(/%/g, ''))
					//console.log('int',  parseInt(rpt.PERCENT_COMPLETE.replace(/%/g, '')))
					//rpt.flat.REVIEWER_PROGRESS=rpt.REVIEWER_PROGRESS
					//console.log('Writer:', rpt.flat.PERCENT_COMPLETE)
					//console.log('Reviewer:', rpt.flat.REVIEWER_PROGRESS)
					if(rpt.PERCENT_COMPLETE){
						rpt.PERCENT_COMPLETE=parseFloat(rpt.PERCENT_COMPLETE.replace('%','')).toFixed(2)
					}
					if(rpt.REVIEWER_PROGRESS){
						rpt.REVIEWER_PROGRESS=parseFloat(rpt.REVIEWER_PROGRESS.replace('%','')).toFixed(2)
					}
				//	rpt.PERCENT_COMPLETE=50 *3.6

				//	rpt.REVIEWER_PROGRESS=50 *3.6
					rpt.ASSESSORTITLE={"TITLE":rpt.ASSESSOR_TITLE};
					rpt.REVIEWERTITLE={"TITLE":rpt.REVIEWER_TITLE};
					rpt.flat.PROJECT_NUMBER=rpt.PROJECT_NUMBER;
					rpt.flat.PROPERTY_NAME=rpt.PROPERTY_NAME;
					rpt.flat.ADDRESS_LINE1= rpt.ADDRESS_LINE1;
					rpt.flat.ADDRESS_LINE2= rpt.ADDRESS_LINE2;
					rpt.flat.CITY= rpt.CITY;
					rpt.flat.PROVSTATE= rpt.PROVSTATE;
					rpt.flat.POSTALZIP= rpt.POSTALZIP;
					rpt.flat.REPORT_ID= rpt.REPORT_ID;
					if(rpt.PORTFOLIO.length>0){
						//console.log("portfolio found", rpt, report)
					}
					if(rpt.PROTOCOL&& rpt.PROTOCOL[0]){
						rpt.flat.PROTOCOL=rpt.PROTOCOL[0].PROTOCOL;
					}
					if(rpt.TRANSACTION_TYPE && rpt.TRANSACTION_TYPE[0]){
						rpt.flat.TRANSACTION_TYPE=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE;
					}
					if(rpt.ASSESSOR && rpt.ASSESSOR[0]){
						rpt.flat.ASSESSOR=rpt.ASSESSOR[0].FULL_NAME? rpt.ASSESSOR[0].FULL_NAME : rpt.ASSESSOR[0].USER_EMAIL;
					}
					if(rpt.REVIEWER && rpt.REVIEWER[0]){
						rpt.flat.REVIEWER=rpt.REVIEWER[0].FULL_NAME? rpt.REVIEWER[0].FULL_NAME : rpt.REVIEWER[0].USER_EMAIL;
					}
					if(rpt.ASSIGNED_USERS && rpt.ASSIGNED_USERS[0]){
						rpt.flat.ASSIGNED_USERS=rpt.ASSIGNED_USERS[0].FULL_NAME? rpt.ASSIGNED_USERS[0].FULL_NAME : rpt.ASSIGNED_USERS[0].USER_EMAIL;
					}
					if(rpt.TEMPLATE && rpt.TEMPLATE[0]){
						rpt.flat.TEMPLATE=rpt.TEMPLATE[0].TEMPLATE_TITLE
					}
					if(!rpt.ASSESSOR){
						rpt.ASSESSOR=[];
					}
					if(!rpt.REVIEWER){
						rpt.REVIEWER=[];
					}
					if(!rpt.ASSIGNED_USERS){
						rpt.ASSIGNED_USERS=[];
					}
					let date=Date.now();
					rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
					rpt.ASSESSOR_DATE=rpt.ASSESSOR_DUE_DATE ==""? null: new Date (rpt.ASSESSOR_DUE_DATE);
					rpt.ASSESSOR_DATE_RED= rpt.ASSESSOR_DATE? rpt.ASSESSOR_DATE<=date: false
					// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
					rpt.REVIEWER_DATE=rpt.REVIEWER_DUE_DATE==""? null: new Date (rpt.REVIEWER_DUE_DATE);
					rpt.REVIEWER_DATE_RED= rpt.REVIEWER_DATE? rpt.REVIEWER_DATE<=date : false
					rpt.REPORT_DATE=rpt.REPORT_DUE_DATE==""? null: new Date (rpt.REPORT_DUE_DATE);
					rpt.REPORT_DATE_RED= rpt.REPORT_DATE? rpt.REPORT_DATE<=date: false
					//rpt.PROJECT_NAME=rpt.REPORT_TYPE; //console.log(rpt)
					rpt.groupIndex=i;
					rpt.reportIndex=j;
					data.children.push({'data':rpt});
				}
			}
			if(data.data.highlight){
				this.reportTreeData.unshift(data);
			}else{
				this.reportTreeData.push(data);
			}
		


		}
		//this.ngZone.run(()=>{	this.reportTreeData=metaData.data;})
		// this.ref.markForCheck();
			this.ngZone.run(()=>{this.loading=false;})
			console.log("reportTreeDatasa", this.reportTreeData);	
			
		
	}
	googleMap2:google.maps.Map;
	infoWindow2=null;
	marker2:any;
	noLocation = true;
	zoomV=18;
	getCords(user){
		console.log("cords", user.LONGITUDE, user.LATITUDE)
		if(!user.LATITUDE || !user.LONGITUDE){
		let list=[user.ADDRESS_LINE1, user.ADDRESS_LINE2, user.CITY, user.PROVSTATE, user.POSTALZIP, user.COUNTRY]
		let list1=[]
		for(var i in list){
			if(list[i]!=''){
				list1.push(list[i])
			}
		}
		let address=user.FULL_ADDRESS
			let content:any;
				content= {'address': address};
				
			console.log("getAddress", content);
			
		this.geoCoder.geocode(content, (results, status) => {
		  console.log(results);
		  console.log(status);
		  console.log("valid", list1.length)
		  if (status === 'OK' && (results[0].geometry.location_type=="ROOFTOP" || results[0].types=="street_address") && list1.length>=2) {
			 console.log("valid", results[0].geometry.location_type)
			 console.log("valid", results[0].types)
			if (results[0]) {
				console.log("geocodedone");
			  //this.zoom = 12;
			  this.address = results[0].formatted_address; console.log(this.address);
			  this.ngZone.run(()=>{
				user.LATITUDE = results[0].geometry.location.lat();
				user.LONGITUDE = results[0].geometry.location.lng();
				this.noLocation = true;
				this.zoomV=18;
			  })
		
			} else {
			//  window.alert('No results found');
			user.LATITUDE=48.3552518;
			user.LONGITUDE=-100.0036572;
			this.noLocation = false;
			this.zoomV = 3;
			console.log("valid", results[0].geometry.location_type)
			console.log("valid", results[0].types)
			}
		  } else {
			//window.alert('Geocoder failed due to: ' + status);
			user.LATITUDE=48.3552518;
			user.LONGITUDE=-100.0036572;
			this.noLocation = false;
			this.zoomV = 3;
			console.log("valid", results[0].geometry.location_type)
			console.log("valid", results[0].types)
		  }
		});
		}else{
			if(user.LATITUDE==0 && user.LONGITUDE==0){
				user.LATITUDE=48.3552518;
				user.LONGITUDE=-100.0036572;
				this.noLocation = false;
				this.zoomV = 3;
			}
		}
		let latLng=new google.maps.LatLng(user.LATITUDE, user.LONGITUDE)
		var mapOptions = {
			mapTypeControl:false,
			center: latLng,
			zoom: this.zoomV,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: true,
			mapId: "DEMO_MAP_ID"
		};
		let that=this;
		setTimeout(() => {
			let ele= document.getElementById("googleMap2") ;
			if(!ele) return
			that.googleMap2 = new google.maps.Map(ele, mapOptions);
			if(!this.noLocation) return
			that.infoWindow2 = new google.maps.InfoWindow({position: latLng, content: '<span style="color:black; font-weight:bold">'+user.FULL_ADDRESS+'</span>'});
			//that.infoWindow2.open(that.googleMap2);
			let map2=that.googleMap2;
		that.marker2=new google.maps.Marker({
			map: map2,
			//icon:'assets/images/Site_Marker.png',
			title: user.FULL_ADDRESS,
			position: { lat: user.LATITUDE, lng: user.LONGITUDE },
		})
		that.marker2.addListener("click", () => {
			that.infoWindow2 .open({
			  anchor: that.marker2,
			  map2,
			});
		  });
		
		}, 250);
		
		
	}
	reversegeoCoder(){
		let input=this.mapInputAddress.split(',');
		let content={ 'location': { lat: parseFloat(input[0]), lng:parseFloat(input[1])  } }
		this.geoCoder.geocode(content, (results, status) => {//console.log(results, status)
			if (results.length == 0) {
				Swal.fire({
					icon:'info',
					title: 'Please check your input.',
				})
				return;
			  }
		  if (status === 'OK' && (results[0].geometry.location_type=="ROOFTOP" || results[0].types=="street_address")) {
				console.log("valid", results[0].geometry.location_type)
				console.log("valid", results[0].types)
				
				this.placeParse(results[0]);
				this.lat = parseFloat(input[0]);
				this.lng = parseFloat(input[1]);
			}else{
				this.lat = parseFloat(input[0]);
				this.lng = parseFloat(input[1]);
			}
	  
		  // Clear out the old markers.
		  this.markers2.forEach((marker) => {
			marker.setMap(null);
		  });
		  this.markers2 = [];
	  
		  // For each place, get the icon, name and location.
		  const bounds = new google.maps.LatLngBounds();
		  		
			const icon = {
			  url: results[0].icon as string,
			  size: new google.maps.Size(71, 71),
			  origin: new google.maps.Point(0, 0),
			  anchor: new google.maps.Point(17, 34),
			  scaledSize: new google.maps.Size(25, 25),
			};
	  
			// Create a marker for each place.

			let map= this.mapcanvas;
			this.markers2.push(
			  new google.maps.Marker({
				map,
				//icon:'../../assets/images/Site_Marker.png',
				title: results[0].name,
				position: results[0].geometry.location,
			  })
			);
	  
			if (results[0].geometry.viewport) {
			  // Only geocodes have viewport.
			  bounds.union(results[0].geometry.viewport);
			} else {
			  bounds.extend(results[0].geometry.location);
			}
		  
		  this.mapcanvas.fitBounds(bounds);
		
		});			
			
					  
	}
	onHide(){
		if (this.infoWindow2 !== null){
			this.infoWindow2.setMap(null);
			this.infoWindow2=null;
		} 	
		if (this.marker2 !== null){
			this.marker2.setMap(null);
			this.marker2=null;
		} 	
		this.googleMap2=null;
	}
	// Get Current Location Coordinates
    private setCurrentLocation() {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          this.zoom = 15;
        });
      }
    }
	
	getWriterReviewerStatus(rowData){
		console.log('Test', rowData.PERCENT_COMPLETE)
		console.log('Test', rowData.REVIEWER_PROGRESS)
		let inputJson={"PROCEDURE":"getrwstatus","USER_ID":parseInt(this.userId),"REPORT_ID":rowData.REPORT_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			console.log("RwStatus", data)
			console.log('Test', rowData.PERCENT_COMPLETE)
			if(data.PERCENT_COMPLETE){
				data.PERCENT_COMPLETE=parseFloat(data.PERCENT_COMPLETE.replace('%','')).toFixed(2)
			}
			if(data.REVIEWER_PROGRESS){
				data.REVIEWER_PROGRESS=parseFloat(data.REVIEWER_PROGRESS.replace('%','')).toFixed(2)
			}
			console.log("RwStatus", data)
			
			rowData.REVIEWER_PROGRESS = data.REVIEWER_PROGRESS
			rowData.PERCENT_COMPLETE = data.PERCENT_COMPLETE 
			
		});
		
	}
	

	mapInputAddress;
	getAddress(latitude, longitude, type) {//'address': inputString 
		let content:any;
		if(type){
			content={ 'location': { lat: latitude, lng: longitude } }
		}else{
			content= {'address': latitude};
			
		}
		console.log("getAddress", content);
		this.geoCoder.geocode(content, (results, status) => {
			console.log(results);
			console.log(status);
			if (status === 'OK' && (results[0].geometry.location_type=="ROOFTOP" || results[0].geometry.location_type=="STREET_ADDRESS")) {
				console.log("valid", results[0].geometry.location_type)
				if (results[0]) {
					console.log("geocodedone");
				//this.zoom = 12;
				this.address = results[0].formatted_address; console.log(this.address);
				this.mapInputAddress= results[0].formatted_address; 
				this.setPin(results);
				this.placeParse(results[0]);
				} else {
				//window.alert('No results found');
				}
			} else {
				//window.alert('Geocoder failed due to: ' + status);
			}
		});
	}

  setPin(places){
	this.markers2.forEach((marker) => {
		marker.setMap(null);
	  });
	  this.markers2 = [];
  
	  // For each place, get the icon, name and location.
	  const bounds = new google.maps.LatLngBounds();
	  places.forEach((place) => {
		if (!place.geometry || !place.geometry.location) {
		  console.log("Returned place contains no geometry");
		  return;
		}
		const icon = {
		  url: place.icon as string,
		  size: new google.maps.Size(71, 71),
		  origin: new google.maps.Point(0, 0),
		  anchor: new google.maps.Point(17, 34),
		  scaledSize: new google.maps.Size(25, 25),
		};
  
		// Create a marker for each place.

		let map= this.mapcanvas
		this.markers2.push(
		  new google.maps.Marker({
			map,
			//icon: 'assets/images/Site_Marker.png' ,// null = default icon
			title: place.name,
			position: place.geometry.location,
		  })
		);
  
		if (place.geometry.viewport) {
		  // Only geocodes have viewport.
		  bounds.union(place.geometry.viewport);
		} else {
		  bounds.extend(place.geometry.location);
		}
	  });
	  this.mapcanvas.fitBounds(bounds);
	
  }
  getAddress2(latitude, longitude, type) {//'address': inputString 
	let content:any;
	if(type){
		content={ 'location': { lat: latitude, lng: longitude } }
	}else{
		content= {'address': latitude};
		
	}
	console.log("getAddress", content);
this.geoCoder.geocode(content, (results, status) => {
  console.log(results);
  console.log(status);
  if (status === 'OK'  && results[0].geometry.location_type=="ROOFTOP") {
	if (results[0]) {
		console.log("geocodedone");
	  //this.zoom = 12;
	  this.address = results[0].formatted_address; console.log(this.address);
	  this.placeParse(results[0]);

	} else {
	//   window.alert('No results found');
	}
  } else {
	// window.alert('Geocoder failed due to: ' + status);
  }
  this.newReport();
});

}
  private placeParse(place){
	  console.log("placeParse", place)
	  let streetNo:string;
			let streetName:string; 
			let City:string; 
			let intersection:string;
			if(place.address_components){
				for(let i=0; i<place.address_components.length; i++){//console.log(place.address_components[i])
					if (place.address_components[i].types.indexOf("street_number")!=-1){
						streetNo=place.address_components[i] && place.address_components[i].long_name;console.log(streetNo)
					}				
					if (place.address_components[i].types.indexOf("administrative_area_level_1")!=-1){
						this.state=place.address_components[i] && place.address_components[i].short_name;console.log(this.state)
						
					}
					if (place.address_components[i].types.indexOf("country")!=-1){
						this.country=place.address_components[i] && place.address_components[i].short_name; //console.log(country);
					
					}
					if ((place.address_components[i].types).indexOf("locality")!=-1){
							City=place.address_components[i] && place.address_components[i].long_name; //console.log(City);
					}
					if (place.address_components[i].types.indexOf("postal_code")!=-1){
						this.postCode=place.address_components[i] && place.address_components[i].long_name;
					}
					if (place.address_components[i].types.indexOf("intersection")!=-1){
						intersection=place.address_components[i] && place.address_components[i].long_name;
					}
					if ((place.address_components[i].types.indexOf("street_address")!=-1)||(place.address_components[i].types.indexOf("route")!=-1)){
						streetName=place.address_components[i] && place.address_components[i].long_name;
					}
				}
				this.street1 =streetNo+" "+streetName;
			}
			
			//this.street = place.address_components[0].long_name+" "+place.address_components[1].long_name;
			this.city= place.formatted_address.split(',')[1]; 
			//this.country= place.address_components[place.address_components.length - 1].long_name;
			//this.postCode= place.address_components[place.address_components.length - 1].long_name; 
			//this.state= place.address_components[place.address_components.length - 1].long_name; 
          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
         this.zoom = 12;
		 this.ngZone.run(()=>{ this.markers[0]={
			lat: this.lat,
			lng: this.lng,
			draggable: true
		  };})
		 
	$('#spinner1').css('display', 'none');
  }

  	updateReport()
	  {
		//   if(notequal){
		// 	  inputJson[]=stuff in form
		//   }
		// let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":this.projectID, 'REPORT_ID':data.REPORT_ID};
		// inputJson[type+ "_ID"]=user[0].USER_ID
		// console.log(inputJson)
		// this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		// 	console.log(data);
		// 	this.getAllReportByGroup(this.groupkey);
		// })

	  }

	  addClient() {
		let inputJson = {
			"PROCEDURE": "insertcompanyclient", "USER_ID": parseInt(this.userId), "COMPANY_NAME": this.form.value.companyName, "ADDRESS_LINE1": this.clientAddress,
			"ADDRESS_LINE2": this.clientAddress2, "PROVSTATE":this.clientState, "POSTALZIP":this.clientZip, "CITY":this.clientCity, "COUNTY":this.clientCounty, "COUNTRY": this.clientCountry
			, "CONTACT_NAME": this.contactName, "CONTACT_TITLE": this.contactTitle, "CONTACT_PHONE": this.form.value.clientPhone, "CONTACT_EMAIL": this.form.value.clientEmail
		};
		console.log("addClient", inputJson);

		this.resetClientForm();
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.curSelectClient=data;
			this.updateClientID();
			this.newReport();
			this.getAllClientInfo(this.userId);
			
		});

	}
	resetcurSelectConsultant(){
		this.curSelectConsultant = null
	}
	changeClient() {
		let inputJson= {"PROCEDURE":"updateclient","USER_ID":parseInt(this.userId),"CLIENT_ID":this.curSelectClient.CLIENT_ID, "COMPANY_NAME": this.form.value.companyName, "ADDRESS_LINE1": this.clientAddress,
			"ADDRESS_LINE2": this.clientAddress2, "PROVSTATE":this.clientState, "POSTALZIP":this.clientZip, "CITY":this.clientCity, "COUNTY":this.clientCounty, "COUNTRY": this.clientCountry
			, "CONTACT_NAME": this.contactName, "CONTACT_TITLE": this.contactTitle, "CONTACT_PHONE": this.form.value.clientPhone, "CONTACT_EMAIL": this.form.value.clientEmail
		};
		console.log("changecliehnt", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log( data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getAllClientInfo(this.userId);
			// this.companyClients[this.clientRemoveIndex]=data;
		});
	}

	newReportPermission = false;
	checkNewReportPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 5};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.newReportPermission = false;
				
				// // close the modal. the timeout is to give it time to load. very hacky, find a better way lol
				setTimeout(() => { $('#reportsModal').modal('hide'); }, 250);
			} else {
				this.newReportPermission = true;
			}
		});
	}
	
	// separate function because setting project flag needs synchronous call
	toggleProjectPrivateFlag() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 45};

		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {

			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse);
				return;
			}

			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.setPrivateProjectPermission = false;
			} else {
				this.setPrivateProjectPermission = true;
			}

			if (this.setPrivateProjectPermission) {
				this.curProject.PRIVATE_FLAG = !this.curProject.PRIVATE_FLAG;
			}
		});
	}

	setPrivateProjectPermission = false;
	checkSetPrivateProjectPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 45};

		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {

			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse);
				return;
			}

			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.setPrivateProjectPermission = false;
			} else {
				this.setPrivateProjectPermission = true;
			}
		});
	}

	newReportValid = true;
	newReport2(){
		this.newReport();
	}
	newReport(){
		console.log("curProject", this.curProject)
		console.log(this.curTempCategories);
		console.log(this.originalData);
		console.log(this.curProject.PROJECT_NUMBER)
		console.log(this.curProject.PROJECT_NAME)
		// if (this.userId && (this.curProject.PROJECT_NUMBER != '' || this.curProject.PROJECT_NAME != '')) {
		if (this.userId && this.curProject.PROJECT_NUMBER != '') {
			let reports=[];
			let procedure="insertproject"
			for(let rpt of this.allTypeRpt){
				//if(rpt.selected){
					let r={ 
							// 'REPORT_ID':null,// or null for new, 
							'REPORT_ID': rpt.REPORT_ID, // null for new
							'REPORT_TITLE':rpt.selectedSubCat? rpt.selectedSubCat.subCategory:null, 
							'REPORT_CATEGORY':rpt.category,
							'TEMPLATE_ID':
							parseInt(rpt.selectedTemplate.TEMPLATE_ID), 
							...(this.companyGroupIndicator ? ({'GROUP_ID': rpt.selectedGroup != null ? rpt.selectedGroup.GROUP_ID : null}) : {}),
							"ASSESSOR_ID": rpt.userList.assessor.USER_ID,
							"ASSESSOR_TITLE": rpt.userList.assessortitle? rpt.userList.assessortitle.CODE_ID:null,
							"REVIEWER_ID": rpt.userList.reviewer.USER_ID,
							"REVIEWER_TITLE": rpt.userList.reviewertitle? rpt.userList.reviewertitle.CODE_ID:null,
							'ASSIGNED_USER_ID': rpt.userList.assigned_user.USER_ID,
							"PROJECT_MANAGER_ID":rpt.userList.pm?.USER_ID,
						}
					// if(this.originalData){
					// 	// let index=this.originalData.RW_REPORTS.findIndex(report=>report.REPORT_CATEGORY==rpt.category);console.log(index);
					// 	// let index2=this.originalData.RW_REPORTS.findIndex(report=>report.TEMPLATE[0].REPORT_TITLE==rpt.REPORT_TITLE);
					// 	let index=this.originalData.RW_REPORTS.findIndex(report=>report.TEMPLATE.length>0 && report.TEMPLATE[0].TEMPLATE_ID==rpt.selectedTemplate.TEMPLATE_ID);console.log(index);

					// 	if(index>-1&&this.originalData.RW_REPORTS[index].REPORT_TITLE==r.REPORT_TITLE){
					// 		r.REPORT_ID=this.originalData.RW_REPORTS[index].REPORT_ID;
					// 	}
					// }
					reports.push(r);
				//}
			}
			// console.log(this.curProject.PROJECT_NUMBER)
			// console.log(this.curProject.PROJECT_NAME)
			// console.log(this.curProject)
			// console.log(this.curSelectConsultant)
			let location_id 
			if(this.curSelectConsultant){
					location_id = this.curSelectConsultant.LOCATION_ID
			} else {
				location_id = null
				console.log(location_id)
			}
			let inputJson={
							"PROCEDURE":procedure, 
							"CLIENT_COMPANY_NAME": this.form.value.companyName, "CLIENT_ADDRESS_LINE1": this.clientAddress,
							"CLIENT_ADDRESS_LINE2": this.clientAddress2, "CLIENT_PROVSTATE": this.clientState, "CLIENT_POSTALZIP": this.clientZip, "CLIENT_CITY": this.clientCity, "CLIENT_COUNTY": this.clientCounty, "CLIENT_COUNTRY": this.clientCountry
							, "CLIENT_CONTACT_NAME": this.contactName, "CLIENT_CONTACT_TITLE": this.contactTitle, "CLIENT_CONTACT_PHONE": this.form.value.clientPhone, "CLIENT_CONTACT_EMAIL": this.form.value.clientEmail,
							"CO_CLIENT_COMPANY_NAME": this.form.value.cocompanyName, "CO_CLIENT_ADDRESS_LINE1": this.coclientAddress,
							"CO_CLIENT_ADDRESS_LINE2": this.coclientAddress2, "CO_CLIENT_PROVSTATE": this.coclientState, "CO_CLIENT_POSTALZIP": this.coclientZip, "CO_CLIENT_CITY": this.coclientCity, "CO_CLIENT_COUNTY": this.coclientCounty, "CO_CLIENT_COUNTRY": this.coclientCountry
							, "CO_CLIENT_CONTACT_NAME": this.cocontactName, "CO_CLIENT_CONTACT_TITLE": this.cocontactTitle, "CO_CLIENT_CONTACT_PHONE": this.form.value.coclientPhone, "CO_CLIENT_CONTACT_EMAIL": this.form.value.coclientEmail,
							"PO_NUMBER":this.curProject.PO_NUMBER,
							"USER_ID":parseInt(this.userId), 
							"PROJECT_ID":this.projectID, 
							"PORTFOLIO_ID":this.curProject.PORTFOLIO_ID, 
							'PORTFOLIO_NAME':this.curProject.PORTFOLIO_ID? null: this.newReportPortfolio,
							"PROPERTY_NAME":this.curProject.PROJECT_NAME,
							"PRIVATE_FLAG": this.curProject.PRIVATE_FLAG ? "Y" : "N",
							"PROJECT_NUMBER":this.curProject.PROJECT_NUMBER, 
							"ADDRESS_LINE1":this.street1, 
							"ADDRESS_LINE2":this.street2, 
							"CITY":this.city, 
							"PROVSTATE":this.state, 
							"POSTALZIP":this.postCode, 
							"COUNTY": this.curProject.PROPERTY_COUNTY,
							"COUNTRY":this.country, 
							"LONGITUDE":this.lng, 
							"LATITUDE":this.lat,
							'PROTOCOL': this.protocols[this.curRptPara.PROTOCOLS]? this.protocols[this.curRptPara.PROTOCOLS].CODE_ID: "",
							'SOW': this.curRptPara.SOW.FILE_URL,
							'TRANSACTION_TYPE': this.transactions[this.curRptPara.TRANSACTION_TYPE] ? this.transactions[this.curRptPara.TRANSACTION_TYPE].CODE_ID: "",
							"SITE_CONTACT_NAME":this.curProject.SITE_CONTACT_NAME,
							"SITE_CONTACT_RELATIONSHIP":this.curProject.SITE_CONTACT_RELATIONSHIP,
							"SITE_CONTACT_PHONE":this.form.value.siteContactPhone,
							"SITE_CONTACT_EMAIL":this.form.value.siteemailAddress,
							"ADD_SITE_CONTACT_NAME":this.curProject.ADD_SITE_CONTACT_NAME,
							"ADD_SITE_CONTACT_RELATIONSHIP":this.curProject.ADD_SITE_CONTACT_RELATIONSHIP,
							"ADD_SITE_CONTACT_PHONE":this.form.value.additionalsiteContactPhone,
							"ADD_SITE_CONTACT_EMAIL":this.form.value.additionalsiteemailAddress,
							"SITE_INSPECTION_INSTRUCTIONS":this.curProject.SITE_INSPECTION_INSTRUCTIONS,
							"CLIENT_PROVIDED_INFORMATION": this.curProject.CLIENT_PROVIDED_INFORMATION,
							//"TURN_TIME": this.date7,
							"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
							//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							"INSPECTION_DATE": this.getFormattedDate(this.date1),
							"FLOOD_ZONE_FEMA": this.curProject.FLOOD_ZONE,
							"METRO_STATISTISIC_AREA_MSA": this.curProject.MSA,
							"ZONING_DESIGNATION": this.curProject.ZONING,
							"PEAK_GROUND_ACCELERATION_PGA":this.curProject.PGA,
							"PARCEL_ID":this.parcelID,
							'RW_REPORTS':reports, 
							'ORDER_NUM':(this.curProject.erisOrder&&this.curProject.erisOrder.length>0)?this.curProject.erisOrder:null, 
							'LOCATION_ID': location_id,
							"CHARGE_AMOUNT":this.curProject.CHARGE_AMOUNT.trim(),
							"EXPENSE_AMOUNT":this.curProject.EXPENSE_AMOUNT.trim(),
							"TOTAL_AMOUNT":this.curProject.TOTAL_AMOUNT.trim(),
							
			};
			// console.log(this.curProject.PROJECT_NUMBER)
			// console.log(this.curProject.PROJECT_NAME)
			// console.log(this.curProject)
			console.log("newinputjson", inputJson)
			if(this.curProject.PROJECT_ID){
				inputJson.PROCEDURE="updateproject";
				inputJson.PROJECT_ID=this.curProject.PROJECT_ID;
			}
			//
			console.log(this.answers)
			console.log(this.questions)
			for(let i=0 ;i<this.questions.length;i++){
							if(this.answers[this.questions[i]]){
								inputJson[this.questions[i]]=this.answers[this.questions[i]];
							}else{
								inputJson[this.questions[i]]='';
							}
						}
						if(this.answers["ADDITIONAL_PROPERTY_INFORMATION"]){
						inputJson["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];	
						}else{
							inputJson["ADDITIONAL_PROPERTY_INFORMATION"]='';
						}
			//
			console.log(inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
				console.log("added", data);

				this.getAllPortfolios1() //gets the list of portfolios
				// if(data.PROJECT_ID>0){
				if (data.RESPONSE_STATUS == 'Y') {
					Swal.fire({
							icon: 'success',
							title: 'Project saved!',	
					});
					console.log(this.allTypeRpt)
					this.justAddedID=data.PROJECT_ID;
					//flag	
					if(this.tabFromVar=='ACTIVE'){
						console.log("NEW")
						//this.getAllReportByGroup(this.groupkey); //flag
						//this.getActiveReports()
						this.addNewToTable(data, this.curProject.PROJECT_NUMBER, inputJson )

					} else if(this.tabFromVar='PORTFOLIO'){
						this.getProjectforPortfolioV2()
					} else {
						this.getAllReportByGroup(this.groupkey);
						this.getProjectforPortfolioV2()
					}						
					// this.resetForm(''); this is unnecessary since it is called anyway when you click to open modal
					$('#reportsModal').modal('hide');
				} else {
					this.throwError(data);
				}

				this.newReportValid = true;

			});	
						
		} else {
			this.newReportValid = true;
			let info={'MESSAGE':'Missing Project No or Project Name!'};
			this.throwError(info);
		}
	}

	// this not used afaik
	newReport1(){
		console.log("curProject", this.curProject)
		console.log("new report", this.save)
		
		let procedure="insertproject"
		if(!this.save){
			//Find new reports here
			let one=false;
			let updatePCA=false;
			for(let rpt of this.curTempCategories){
				if(rpt.selected){
					one=true;
					let x=false;
					let y;
				
					for(let i=0; i<this.originalData.RW_REPORTS.length;i++){
						if(this.originalData.RW_REPORTS[i].REPORT_CATEGORY==rpt.category){
							x=true;
							y=i;
							break;
						}
					}

					if(!x){
						procedure="insertproject";
						let r={	
							'REPORT_ID':null,// or null for new, 
							'REPORT_TITLE':rpt.selectedSubCat? rpt.selectedSubCat.subCategory:null, 
							'REPORT_CATEGORY':rpt.category,
							'TEMPLATE_ID':parseInt(rpt.selectedTemplate.TEMPLATE_ID), 
							//'COVERPAGE_ID':parseInt(rpt.selectedTemplate.COVERPAGE_ID), 
							//'REPORT_URL':rpt.selectedTemplate.TEMPLATE_URL, 
							//'REPORT_DATA': rpt.selectedTemplate.TEMPLATE_DATA, 
							//'STATUS':"", 
							//'REPORT_ROLE': "",  
							//'ORDER_NUM': (this.curProject.erisOrder&&this.curProject.erisOrder.length>0)?this.curProject.erisOrder:null, 
							//'SHARED': "", 
							//'PERCENT_COMPLETE':null, 
							//"APPENDIX_LIST": rpt.selectedTemplate.APPENDIX_LIST,
							
							//"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
						//	"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							//"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							//"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							//"INSPECTION_DATE": this.getFormattedDate(this.date1),
							"ASSESSOR_ID": rpt.userList.assessor.USER_ID,
							"ASSESSOR_TITLE": rpt.userList.assessortitle.CODE_ID,
							"REVIEWER_ID": rpt.userList.reviewer.USER_ID,
							"REVIEWER_TITLE": rpt.userList.reviewertitle.CODE_ID,
							'ASSIGNED_USER_ID': rpt.userList.assigned_user.USER_ID,
							"PROJECT_MANAGER_ID":rpt.userList.pm?.USER_ID,
						}
						let inputJson={
							"PROCEDURE":procedure, 
							"CLIENT_COMPANY_NAME": this.form.value.companyName, "CLIENT_ADDRESS_LINE1": this.clientAddress,
							"CLIENT_ADDRESS_LINE2": this.clientAddress2, "CLIENT_PROVSTATE": this.clientState, "CLIENT_POSTALZIP": this.clientZip, "CLIENT_CITY": this.clientCity, "CLIENT_COUNTY": this.clientCounty, "CLIENT_COUNTRY": this.clientCountry
							, "CLIENT_CONTACT_NAME": this.contactName, "CLIENT_CONTACT_TITLE": this.contactTitle, "CLIENT_CONTACT_PHONE": this.form.value.clientPhone, "CLIENT_CONTACT_EMAIL": this.form.value.clientEmail,
							"CO_CLIENT_COMPANY_NAME": this.form.value.cocompanyName, "CO_CLIENT_ADDRESS_LINE1": this.coclientAddress,
							"CO_CLIENT_ADDRESS_LINE2": this.coclientAddress2, "CO_CLIENT_PROVSTATE": this.coclientState, "CO_CLIENT_POSTALZIP": this.coclientZip, "CO_CLIENT_CITY": this.coclientCity, "CO_CLIENT_COUNTY": this.coclientCounty, "CO_CLIENT_COUNTRY": this.coclientCountry
							, "CO_CLIENT_CONTACT_NAME": this.cocontactName, "CO_CLIENT_CONTACT_TITLE": this.cocontactTitle, "CO_CLIENT_CONTACT_PHONE": this.form.value.coclientPhone, "CO_CLIENT_CONTACT_EMAIL": this.form.value.coclientEmail,
							"USER_ID":parseInt(this.userId), 
							"PROJECT_ID":this.projectID, 
							"PORTFOLIO_ID":this.curProject.PORTFOLIO_ID, 
							'PORTFOLIO_NAME':this.curProject.PORTFOLIO_ID? null: this.newReportPortfolio,
							"PROPERTY_NAME":this.curProject.PROJECT_NAME, 
							"PROJECT_NUMBER":this.curProject.PROJECT_NUMBER, 
							"ADDRESS_LINE1":this.street1, 
							"ADDRESS_LINE2":this.street2, 
							"CITY":this.city, 
							"PROVSTATE":this.state, 
							"POSTALZIP":this.postCode, 
							"COUNTY": this.curProject.PROPERTY_COUNTY,
							"COUNTRY":this.country, 
							"LONGITUDE":this.lng, 
							"LATITUDE":this.lat,
							'PROTOCOL': this.protocols[this.curRptPara.PROTOCOLS]? this.protocols[this.curRptPara.PROTOCOLS].CODE_ID: "",
							'SOW': this.curRptPara.SOW.FILE_URL,
							'TRANSACTION_TYPE': this.transactions[this.curRptPara.TRANSACTION_TYPE] ? this.transactions[this.curRptPara.TRANSACTION_TYPE].CODE_ID: "",
							"SITE_CONTACT_NAME":this.curProject.SITE_CONTACT_NAME,
							"SITE_CONTACT_RELATIONSHIP":this.curProject.SITE_CONTACT_RELATIONSHIP,
							"SITE_CONTACT_PHONE":this.form.value.siteContactPhone,
							"SITE_CONTACT_EMAIL":this.form.value.siteemailAddress,
							"ADD_SITE_CONTACT_NAME":this.curProject.ADD_SITE_CONTACT_NAME,
							"ADD_SITE_CONTACT_RELATIONSHIP":this.curProject.ADD_SITE_CONTACT_RELATIONSHIP,
							"ADD_SITE_CONTACT_PHONE":this.form.value.additionalsiteContactPhone,
							"ADD_SITE_CONTACT_EMAIL":this.form.value.additionalsiteemailAddress,
							"SITE_INSPECTION_INSTRUCTIONS":this.curProject.SITE_INSPECTION_INSTRUCTIONS,
							"CLIENT_PROVIDED_INFORMATION": this.curProject.CLIENT_PROVIDED_INFORMATION,
							//"CLIENT_ID": this.curProject.CLIENT_ID,
						//	"CO_CLIENT_ID": this.curProject.CO_CLIENT_ID,
							//"TURN_TIME": this.date7,
							"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
							//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							"INSPECTION_DATE": this.getFormattedDate(this.date1),
							"FLOOD_ZONE_FEMA": this.curProject.FLOOD_ZONE,
							"METRO_STATISTISIC_AREA_MSA": this.curProject.MSA,
							"ZONING_DESIGNATION": this.curProject.ZONING,
							"PEAK_GROUND_ACCELERATION_PGA":this.curProject.PGA,
							"PARCEL_ID":this.parcelID,
							'RW_REPORTS':[r] 
						};
						for(let i=0 ;i<this.questions.length;i++){
							inputJson[this.questions[i]]=this.answers[this.questions[i]];
						}
						inputJson["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];	
						console.log("newinputjson", inputJson)
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
							console.log("insertReport",data);	
							/*if(!updatePCA){
								let input={"PROCEDURE":"updatepropertyquestions","USER_ID":parseInt(this.userId),"PROJECT_ID":data.PROJECT_ID,}
								for(let i=0 ;i<this.questions.length;i++){
									input[this.questions[i]]=this.answers[this.questions[i]];
								}
								input["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];
								this.reportService.univeralService(JSON.stringify(input)).subscribe(data=>{
						
									console.log("update questions", data)
									updatePCA=true;
									if(data.RESPONSE_STATUS=='Y'){
										Swal.fire({
														icon: 'success',
														html: data.MESSAGE,
														
													});
											}else{
												Swal.fire({
													html: '<p style="font-size:16px; color:red">'+data.MESSAGE+'</p>',
													});
												}
								})
							}*/	
							//find group it should be in and isnert			
							// if(this.groupkey=='PROJECT_NUMBER'){
							// 	console.log("isnerting")
							// 	for(let i=0; i<this.reports.length;i++){
							// 		let x=false;;
							// 		for(let j=0;j<this.reports[i].RW_REPORTS.length;j++){
							// 			if(this.reports[i].RW_REPORTS[j].PROJECT_ID==data.PROJECT_ID){
							// 				console.log("match", this.reports[i].RW_REPORTS[j]);
							// 				if(this.reports[i].RW_REPORTS.length==0){
							// 					this.reports[i].GROUP_COUNT=1;
							// 					x=true;
												
							// 				}
							// 				this.reports[i].RW_REPORTS=data.RW_REPORTS;
									
							// 				break;
							// 			}
							// 		}
							// 		if(x){
							// 			break;
							// 		}
							// 	}
							// 	this.toTreeData();
							// }
						});
					
					}
					if(x)
					{
						procedure="updateproject";
						let r={	
							'REPORT_ID':this.originalData.RW_REPORTS[y].REPORT_ID,// or null for new, 
							'REPORT_TITLE':rpt.selectedSubCat? rpt.selectedSubCat.subCategory:null,
							'REPORT_CATEGORY':rpt.category,
							'TEMPLATE_ID':parseInt(rpt.selectedTemplate.TEMPLATE_ID),
							"ASSESSOR_ID": rpt.userList.assessor.USER_ID,
							"ASSESSOR_TITLE": rpt.userList.assessortitle? rpt.userList.assessortitle.CODE_ID: null,
							"REVIEWER_ID": rpt.userList.reviewer.USER_ID,
							"REVIEWER_TITLE": rpt.userList.reviewertitle? rpt.userList.reviewertitle.CODE_ID: null,
							'ASSIGNED_USER_ID': rpt.userList.assigned_user.USER_ID,
							"PROJECT_MANAGER_ID":rpt.userList.pm?.USER_ID,
						}
						let inputJson={
							"PROCEDURE":procedure, 
							"CLIENT_COMPANY_NAME": this.form.value.companyName, "CLIENT_ADDRESS_LINE1": this.clientAddress,
							"CLIENT_ADDRESS_LINE2": this.clientAddress2, "CLIENT_PROVSTATE": this.clientState, "CLIENT_POSTALZIP": this.clientZip, "CLIENT_CITY": this.clientCity, "CLIENT_COUNTY": this.clientCounty, "CLIENT_COUNTRY": this.clientCountry
							, "CLIENT_CONTACT_NAME": this.contactName, "CLIENT_CONTACT_TITLE": this.contactTitle, "CLIENT_CONTACT_PHONE": this.form.value.clientPhone, "CLIENT_CONTACT_EMAIL": this.form.value.clientEmail,
							"CO_CLIENT_COMPANY_NAME": this.form.value.cocompanyName, "CO_CLIENT_ADDRESS_LINE1": this.coclientAddress,
							"CO_CLIENT_ADDRESS_LINE2": this.coclientAddress2, "CO_CLIENT_PROVSTATE": this.coclientState, "CO_CLIENT_POSTALZIP": this.coclientZip, "CO_CLIENT_CITY": this.coclientCity, "CO_CLIENT_COUNTY": this.coclientCounty, "CO_CLIENT_COUNTRY": this.coclientCountry
							, "CO_CLIENT_CONTACT_NAME": this.cocontactName, "CO_CLIENT_CONTACT_TITLE": this.cocontactTitle, "CO_CLIENT_CONTACT_PHONE": this.form.value.coclientPhone, "CO_CLIENT_CONTACT_EMAIL": this.form.value.coclientEmail,
							"USER_ID":parseInt(this.userId), 
							"PROJECT_ID":this.projectID, 
						 "PORTFOLIO_ID":this.curProject.PORTFOLIO_ID, 
						 'PORTFOLIO_NAME':this.curProject.PORTFOLIO_ID? null: this.newReportPortfolio,
							"PROPERTY_NAME":this.curProject.PROJECT_NAME, 
							"PROJECT_NUMBER":this.curProject.PROJECT_NUMBER, 
							"ADDRESS_LINE1":this.street1, 
							"ADDRESS_LINE2":this.street2, 
							"CITY":this.city, 
							"PROVSTATE":this.state, 
							"POSTALZIP":this.postCode, 
							"COUNTY": this.curProject.PROPERTY_COUNTY,
							"COUNTRY":this.country, 
							"LONGITUDE":this.lng, 
							"LATITUDE":this.lat,
							'PROTOCOL': this.protocols[this.curRptPara.PROTOCOLS]? this.protocols[this.curRptPara.PROTOCOLS].CODE_ID: "",
							'SOW': this.curRptPara.SOW.FILE_URL,
							'TRANSACTION_TYPE': this.transactions[this.curRptPara.TRANSACTION_TYPE] ? this.transactions[this.curRptPara.TRANSACTION_TYPE].CODE_ID: "",
							"SITE_CONTACT_NAME":this.curProject.SITE_CONTACT_NAME,
							"SITE_CONTACT_RELATIONSHIP":this.curProject.SITE_CONTACT_RELATIONSHIP,
							"SITE_CONTACT_PHONE":this.form.value.siteContactPhone,
							"SITE_CONTACT_EMAIL":this.form.value.siteemailAddress,
							"ADD_SITE_CONTACT_NAME":this.curProject.ADD_SITE_CONTACT_NAME,
							"ADD_SITE_CONTACT_RELATIONSHIP":this.curProject.ADD_SITE_CONTACT_RELATIONSHIP,
							"ADD_SITE_CONTACT_PHONE":this.form.value.additionalsiteContactPhone,
							"ADD_SITE_CONTACT_EMAIL":this.form.value.additionalsiteemailAddress,
							"SITE_INSPECTION_INSTRUCTIONS":this.curProject.SITE_INSPECTION_INSTRUCTIONS,
							"CLIENT_PROVIDED_INFORMATION": this.curProject.CLIENT_PROVIDED_INFORMATION,
						//	"CLIENT_ID": this.curProject.CLIENT_ID,
						//	"CO_CLIENT_ID": this.curProject.CO_CLIENT_ID,
							//"TURN_TIME": this.date7,
							//"REPORT_DUE_DATE":this.date5,
							//"REVISED_REPORT_DATE":this.date6,
							//"REVIEWER_DUE_DATE": this.date2,
							//"ASSESSOR_DUE_DATE": this.date3,
							//"INSPECTION_DATE": this.date1,
							"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
							//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							"INSPECTION_DATE": this.getFormattedDate(this.date1),
							"FLOOD_ZONE_FEMA": this.curProject.FLOOD_ZONE,
							"METRO_STATISTISIC_AREA_MSA": this.curProject.MSA,
							"ZONING_DESIGNATION": this.curProject.ZONING,
							"PEAK_GROUND_ACCELERATION_PGA":this.curProject.PGA,
							"PARCEL_ID":this.parcelID,
							'RW_REPORTS':[r] 
							/*'REPORT_ID':this.originalData.RW_REPORTS[y].REPORT_ID,
							'REPORT_TITLE':rpt.selectedSubCat? rpt.selectedSubCat.subCategory:null, 
							// 'REPORT_TYPE':rpt.category,
							'TEMPLATE_ID':parseInt(rpt.selectedTemplate.TEMPLATE_ID), 
							'COVERPAGE_ID':parseInt(rpt.selectedTemplate.COVERPAGE_ID), 
							'REPORT_URL':rpt.selectedTemplate.TEMPLATE_URL, 
							'REPORT_DATA': rpt.selectedTemplate.TEMPLATE_DATA, 

							'ORDER_NUM': (this.curProject.erisOrder&&this.curProject.erisOrder.length>0)?this.curProject.erisOrder:null, 

							//'PERCENT_COMPLETE':null, 
							"APPENDIX_LIST": rpt.selectedTemplate.APPENDIX_LIST,
							"ASSESSOR_ID": rpt.userList.assessor.USER_ID,
							"ASSESSOR_TITLE":  rpt.userList.assessortitle? rpt.userList.assessortitle.CODE_ID: null,
							"REVIEWER_ID": rpt.userList.reviewer.USER_ID,
							"REVIEWER_TITLE": rpt.userList.reviewertitle? rpt.userList.reviewertitle.CODE_ID: null,
							'ASSIGNED_USER_ID': rpt.userList.assigned_user.USER_ID,*/
						}
						for(let i=0 ;i<this.questions.length;i++){
							inputJson[this.questions[i]]=this.answers[this.questions[i]];
						}
						inputJson["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];	
												console.log("newinputjson", inputJson)
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
							console.log("updatereport",response);
							if(response.RESPONSE_STATUS=='Y'){
								let index=this.reportTreeData.findIndex(row=>row.data.PROJECT_ID==response.PROJECT_ID); console.log(index);
								
							/*if(!updatePCA){
								let input={"PROCEDURE":"updatepropertyquestions","USER_ID":parseInt(this.userId),"PROJECT_ID":response.PROJECT_ID}
								for(let i=0 ;i<this.questions.length;i++){
									input[this.questions[i]]=this.answers[this.questions[i]];
								}
								input["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];
								this.reportService.univeralService(JSON.stringify(input)).subscribe(data=>{
						
									console.log("update questions", data)
									updatePCA=true;
									if(data.RESPONSE_STATUS=='Y'){
										Swal.fire({
														icon: 'success',
														html: data.MESSAGE,
														
													});
											}else{
												Swal.fire({
													html: '<p style="font-size:16px; color:red">'+data.MESSAGE+'</p>',
													});
												}
								})
							}*/
							}else{
								this.throwError(response)			
							}
							//find group it should be in and replace
								// for(let i=0; i<this.reports.length;i++){
								// 	for(let j=0;j<this.reports[i].RW_REPORTS.length;j++){
								// 		if(this.reports[i].RW_REPORTS[j].REPORT_ID==data.REPORT_ID){
								// 			console.log("match", this.reports[i].RW_REPORTS[j]);

								// 			this.reports[i].RW_REPORTS[j]=data;
								// 			this.toTreeData();
								// 			break;
								// 		}
								// 	}
								// }
						});

					}
				}
			}
			if(!one){
				//Need to do request here

				procedure="updateproject"
						let inputJson={
							"PROCEDURE":procedure, 
							"CLIENT_COMPANY_NAME": this.form.value.companyName, "CLIENT_ADDRESS_LINE1": this.clientAddress,
							"CLIENT_ADDRESS_LINE2": this.clientAddress2, "CLIENT_PROVSTATE": this.clientState, "CLIENT_POSTALZIP": this.clientZip, "CLIENT_CITY": this.clientCity, "CLIENT_COUNTY": this.clientCounty, "CLIENT_COUNTRY": this.clientCountry
							, "CLIENT_CONTACT_NAME": this.contactName, "CLIENT_CONTACT_TITLE": this.contactTitle, "CLIENT_CONTACT_PHONE": this.form.value.clientPhone, "CLIENT_CONTACT_EMAIL": this.form.value.clientEmail,
							"CO_CLIENT_COMPANY_NAME": this.form.value.cocompanyName, "CO_CLIENT_ADDRESS_LINE1": this.coclientAddress,
							"CO_CLIENT_ADDRESS_LINE2": this.coclientAddress2, "CO_CLIENT_PROVSTATE": this.coclientState, "CO_CLIENT_POSTALZIP": this.coclientZip, "CO_CLIENT_CITY": this.coclientCity, "CO_CLIENT_COUNTY": this.coclientCounty, "CO_CLIENT_COUNTRY": this.coclientCountry
							, "CO_CLIENT_CONTACT_NAME": this.cocontactName, "CO_CLIENT_CONTACT_TITLE": this.cocontactTitle, "CO_CLIENT_CONTACT_PHONE": this.form.value.coclientPhone, "CO_CLIENT_CONTACT_EMAIL": this.form.value.coclientEmail,
							"USER_ID":parseInt(this.userId), 
							"PROJECT_ID":this.projectID, 
							 "PORTFOLIO_ID":this.curProject.PORTFOLIO_ID, 
							 'PORTFOLIO_NAME':this.curProject.PORTFOLIO_ID? null: this.newReportPortfolio,
							"PROPERTY_NAME":this.curProject.PROJECT_NAME, 
							"PROJECT_NUMBER":this.curProject.PROJECT_NUMBER, 
							"ADDRESS_LINE1":this.street1, 
							"ADDRESS_LINE2":this.street2, 
							"CITY":this.city, 
							"PROVSTATE":this.state, 
							"POSTALZIP":this.postCode, 
							"COUNTY": this.curProject.PROPERTY_COUNTY,
							"COUNTRY":this.country, 
							"LONGITUDE":this.lng, 
							"LATITUDE":this.lat,
							'PROTOCOL': this.protocols[this.curRptPara.PROTOCOLS]? this.protocols[this.curRptPara.PROTOCOLS].CODE_ID: "",
							'SOW': this.curRptPara.SOW.FILE_URL,
							'TRANSACTION_TYPE': this.transactions[this.curRptPara.TRANSACTION_TYPE] ? this.transactions[this.curRptPara.TRANSACTION_TYPE].CODE_ID: "",
							"SITE_CONTACT_NAME":this.curProject.SITE_CONTACT_NAME,
							"SITE_CONTACT_RELATIONSHIP":this.curProject.SITE_CONTACT_RELATIONSHIP,
							"SITE_CONTACT_PHONE":this.form.value.siteContactPhone,
							"SITE_CONTACT_EMAIL":this.form.value.siteemailAddress,
							"ADD_SITE_CONTACT_NAME":this.curProject.ADD_SITE_CONTACT_NAME,
							"ADD_SITE_CONTACT_RELATIONSHIP":this.curProject.ADD_SITE_CONTACT_RELATIONSHIP,
							"ADD_SITE_CONTACT_PHONE":this.form.value.additionalsiteContactPhone,
							"ADD_SITE_CONTACT_EMAIL":this.form.value.additionalsiteemailAddress,
							"SITE_INSPECTION_INSTRUCTIONS":this.curProject.SITE_INSPECTION_INSTRUCTIONS,
							"CLIENT_PROVIDED_INFORMATION": this.curProject.CLIENT_PROVIDED_INFORMATION,
					//		"CLIENT_ID": this.curProject.CLIENT_ID,
					//		"CO_CLIENT_ID": this.curProject.CO_CLIENT_ID,
							//"TURN_TIME": this.date7,
							//"REPORT_DUE_DATE":this.date5,
							//"REVISED_REPORT_DATE":this.date6,
							//"REVIEWER_DUE_DATE": this.date2,
							//"ASSESSOR_DUE_DATE": this.date3,
							//"INSPECTION_DATE": this.date1,
							"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
							//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							"INSPECTION_DATE": this.getFormattedDate(this.date1),
							"FLOOD_ZONE_FEMA": this.curProject.FLOOD_ZONE,
							"METRO_STATISTISIC_AREA_MSA": this.curProject.MSA,
							"ZONING_DESIGNATION": this.curProject.ZONING,
							"PEAK_GROUND_ACCELERATION_PGA":this.curProject.PGA,
							"PARCEL_ID":this.parcelID,

							'ORDER_NUM': (this.curProject.erisOrder&&this.curProject.erisOrder.length>0)?this.curProject.erisOrder:null, 

							//'PERCENT_COMPLETE':null, 
						}
						for(let i=0 ;i<this.questions.length;i++){
							inputJson[this.questions[i]]=this.answers[this.questions[i]];
						}
						inputJson["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];		
						console.log("newinputjson", inputJson)
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
							console.log("no report update test", data);
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)
																
							}
							/*if(!updatePCA){
								let input={"PROCEDURE":"updatepropertyquestions","USER_ID":parseInt(this.userId),"PROJECT_ID":data.PROJECT_ID,}
								for(let i=0 ;i<this.questions.length;i++){
									input[this.questions[i]]=this.answers[this.questions[i]];
								}
								input["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];
								this.reportService.univeralService(JSON.stringify(input)).subscribe(data=>{
						
									console.log("update questions", data)
									updatePCA=true;
								if(data.RESPONSE_STATUS=='Y'){
								Swal.fire({
												icon: 'success',
												html: data.MESSAGE,
												
											});
									}else{
										Swal.fire({
											html: '<p style="font-size:16px; color:red">'+data.MESSAGE+'</p>',
											});
										}
								})
							}*/
							
							//Depends on backend result here
			});
			}
			// this.justAddedID=this.projectID;
			$('#reportsModal').modal('hide');
			
			
			 this.getAllReportByGroup(this.groupkey);

			return;
		}
		console.log("transaction,protocl", this.protocols[this.curRptPara.TRANSACTION_TYPE], this.transactions[this.curRptPara.PROTOCOLS])
		console.log("transaction,protocl",this.protocols, this.transactions)
		console.log(this.curProject)
		
		/*let addrss=this.street1;
		let city=this.city;
		let provstate=this.state;
		let postalzip=this.postCode;
		let country=this.country;
		let lat=this.lat;
		let lng=this.lng;*/


		// APPENDIX_LIST: ""
		// COVERPAGE_ID: null
		// TEMPLATE_DATA: "[{\"SECTION_TITLE\":\"EXECUTIVE SUMMARY\",\"SECTI
		// TEMPLATE_ID: 22
		// TEMPLATE_TITLE: "hj"
		// TEMPLATE_TYPE_ID: 7
		// TEMPLATE_URL: ""
		// if (this.curTempCategoriesselectedSubCat== ''|| this.curProject.PROJECT_NAME != '')
		if (this.userId && (this.curProject.PROJECT_NUMBER != '' || this.curProject.PROJECT_NAME != '')) {
			let reports=[];//(list of all new or existing Reports for this project) – REPORT_ID:1 or null for new, REPORT_TITLE: "abc", TEMPLATE_ID:1, COVERPAGE_ID:1, REPORT_URL:"http:abc", REPORT_DATA: "abc", STATUS:"abc", REPORT_ROLE: "abc", ORDER_NUM: "28272829", ASSIGNED_USERS: "abc", SHARED: "Y", PERCENT_COMPLETE:10, PROTOCOLS: "abc", SOW: "abc", TRANSACTION_TYPE: "abc", DATE_CREATED: "DD-MON-YY"
			for(let rpt of this.curTempCategories){
				// if(rpt.selected && (!rpt.selectedSubCat || !rpt.selectedTemplate.TEMPLATE_ID)){
				// 	console.log(rpt.selectedSubCat, rpt.selectedTemplate.TEMPLATE_ID, rpt)
				// 	Swal.fire({
				// 		icon: 'error',
				// 		title: 'Missing Template Information!',
				// 	});
				// 	return;
				// }
				if(rpt.selected){
					console.log("rpt", rpt);
					
					let r={	
						'REPORT_ID':null,// or null for new, 
						'REPORT_TITLE':rpt.selectedSubCat? rpt.selectedSubCat.subCategory: null, 
						'REPORT_CATEGORY':rpt.category,
						'TEMPLATE_ID':parseInt(rpt.selectedTemplate.TEMPLATE_ID), 
						//'COVERPAGE_ID':parseInt(rpt.selectedTemplate.COVERPAGE_ID), 
						//'REPORT_URL':rpt.selectedTemplate.TEMPLATE_URL, 
						//'REPORT_DATA': rpt.selectedTemplate.TEMPLATE_DATA, 
						//'STATUS':"", 
						//'REPORT_ROLE': "",  
						//'ORDER_NUM': (this.curProject.erisOrder&&this.curProject.erisOrder.length>0)?this.curProject.erisOrder:null, 
						//'SHARED': "", 
						//'PERCENT_COMPLETE':null, 
						//"APPENDIX_LIST": rpt.selectedTemplate.APPENDIX_LIST,
						//"REPORT_DUE_DATE":this.date5,
						//"REVISED_REPORT_DATE":this.date6,
						//"REVIEWER_DUE_DATE": this.date2,
						//"ASSESSOR_DUE_DATE": this.date3,
						//"INSPECTION_DATE": this.date1,
							//"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
							//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
							//"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
							//"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
							//"INSPECTION_DATE": this.getFormattedDate(this.date1),
						"ASSESSOR_ID": rpt.userList.assessor.USER_ID,
						"ASSESSOR_TITLE": rpt.userList.assessortitle.CODE_ID,
						"REVIEWER_ID": rpt.userList.reviewer.USER_ID,
						"REVIEWER_TITLE": rpt.userList.reviewertitle.CODE_ID,
						'ASSIGNED_USER_ID': rpt.userList.assigned_user.USER_ID,
						//"DATE_CREATED": "", // placeholder
						//"DATE_UPDATED": "", // placeholder
						//"UPDATED_BY": "", // placeholder
					}
					reports.push(r);
				}
			}	
			console.log("newreports", reports);
			let inputJson={
				"PROCEDURE":procedure, 
				"CLIENT_COMPANY_NAME": this.form.value.companyName, "CLIENT_ADDRESS_LINE1": this.clientAddress,
				"CLIENT_ADDRESS_LINE2": this.clientAddress2, "CLIENT_PROVSTATE": this.clientState, "CLIENT_POSTALZIP": this.clientZip, "CLIENT_CITY": this.clientCity, "CLIENT_COUNTY": this.clientCounty, "CLIENT_COUNTRY": this.clientCountry
				, "CLIENT_CONTACT_NAME": this.contactName, "CLIENT_CONTACT_TITLE": this.contactTitle, "CLIENT_CONTACT_PHONE": this.form.value.clientPhone, "CLIENT_CONTACT_EMAIL": this.form.value.clientEmail,
				"CO_CLIENT_COMPANY_NAME": this.form.value.cocompanyName, "CO_CLIENT_ADDRESS_LINE1": this.coclientAddress,
				"CO_CLIENT_ADDRESS_LINE2": this.coclientAddress2, "CO_CLIENT_PROVSTATE": this.coclientState, "CO_CLIENT_POSTALZIP": this.coclientZip, "CO_CLIENT_CITY": this.coclientCity, "CO_CLIENT_COUNTY": this.coclientCounty, "CO_CLIENT_COUNTRY": this.coclientCountry
				, "CO_CLIENT_CONTACT_NAME": this.cocontactName, "CO_CLIENT_CONTACT_TITLE": this.cocontactTitle, "CO_CLIENT_CONTACT_PHONE": this.form.value.coclientPhone, "CO_CLIENT_CONTACT_EMAIL": this.form.value.coclientEmail,
				"USER_ID":parseInt(this.userId), 
				"PROJECT_ID":null, 
				"PORTFOLIO_ID":this.curProject.PORTFOLIO_ID, 
				'PORTFOLIO_NAME':this.curProject.PORTFOLIO_ID? null: this.newReportPortfolio,
				"PROPERTY_NAME":this.curProject.PROJECT_NAME, 
				"PROJECT_NUMBER":this.curProject.PROJECT_NUMBER, 
				"ADDRESS_LINE1":this.street1, 
				"ADDRESS_LINE2":this.street2, 
				"CITY":this.city, 
				"PROVSTATE":this.state, 
				"POSTALZIP":this.postCode, 
				"COUNTY": this.curProject.PROPERTY_COUNTY,
				"COUNTRY":this.country, 
				"LONGITUDE":this.lng, 
				"LATITUDE":this.lat,
				"PARCEL_ID":this.parcelID,
				'PROTOCOL': this.protocols[this.curRptPara.PROTOCOLS]? this.protocols[this.curRptPara.PROTOCOLS].CODE_ID: "",
				'SOW': this.curRptPara.SOW.FILE_URL,
				'TRANSACTION_TYPE': this.transactions[this.curRptPara.TRANSACTION_TYPE] ? this.transactions[this.curRptPara.TRANSACTION_TYPE].CODE_ID: "",
				"SITE_CONTACT_NAME":this.curProject.SITE_CONTACT_NAME,
				"SITE_CONTACT_RELATIONSHIP":this.curProject.SITE_CONTACT_RELATIONSHIP,
				"SITE_CONTACT_PHONE":this.form.value.siteContactPhone,
				"SITE_CONTACT_EMAIL":this.form.value.siteemailAddress,
				"ADD_SITE_CONTACT_NAME":this.curProject.ADD_SITE_CONTACT_NAME,
				"ADD_SITE_CONTACT_RELATIONSHIP":this.curProject.ADD_SITE_CONTACT_RELATIONSHIP,
				"ADD_SITE_CONTACT_PHONE":this.form.value.additionalsiteContactPhone,
				"ADD_SITE_CONTACT_EMAIL":this.form.value.additionalsiteemailAddress,
				"SITE_INSPECTION_INSTRUCTIONS":this.curProject.SITE_INSPECTION_INSTRUCTIONS,
				"CLIENT_PROVIDED_INFORMATION": this.curProject.CLIENT_PROVIDED_INFORMATION,
			//	"CLIENT_ID": this.curProject.CLIENT_ID,
			//	"CO_CLIENT_ID": this.curProject.CO_CLIENT_ID,
				//"TURN_TIME": this.date7,
				//"REPORT_DUE_DATE":this.date5,
				//"REVISED_REPORT_DATE":this.date6,
				//"REVIEWER_DUE_DATE": this.date2,
				//"ASSESSOR_DUE_DATE": this.date3,
				//"INSPECTION_DATE": this.date1,
				"REPORT_DUE_DATE": this.getFormattedDate(this.date5),
				//"REVISED_REPORT_DATE": this.getFormattedDate(this.date6),
				"REVIEWER_DUE_DATE": this.getFormattedDate(this.date2),
				"ASSESSOR_DUE_DATE": this.getFormattedDate(this.date3),
				"INSPECTION_DATE": this.getFormattedDate(this.date1),
				"FLOOD_ZONE_FEMA": this.curProject.FLOOD_ZONE,
				"METRO_STATISTISIC_AREA_MSA": this.curProject.MSA,
				"ZONING_DESIGNATION": this.curProject.ZONING,
				"PEAK_GROUND_ACCELERATION_PGA":this.curProject.PGA,
				"DATE_CREATED": "", // placeholder
				"DATE_UPDATED": "", // placeholder
				"UPDATED_BY": "", // placeholder
				'RW_REPORTS':reports 
			};
			// perhaps write function here to populate allTypeRpt[] 
			console.log(inputJson);
		
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
				$('#reportsModal').modal('hide');
				console.log("added", data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				if(data.PROJECT_ID>0){
					Swal.fire({
							icon: 'success',
							title: 'Project saved!',
							
						});
						this.justAddedID=data.PROJECT_ID;
						let input={"PROCEDURE":"insertpropertyquestions","USER_ID":parseInt(this.userId),"PROJECT_ID":data.PROJECT_ID,}
						for(let i=0 ;i<this.questions.length;i++){
							input[this.questions[i]]=this.answers[this.questions[i]];
						}
						input["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];
						this.reportService.univeralService(JSON.stringify(input)).subscribe(data=>{
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)
								return										
							}
							console.log("update questions", data)
						})
						// if(false && this.groupkey=='PROJECT_NUMBER'){
						// 	let report={"GROUP_LABEL": data.PROJECT_NUMBER, "GROUP_COUNT":data.RW_REPORTS.length==0? "No Reports": data.RW_REPORTS.length, "RW_REPORTS":data.RW_REPORTS}
						// 	this.reports.push(report);
						// 	this.toTreeData();
						// }else{
							this.getAllReportByGroup(this.groupkey);
						// }
						// this.getAllReportByGroup(this.groupkey);
				}

			this.resetForm('');
			});
		} else {
			let info={'MESSAGE':'Missing Project No or Project Name!'}
			this.throwError(info)
		}



	
	}
	display(x){
		console.log(x)
	}
	selectType(index,e, array=this.allTypeRpt){
		console.log(array)
		console.log('TEST',this.allTypeRpt)
		//this.allTypeRpt
		//if($(e.target).prop('checked')){//console.log(type.REPORT_TYPE.TYPE_ID);
		//console.log(this.allTypeRpt[0].REPORT_TYPE.TYPE_ID);
			//$(e.target).siblings('div').css('display','block');
			//let index=this.allTypeRpt.findIndex(rpt=>{rpt.REPORT_TYPE.TYPE_ID==type.REPORT_TYPE.TYPE_ID});console.log(index)
			array[index].selected=true;
			console.log('SELECTED FLAG')
			console.log('SELECTED',array[index])
			if (array == this.allTypeRpt) {
				array[index].REPORT_TITLE=this.curProject.PROJECT_NAME+array[index].types.REPORT_TYPE;
				console.log(this.allTypeRpt)
			}
			/*let report={
				REPORT_ID:null,// or null for new, 
				REPORT_TYPE:type,
				REPORT_TITLE:null, 
				TEMPLATE_ID:null, 
				COVERPAGE_ID:null, 
				REPORT_URL:null, 
				REPORT_DATA: null, 
				STATUS:null, 
				REPORT_ROLE: null, 
				ORDER_NUM: null, 
				ASSIGNED_USERS: null, 
				SHARED: null, 
				PERCENT_COMPLETE:null, 
				PROTOCOLS: null, 
				SOW: null, 
				TRANSACTION_TYPE: null, 
				DATE_CREATED: null,
				selected:false
			}*/
			//this.curProject.RW_REPORTS.push(report)
		//}else{
			//$(e.target).siblings('div').css('display','none');
			//let index=this.allTypeRpt.findIndex(rpt=>{rpt.REPORT_TYPE.TYPE_ID==type.REPORT_TYPE.TYPE_ID});
		//	array[index].selected=false;
		//	//this.allTypeRpt.splice(index,1);
		//}
	}

	selectAllReports(event) {
		let that = this;
		this.setDisplaySections(7);
		
		if(this.checkall){
			this.checkall=false;
			$('.classChk').each(function(){
				$(this).prop("checked", true);
				$(this).siblings('div').css('display','block');
				for(let cat of that.curTempCategories){
					cat.selected = true;
					that.setSubCat(cat);
					that.clearInvite2(cat.userList);
					// rpt.REPORT_TITLE=this.curProject.PROJECT_NAME+rpt.types.REPORT_TYPE;
				}
			})
		}else{
			this.checkall=true;
			$('.classChk').each(function() {
				$(this).prop("checked", false);
				$(this).siblings('div').css('display','none');
				for(let cat of that.curTempCategories){
					cat.selected=false;
				}
			})
			
		}
	}

	selectAllType(e){
		let that = this;
		if(this.checkall){
			this.checkall=false;
			$('.classChk').each(function(){
				$(this).prop("checked", true);
				$(this).siblings('div').css('display','block');
				for(let rpt of that.allTypeRpt){
					console.log('SELECTED FLAG')
					rpt.selected=true
					rpt.REPORT_TITLE=that.curProject.PROJECT_NAME+rpt.types.REPORT_TYPE;
			
				}
			})
		}else{
			this.checkall=true;
			$('.classChk').each(function() {
				$(this).prop("checked", false);
				$(this).siblings('div').css('display','none');
				for(let rpt of that.allTypeRpt){
					rpt.selected=false;
				}
			})
			
		}
	}
	uploadFile2(rowdata){
		console.log("rowdata",rowdata)
		let that=this;
		this.uploadFiles=0;
		this.uploadNo=0;
		const files = $("#"+this.currentRowData.REPORT_ID.toString()+"x").prop("files"); console.log(files);
		if(files.length==0){
			this.loading=false;
		return
		}
		for (let file of files){  //for multiple files
			const ext = file.name.replace(/.+\./, '');
		   if (this.acceptType.indexOf(ext) === -1) {
			   Swal.fire('Oops...', ext + ' file Type is not acceptable.');
			   this.loading=false;
			   return;
		   }
	   }
		const total=files.length;
		this.uploadNo=total;
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userId,"report_id":rowdata.REPORT_ID,"project_id":rowdata.PROJECT_ID,"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.uploadedFiles.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
										
				})		
			console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		} 
  }
  public uploadImage(rowdata) {console.log(rowdata);
	let that=this;
	console.log("Test")
	this.uploadFiles=0;
		this.uploadNo=0;
    //const file = $(rowdata.REPORT_ID.toString()).files[0];
	const files = $("#"+rowdata.REPORT_ID.toString())[0].files; console.log(files);
    /*$(rowdata.REPORT_ID.toString()).value = null;
    const ext = file.name.replace(/.+\./, '');
    if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG'].indexOf(ext) === -1) {
      Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg', 'error');
      return;
    }*/
	 if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){console.log(files[0]);
      //$(rowdata.REPORT_ID.toString()).value = null;
      const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable.');
			this.loading=false;
			return;
		}
    }
    //this.fileReader.readAsDataURL(file);
	for (let file of files)  //for multiple files
    {   
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
					
			if(that.uploadType=='BKIMAGE'){console.log('bk image');
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++	
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
								
			})
			}else if(that.uploadType=='PHOTO'){console.log('report image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
								
			})
			}else if(that.uploadType=='IMAGE'){console.log('other image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='LOGO'){console.log('LOGO image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":rowdata.REPORT_ID.toString(),"project_id":rowdata.PROJECT_ID.toString(),"file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}
			console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		}
		this.getAllBk(rowdata.PROJECT_ID, rowdata.REPORT_ID)
  }
	public uploadFile(){
		let that=this;
		$('#inputWarn').css('display', 'none');
		$('#inputSuccess').css('display', 'none');
		const file = this.rptFile.nativeElement.files[0];console.log(file)
		if(!file){			
			$('#inputWarn').css('display', 'inline-block');
			return
		}
		
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable.');
			return;
		}
		$('#spinner').css('display', 'inline-block');
    //this.fileReader.readAsDataURL(file);
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let data = e.target.result.toString().split(',')[1];; console.log(data)//upload service
			//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; console.log(inputJson)
			let inputJson={"filename":file.name,"order_num":"","reportID":"","r":that.r,"desc":"","fdata":data, "user_id":parseInt(that.userId), "FILE_TYPE":"PROJECT_SOW"}
			that.reportService.uploadFile2(inputJson).subscribe(result=>{
				console.log("result", result);
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara.SOW=result;
				 console.log("SOW", that.curRptPara.SOW);
				that.rptFile.nativeElement.value = null;
				$('#spinner').css('display', 'none');
				$('#inputSuccess').css('display', 'inline-block');
				that.curRptPara.name='Choose File';
			})
			//.error
		}
		reader.readAsDataURL(file);
  
	}
	locate(){
		$('#spinner1').css('display', 'inline-block');
		let list=[this.city,this.state,this.postCode,this.country];console.log(list)
		let address=this.street1;
		for(let l of list){console.log(l)
			if(l.length>0){
				address +=','+l;
			}
		}
		console.log("address:"+address);
		this.getAddress(address,'',false);
		$('#map-input').val(address);
		$('#map-input').focus();
		$( ".test").focus();
		$('#spinner1').css('display', 'none');
	}
	locate2(){
		$('#spinner1').css('display', 'inline-block');
		let list=[this.city,this.state,this.postCode,this.country];console.log(list)
		let address=this.street1;
		for(let l of list){console.log(l)
			if(l.length>0){
				address +=','+l;
			}
		}
		console.log("address:"+address);
		this.getAddress2(address,'',false);
		$('#map-input').val(address);
		$('#map-input').focus();
		$( ".test").focus();
		$('#spinner1').css('display', 'none');
	}
	mapToggle(status){
		if(status=='small'){
			this.largeMap=true;
			$('#summaryContainer').css('display','none');
			$('#mapContainer').removeClass('mapInfo');
			$('#mapContainer').addClass('mapInfo1');
			$('#test').removeClass('googleMap');
			$('#test').addClass('googleMap1');
		}else{
			this.largeMap=false;
			$('#summaryContainer').css('display','block');
			$('#mapContainer').removeClass('mapInfo1');
			$('#mapContainer').addClass('mapInfo');
			$('#test').removeClass('googleMap1');
			$('#test').addClass('googleMap');
		}
		
	}
	selectFile(){
		this.rptFile.nativeElement.click();
	}
	getName(){
		this.curRptPara.name = this.rptFile.nativeElement.files[0].name;
	}
	//excel;
	excelJson;
	rawExcelJson;
	excelCols;
	excelArray;
	changeCol(){
	}
	sheet1;
	uploadBatchFrom
	
	//ACTIVE
	resetUpload(from){
		this.uploadBatchFrom = from;
		this.portfolioName='';
		if(from =='PORTFOLIO'){
			console.log('port', this.portfolioDisplayName)
			if(this.portfolioDisplayName !== null) {
				this.portfolioName = this.portfolioDisplayName;
			}
		}
		if(from =='ACTIVE'){
			console.log(from)
		}
		this.sheet1=''
		this.excelJson=null; this.excelCols=[];
		this.rawExcelJson=null;
		this.excelArray=null;
		this.sheets=[];
		this.selectedSheet='';

	}
	newReportPortfolio
	resetSheet(){
		this.excelJson=null; this.excelCols=[];
		if (this.uploadBatchFrom == 'PORTFOLIO' && this.portfolioDisplayName !== null) {
			this.portfolioName = this.portfolioDisplayName;
		} else {
			this.portfolioName='';			
		}
		//this.rawExcelJson=null;
		this.excelArray=null;
	}
	presetCols=["PROJECT_NUMBER", 'PROPERTY_NAME', 'ADDRESS_LINE1', 'ADDRESS_LINE2','CITY','PROVSTATE',"POSTALZIP","COUNTY","COUNTRY",
	"CLIENT_COMPANY_NAME",	"CLIENT_ADDRESS_LINE1",	"CLIENT_ADDRESS_LINE2",	"CLIENT_CITY",
	"CLIENT_PROVSTATE",	"CLIENT_POSTALZIP",	"CLIENT_CONTACT_NAME",	"CLIENT_CONTACT_TITLE", "CLIENT_CONTACT_EMAIL","CLIENT_CONTACT_PHONE", "CLIENT_COUNTRY"];
	//presetCols=[]
	uploadExcel(){
		console.log("uploadExcel")

		let that=this;
		const file = this.excelFile.nativeElement.files[0];
		console.log(file)
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable.');
			return;
		}
    //this.fileReader.readAsDataURL(file);
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			const data = reader.result;
			let workBook = XLSX.read(data, { type: 'binary' });
			let jsonData = workBook.SheetNames.reduce((initial, name) => {
			  const sheet = workBook.Sheets[name];
			  initial[name] = XLSX.utils.sheet_to_json(sheet);
			  return initial;
			}, {});
			//const dataString = JSON.stringify(jsonData);
			console.log(jsonData);

			for(var key in jsonData){
				if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
					that.sheets.push(key);
				}
			}
		//	that.selectedSheet=that.sheets[0]
			that.rawExcelJson=jsonData;
		//	that.resetSheet();
		//	that.selectSheet()

		
		  }
		  reader.readAsBinaryString(file);
	}
	portfolioName;
	selectedSheet
	selectSheet(){
		let array=[];
		for(let project of this.rawExcelJson[this.selectedSheet]){
			for (var key in project) {
				if (Object.prototype.hasOwnProperty.call(project, key)) {
				
						array.indexOf(key) === -1 ? array.push(key) : console.log("");
				//	}
					
				}
			}
		}
		this.excelArray=array;
		for(let col of array){
			this.excelCols.push({'header':col, "changeHeader":col});
		}

		this.excelJson=this.rawExcelJson[this.selectedSheet];
		//that.uploadBatchProjects(jsonData['Sample Data']);
	}
	hasDuplicates(array) {
		return (new Set(array)).size !== array.length;
	}
	sheets=[];
	uploadPortfolioName
	uploadBatchProjectsPermission = false;
	checkUploadBatchProjectsPermission() {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 5};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.uploadBatchProjectsPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { $('#import').modal('hide'); }, 250);
			} else {
				this.uploadBatchProjectsPermission = true;
			}

		});
	}
	uploadBatchProjects(){
		console.log(this.portfolioName)
		console.log(this.uploadBatchFrom)
		this.ngZone.run(()=>{this.loading=true;})
		// if(this.uploadBatchFrom=='ACTIVE' || this.portfolioDisplayName===null){
		// 	this.uploadPortfolioName = this.portfolioName
		// } else if(this.uploadBatchFrom=='PORTFOLIO' && this.portfolioDisplayName!==null){
		// 	this.uploadPortfolioName = this.portfolioDisplayName
		// }
		this.uploadPortfolioName = this.portfolioName;
		let inputJson={"PROCEDURE":"batchuploadprojects","USER_ID":parseInt(this.userId),"PORTFOLIO_NAME": this.uploadPortfolioName, "RW_PROJECTS":this.excelJson}

		console.log(inputJson);

		let array=[];
		for(let col of this.excelCols){
			array.push(col.changeHeader);
			
		}
		if(!array.every(val => this.presetCols.includes(val))|| this.hasDuplicates(array)){
			let info={'MESSAGE':'Repeated/invalid column labels'};
			this.throwError(info)
			this.ngZone.run(()=>{this.loading=false;})
			return;
		}
		for(let col of this.excelCols){
			if(col.header!=col.changeHeader){
				for(let project of this.excelJson){
					delete Object.assign(project, {[col.changeHeader]: project[col.header] })[col.header];
				}
			}
		}
		$('#import').modal('hide');
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
			{
			console.log(data);
			this.portfolioName="";
			if(this.tabFromVar=='ACTIVE'){
				this.getActiveReports()
				//this.getAllReportByGroup(this.groupkey);
			} else if(this.tabFromVar='PORTFOLIO'){
				this.getProjectforPortfolioV2()
			} else {
				this.getActiveReports()
				//this.getAllReportByGroup(this.groupkey);
				this.getProjectforPortfolioV2()
			}
			
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
			}else{
				Swal.fire({
					html: data.MESSAGE,
				})
				this.totalrecords=data.REPORT_TOTAL;				
			}
			this.ngZone.run(()=>{this.loading=false;})
			
		})
	}
	tabFromVar
	tabFrom(from){
		this.tabFromVar = from
		if (from == 'ACTIVE') this.curProject.PORTFOLIO_ID = null;
		console.log('TABFROM',this.tabFromVar)
	}
	resetForm(from){
		this.checkErisData();
		this.newReportPortfolio=""
		this.newEditClient=false;
		this.parcelOn=false;
		this.parcelID="";
		this.resetMap();
		this.mapInputAddress=""
		this.resetClientForm();
		this.resetCoClientForm();
		this.answers={};
		this.projectID=null;
		// this.show('collapse1');
		// this.hide('inner-collapse1'); this.hide('inner-collapse2');
		this.save=true;
		this.form.reset();
		$('#inputWarn').css('display', 'none');
		$('#inputSuccess').css('display', 'none');
		this.street1='';
		this.street2='';
		this.city='';
		this.state='';
		this.postCode='';
		this.country='';
		this.date1 = null;
		this.date2 = null;
		this.date3 = null;
		// this.date4 = null; no longer needed
		this.date5 = null;
		//this.date6 = null;
		//this.date7 = '';
		this.checkall = true;
		let project_portfolio
		if(from == 'PORTFOLIO'){
			project_portfolio = this.selectedPortfolio
		} else if (from == 'ACTIVE'){
			project_portfolio = null
		} else {
			project_portfolio = null
		}
		console.log(from)
		this.curProject={
			'USER_ID':null, 
			'PROJECT_ID':null,//or null for new, 
			'PORTFOLIO_ID': project_portfolio, //this.selectedPortfolio
			'PROJECT_NAME': '', 
			'PROJECT_NUMBER': '', 
			'PRIVATE_FLAG': false,
			'ADDRESS': null, 
			'CITY': null, 
			'PROVSTATE': null,
			'POSTALZIP': null,
			'COUNTRY': null, 
			'PROPERTY_COUNTY': '',
			'FLOOD_ZONE': '',
			'MSA': '',
			'PGA': '',
			'ZONING': '',
			'LONGITUDE':null, 
			'LATITUDE':null, 
			'RW_REPORTS':[],
			"SITE_CONTACT_NAME":"",
			"SITE_CONTACT_RELATIONSHIP":"",
			"SITE_CONTACT_PHONE":"",
			"SITE_CONTACT_EMAIL":"",
			"ADD_SITE_CONTACT_NAME":"",
			"ADD_SITE_CONTACT_RELATIONSHIP":"",
			"ADD_SITE_CONTACT_PHONE":"",
			"ADD_SITE_CONTACT_EMAIL":"",
			"SITE_INSPECTION_INSTRUCTIONS":"",
			"CLIENT_ID": "", 
			"CO_CLIENT_ID": "", 
			"TURN_TIME": "",
			"REPORT_DUE_DATE": "", 
			"REVISED_REPORT_DATE": "", 
			"REVIEWER_DUE_DATE": "", 
			"ASSESSOR_DUE_DATE": "",
			"INSPECTION_DATE": "", 
			"CLIENT_COMPANY_NAME":"",
			"CLIENT_CO_COMPANY_NAME":"",
			"PO_NUMBER":"",
			"CLIENT_ADDRESS":"",
			"CLIENT_CITY":"",
			"CLIENT_PROVSTATE":"",
			"CLIENT_COUNTRY":"",
			"CLIENT_POSTALZIP":"",
			"CLIENT_CONTACT_NAME":"",
			"CLIENT_CONTACT_TITLE":"",
			"CLIENT_CONTACT_PHONE":"",
			"CLIENT_CONTACT_EMAIL":"",
			"CLIENT_PROVIDED_INFORMATION":"",
			'PROTOCOL': "", 
			'SOW': "", 
			'TRANSACTION_TYPE': "",
			'erisOrder':'',
			"CHARGE_AMOUNT":"",
			"EXPENSE_AMOUNT":"",
			"TOTAL_AMOUNT":"",
		};
		this.curCoSelectClient = null;
		this.curSelectClient = null;
		this.curRptPara={
			'TRANSACTION_TYPE':'',
			'PROTOCOLS':'',
			'ASSIGNED_USERS':"",
			'SOW':{'FILE_URL':''},
			'name':'Choose File',
		}
		
		for (let i = 0; i <9; ++i ) {
			this.displaySections[i] = false;
		}
		this.enabledDisplayInfo = false;

		console.log(this.markers);
		// resets map 
		const pos = {
			lat:this.default_lat,
			lng:this.default_lng,
		}
		this.zoom=3;
		this.lat=null;
		this.lng=null
		// this.ngZone.run(()=>{ this.markers[0]={
		// 	lat: this.lat,
		// 	lng: this.lng,
		// 	draggable: true
		//   };})
		this.markers = [];
		
		this.curTempCategories = [];
		for (let obj of this.categoryList) {
			let rpt={
				category:obj.CATEGORY,
				subCategories:null,
				typeIdTemplates:null,
				selectedSubCat:null,
				selectedTemplate:"",
				...(this.companyGroupIndicator ? {selectedGroup:null,} : {}),
				userList: {
					assessor:"",
					assessortitle:{},
					reviewertitle:{},
					reviewer:"",
					assigned_user:"",
					pm:'',
				},
				selected:false, 
			}
			this.setSubCat(rpt);
			this.curTempCategories.push(rpt);
		}

		this.allTypeRpt=[];
		// console.log(this.allTypeRpt)
		// 	for(let type of this.types){
		// 		let rpt={
		// 			REPORT_ID:null,// or null for new, 
		// 			types:type,
		// 			REPORT_TITLE:null, 
		// 			TEMPLATE_ID:null, 
		// 			COVERPAGE_ID:null, 
		// 			REPORT_URL:null, 
		// 			REPORT_DATA: null, 
		// 			STATUS:null, 
		// 			REPORT_ROLE: null, 
		// 			ORDER_NUM: null, 
		// 			ASSIGNED_USERS: null, 
		// 			SHARED: null, 
		// 			PERCENT_COMPLETE:null, 
		// 			//PROTOCOL: null, 
		// 			//SOW: null, 
		// 			//TRANSACTION_TYPE: null, 
		// 			DATE_CREATED: null,
		// 			selected:false
		// 		}
		// 		this.allTypeRpt.push(rpt);
		// 	}
		// 	console.log("serachelement", this.searchElementRef)
		// this.searchElementRef.nativeElement.value='';
	}

	// this is not used anywhere as far is i can tell:
	resetForm1(){
		this.newReportPortfolio=""
		this.newEditClient=false;
		this.parcelOn=false;
		this.parcelID="";
		this.resetMap();
		this.mapInputAddress=""
		this.resetClientForm();
		this.resetCoClientForm();
		this.answers={};
		//this.form.resetForm();
		this.curTempCategories=[];
			for(let type of this.types){
				let rpt={
					REPORT_ID:null,// or null for new, 
					types:type,
					REPORT_TITLE:null, 
					TEMPLATE_ID:null, 
					COVERPAGE_ID:null, 
					REPORT_URL:null, 
					REPORT_DATA: null, 
					STATUS:null, 
					REPORT_ROLE: null, 
					ORDER_NUM: null, 
					ASSIGNED_USERS: null, 
					SHARED: null, 
					//PERCENT_COMPLETE:null, 
					//PROTOCOL: null, 
					//SOW: null, 
					//TRANSACTION_TYPE: null, 
					DATE_CREATED: null,
					selected:false
				}
				this.curTempCategories.push(rpt);
			}
	}
	resetForm2(callback){
		console.log(callback)
		//this.allTypeRpt = []
		this.newReportPortfolio=""
		this.newEditClient=false;
		this.parcelOn=false;
		this.parcelID="";
		this.resetMap();
		this.mapInputAddress=""
		this.resetClientForm();
		this.resetCoClientForm();
		this.answers={};
		this.projectID=null;
		// this.show('collapse1');
		// this.hide('inner-collapse1'); this.hide('inner-collapse2');
		this.save=true;
		this.form.reset();
		$('#inputWarn').css('display', 'none');
		$('#inputSuccess').css('display', 'none');
		this.street1='';
		this.street2='';
		this.city='';
		this.state='';
		this.postCode='';
		this.country='';
		this.date1 = null;
		this.date2 = null;
		this.date3 = null;
		// this.date4 = null; no longer needed
		this.date5 = null;
		//this.date6 = null;
		//this.date7 = '';
		this.checkall = true;

		this.curProject={
			'USER_ID':null, 
			'PROJECT_ID':null,//or null for new, 
			'PORTFOLIO_ID':null, 
			'PROJECT_NAME': '', 
			'PROJECT_NUMBER': '', 
			'PRIVATE_FLAG': false,
			'ADDRESS': null, 
			'CITY': null, 
			'PROVSTATE': null,
			'POSTALZIP': null,
			'COUNTRY': null, 
			'PROPERTY_COUNTY': '',
			'FLOOD_ZONE': '',
			'MSA': '',
			'PGA': '',
			'ZONING': '',
			'LONGITUDE':null, 
			'LATITUDE':null, 
			'RW_REPORTS':[],
			"SITE_CONTACT_NAME":"",
			"SITE_CONTACT_RELATIONSHIP":"",
			"SITE_CONTACT_PHONE":"",
			"SITE_CONTACT_EMAIL":"",
			"ADD_SITE_CONTACT_NAME":"",
			"ADD_SITE_CONTACT_RELATIONSHIP":"",
			"ADD_SITE_CONTACT_PHONE":"",
			"ADD_SITE_CONTACT_EMAIL":"",
			"SITE_INSPECTION_INSTRUCTIONS":"",
			"CLIENT_ID": "", 
			"CO_CLIENT_ID": "", 
			"TURN_TIME": "",
			"REPORT_DUE_DATE": "", 
			"REVISED_REPORT_DATE": "", 
			"REVIEWER_DUE_DATE": "", 
			"ASSESSOR_DUE_DATE": "",
			"INSPECTION_DATE": "", 
			"CLIENT_COMPANY_NAME":"",
			"CLIENT_CO_COMPANY_NAME":"",
			"PO_NUMBER":"",
			"CLIENT_ADDRESS":"",
			"CLIENT_CITY":"",
			"CLIENT_PROVSTATE":"",
			"CLIENT_COUNTRY":"",
			"CLIENT_POSTALZIP":"",
			"CLIENT_CONTACT_NAME":"",
			"CLIENT_CONTACT_TITLE":"",
			"CLIENT_CONTACT_PHONE":"",
			"CLIENT_CONTACT_EMAIL":"",
			"CLIENT_PROVIDED_INFORMATION":"",
			'PROTOCOL': "", 
			'SOW': "", 
			'TRANSACTION_TYPE': "",
			'erisOrder':'',
			"CHARGE_AMOUNT":"",
			"EXPENSE_AMOUNT":"",
			"TOTAL_AMOUNT":"",
		};
		this.curCoSelectClient = null;
		this.curSelectClient = null;
		this.curRptPara={
			'TRANSACTION_TYPE':'',
			'PROTOCOLS':'',
			'ASSIGNED_USERS':"",
			'SOW':{'FILE_URL':''},
			'name':'Choose File',
		}
		
		for (let i = 0; i <9; ++i ) {
			this.displaySections[i] = false;
		}
		this.enabledDisplayInfo = false;

		console.log(this.markers);
		// resets map 
		const pos = {
			lat:this.default_lat,
			lng:this.default_lng,
		}
		this.zoom=3;
		this.lat=null
		this.lng=null
		// this.ngZone.run(()=>{ this.markers[0]={
		// 	lat: this.lat,
		// 	lng: this.lng,
		// 	draggable: true
		//   };})
		  console.log("?");
		this.markers = [];
		
		this.curTempCategories = [];
		for (let obj of this.categoryList) {
			let rpt={
				category:obj.CATEGORY,
				subCategories:null,
				typeIdTemplates:null,
				selectedSubCat:null,
				selectedTemplate:"",
				...(this.companyGroupIndicator ? {selectedGroup:null,} : {}),
				userList: {
					assessor:"",
					assessortitle:{},
					reviewertitle:{},
					reviewer:"",
					assigned_user:"",
					pm:'',
				},
				selected:false, 
			}
			this.setSubCat2(rpt, callback);
			this.curTempCategories.push(rpt);
		}

		this.allTypeRpt=[];
		// 	for(let type of this.types){
		// 		let rpt={
		// 			REPORT_ID:null,// or null for new, 
		// 			types:type,
		// 			REPORT_TITLE:null, 
		// 			TEMPLATE_ID:null, 
		// 			COVERPAGE_ID:null, 
		// 			REPORT_URL:null, 
		// 			REPORT_DATA: null, 
		// 			STATUS:null, 
		// 			REPORT_ROLE: null, 
		// 			ORDER_NUM: null, 
		// 			ASSIGNED_USERS: null, 
		// 			SHARED: null, 
		// 			PERCENT_COMPLETE:null, 
		// 			//PROTOCOL: null, 
		// 			//SOW: null, 
		// 			//TRANSACTION_TYPE: null, 
		// 			DATE_CREATED: null,
		// 			selected:false
		// 		}
		// 		this.allTypeRpt.push(rpt);
		// 	}
		// 	console.log("serachelement", this.searchElementRef)
		// this.searchElementRef.nativeElement.value='';
	}
	changeAssi(data){
		
	}
	/*addToProject(data){
		console.log(data);
		$('#inputWarn').css('display', 'none');
		$('#inputSuccess').css('display', 'none');
		this.street1=data.ADDRESS;
		this.city=data.CITY;
		this.state=data.PROVSTATE;
		this.postCode=data.POSTALZIP;
		this.country=data.COUNTRY;
		this.lat=data.LATITUDE;
		this.lng=data.LONGITUDE;
		this.curProject={
			'USER_ID':null, 
			'PROJECT_ID':data.PROJECT_ID,//or null for new, 
			'PORTFOLIO_ID':data.PORTFOLIO[0].PORTFOLIO_ID, 
			'PROJECT_NAME': data.PROJECT_NAME, 
			'PROJECT_NUMBER': data.PROJECT_NUMBER, 
			'ADDRESS': data.ADDRESS, 
			'CITY': data.CITY, 
			'PROVSTATE': data.PROVSTATE,
			'POSTALZIP': data.POSTALZIP,
			'COUNTRY': data.COUNTRY, 
			'PROPERTY_COUNTY': null, // placeholder
			'FLOOD_ZONE': null, // placeholder
			'MSA': null, // placeholder
			'PGA': null, // placeholder
			'ZONING': null, // placeholder
			'LONGITUDE':data.LONGITUDE, 
			'LATITUDE':data.LATITUDE, 
			'RW_REPORTS':[],
			//'SITE_CONTACT':data.SITE_CONTACT,
			"SITE_CONTACT_NAME":data.SITE_CONTACT_NAME,
			"SITE_CONTACT_RELATIONSHIP":data.SITE_CONTACT_RELATIONSHIP,
			"SITE_CONTACT_PHONE":data.SITE_CONTACT_PHONE,
			"SITE_CONTACT_EMAIL":data.SITE_CONTACT_EMAIL,
			"ADD_SITE_CONTACT_NAME":data.ADD_SITE_CONTACT_NAME,
			"ADD_SITE_CONTACT_RELATIONSHIP":data.ADD_SITE_CONTACT_RELATIONSHIP,
			"ADD_SITE_CONTACT_PHONE":data.ADD_SITE_CONTACT_PHONE,
			"ADD_SITE_CONTACT_EMAIL":data.ADD_SITE_CONTACT_EMAIL,
			"SITE_INSPECTION_INSTRUCTIONS":data.SITE_INSPECTION_INSTRUCTIONS,
			"CLIENT_ID": null, // placeholder
			"CO_CLIENT_ID": null, // placeholder
			"TURN_TIME": "", // placeholder
			"REPORT_DUE_DATE": "", // placeholder
			"REVISED_REPORT_DATE": "", // placeholder
			"REVIEWER_DUE_DATE": "", // placeholder
			"ASSESSOR_DUE_DATE": "", // placeholder
			"INSPECTION_DATE": "", // placeholder
			"CLIENT_COMPANY_NAME":data.CLIENT_COMPANY_NAME,
			"CLIENT_CO_COMPANY_NAME":data.CLIENT_CO_COMPANY_NAME,
			"CLIENT_ADDRESS":data.CLIENT_ADDRESS,
			"CLIENT_CITY":data.CLIENT_CITY,
			"CLIENT_PROVSTATE":data.CLIENT_PROVSTATE,
			"CLIENT_POSTALZIP":data.CLIENT_POSTALZIP,
			"CLIENT_CONTACT_NAME":data.CLIENT_CONTACT_NAME,
			"CLIENT_CONTACT_TITLE":data.CLIENT_CONTACT_TITLE,
			"CLIENT_CONTACT_PHONE":data.CLIENT_CONTACT_PHONE,
			"CLIENT_CONTACT_EMAIL":data.CLIENT_CONTACT_EMAIL,
			"CLIENT_PROVIDED_INFORMATION":data.CLIENT_PROVIDED_INFORMATION,
			'PROTOCOL': data.PROTOCOL, 
			'SOW': data.SOW, 
			'TRANSACTION_TYPE': data.TRANSACTION_TYPE,
			'erisOrder':null,
		};
		this.curProject.erisOrder=data.ORDER_NUM;
		//console.log(this.transactions.findIndex(pro=>pro.CODE_VALUE==reportArray[0].TRANSACTION_TYPE));
		//console.log(this.protocols.findIndex(pro=>pro.CODE_VALUE==reportArray[0].PROTOCOL));
		this.curRptPara={
			'TRANSACTION_TYPE':data.TRANSACTION_TYPE,
			'PROTOCOLS':data.PROTOCOL,
			'ASSIGNED_USERS':data.SITE_CONTACT,
			'SOW':{'FILE_URL':''},
			'name':'Choose File',
		}
		console.log(this.curRptPara);
		this.allTypeRpt=[];
		for(let type of this.types){
				let rpt={
					REPORT_ID:null,// or null for new, 
					types:type,
					REPORT_TITLE:null, 
					TEMPLATE_ID:null, 
					COVERPAGE_ID:null, 
					REPORT_URL:null, 
					REPORT_DATA: null, 
					STATUS:null, 
					REPORT_ROLE: null, 
					ORDER_NUM: null, 
					ASSIGNED_USERS: null, 
					SHARED: null, 
					//PERCENT_COMPLETE:null, 
					//PROTOCOL: null, 
					//SOW: null, 
					//TRANSACTION_TYPE: null, 
					DATE_CREATED: null,
					selected:false
				}
				this.allTypeRpt.push(rpt);
			
		}
		console.log(this.allTypeRpt);
		for(let report of reportArray){
			let typeIndex=this.allTypeRpt.findIndex(rpt=>rpt.types.REPORT_TYPE==report.REPORT_TYPE);console.log(typeIndex)
			let rpt=this.allTypeRpt[typeIndex];
			if(typeIndex>-1){
				rpt.REPORT_ID=report.REPORT_ID;
				rpt.REPORT_TITLE=report.REPORT_TITLE;
				rpt.TEMPLATE_ID=report.TEMPLATE_ID;
				rpt.COVERPAGE_ID=report.COVERPAGE_ID;
				rpt.REPORT_URL=report.REPORT_URL;
				rpt.REPORT_DATA=report.REPORT_DATA;
				rpt.STATUS=report.STATUS;
				rpt.REPORT_ROLE=report.REPORT_ROLE;
				rpt.ORDER_NUM=report.ORDER_NUM;
				rpt.ASSIGNED_USERS=report.ASSIGNED_USERS;
				rpt.SHARED=report.SHARED;
				rpt.PERCENT_COMPLETE=report.PERCENT_COMPLETE;
				rpt.PROTOCOL=report.PROTOCOL;
				rpt.SOW=report.SOW;
				rpt.TRANSACTION_TYPE=report.TRANSACTION_TYPE;
				rpt.DATE_CREATED=report.DATE_CREATED;
				rpt.selected=true;				
			}
		}
		// $('#reportModal').modal('show');
	}*/
	deleteProject2(id){
		for(let i=0; i<this.reports.length;i++){
			for(let j=0;j<this.reports[i].RW_REPORTS.length;j++){
				if(this.reports[i].RW_REPORTS[j].PROJECT_ID==id){
					console.log("match", this.reports[i].RW_REPORTS[j]);
					if(this.reports[i].RW_REPORTS.length==1){
						this.reports[i].GROUP_COUNT="No Reports";
		
					}else{
						this.reports[i].RW_REPORTS.splice(j, 1);console.log(this.reports);
						j--;
						console.log("delete", this.reports[i].RW_REPORTS);
					}
				}
			}
		}
	}
	deleteProject(id){ //flag
		//this.toTreeData();
		let inputJson={"PROCEDURE":"deleteproject", "USER_ID": parseInt(this.userId), "PROJECT_ID":id};
		console.log("deleteProject", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			//Return fields – "STATUS":”Y” or “N”, "MESSAGE":” Deletion of Project was successful" or “Project_id does not exist”
			if(data.RESPONSE_STATUS=='Y'){
				Swal.fire({
					title:data.MESSAGE,
					timer: 2000,
					showConfirmButton:false,
				})
				if(this.tabFromVar=='ACTIVE'){
					this.getAllReportByGroup(this.groupkey);
				} else if(this.tabFromVar=='PORTFOLIO'){
					this.getProjectforPortfolioV2()
				} else {
					this.getAllReportByGroup(this.groupkey);
					this.getProjectforPortfolioV2()
				}
            
			}else {
				this.throwError(data);
			}
		})

	}
	addOrder(rowdata, e){ 
		// let orderno=$(e.target).prev('input').val()?$(e.target).prev('input').val().trim():$(e.target).parent().prev('input').val().trim();console.log(orderno);
		let orderno=rowdata.ORDER_NUM;
		console.log(rowdata);
		let inputJson={"PROCEDURE":"updatereport", "USER_ID":parseInt(this.userId), "PROJECT_ID":rowdata.PROJECT_ID, "PORTFOLIO_ID":rowdata.PORTFOLIO_ID, 'REPORT_ID':rowdata.REPORT_ID, "ORDER_NUM":orderno};
			console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("ORDERREPORTSHERE", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			rowdata.ORDER_REPORTS=data.ORDER_REPORTS;
			// this.getAllReportByGroup(this.groupkey);
			// let index=this.reports.findIndex(proj=>proj.PROJECT_ID==data.PROJECT_ID);console.log(index)
			// if(index>-1){
			// 	let rpts=this.reports[index].RW_REPORTS;
			// 	let index2=rpts.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);//console.log(index2)
			// 	this.reports[index].RW_REPORTS[index2].ORDER_NUM=data.ORDER_NUM;//console.log(this.reports)
			// 	this.reports[index].RW_REPORTS[index2].ORDER_REPORTS=data.ORDER_REPORTS;
			// 	this.toTreeData();
			// }
		})
		
	}
	compareFn(c1, c2): boolean {
		return c1 && c2 && c1.CODE_ID==c2.CODE_ID
	}
	changeTemplate(data){
		console.log(this.catToChange);
		let index=this.catToChange.typeIdTemplates.findIndex(temp=>temp.TEMPLATE_ID==this.catToChange.selectedTemplate.TEMPLATE_ID);
		if(index>-1){
			this.catToChange.selectedTemplate=this.catToChange.typeIdTemplates[index];
			
		}
		data.TEMPLATE[0]=this.catToChange.selectedTemplate;
		data.flat.TEMPLATE=data.TEMPLATE[0].TEMPLATE_TITLE,
		console.log("flat",data.flat);
		//data.REPORT_TITLE=this.catToChange.selectedTemplate.SUBCATEGORY_NAME;
		let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, 'TEMPLATE_ID':this.catToChange.selectedTemplate.TEMPLATE_ID, 'REPORT_TITLE':this.catToChange.selectedTemplate.SUBCATEGORY_NAME};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getAllReportByGroup(this.groupkey);
		})

	}
	changeTitle(assessor, data){
		console.log(data)
		console.log(data.REVIEWER_TITLE[0])
		console.log(assessor)
		if(assessor){
			let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, "ASSESSOR_TITLE":data.ASSESSOR_TITLE[0].CODE_ID};
			console.log("changeTitle", inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				// this.getAllReportByGroup(this.groupkey);
			})

		}else{
			let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, "REVIEWER_TITLE":data.REVIEWER_TITLE[0].CODE_ID};
			console.log("changeTitle", inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				// this.getAllReportByGroup(this.groupkey);
			})
		}
	}
	changeReportTitle(data){
		let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, 'REPORT_TITLE': data.REPORT_TITLE};
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			// this.getAllReportByGroup(this.groupkey);
		})
	}

	assignUserPermission = false;
	checkAssignUserPermission(report_id) {
		this.assignUserPermission = false;

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":report_id, "FUNCTION_ID": 4};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				this.assignUserPermission = false;
			} else {
				this.assignUserPermission = true;
			}

		});
	}

	addAssignedUser(data, user){console.log(data, user)
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":data.REPORT_ID, "FUNCTION_ID": 4};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				console.log(data);
				let inputJson={"PROCEDURE":"addassigneduser","USER_ID":parseInt(this.userId),"REPORT_ID":data.REPORT_ID,"ASSIGNED_USER_ID":user.USER_ID}
				console.log(inputJson)
				data.USER_TO_ADD=null;
				//data.flat['ASSIGNED_USERS'].push(user.FULL_NAME);
				//data.flat['ASSIGNED_USERS_ID'].push(user.USER_ID);

				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data2 => {
					console.log(data2);
					if (data2.RESPONSE_STATUS=='N') {
						this.throwError(data2)
						return										
					}
					data.ASSIGNED_USERS=data2.ASSIGNED_USERS;
					this.getStatusCounts();
				})

			}

		});
	}
	removeAssignedUser(data, user){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":data.REPORT_ID, "FUNCTION_ID": 4};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson={"PROCEDURE":"removeassigneduser","USER_ID":parseInt(this.userId),"REPORT_ID":data.REPORT_ID,"ASSIGNED_USER_ID":user.USER_ID}
				console.log(inputJson)
				for(let i=0; i<data.ASSIGNED_USERS.length;i++){
					if(user.USER_ID==data.ASSIGNED_USERS[i].USER_ID){
							data.ASSIGNED_USERS.splice(i, 1);
							data.flat['ASSIGNED_USERS'].splice(i, 1);
							data.flat['ASSIGNED_USERS_ID'].splice(i, 1);
							break;
					}
				}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					this.getStatusCounts();
					
				})
			}

		});
		
	}
	
	changeUsers(data){
		console.log("changeUsersdata",data)
		let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, 'ASSESSOR_ID':this.assessor.USER_ID, "ASSIGNED_USER_ID":this.user.USER_ID, "REVIEWER_ID":this.reviewer.USER_ID};
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.getAllReportByGroup(this.groupkey);
		})
	}
	changeUser(data, user, type){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":data.REPORT_ID, "FUNCTION_ID": 4};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				console.log("data", data, user, type)
	
				let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID};
				inputJson[type+ "_ID"]=user[0].USER_ID
				if(data.flat!=undefined){
					if(user[0].USER_ID==null){
						data[type]=[];
						data.flat[type]="";
						data.flat[type+"_ID"]=null;
					}else{
						data.flat[type]=data[type][0].FULL_NAME;
						data.flat[type+"_ID"]=user[0].USER_ID;
					}
				}
				console.log(inputJson)
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						return										
					}
					// this.getAllReportByGroup(this.groupkey);
					this.getStatusCounts();
					// console.log(this.statusList);
					console.log(this.activeData);
				})

			}

		});
		
	}
	
	currentDate=new Date();data
	//(rowData, rowData.ASSESSOR_DUE_DATE, col.field, col.sortfield)
	changeDate (rowdata, date, type, sortfield){
		if (rowdata.CONSULTANT != 'Y') {

			let intype="";
			if (type=="ASSESSOR_DATE") {
				intype="ASSESSOR_DUE_DATE";
			} else if (type=="REVIEWER_DATE") {
				intype="REVIEWER_DUE_DATE";
			} else if (type=="REPORT_RECEIVED_DATE_DATE") {
				intype="REPORT_RECEIVED_DATE"
			} else {
				intype="REPORT_DUE_DATE"
			}

			// first check if user has permission:
			let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":rowdata.REPORT_ID, "FUNCTION_ID": 9};
			console.log(checkUserInputJson);
			this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
				console.log(checkResponse)
				if (checkResponse.RESPONSE_STATUS=='N') {
					this.throwError(checkResponse)
					return										
				}
				if (checkResponse.USER_PERMISSION == 'N') {
					rowdata[intype] = rowdata[sortfield];
					this.throwError(checkResponse)
					 // restore active table
				} else {
					
					console.log("date", date, rowdata, type)
					//console.log(this.reportTreeData[rowdata.groupIndex]);

					rowdata[type+ '_RED']=date? date<=Date.now() : false;
					console.log("changecolor", rowdata[type+ '_RED'], intype+ '_RED', rowdata)
					let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":rowdata.PROJECT_ID, 'REPORT_ID':rowdata.REPORT_ID};
					inputJson[intype]=this.getFormattedDate(date)

					console.log(inputJson)
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
						// console.log('Test', response[intype]);
						console.log(response);
						if (response.RESPONSE_STATUS=='N') {
							this.throwError(response)
							return										
						}

						
							// updates the active table
							rowdata[sortfield] = date
						

					})
					
				}

			});

		}
	}
	expandToggle(){		
			if(this.isExpanded){
				this.reportTreeData.forEach(data =>{
					data.expanded = false;					
				})				
			}else{
				this.reportTreeData.forEach(data =>{
					data.expanded = true;					
				})				
			}
			this.isExpanded=!this.isExpanded;
			this.reportTreeData=[...this.reportTreeData];
		
	}
	isExpanded2=true;
	expandToggle2(){		
		if(this.isExpanded2){
			this.portfolioTreeData.forEach(data =>{
				data.expanded = false;					
			})				
		}else{
			this.portfolioTreeData.forEach(data =>{
				data.expanded = true;					
			})				
		}
		this.isExpanded2=!this.isExpanded2;
		this.portfolioTreeData=[...this.portfolioTreeData];
	
}
	selectUser(index, user){
		this.allTypeRpt[index].ASSIGNED_USERS=user;
	}

	reportToDelete;

	deleteRpt(data){ //flag
		console.log(data);
		let inputJson={"PROCEDURE":"deletereport", "REPORT_ID":data.REPORT_ID, "USER_ID":parseInt(this.userId)};
		console.log("deletee", inputJson)
		console.log("this.reports", this.reports)
		for(let i=0; i<this.reports.length;i++){
			for(let j=0;j<this.reports[i].RW_REPORTS.length;j++){
				if(this.reports[i].RW_REPORTS[j].REPORT_ID==data.REPORT_ID){
					if(this.reports[i].RW_REPORTS.length==1){
						this.reports[i].GROUP_COUNT="No Reports";
		
					}else{
						this.reports[i].RW_REPORTS.splice(j, 1);console.log(this.reports);
					}
					this.toTreeData();
					break;
				}
			}
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if(response.RESPONSE_STATUS=='Y'){
				// Swal.fire({
				// 	title:response.MESSAGE,
				// 	timer: 2000,
				// 	showConfirmButton:false,
				// }) 
				console.log("deleted");
				if(this.tabFromVar=='ACTIVE'){
					this.getAllReportByGroup(this.groupkey);
				} else if(this.tabFromVar='PORTFOLIO'){
					this.getProjectforPortfolioV2()
				} else {
					this.getAllReportByGroup(this.groupkey);
					this.getProjectforPortfolioV2()
				}
				// this.getAllReportByGroup(this.groupkey);
            
			}else {
				this.throwError(response);
			}
		})
			
			//this.reportTreeData[index].children.splice(index2, 1);console.log(this.reportTreeData);
		
	}
	rotate(e){
		// console.log(e);
		console.log(e.target.nodeName);
		if(e.target.nodeName=="SPAN"){
			$(e.target.nextElementSibling).toggleClass('active');
		}else{
			$(e.target).toggleClass('active');
		}


	}
	proToggle(e){
		$(event.target).toggleClass('active');
		if($(event.target).hasClass('active')){
			$('.collapse').addClass('show');
			$('.collapsible1').addClass('active');
		}else{
			$('.collapse').removeClass('show');
			$('.collapsible1').removeClass('active');
		}
	}
	/*showMap(data) {
		console.log("showmap", data);
		$(".modal-title").html("Project Info");
		this.addToProject(data);
		this.locate();
		this.resetForm();
	}*/
	emptyClient={
		CLIENT_COMPANY_NAME:"",
		CLIENT_ADDRESS_LINE1:"",
		CLIENT_FULL_ADDRESS:"",
		CLIENT_ADDRESS_LINE2:"",
		CLIENT_PROVSTATE:"",
		CLIENT_COUNTY:"",
		CLIENT_COUNTRY:"",
		CLIENT_POSTALZIP:"",
		CLIENT_CITY:"",
		CLIENT_CONTACT_NAME:"",
		CLIENT_CONTACT_PHONE:"",
		CLIENT_DISPLAY_TEXT:""
	}
	fillClient(user) {
		if(!user){
			return
		}
		this.resetClientForm();
		console.log("fillclient", user);
		this.companyName = user.CLIENT_COMPANY_NAME;
		this.clientAddress = user.CLIENT_ADDRESS_LINE1;
		this.clientAddress2= user.CLIENT_ADDRESS_LINE2;
		this.clientState= user.CLIENT_PROVSTATE;
		this.clientCounty= user.CLIENT_COUNTY;
		this.clientCountry= user.CLIENT_COUNTRY;
		this.clientZip= user.CLIENT_POSTALZIP;
		this.clientCity= user.CLIENT_CITY;
		this.contactName = user.CLIENT_CONTACT_NAME;
		this.contactTitle = user.CLIENT_CONTACT_TITLE;
		this.curSelectClient={
			'CLIENT_COMPANY_NAME': user.CLIENT_COMPANY_NAME,
			'CLIENT_CONTACT_EMAIL': user.CLIENT_CONTACT_EMAIL,
			'CLIENT_CONTACT_NAME': user.CLIENT_CONTACT_NAME,
			'CLIENT_CONTACT_PHONE': user.CLIENT_CONTACT_PHONE,
			'CLIENT_PROVIDED_INFORMATION':user.CLIENT_PROVIDED_INFORMATION,
			// 'CLIENT_FULL_ADDRESS':user.CLIENT_ADDRESS_LINE1+", "+user.CLIENT_ADDRESS_LINE2+", "+user.CLIENT_CITY+", "+user.CLIENT_PROVSTATE+", "+user.CLIENT_POSTALZIP,
			// 'CLIENT_FULL_ADDRESS': `${user.CLIENT_ADDRESS_LINE1? user.CLIENT_ADDRESS_LINE1+', ': ''}${user.CLIENT_ADDRESS_LINE2? user.CLIENT_ADDRESS_LINE2+', ': ''}${user.CLIENT_CITY? user.CLIENT_CITY+', ': ''}${user.CLIENT_PROVSTATE? user.CLIENT_PROVSTATE+', ': ''}${user.CLIENT_POSTALZIP? user.CLIENT_POSTALZIP+', ': ''}`,
			'CLIENT_FULL_ADDRESS': [user.CLIENT_ADDRESS_LINE1,user.CLIENT_ADDRESS_LINE2,user.CLIENT_CITY,user.CLIENT_PROVSTATE,user.CLIENT_POSTALZIP,user.CLIENT_COUNTRY].filter(value=>value!='').join(', ')
		}

		//this.cocompanyName = user.CLIENT_COMPANY_NAME;
		
		this.form.patchValue({ companyName: user["CLIENT_COMPANY_NAME"] });
		this.form.patchValue({ clientEmail: user["CLIENT_CONTACT_EMAIL"] });
		this.form.patchValue({ clientPhone: user["CLIENT_CONTACT_PHONE"] });

	}
	fillCoClient(user) {
		if(!user){
			return
		}
		this.resetCoClientForm();
		this.coclientAddress = user.CLIENT_ADDRESS_LINE1;
		this.coclientAddress2= user.CLIENT_ADDRESS_LINE2;
		this.coclientState= user.CLIENT_PROVSTATE;
		this.coclientCounty= user.CLIENT_COUNTY;
		this.coclientCountry= user.CLIENT_COUNTRY;
		this.coclientZip= user.CLIENT_POSTALZIP;
		this.coclientCity= user.CLIENT_CITY;
		this.cocontactName = user.CLIENT_CONTACT_NAME;
		this.cocontactTitle = user.CLIENT_CONTACT_TITLE;
		this.form.patchValue({ cocompanyName: user["CLIENT_COMPANY_NAME"] });
		this.form.patchValue({ coclientEmail: user["CLIENT_CONTACT_EMAIL"] });
		this.form.patchValue({ coclientPhone: user["CLIENT_CONTACT_PHONE"] });
		this.curCoSelectClient={
			'CLIENT_COMPANY_NAME': user.CLIENT_COMPANY_NAME,
			'CLIENT_CONTACT_EMAIL': user.CLIENT_CONTACT_EMAIL,
			'CLIENT_CONTACT_NAME': user.CLIENT_CONTACT_NAME,
			'CLIENT_CONTACT_PHONE': user.CLIENT_CONTACT_PHONE,
			'CLIENT_PROVIDED_INFORMATION':user.CLIENT_PROVIDED_INFORMATION,
			// 'CLIENT_FULL_ADDRESS':user.CLIENT_ADDRESS_LINE1+", "+user.CLIENT_ADDRESS_LINE2+", "+user.CLIENT_CITY+", "+user.CLIENT_PROVSTATE+", "+user.CLIENT_POSTALZIP,
			'CLIENT_FULL_ADDRESS': [user.CLIENT_ADDRESS_LINE1,user.CLIENT_ADDRESS_LINE2,user.CLIENT_CITY,user.CLIENT_PROVSTATE,user.CLIENT_POSTALZIP,user.CLIENT_COUNTRY].filter(value=>value!='').join(', '),
		}

	}
	fillCoClient2(user){
		this.resetCoClientForm();
		this.coclientAddress = user.CO_CLIENT_ADDRESS_LINE1;
		this.coclientAddress2= user.CO_CLIENT_ADDRESS_LINE2;
		this.coclientState= user.CO_CLIENT_PROVSTATE;
		this.coclientCounty= user.CO_CLIENT_COUNTY;
		this.coclientCountry= user.CO_CLIENT_COUNTRY;
		this.coclientZip= user.CO_CLIENT_POSTALZIP;
		this.coclientCity= user.CO_CLIENT_CITY;
		this.cocontactName = user.CO_CLIENT_CONTACT_NAME;
		this.cocontactTitle = user.CO_CLIENT_CONTACT_TITLE;
		this.form.patchValue({ cocompanyName: user["CO_CLIENT_COMPANY_NAME"] });
		this.form.patchValue({ coclientEmail: user["CO_CLIENT_CONTACT_EMAIL"] });
		this.form.patchValue({ coclientPhone: user["CO_CLIENT_CONTACT_PHONE"] });
		this.curCoSelectClient={
			'CLIENT_COMPANY_NAME': user.CO_CLIENT_COMPANY_NAME,
			'CLIENT_CONTACT_EMAIL': user.CO_CLIENT_CONTACT_EMAIL,
			'CLIENT_CONTACT_NAME': user.CO_CLIENT_CONTACT_NAME,
			'CLIENT_CONTACT_PHONE': user.CO_CLIENT_CONTACT_PHONE,
			'CLIENT_PROVIDED_INFORMATION':user.CO_CLIENT_PROVIDED_INFORMATION,
			// 'CLIENT_FULL_ADDRESS':user.CO_CLIENT_ADDRESS_LINE1+", "+user.CO_CLIENT_ADDRESS_LINE2+", "+user.CO_CLIENT_CITY+", "+user.CO_CLIENT_PROVSTATE+", "+user.CO_CLIENT_POSTALZIP,
			'CLIENT_FULL_ADDRESS': [user.CO_CLIENT_ADDRESS_LINE1,user.CO_CLIENT_ADDRESS_LINE2,user.CO_CLIENT_CITY,user.CO_CLIENT_PROVSTATE, user.CO_CLIENT_POSTALZIP,user.CO_CLIENT_COUNTRY].filter(value=>value!='').join(', ')
		}
	}
	newEditCoClient=false
	cocontactName;
	cocontactTitle:string;
	coclientAddress
	coclientCity
	coclientAddress2
	coclientState
	coclientZip
	coclientCounty;
	coclientCountry;
	resetIsEmpty() {
		this.emptyCol = false;
	}
	setEmpty() {
		this.emptyCol = true;
	}
	isEmpty() {
		return this.emptyCol;
	}

	setFloatPosition() {
		this.dragPosition = {x: 200, y: 10}
	}

	printProjectDetails(rowData) {
		let outputStr = "- ";
		if (rowData.PROPERTY_NAME != '') {
			outputStr += rowData.PROPERTY_NAME+"("+rowData.size+") ";
		}
		if (rowData.ADDRESS != null && rowData.ADDRESS != "") {
			outputStr += rowData.ADDRESS + ", ";
		}
		if (rowData.CITY != "") {
			outputStr += rowData.CITY;
		}
		if (rowData.PROVSTATE != "") {
			outputStr += ", " +rowData.PROVSTATE;
		}
		if (rowData.POSTALZIP != "") {
			outputStr += ", " + rowData.POSTALZIP;
		}
		if (rowData.COUNTRY != "") {
			outputStr += ", " + rowData.COUNTRY;
		}
		// console.log(outputStr);
		return outputStr;
	}
	test(x){
		console.log("test", x);
	}
	setDisplaySections (num) {
		console.log("setDisplaySections")
		console.log(this.displaySections[num - 1])
		// console.log("form", this.form);
		this.displaySections[0] = true; //why
		this.displaySections[num - 1] = true;
		this.enabledDisplayInfo = true;
		console.log(this.displaySections[7])
	}
	showTitle(x){
		console.log("showtitle", x);
	}
	getFormattedTime(date: Date) {
		if (date != null) {
			let hours = date.getHours();
			let apm = hours >= 12 ? ' PM' : ' AM';
			if (hours != 12) {
				hours %= 12;
			} 
			if (hours == 0) {
				hours = 12;
			}
			let mins = date.getMinutes().toString().padStart(2, "0");
			return hours.toString().padStart(2, "0")+":"+mins+apm; 
		}
		return "";
	}
	formatDate(date){
		/*var x;
		var array = date.split(' '),
    	a = array[0], b = array[1], c = array[2];
		x = b + '-' + c + '-' + '20' + a*/
		//console.log("date", x)
		let x=date;
		x = new Date(x)
		//x = this.datepipe.transform(x, 'dd-mm-yy')
		return(x)
	}
	getFormattedDate(date: Date) {		
		console.log('date', date)
		if (date != null) {
			const shortMonths = [
				'JAN','FEB','MAR','APR',
				'MAY','JUN','JUL','AUG',
				'SEP','OCT','NOV','DEC'
			];
			let day = date.getDate().toString().padStart(2, "0");
			let month = shortMonths[date.getMonth()];
			let year = date.getFullYear() % 100;
			console.log('Test', year+"-"+month+"-"+day)
			return (day+"-"+month+"-"+year);
			
		} 
		return "";
	}
	closeResult = '';
	open(content) {
		this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
		  this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
		  this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		  $('body').removeClass('modal-open');
		});
	}
	
	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}
	@ViewChild("tt") tt: TreeTable;
	@ViewChild("tt2") tt2: TreeTable;
	@ViewChild('activeTable2') activeTable2: Table;
	@ViewChild('portfolioTable') portfolioTable: Table;
	// vv this is for treetable, currently not used
	resetTableFilters() {
	// this.tt.filter('', 'ABSTRACT', 'contains'); 
		this.tt.filter('', 'SOW', 'contains');
		this.tt.filter('', 'STATUS', 'contains');
		this.tt.filter('', 'flat.PROTOCOL', 'contains');
	// this.tt.filter('', 'SMART_CD', 'contains'); 
	// this.tt.filter('', 'BATCH_FLAG', 'contains');
	// this.tt.filter('', 'EXTERNAL_FLAG', 'contains');
	}
	resetTableFilters1() {
		console.log(this.statusModel)
		console.log(this.activeTable2)
		//this.numActiveReports = this.activeTable2.filteredValue.length
		// this.tt.filter('', 'ABSTRACT', 'contains'); 
		this.activeTable2.filter('', 'SOW', 'contains');
		this.activeTable2.filter('', 'STATUS', 'contains');
		this.activeTable2.filter('', 'flat.PROTOCOL', 'contains');
		this.activeTable2.filter(null, 'flat', 'assignedtome')

		if(this.statusModel=='All'){
			// this.activeData = this.activeDataHolder;
			this.numActiveReports = this.statusList[0].TOTAL;
			// if(this.activeData==this.assignedToMeDataHolder){
			// 	this.activeData = this.activeDataHolder
			// }
			//  console.log('All')
		} else if(this.statusModel=='Assigned to me'){
			//this.getAssignedToMe()
			// this.activeData = this.assignedToMeDataHolder;
			// this.numActiveReports = this.assignedToMeLength; /// i do not know why this is not statusList[1]. 
			// this.activeData = this.activeDataHolder;
			this.activeTable2.filter(parseInt(this.userId), 'flat', 'assignedtome')
			this.numActiveReports = this.statusList[1].TOTAL;
		} else { 
			this.activeTable2.filter(this.statusModel, 'STATUS', 'contains')

			let index2=this.statusList.findIndex(status=>status.STATUS==this.statusModel); console.log(index2)
			if(index2>-1){
				console.log(this.statusList[index2].TOTAL)
				this.numActiveReports = this.statusList[index2].TOTAL
			}
		}
	}

	onFilterReports(event) {
		console.log(event)
		this.numActiveReports = 0;
		//filter to count table entries that have a report:
		this.numActiveReports = event.filteredValue.filter(report=>report.REPORT_ID!==undefined).length; 
		// console.log(this.numActiveReports);
	}
	onFilterPortfolio(event) {
		console.log(event)
		this.numPortfolioReports = 0;
		//filter to count table entries that have a report:
		this.numPortfolioReports = event.filteredValue.filter(report=>report.REPORT_ID!==undefined).length; 
		// console.log(this.numActiveReports);
	}

	/*getCurrentTime() {
		this.date4 = new Date();
		console.log(this.date4);
	}*/

	assessor;
	reviewer;
	user;
	setinputs(rowData){
	}
	AddressChange(address: any){
		console.log("Address change",address)
		// this.formattedaddress=address.formatted_address; console.log(this.formattedaddress)
		//  let place: google.maps.places.PlaceResult = autocomplete.getPlace();console.log(place)
				
        //   //verify result
        //   if (place.geometry === undefined || place.geometry === null) {
        //     return;
        //   }	
			this.placeParse(address);
	}
	
	tabOpen(collapse){
		return($('#'+collapse)[0].classList.contains('show'));
	}
	show(collapse){

		$('#'+collapse).collapse('show');
	}
	hide(collapse){
		console.log("hide")
		$('#'+collapse).collapse('hide');
	}
	appendMap(){
		console.log($(".pac-container"))
		$("#mapContainer").append($(".pac-container"));
	}
	reviewertitles;
	assessortitles;
	getTitles(){
		let inputJson= {"PROCEDURE":"gettitlelist","USER_ID":parseInt(this.userId),"TITLE_TYPE":"ASSESSOR"}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("assessortitles", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.assessortitles=data.RW_TITLES;
		})
		
		inputJson= {"PROCEDURE":"gettitlelist","USER_ID":parseInt(this.userId),"TITLE_TYPE":"REVIEWER"}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("reviewertitles", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.reviewertitles=data.RW_TITLES;
		})

	}
	catToChange;
	findType(data){
		console.log("findType", this.categoryList);
		console.log("savedTemp", data);
		for(let cat of this.categoryList){
			if(cat.CATEGORY==data.REPORT_CATEGORY){
				this.catToChange={
					category:cat.CATEGORY,
					subCategories:null,
					typeIdTemplates:null,
					selectedSubCat:null,
					selectedTemplate:null,
					...(this.companyGroupIndicator ? {selectedGroup:null} : {}),
					userList: {
						assessor:"",
						assessortitle:{},
						reviewertitle:{},
						reviewer:"",
						assigned_user:"",
					},
					selected:false, 
				}
				console.log(this.catToChange);
				this.setSubCat(this.catToChange);
			}	
		}

	}
	findType1(data){
		console.log("findType1", this.categoryList);
		console.log("savedTemp1", data);
		//for(let cat of this.categoryList){
			//if(cat.CATEGORY==data.REPORT_CATEGORY){
				let selected={'selected': false,
					'subCategory': data.TEMPLATE[0].SUBCATEGORY_NAME,
					'typeId':  data.TEMPLATE[0].TEMPLATE_TYPE_ID,
					}
				this.catToChange={
					category:data.REPORT_CATEGORY,
					subCategories:null,
					typeIdTemplates:this.tableTemplates,
					selectedSubCat:selected, //flag
					selectedTemplate:data.TEMPLATE[0],
					userList: {
						assessor:"",
						assessortitle:{},
						reviewertitle:{},
						reviewer:"",
						assigned_user:"",
					},
					selected:false, 
				}
				console.log(this.catToChange);
				this.setSubCat(this.catToChange);
			//}	
		//}

	}
	/*getPCA(id){
		let inputJson={"PROCEDURE":"getpropertyquestions","USER_ID":parseInt(this.userId),"REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("PCA", data);
			this.answers=data;
		})
	}*/
	saveAnswers;
	idToSave;
	saveRow;
	savePCA(){
		let proc=this.saveRow.PCA_QUESTIONS=='Y'? "updatepropertyquestions" : "insertpropertyquestions";
		if(this.saveRow.PCA_QUESTIONS=='N'){
			this.saveRow.PCA_QUESTIONS='Y'
		}
		
		let inputJson={"PROCEDURE":proc,"USER_ID":parseInt(this.userId),"REPORT_ID":this.idToSave,}
		for(let i=0 ;i<this.questions.length;i++){
			inputJson[this.questions[i]]=this.answers[this.questions[i]];
		}
		inputJson["ADDITIONAL_PROPERTY_INFORMATION"]=this.answers["ADDITIONAL_PROPERTY_INFORMATION"];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{

			console.log("update questions", data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
		})
	}
	originalData;
	//update(){
	//	let inputJson={"PROCEDURE":"getreportsforproject","USER_ID":parseInt(this.userId),"PROJECT_ID":this.projectID};
	//	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data1 => {
	//		for(var i in this.reportTreeData){
	//			if(this.reportTreeData[i].children[0].data.PROJECT_ID == data1.PROJECT_ID){
	//				this.reportTreeData[i].children[0] = data1
	//				console.log('test', this.reportTreeData[i].children[0])
	//				return;
	//			}	
	//		}
	//		
	//	})
	//}
	editProjectPermission = false;
	checkEditProjectPermission(project_id) {
		this.editProjectPermission = false;

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "PROJECT_ID":project_id, "FUNCTION_ID": 5};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.editProjectPermission = false;
				
				// // close the modal. the timeout is to give it time to load. very hacky, find a better way lol
				setTimeout(() => { $('#reportsModal').modal('hide'); }, 250);

			} else {
				this.editProjectPermission = true;
			}
		});
	}
	editProject(rowdata, node, newreport){ //
		this.newReportPortfolio='';
		this.selectExisting=true;

		console.log(this.questions);
		console.log(this.answers);
		this.changed=false;

		let inputJson={"PROCEDURE":"getreportsforproject","USER_ID":parseInt(this.userId),"PROJECT_ID":rowdata.PROJECT_ID};
		console.log("getreportsforproject", inputJson);
		//let inputJson2={"PROCEDURE":"getpropertyquestions","USER_ID":parseInt(this.userId),"PROJECT_ID":rowdata.PROJECT_ID};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log('savedProject', data)
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data)
			return										
		}
			this.originalData=data;	
			console.log(data.CONSULTANT_LOCATION)
			if(data.CONSULTANT_LOCATION != null){
				this.curSelectConsultant = data.CONSULTANT_LOCATION
			}
			this.addRpt2(()=>{
				if(newreport){
					this.show('collapse5');
				}
				/*this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
					console.log("PCA", data);
					this.answers=data;
				})*/
				
				for(let i=0; i<this.originalData.RW_REPORTS.length;i++){
					for(let cat of this.curTempCategories){
					//	console.log("compare", cat.category, this.originalData.RW_REPORTS[i].REPORT_CATEGORY)
						if(cat.category==this.originalData.RW_REPORTS[i].REPORT_CATEGORY){
							cat.selected=true;

							//this.curSelectConsultant=this.originalData.RW_REPORTS[i].REPORT_COMPANY	
							//console.log(this.curSelectConsultant)
							//console.log(cat.company)

							// console.log('SELECTED FLAG')
							// this.originalData.RW_REPORTS[i].ASSESSOR[0]? cat.userList.assessor=this.originalData.RW_REPORTS[i].ASSESSOR[0] :  cat.userList.assesso=cat.userList.assesso
							//.RW_REPORTS[i].ASSESSOR_TITLE[0] ? cat.userList.assessortitle=data.RW_REPORTS[i].ASSESSOR_TITLE[0]: data.RW_REPORTS[i].ASSESSOR_TITLE=data.RW_REPORTS[i].ASSESSOR_TITLE
							//console.log("cat.userList.assessortitle",JSON.stringify(cat.userList.assessortitle));
							/*console.log("undefined reviewer", this.originalData.RW_REPORTS[i])
							console.log("undefined reviewer", this.originalData)
							this.originalData.RW_REPORTS[i].REVIEWER[0]? cat.userList.reviewer=this.originalData.RW_REPORTS[i].REVIEWER[0]:this.originalData.RW_REPORTS[i].REVIEWER[0]=this.originalData.RW_REPORTS[i].REVIEWER[0];
							cat.userList.assessortitle=data.RW_REPORTS[i].ASSESSOR_TITLE[0]		
							this.originalData.RW_REPORTS[i].REVIEWER_TITLE[0]? cat.userList.reviewertitle=this.originalData.RW_REPORTS[i].REVIEWER_TITLE[0]: this.originalData.RW_REPORTS[i].REVIEWER_TITLE==this.originalData.RW_REPORTS[i].REVIEWER_TITLE;
							this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0]? cat.userList.assigned_user=this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0] : this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0]=this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0];
							*/
							if(this.originalData.RW_REPORTS[i].TEMPLATE[0]){			
								for(let j=0; j<cat.subCategories.length;j++){
									let subcat=cat.subCategories[j];
									if(subcat.typeId==data.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_TYPE_ID ){
										subcat.selected=true;
										// console.log('SELECTED FLAG')
										// cat.selectedSubCat= subcat;
										// this.setByTypeId2(cat, ()=>{
										// 	for(let template of cat.typeIdTemplates){
										// 		//console.log("templates", template.TEMPLATE_ID,this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_ID )
										// 		if(template.TEMPLATE_ID==this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_ID){
										// 			cat.selectedTemplate=template;
		
										// 		}
										// 	}
										// });
										// console.log("cat", cat);
									}
								}
							}
						}
					}
				}
				for(let i=0 ;i<this.questions.length;i++){
					this.answers[this.questions[i]]=data[this.questions[i]];
				}
				this.answers["ADDITIONAL_PROPERTY_INFORMATION"]=data["ADDITIONAL_PROPERTY_INFORMATION"];	
				//console.log(this.answers);
			});
			console.log('savedRpt', this.originalData.RW_REPORTS)
			
			this.save=false;
			console.log("reportsforproject", data);
		
			// this.ngZone.run(()=>{
			// 	// this.curProject.PROJECT_NUMBER=data.PROJECT_NUMBER;
			// 	// this.curProject.PROJECT_NAME=data.PROJECT_NAME;
			// 	// this.curProject.erisOrder=data.ORDER_NUM;
			// 	// this.street1=data.ADDRESS_LINE1;
			// 	// this.street2=data.ADDRESS_LINE1;
			// 	// this.city=data.CITY
			// 	// this.state=data.STATE;
			// 	// this.postCode=data.PROVSTATE
			// 	// this.country=data.COUNTRY
			// 	// curProject.PROPERTY_COUNTY
			// 	// urProject.FLOOD_ZONE
			// 	// curProject.MSA
			// 	// curProject.PGA
			// 	// curProject.ZONING
			// 	// curRptPara.TRANSACTION_TYPE
			// 	// curRptPara.PROTOCOLS\
			// 	// date1//insepction
			// 	// date2//reviewer
			// 	// date3//assessor 5,6,7 report, revised, project
			// 	// curProject.SITE_CONTACT_NAME
			// 	// curProject.SITE_CONTACT_RELATIONSHIP
			// })

			this.checkErisData();

			this.curProject.PROJECT_ID=data.PROJECT_ID;
			this.curProject.PROJECT_NUMBER=data.PROJECT_NUMBER;
			this.curProject.PROJECT_NAME=data.PROPERTY_NAME;
			this.curProject.erisOrder=data.ORDER_NUM;
			this.street1=data.ADDRESS_LINE1;
			this.street2=data.ADDRESS_LINE2;
			this.city=data.CITY
			this.state=data.PROVSTATE;
			this.postCode=data.POSTALZIP
			this.country=data.COUNTRY
			this.projectID=data.PROJECT_ID
			this.curProject.PROPERTY_COUNTY=data["COUNTY"]
			this.curProject.PRIVATE_FLAG=data.PRIVATE_FLAG === 'Y' ? true : false;
			this.curProject.PO_NUMBER=data.PO_NUMBER;

			//this.protocols[this.curRptPara.PROTOCOLS]=data['PROTOCOL']
			this.curRptPara.SOW.FILE_URL=data['SOW']
			for(let i=0; i<this.transactions.length;i++){
				if(data['TRANSACTION_TYPE'][0] && this.transactions[i].CODE_ID==data['TRANSACTION_TYPE'][0].TRANSACTION_TYPE_ID){
					this.curRptPara.TRANSACTION_TYPE=i.toString();
					console.log("trans", this.curRptPara.TRANSACTION_TYPE);
				}
			}
			for(let i=0; i<this.protocols.length;i++){
				if( data['PROTOCOL'][0] &&this.protocols[i].CODE_ID==data['PROTOCOL'][0].PROTOCOL_ID){
					this.curRptPara.PROTOCOLS=i.toString();;
					console.log("prot", this.curRptPara.PROTOCOLS);
				}
			}
			console.log("curTempCategories", JSON.stringify(this.curTempCategories));

			//this.transactions[this.curRptPara.TRANSACTION_TYPE]=data['TRANSACTION_TYPE' ]
			this.curProject.SITE_CONTACT_NAME=data["SITE_CONTACT_NAME"]
			this.curProject.SITE_CONTACT_RELATIONSHIP=data["SITE_CONTACT_RELATIONSHIP"]
			this.curProject.PORTFOLIO_ID=data.PORTFOLIO[0]?.PORTFOLIO_ID;
			this.form.patchValue({siteContactPhone: data["SITE_CONTACT_PHONE"]})
			this.form.patchValue({siteemailAddress: data["SITE_CONTACT_EMAIL"]})
			this.form.patchValue({additionalsiteContactPhone: data["ADD_SITE_CONTACT_PHONE"]})
			this.form.patchValue({additionalsiteemailAddress: data["ADD_SITE_CONTACT_EMAIL"]})
			// this.form.value.siteemailAddress=data["SITE_CONTACT_EMAIL"]
			this.curProject.ADD_SITE_CONTACT_NAME=data["ADD_SITE_CONTACT_NAME"]
			this.curProject.ADD_SITE_CONTACT_RELATIONSHIP=data["ADD_SITE_CONTACT_RELATIONSHIP"]
			// this.form.value.additionalsiteContactPhone=data["ADD_SITE_CONTACT_PHONE"]
			// this.form.value.additionalsiteemailAddress=data["ADD_SITE_CONTACT_EMAIL"]fff
			this.curProject.SITE_INSPECTION_INSTRUCTIONS=data["SITE_INSPECTION_INSTRUCTIONS"]
			this.curProject.CLIENT_PROVIDED_INFORMATION=data["CLIENT_PROVIDED_INFORMATION"]
			//this.curSelectClient=data.RW_CLIENTS[0]
			this.fillClient(data);
			this.fillCoClient2(data);
		
			//this.curCoSelectClient=data.RW_CLIENTS[1]
			//this.date7=data["TURN_TIME"]
			if(data["INSPECTION_DATE"]){
				this.date1= this.formatDate(data["INSPECTION_DATE"])//=="" ? null: new Date(data["INSPECTION_DATE"]);
				this.date1Text=this.getFormattedDate(this.date1);
			}else{
				this.date1= null
			}
			if(data["ASSESSOR_DUE_DATE"]){console.log(data["ASSESSOR_DUE_DATE"])
				this.date3= this.formatDate(data["ASSESSOR_DUE_DATE"]) //=="" ? null: new Date(data["ASSESSOR_DUE_DATE"]);
				this.date3Text=this.getFormattedDate(this.date3);
			}else{
				this.date3 = null
			}
			if(data["REVIEWER_DUE_DATE"]){
				this.date2= this.formatDate(data["REVIEWER_DUE_DATE"]) //=="" ? null: new Date(data["REVIEWER_DUE_DATE"]);
				this.date2Text=this.getFormattedDate(this.date2);
			}else{
				this.date2 = null
			}
			if(data["REPORT_DUE_DATE"]){
				this.date5= this.formatDate(data["REPORT_DUE_DATE"]) //=="" ? null: new Date(data["REPORT_DUE_DATE"]);
				this.date5Text=this.getFormattedDate(this.date5);
				
			}else{
				this.date5 = null
			}
			// this.date6= data["REVISED_REPORT_DATE"]=="" ? null: new Date(data["REVISED_REPORT_DATE"]);
			
			
			// console.log('date1', this.date1)
			// console.log('date3', this.date3)
			// console.log('date2', this.date2)
			// console.log('date5', this.date5)
			if(data["CHARGE_AMOUNT"]){
				this.curProject["CHARGE_AMOUNT"]=data["CHARGE_AMOUNT"];
			}else{
				this.curProject["CHARGE_AMOUNT"]= '';
			}
			if(data["EXPENSE_AMOUNT"]){
				this.curProject["EXPENSE_AMOUNT"]=data["EXPENSE_AMOUNT"];
			}else{
				this.curProject["EXPENSE_AMOUNT"]= '';
			}
			if(data["TOTAL_AMOUNT"]){
				this.curProject["TOTAL_AMOUNT"]=data["TOTAL_AMOUNT"];
			}else{
				this.curProject["TOTAL_AMOUNT"]= '';
			}

			this.curProject.FLOOD_ZONE=data["FLOOD_ZONE_FEMA"]
			this.curProject.MSA=data["METRO_STATISTISIC_AREA_MSA"]
			this.curProject.ZONING=data["ZONING_DESIGNATION"];
			this.curProject.PGA=data["PEAK_GROUND_ACCELERATION_PGA"]

			// console.log("this.curProject.PROJECT_NUMBER",this.curProject.PROJECT_NUMBER);
			this.parcelID=data.PARCEL_ID
			this.lat=data.LATITUDE;
			this.lng=data.LONGITUDE;
			if(this.lat&this.lng){
			this.setLatLngPin(this.lat,this.lng);
			this.zoom = 12;
			this.markers[0]={
				lat: this.lat,
				lng: this.lng,
				draggable: true
				}
			}
			for(let i=0; i<10;i++){
				this.setDisplaySections(i);
			}

			this.newReportValid = true;

		})
	}

	clientAddress;
	clientAddress2;
	clientState;
	clientCounty;
	clientCountry;
	clientZip;
	clientCity;
	companyName;
	contactName;
	contactTitle:string;
	resetClientForm() {

		this.companyName = "";
	//	this.address = "";
		this.contactName = "";
		this.contactTitle = "";
		this.clientAddress= "";
		this.clientAddress2= "";
		this.clientState= "";
		this.clientCounty= "";
		this.clientCountry= "";
		this.clientZip= "";
		this.clientCity= "";
		this.form.patchValue({ companyName: ""});
		this.form.patchValue({ clientEmail: "" });
		this.form.patchValue({ clientPhone: "" });
	//	this.form.reset();
	}
	resetCoClientForm() {

	//	this.cocompanyName = "";
	//	this.address = "";
		this.cocontactName = "";
		this.cocontactTitle = "";
		this.coclientAddress= "";
		this.coclientAddress2= "";
		this.coclientState= "";
		this.coclientCounty= "";
		this.coclientCountry="";
		this.coclientZip= "";
		this.coclientCity= "";
		this.form.patchValue({ cocompanyName: ""});
		this.form.patchValue({ coclientEmail: "" });
		this.form.patchValue({ coclientPhone: "" });
	//	this.form.reset();
	}
	getHistory(rowdata){
		let inputJson={"PROCEDURE":"getreporthistory","USER_ID":parseInt(this.userId),"REPORT_ID":rowdata.REPORT_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			rowdata.RW_REPORT_HISTORY=data.RW_REPORT_HISTORY;
		});
	}
	oneSelected(){
		for(let cat of this.curTempCategories){
			if(cat.selected){
				return true;
			}
		}
		return false;
	}

	setLatLngPin(lt, ln){
		console.log("setlatlngpin",lt,ln)
		const icon = {
			url: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
			size: new google.maps.Size(71, 71),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(17, 34),
			scaledSize: new google.maps.Size(25, 25),
		  };
	
		  // Create a marker for each place.

		  let map= this.mapcanvas
		//  google.place.geometry.location
		  this.markers2.push(
			new google.maps.Marker({
			  map,
			  //icon:'assets/images/Site_Marker.png',
			  title: this.address,
			  position: { lat: lt, lng: ln },
			})
		  );
		  const bounds = new google.maps.LatLngBounds();
		//   if (place.geometry.viewport) {
		// 	// Only geocodes have viewport.
		// 	bounds.union(place.geometry.viewport);
		//   } else {
		 	bounds.extend({ lat: lt, lng: ln });
		//   }

		this.mapcanvas.fitBounds(bounds);
		this.mapcanvas.setZoom(20);
	}
	// shareEmailList = [];
	// getShareEmailList() {
	// 	let inputJson={"PROCEDURE":"getcompanycontractors", "USER_ID":parseInt(this.userId)};
	// 	console.log(inputJson)
	// 	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
	// 		console.log("getcompanycontractors", data);
	// 		this.shareEmailList = data.RW_CONTRACTORS;
	// 	})
	// }
	shareEmail;
	sharecontents=[];
	sharefrontpages=[];
	shareappendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};;
	sharereportInfo:any;
	sharelpagesize:string;
	blackText=false;
	sharepdfs=[];
	shareerisPdfs=[];
	sharepdfType:any
	toprintIndex=0;
	noPrint=false;
	sharing=false;
	sharePOP='N';
	endPdf(e){
		if(!this.loading7){
			let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":parseInt(e),"SHARE_EMAIL":this.shareEmail}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
					console.log(data);
					this.noPrint=false;
					if(data.RESPONSE_STATUS=='Y'){						
						Swal.fire({
							title:"Success",
							html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
							//timer: 3000,noPrint
							showConfirmButton:true,
						// timerProgressBar: true,
			
						})
						//this.emailId="";						
					}else{
						this.throwError(data);
					}

				})
		}
	}
	pdfSpin(e){
		if(e=='start'){
			this.noPrint=true;
		}else{
			//this.noPrint=false;
		}
		
	}
	showErrMsg(e){console.log(e)
		if(!this.loading7){		
			this.noPrint=false;
			let info={"MESSAGE":e};
			this.throwError(info);
		}
	}
	async shareByEmail(id){
		if(this.shareEmail.length<3){
			return
		}
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":id, "FUNCTION_ID": 7};
		console.log(checkUserInputJson)
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N'||checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			}else {
				this.generatepdf(id); 
				/*let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":id,"SHARE_EMAIL":this.shareEmail}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
					console.log(data);
					if(data.RESPONSE_STATUS=='Y'){
						Swal.fire({
							title:"Success",
							html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
							//timer: 3000,
							showConfirmButton:true,
						// timerProgressBar: true,
			
						})
					}else{
						this.throwError(data.MESSAGE);
					}

				})*/
			
		}
		});


	}
	allRptSlots=[];
	async getRptSlots(id){
		
		let tempJson={"PROCEDURE":"getslotsbyreportnocategory", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		
		const response = await this.reportService.univeralService(JSON.stringify(tempJson)).toPromise();
		
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response)
			this.allSlots=[];
			$('#overlay').css('display','none');
		}else{
			
			this.allRptSlots=response.RW_SLOTS; 
		}
	}
	async generatepdf(id){
		this.noPrint=true;
		await this.getRptSlots(id);
		let inputJson={"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
		let data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('otherdata',data);
		if (data.RESPONSE_STATUS === 'N') {
			this.throwError(data, id);
		} else {
			if((data.REPORT_DATA&&data.REPORT_DATA.length>0)||(data.BEFORE_TOC&&data.BEFORE_TOC.length>0)){
				if(data.REPORT_DATA.length>0){
					this.sharecontents=JSON.parse(data.REPORT_DATA); //console.log('content',this.contents);
				}else{
					this.sharecontents=[];
				}
				
				if(data.BEFORE_TOC.length>0){
					this.sharefrontpages=JSON.parse(data.BEFORE_TOC); //console.log('content',this.contents);
				}else{
					this.sharefrontpages=[];
				}
				//this.sharefrontpages=JSON.parse(data.BEFORE_TOC);
				let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
				let response =await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response, id)
					return										
				}
							this.sharereportInfo=response;
							if(response.REPORT_PDF_SETTING){
								let setInfo=JSON.parse(response.REPORT_PDF_SETTING);
								if(setInfo.pagesize){
									this.sharelpagesize=setInfo.pagesize;
								}						
							}
								
							if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
								this.blackText=true;
							}else{
								this.blackText=false;
							}
							if(this.sharereportInfo.ORDER_NUM&&this.sharereportInfo.ORDER_NUM.length>0){
								let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};
								let result= await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise();
									//console.log(result);
									if (result.RESPONSE_STATUS=='N') {
										this.throwError(result, id)
										return										
									}
									this.sharepdfs=result.REPORT_LINKS;
																
								
								let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};console.log(inputJson6);
								let result2= await this.reportService.univeralService(JSON.stringify(inputJson6)).toPromise();
								if (result2.RESPONSE_STATUS=='N') {
									this.throwError(result2, id)
									return										
								}
								this.shareerisPdfs=result2.PRODUCT_LINKS;
								
							}
							let inputJson4= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":id};
							let result3= await this.reportService.univeralService(JSON.stringify(inputJson4)).toPromise();
							if (result3.RESPONSE_STATUS=='N') {
								this.throwError(result3, id)
								return										
							}
							if(result3.APPENDIX_DATA&&result3.APPENDIX_DATA.length>0){
								this.shareappendices=JSON.parse(result3.APPENDIX_DATA);//console.log(this.appendices);
							}
							
				this.toprintIndex++;
				if(this.shareappendices.SUB_SECTIONS.length>0){
					this.sharepdfType={'index':this.toprintIndex, 'type':'app'};
				}else{
					this.sharepdfType={'index':this.toprintIndex, 'type':''};
				}
				
			
			}else{
				if(this.loading7){
					this.deliverError(id, 'This report has not been edited')
				}else{
					this.noPrint=false;
				
				
					Swal.fire({
						icon:'info',
						text: 'This report has not been edited. Please add data to the report before sharing.',
					
					})
				}
			}
		}
	}
	setTabs(){
		$('#myTab a[href="#Portfolio"]').tab('show');
	}
	selectedPortfolio;
	portfolioList
	getAllPortfolios(){
		//if(!this.portfolioList){
		let inputJson={"PROCEDURE":"getCompanyPortfolios","USER_ID":parseInt(this.userId)}

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log("allportfolios",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.portfolioList=data.RW_PORTFOLIOS
			//this.selectPorfolioName	
			if(this.portfolioList.length>0){
				this.selectedPortfolio=this.portfolioList[0].PORTFOLIO_ID;
				this.portfolioDisplayName = this.portfolioList[0].PORTFOLIO_NAME
				console.log(this.portfolioDisplayName)
			} else {
				this.selectedPortfolio = null
				this.portfolioDisplayName = null
			}
			this.getProjectforPortfolioV2()



		});
		//}

	}
	portfolioData;
	getProjectforPortfolio(){
		console.log(this.selectedPortfolio);
		let inputJson={"PROCEDURE":"getprojectsforportfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}

		//let inputJson={"PROCEDURE":"getprojectsforportfoliov2","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log("allportfolios2",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.portfolioData=data.RW_PROJECTS;
			this.toTreeData2();
		});
	}
	
	getAllPortfolios1(){
		//if(!this.portfolioList){
		let inputJson={"PROCEDURE":"getCompanyPortfolios","USER_ID":parseInt(this.userId)}

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log("allportfolios",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.portfolioList=data.RW_PORTFOLIOS
		});
	}
	getAllPortfoliosFromActive(){
		//if(!this.portfolioList){
		let inputJson={"PROCEDURE":"getCompanyPortfolios","USER_ID":parseInt(this.userId)}

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log("allportfolios",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.portfolioList=data.RW_PORTFOLIOS
			//this.selectPorfolioName	
			// if(this.portfolioList.length>0){
			// 	this.selectedPortfolio=this.portfolioList[0].PORTFOLIO_ID;
			// 	this.portfolioDisplayName = this.portfolioList[0].PORTFOLIO_NAME
			// 	console.log(this.portfolioDisplayName)
			// } else {
			// 	this.selectedPortfolio = null
			// 	this.portfolioDisplayName = null
			// }
			this.getProjectforPortfolioV2()



		});
	}

	portfolioDataV2
	portfolioDisplayName
	numPortfolioReports = 0;
	profolipZipUrl='';
	getProjectforPortfolioV2(){
		this.loading = true;

		console.log(this.selectedPortfolio);
		console.log(this.portfolioList)
		let index=this.portfolioList.findIndex(portfolio=>portfolio.PORTFOLIO_ID==this.selectedPortfolio); console.log(index)
		if(index>-1){
			console.log(this.portfolioList[index])
			this.portfolioDisplayName = this.portfolioList[index].PORTFOLIO_NAME
			console.log(this.portfolioDisplayName)
		}
		// console.log(this.selectedPortfolio);
		//let inputJson={"PROCEDURE":"getprojectsforportfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}
		this.curSelectConsultant = null
		let inputJson={"PROCEDURE":"getprojectsforportfoliov2","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.numPortfolioReports = data.REPORT_TOTAL
			this.profolipZipUrl=data.PORTFOLIO_ZIP_URL;
			console.log("allportfoliosV2",data);
			this.portfolioDataV2=data.REPORT_LIST;
			
			for(let i =0; i<this.portfolioDataV2.length; i ++){
				this.portfolioDataV2[i]['flat']={};
				this.portfolioDataV2[i].ASSESSORTITLE={"TITLE":this.portfolioDataV2[i].ASSESSOR_TITLE};
				this.portfolioDataV2[i].REVIEWERTITLE={"TITLE":this.portfolioDataV2[i].REVIEWER_TITLE};
				this.portfolioDataV2[i].flat.PROJECT_NUMBER=this.portfolioDataV2[i].PROJECT_NUMBER;
				this.portfolioDataV2[i].flat.PROPERTY_NAME=this.portfolioDataV2[i].PROPERTY_NAME;
				this.portfolioDataV2[i].flat.ADDRESS_LINE1= this.portfolioDataV2[i].ADDRESS_LINE1;
				this.portfolioDataV2[i].flat.ADDRESS_LINE2= this.portfolioDataV2[i].ADDRESS_LINE2;
				this.portfolioDataV2[i].flat.CITY= this.portfolioDataV2[i].CITY;
				this.portfolioDataV2[i].flat.PROVSTATE= this.portfolioDataV2[i].PROVSTATE;
				this.portfolioDataV2[i].flat.POSTALZIP= this.portfolioDataV2[i].POSTALZIP;
				this.portfolioDataV2[i].flat.REPORT_ID= this.portfolioDataV2[i].REPORT_ID;
				// if(this.portfolioDataV2[i].PORTFOLIO.length>0){
				// 	console.log("portfolio found", this.portfolioDataV2[i])
				// }
				if(this.portfolioDataV2[i].PROTOCOL&& this.portfolioDataV2[i].PROTOCOL[0]){
					this.portfolioDataV2[i].flat.PROTOCOL=this.portfolioDataV2[i].PROTOCOL[0].PROTOCOL;
				}
				if(this.portfolioDataV2[i].TRANSACTION_TYPE && this.portfolioDataV2[i].TRANSACTION_TYPE[0]){
					this.portfolioDataV2[i].flat.TRANSACTION_TYPE=this.portfolioDataV2[i].TRANSACTION_TYPE[0].TRANSACTION_TYPE;
				}
				if(this.portfolioDataV2[i].ASSESSOR && this.portfolioDataV2[i].ASSESSOR[0]){
					this.portfolioDataV2[i].flat.ASSESSOR=this.portfolioDataV2[i].ASSESSOR[0].FULL_NAME? this.portfolioDataV2[i].ASSESSOR[0].FULL_NAME : this.portfolioDataV2[i].ASSESSOR[0].USER_EMAIL;
				}
				if(this.portfolioDataV2[i].REVIEWER && this.portfolioDataV2[i].REVIEWER[0]){
					this.portfolioDataV2[i].flat.REVIEWER=this.portfolioDataV2[i].REVIEWER[0].FULL_NAME? this.portfolioDataV2[i].REVIEWER[0].FULL_NAME : this.portfolioDataV2[i].REVIEWER[0].USER_EMAIL;
				}
				// if(this.portfolioDataV2[i].ASSIGNED_USERS && this.portfolioDataV2[i].ASSIGNED_USERS[0]){
				// 	this.portfolioDataV2[i].flat.ASSIGNED_USERS=this.portfolioDataV2[i].ASSIGNED_USERS[0].FULL_NAME? this.portfolioDataV2[i].ASSIGNED_USERS[0].FULL_NAME : this.portfolioDataV2[i].ASSIGNED_USERS[0].USER_EMAIL;
				// }
				if (this.portfolioDataV2[i].ASSIGNED_USERS) {
					this.portfolioDataV2[i].flat.ASSIGNED_USERS=this.portfolioDataV2[i].ASSIGNED_USERS.map(user=>user.FULL_NAME);
					this.portfolioDataV2[i].flat.ASSIGNED_USERS_ID=this.portfolioDataV2[i].ASSIGNED_USERS.map(user=>user.USER_ID);
				}
				if(this.portfolioDataV2[i].TEMPLATE && this.portfolioDataV2[i].TEMPLATE[0]){
					this.portfolioDataV2[i].flat.TEMPLATE=this.portfolioDataV2[i].TEMPLATE[0].TEMPLATE_TITLE
				}
				if(!this.portfolioDataV2[i].ASSESSOR){
					
					this.portfolioDataV2[i].ASSESSOR=[];
				}
				if(!this.portfolioDataV2[i].REVIEWER){
					this.portfolioDataV2[i].REVIEWER=[];
				}
				if(!this.portfolioDataV2[i].ASSIGNED_USERS){
					this.portfolioDataV2[i].ASSIGNED_USERS=[];
				}
				let date=Date.now();
				//rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
				this.portfolioDataV2[i].ASSESSOR_DATE=this.portfolioDataV2[i].ASSESSOR_DUE_DATE ==""? null: new Date (this.portfolioDataV2[i].ASSESSOR_DUE_DATE);
				this.portfolioDataV2[i].ASSESSOR_DATE_RED= this.portfolioDataV2[i].ASSESSOR_DATE? this.portfolioDataV2[i].ASSESSOR_DATE<=date: false
				// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
				this.portfolioDataV2[i].REPORT_RECEIVED_DATE_DATE=(this.portfolioDataV2[i].REPORT_RECEIVED_DATE===undefined || this.portfolioDataV2[i].REPORT_RECEIVED_DATE=="")? null: new Date (this.portfolioDataV2[i].REPORT_RECEIVED_DATE);
				this.portfolioDataV2[i].REVIEWER_DATE=this.portfolioDataV2[i].REVIEWER_DUE_DATE==""? null: new Date (this.portfolioDataV2[i].REVIEWER_DUE_DATE);
				this.portfolioDataV2[i].REVIEWER_DATE_RED= this.portfolioDataV2[i].REVIEWER_DATE? this.portfolioDataV2[i].REVIEWER_DATE<=date : false
				this.portfolioDataV2[i].REPORT_DATE=this.portfolioDataV2[i].REPORT_DUE_DATE==""? null: new Date (this.portfolioDataV2[i].REPORT_DUE_DATE);
				this.portfolioDataV2[i].REPORT_DATE_RED= this.portfolioDataV2[i].REPORT_DATE? this.portfolioDataV2[i].REPORT_DATE<=date: false

				this.portfolioDataV2[i].REPORT_COMPANY_NAME = this.portfolioDataV2[i].REPORT_COMPANY===undefined? null : this.portfolioDataV2[i].REPORT_COMPANY.REPORT_COMPANY_NAME
				this.portfolioDataV2[i].REPORT_GROUP = this.portfolioDataV2[i].REPORT_GROUP===undefined? null : this.portfolioDataV2[i].REPORT_GROUP;

				//console.log(this.portfolioDataV2[i])
			}
			console.log('new',this.portfolioDataV2)

			this.loading = false;

		});
		
	}
	protfolioInfo=[];
	loading8=false;
	public getPortfolioRptList(){
		this.loading8=true;
		let inputJson1={"PROCEDURE":"getportfolioreportlist","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
					
					this.loading8=false;
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						//return										
					}else{
						if(data.PORTFOLIO_INFO.length>0){
							//this.deliverPortfolioInfo=JSON.parse(JSON.stringify(this.portfolioDataV2));
							this.protfolioInfo=this.addRptInfoTo(JSON.parse(data.PORTFOLIO_INFO), this.portfolioDataV2);
						}
						
					}					
				})
	}
	addRptInfoTo(rpts,group){
		let arr=[];
		for(let rpt of rpts){
			let index=group.findIndex(item=>item.REPORT_ID==rpt.id);
			if(index>-1){
				let srcRpt=group[index];
				let item=JSON.parse(JSON.stringify(rpt));
				item['reportInfo']=srcRpt.REPORT_TITLE+"( "+srcRpt.PROJECT_NUMBER+' - '+srcRpt.PROPERTY_NAME+" )--"+srcRpt.FULL_ADDRESS;
				arr.push(item)
			}
		}
		
		return arr
	}
	private getProjectforPortfolioRefresh(){
		let that = this;
		let refreshActiveData;
		let inputJson={"PROCEDURE":"getprojectsforportfoliov2","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}
	
		that.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getprojectsforportfoliov2, from refresh", data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			refreshActiveData = data.REPORT_LIST
			that.numPortfolioReports = data.REPORT_TOTAL;
			that.profolipZipUrl=data.PORTFOLIO_ZIP_URL;
			// this is for exporting to excel and for sorting/filtering
			for (let i = 0; i<refreshActiveData.length; i++) {
				refreshActiveData[i]['flat']={};
				refreshActiveData[i].ASSESSORTITLE={"TITLE":refreshActiveData[i].ASSESSOR_TITLE};
				refreshActiveData[i].REVIEWERTITLE={"TITLE":refreshActiveData[i].REVIEWER_TITLE};
				refreshActiveData[i].flat.PROJECT_NUMBER=refreshActiveData[i].PROJECT_NUMBER;
				refreshActiveData[i].flat.PROPERTY_NAME=refreshActiveData[i].PROPERTY_NAME;
				refreshActiveData[i].flat.ADDRESS_LINE1= refreshActiveData[i].ADDRESS_LINE1;
				refreshActiveData[i].flat.ADDRESS_LINE2= refreshActiveData[i].ADDRESS_LINE2;
				refreshActiveData[i].flat.CITY= refreshActiveData[i].CITY;
				refreshActiveData[i].flat.PROVSTATE= refreshActiveData[i].PROVSTATE;
				refreshActiveData[i].flat.POSTALZIP= refreshActiveData[i].POSTALZIP;
				refreshActiveData[i].flat.REPORT_ID= refreshActiveData[i].REPORT_ID;
				if(refreshActiveData[i].PROTOCOL&& refreshActiveData[i].PROTOCOL[0]){
					refreshActiveData[i].flat.PROTOCOL=refreshActiveData[i].PROTOCOL[0].PROTOCOL;
				}
				if(refreshActiveData[i].TRANSACTION_TYPE && refreshActiveData[i].TRANSACTION_TYPE[0]){
					refreshActiveData[i].flat.TRANSACTION_TYPE=refreshActiveData[i].TRANSACTION_TYPE[0].TRANSACTION_TYPE;
				}
				if(refreshActiveData[i].ASSESSOR && refreshActiveData[i].ASSESSOR[0]){
					refreshActiveData[i].flat.ASSESSOR=refreshActiveData[i].ASSESSOR[0].FULL_NAME? refreshActiveData[i].ASSESSOR[0].FULL_NAME : refreshActiveData[i].ASSESSOR[0].USER_EMAIL;
					refreshActiveData[i].flat.ASSESSOR_ID=refreshActiveData[i].ASSESSOR[0].USER_ID;
				}
				if(refreshActiveData[i].REVIEWER && refreshActiveData[i].REVIEWER[0]){
					refreshActiveData[i].flat.REVIEWER=refreshActiveData[i].REVIEWER[0].FULL_NAME? refreshActiveData[i].REVIEWER[0].FULL_NAME : refreshActiveData[i].REVIEWER[0].USER_EMAIL;
					refreshActiveData[i].flat.REVIEWER_ID=refreshActiveData[i].REVIEWER[0].USER_ID;
				}
				if (refreshActiveData[i].ASSIGNED_USERS) {
					refreshActiveData[i].flat.ASSIGNED_USERS=refreshActiveData[i].ASSIGNED_USERS.map(user=>user.FULL_NAME);
					refreshActiveData[i].flat.ASSIGNED_USERS_ID=refreshActiveData[i].ASSIGNED_USERS.map(user=>user.USER_ID);
				}
				if(refreshActiveData[i].PROJECT_MANAGER && refreshActiveData[i].PROJECT_MANAGER[0]){
					refreshActiveData[i].flat.PROJECT_MANAGER_ID=refreshActiveData[i].PROJECT_MANAGER[0].USER_ID; // this is only needed for assigned to me filter
				}
				if(refreshActiveData[i].TEMPLATE && refreshActiveData[i].TEMPLATE[0]){
					refreshActiveData[i].flat.TEMPLATE=refreshActiveData[i].TEMPLATE[0].TEMPLATE_TITLE
				}
				if(!refreshActiveData[i].ASSESSOR){
					refreshActiveData[i].ASSESSOR=[];
				}
				if(!refreshActiveData[i].REVIEWER){
					refreshActiveData[i].REVIEWER=[];
				}
				if(!refreshActiveData[i].ASSIGNED_USERS){
					refreshActiveData[i].ASSIGNED_USERS=[];
				}
				let date=Date.now();
				//rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
				refreshActiveData[i].ASSESSOR_DATE=refreshActiveData[i].ASSESSOR_DUE_DATE ==""? null: new Date (refreshActiveData[i].ASSESSOR_DUE_DATE);
				refreshActiveData[i].ASSESSOR_DATE_RED= refreshActiveData[i].ASSESSOR_DATE? refreshActiveData[i].ASSESSOR_DATE<=date: false
				// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
				refreshActiveData[i].REPORT_RECEIVED_DATE_DATE=(refreshActiveData[i].REPORT_RECEIVED_DATE===undefined || refreshActiveData[i].REPORT_RECEIVED_DATE=="")? null: new Date (refreshActiveData[i].REPORT_RECEIVED_DATE);
				refreshActiveData[i].REVIEWER_DATE=refreshActiveData[i].REVIEWER_DUE_DATE==""? null: new Date (refreshActiveData[i].REVIEWER_DUE_DATE);
				refreshActiveData[i].REVIEWER_DATE_RED= refreshActiveData[i].REVIEWER_DATE? refreshActiveData[i].REVIEWER_DATE<=date : false
				refreshActiveData[i].REPORT_DATE=refreshActiveData[i].REPORT_DUE_DATE==""? null: new Date (refreshActiveData[i].REPORT_DUE_DATE);
				refreshActiveData[i].REPORT_DATE_RED= refreshActiveData[i].REPORT_DATE? refreshActiveData[i].REPORT_DATE<=date: false

				refreshActiveData[i].REPORT_COMPANY_NAME = refreshActiveData[i].REPORT_COMPANY===undefined? null : refreshActiveData[i].REPORT_COMPANY.REPORT_COMPANY_NAME
				refreshActiveData[i].REPORT_GROUP = refreshActiveData[i].REPORT_GROUP===undefined? null : refreshActiveData[i].REPORT_GROUP;

				//console.log(refreshActiveData[i])
			}
			// that.activeDataHolder = JSON.parse(JSON.stringify(refreshActiveData));

			// check difference between old and new data that already exists
			for (let report of refreshActiveData) {
				let index;
				if (report.REPORT_ID !== undefined) {
					index = that.portfolioDataV2.findIndex(old_report => (old_report.REPORT_ID !== undefined) && (old_report.REPORT_ID == report.REPORT_ID)); //console.log(index)
				} else {
					index = that.portfolioDataV2.findIndex(old_report => (old_report.REPORT_ID === undefined) && (old_report.PROJECT_ID == report.PROJECT_ID));
				}

				if (index > -1) {
					that.portfolioDataV2[index].PERCENT_COMPLETE = report.PERCENT_COMPLETE
					that.portfolioDataV2[index].REVIEWER_PROGRESS = report.REVIEWER_PROGRESS
					that.portfolioDataV2[index].PROJECT_NUMBER = report.PROJECT_NUMBER
					that.portfolioDataV2[index].PROPERTY_NAME = report.PROPERTY_NAME
					that.portfolioDataV2[index].FULL_ADDRESS = report.FULL_ADDRESS
					
					if ((that.portfolioDataV2[index].TEMPLATE !== undefined && report.TEMPLATE !== undefined) &&
						(that.portfolioDataV2[index].TEMPLATE[0] !== undefined && report.TEMPLATE[0] !== undefined)) {
						that.portfolioDataV2[index].TEMPLATE[0].TEMPLATE_TITLE = report.TEMPLATE[0].TEMPLATE_TITLE
					}

					that.portfolioDataV2[index].ASSESSOR_DUE_DATE = report.ASSESSOR_DATE
					that.portfolioDataV2[index].ASSESSOR_DUE_DATE = report.ASSESSOR_DUE_DATE
					that.portfolioDataV2[index].REPORT_RECEIVED_DATE = report.REPORT_RECEIVED_DATE_DATE
					that.portfolioDataV2[index].REPORT_RECEIVED_DATE = report.REPORT_RECEIVED_DATE
					that.portfolioDataV2[index].REVIEWER_DUE_DATE = report.REVIEWER_DATE
					that.portfolioDataV2[index].REVIEWER_DUE_DATE = report.REVIEWER_DUE_DATE
					that.portfolioDataV2[index].REPORT_DUE_DATE = report.REPORT_DATE
					that.portfolioDataV2[index].REPORT_DUE_DATE = report.REPORT_DUE_DATE
					that.portfolioDataV2[index].ASSESSOR_DATE_RED = report.ASSESSOR_DATE_RED
					that.portfolioDataV2[index].REPORT_DATE_RED = report.REPORT_DATE_RED
					that.portfolioDataV2[index].REPORT_RECEIVED_DATE_RED = report.REPORT_RECEIVED_DATE_RED
					that.portfolioDataV2[index].ASSESSOR = JSON.parse(JSON.stringify(report.ASSESSOR));
					that.portfolioDataV2[index].REVIEWER = JSON.parse(JSON.stringify(report.REVIEWER));
					that.portfolioDataV2[index].ASSIGNED_USERS = JSON.parse(JSON.stringify(report.ASSIGNED_USERS));
					that.portfolioDataV2[index].ORDER_NUM = report.ORDER_NUM
					if (report.ORDER_REPORTS !== undefined) {
						that.portfolioDataV2[index].ORDER_REPORTS = JSON.parse(JSON.stringify(report.ORDER_REPORTS));
					}
					that.portfolioDataV2[index].CONSULTANT_LOCATION.LOCATION_NAME = report.CONSULTANT_LOCATION.LOCATION_NAME
					that.portfolioDataV2[index].STATUS = report.STATUS
					that.portfolioDataV2[index].TRANSACTION_TYPE = JSON.parse(JSON.stringify(report.TRANSACTION_TYPE));
					that.portfolioDataV2[index].PROTOCOL = JSON.parse(JSON.stringify(report.PROTOCOL));
					
					that.portfolioDataV2[index].REPORT_COMPANY_NAME = report.REPORT_COMPANY===undefined? null : report.REPORT_COMPANY.REPORT_COMPANY_NAME
					that.portfolioDataV2[index].REPORT_GROUP = report.REPORT_GROUP===undefined? null : report.REPORT_GROUP;

					// if(that.activeData[index].TRANSACTION_TYPE[0]!==undefined&&report.TRANSACTION_TYPE[0]!==undefined){
					// 	that.activeData[index].TRANSACTION_TYPE[0].TRANSACTION_TYPE = report.TRANSACTION_TYPE[0].TRANSACTION_TYPE
					// }
				}
			}

			// check if need to delete any reports from portfolioDataV2
			for(let i = 0; i < that.portfolioDataV2.length; i++){
				let match = false
				// in this case, it is an empty project
				if (that.portfolioDataV2[i].REPORT_ID === undefined) {
					for (let j =0; j < refreshActiveData.length; j++) {
						if (that.portfolioDataV2[i].PROJECT_ID == refreshActiveData[j].PROJECT_ID && refreshActiveData[j].REPORT_ID === undefined) {
							match = true;
						}
					}
					if (match == false) {
						console.log("FLAG2")
						that.portfolioDataV2 = that.removeNoReportID(that.portfolioDataV2, that.portfolioDataV2[i].PROJECT_ID);
						i--;
					}
				// in this case, it is a report
				} else {
					for (let j =0; j < refreshActiveData.length; j++) {
						if (that.portfolioDataV2[i].REPORT_ID == refreshActiveData[j].REPORT_ID) {
							match = true
						}
					}
					if (match == false) {
						console.log("FLAG")
						that.portfolioDataV2 = that.remove(that.portfolioDataV2, that.portfolioDataV2[i].REPORT_ID);
						i--;
					}
				}
			}
			
			// check if need to add any reports to portfolioDataV2
			for(let i = 0; i < refreshActiveData.length; i++){
				let match = false
				
				// empty project case
				if (refreshActiveData[i].REPORT_ID === undefined) {
					for (let j =0; j < that.portfolioDataV2.length; j++) {
						if (that.portfolioDataV2[j].REPORT_ID === undefined && that.portfolioDataV2[j].PROJECT_ID == refreshActiveData[i].PROJECT_ID) {
							match = true
						}
					}
				// project has reports case
				} else {
					for (let j =0; j < that.portfolioDataV2.length; j++) {
						if (that.portfolioDataV2[j].REPORT_ID == refreshActiveData[i].REPORT_ID) {
							match = true
						}
					}
				}
				if (match == false) {
					// console.log("FLAG")
					// console.log(refreshActiveData[i])
					//that.activeData.unshift(refreshActiveData[i])
					//that.activeData = [...that.activeData, refreshActiveData[i]]
					that.portfolioDataV2 = [refreshActiveData[i],...that.portfolioDataV2]
				}
			}
			
			// that.getStatusCounts();
			// that.resetTableFilters1();

		})

		that.autoRefresh();
		
	}

	replaceWord;
	searchWord;
	searchAndReplace(){
		let inputJson={"PROCEDURE":"searchreplaceportfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio,"ORIG_WORD":this.searchWord,"REPLACE_WORD":this.replaceWord}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.searchWord=this.replaceWord;
			this.tt2.filterGlobal(this.replaceWord, 'contains')
			console.log("searchAndReplace",data);
			this.getProjectforPortfolio();
			this.getAllReportByGroup(this.groupkey);
		});
	}
	portfolioRecords=0;
	portfolioTreeData:TreeNode[];
	toTreeData2(){
		this.portfolioTreeData=[];
		this.portfolioRecords=0;
		let metaData={'data':[]};
		for(const [i, report] of this.portfolioData.entries()){
			this.portfolioRecords++;
			// console.log(report, i);
			let data={
				"data":{
					"GROUP_LABEL":report.PROJECT_NUMBER,
					"PROJECT_ID":report.PROJECT_ID,
					"highlight":report.PROJECT_ID==this.justAddedID,
					"size":report.RW_REPORTS.length,
					'project':true,
					"added":report.added?true:false,
				},

				"children":[],
				expanded: true,
			}
			// console.log(data);
			if(true){
				for(const [j, rpt]  of report.RW_REPORTS.entries()){
	
					rpt['flat']={};
					if(rpt.PERCENT_COMPLETE){
						rpt.PERCENT_COMPLETE=parseFloat(rpt.PERCENT_COMPLETE.replace('%','')).toFixed(2)
					}
					if(rpt.REVIEWER_PROGRESS){
						rpt.REVIEWER_PROGRESS=parseFloat(rpt.REVIEWER_PROGRESS.replace('%','')).toFixed(2)
					}
				//	rpt.PERCENT_COMPLETE=rpt.PERCENT_COMPLETE *3.6
				//	rpt.PERCENT_COMPLETE=50 *3.6
				//	rpt.REVIEWER_PROGRESS=rpt.REVIEWER_PROGRESS *3.6
				//	rpt.REVIEWER_PROGRESS=50 *3.6
					rpt.ASSESSORTITLE={"TITLE":rpt.ASSESSOR_TITLE};
					rpt.REVIEWERTITLE={"TITLE":rpt.REVIEWER_TITLE};
					rpt.flat.PROJECT_NUMBER=rpt.PROJECT_NUMBER;
					rpt.flat.PROPERTY_NAME=rpt.PROPERTY_NAME;
					rpt.flat.ADDRESS_LINE1= rpt.ADDRESS_LINE1;
					rpt.flat.ADDRESS_LINE2= rpt.ADDRESS_LINE2;
					rpt.flat.CITY= rpt.CITY;
					rpt.flat.PROVSTATE= rpt.PROVSTATE;
					rpt.flat.POSTALZIP= rpt.POSTALZIP;
					rpt.flat.REPORT_ID= rpt.REPORT_ID;
					if(rpt.PORTFOLIO.length>0){
						console.log("portfolio found", rpt, report)
					}
					if(rpt.PROTOCOL&& rpt.PROTOCOL[0]){
						rpt.flat.PROTOCOL=rpt.PROTOCOL[0].PROTOCOL;
					}
					if(rpt.TRANSACTION_TYPE && rpt.TRANSACTION_TYPE[0]){
						rpt.flat.TRANSACTION_TYPE=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE;
					}
					if(rpt.ASSESSOR && rpt.ASSESSOR[0]){
						rpt.flat.ASSESSOR=rpt.ASSESSOR[0].FULL_NAME? rpt.ASSESSOR[0].FULL_NAME : rpt.ASSESSOR[0].USER_EMAIL;
					}
					if(rpt.REVIEWER && rpt.REVIEWER[0]){
						rpt.flat.REVIEWER=rpt.REVIEWER[0].FULL_NAME? rpt.REVIEWER[0].FULL_NAME : rpt.REVIEWER[0].USER_EMAIL;
					}
					// if(rpt.ASSIGNED_USERS && rpt.ASSIGNED_USERS[0]){
					// 	rpt.flat.ASSIGNED_USERS=rpt.
					// 	ASSIGNED_USERS[0].FULL_NAME? rpt.ASSIGNED_USERS[0].FULL_NAME : rpt.ASSIGNED_USERS[0].USER_EMAIL;
					// }
					if (rpt.ASSIGNED_USERS) {
						rpt.flat.ASSIGNED_USERS=rpt.ASSIGNED_USERS.map(user=>user.FULL_NAME);
					}
					if(rpt.TEMPLATE && rpt.TEMPLATE[0]){
						rpt.flat.TEMPLATE=rpt.TEMPLATE[0].TEMPLATE_TITLE
					}
					if(!rpt.ASSESSOR){
						
						rpt.ASSESSOR=[];
					}
					if(!rpt.REVIEWER){
						rpt.REVIEWER=[];
					}
					if(!rpt.ASSIGNED_USERS){
						rpt.ASSIGNED_USERS=[];
					}
					//
					let date=Date.now();
					rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
					rpt.ASSESSOR_DATE=rpt.ASSESSOR_DUE_DATE ==""? null: new Date (rpt.ASSESSOR_DUE_DATE);
					rpt.ASSESSOR_DATE_RED= rpt.ASSESSOR_DATE? rpt.ASSESSOR_DATE<=date: false
					// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
					rpt.REPORT_RECEIVED_DATE_DATE=(rpt.REPORT_RECEIVED_DATE===undefined || rpt.REPORT_RECEIVED_DATE=="")? null: new Date (rpt.REPORT_RECEIVED_DATE);
					rpt.REVIEWER_DATE=rpt.REVIEWER_DUE_DATE==""? null: new Date (rpt.REVIEWER_DUE_DATE);
					rpt.REVIEWER_DATE_RED= rpt.REVIEWER_DATE? rpt.REVIEWER_DATE<=date : false
					rpt.REPORT_DATE=rpt.REPORT_DUE_DATE==""? null: new Date (rpt.REPORT_DUE_DATE);
					rpt.REPORT_DATE_RED= rpt.REPORT_DATE? rpt.REPORT_DATE<=date: false
					//rpt.PROJECT_NAME=rpt.REPORT_TYPE; //console.log(rpt)
					rpt.groupIndex=i;
					rpt.reportIndex=j;
					data.children.push({'data':rpt});
				}
			}
			this.portfolioTreeData.push(data);
		}
		//this.ngZone.run(()=>{	this.reportTreeData=metaData.data;})
		// this.ref.markForCheck();
		this.portfolioTreeData = [].concat(this.portfolioTreeData);
		console.log("portfolioTreeData", this.portfolioTreeData);	
	}

	@Input() get selectedColumns(): any[] {
        return this._selectedColumns
    }

    set selectedColumns(val: any[]) {
        //restore original order
		let valheaders = val.map(col=>col.header);
		let permanent = ['GROUP_LABEL', 'PROJECT_NUMBER', 'REPORT_TITLE'];
        this._selectedColumns = this.portfolioCols.filter(col => valheaders.includes(col.header) || permanent.includes(col.field));
    }

	saveSelectedColumns() {
		let converted_columns = this._selectedColumns.map(col => col.field).join() // convert array to string for oracle

		let inputJson = {
			"PROCEDURE":"updaterwuser",
			"USER_ID":parseInt(this.userId),
			"UPDATE_USER_ID":parseInt(this.userId),
			"DASHBOARD_COLUMNS": converted_columns,
		};
		console.log('saveSelectedColumns', inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS === 'N') {
				this.throwError(data);
			} else {
				this.userInfo['DASHBOARD_COLUMNS'] = converted_columns;
				this.cookieService.setCookieSession("userInfo",JSON.stringify(this.userInfo));
			}
		});
	}
	loadSelectedColumns(columns) {
		if (columns === undefined || columns === "*") {
			this._selectedColumns = this.portfolioCols;
		} else {
			let converted_columns = columns.split(',');
			this._selectedColumns = this.portfolioCols.filter(col => converted_columns.includes(col.field));
		}
	}

	deleteSOW(){
		//this.curRptPara.SOW=null;
		this.curRptPara.SOW.FILE_URL='';
	}
	trackByFuntion(index, item) {
    return index;
  }
	pmList=[];
	getProM(){
		//if(this.pmList.length>0) return;
		let newinputJson = {
			"PROCEDURE": this.companyGroupIndicator ? "getgroupreportuserlist" : "getcompanyuserlist",
			"USER_ID": parseInt(this.userId),
			"INCLUDE_EXTERNAL": "N",
			"ACTIVE_ONLY": "Y"
		}; // hardcoded for now 

		this.reportService.univeralService(JSON.stringify(newinputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.pmList=["", ...data.RW_USERS]; // add a empty string to have blank option in the user selection
			console.log("PMLIST", this.pmList);
		})
	}

	companyGroupIndicator = false;
	getCompanyGroupIndicator() {
		let getcompanyinfoJson = { "PROCEDURE": "getcompanyprofile", "USER_ID": parseInt(this.userId) };
		this.reportService.univeralService(JSON.stringify(getcompanyinfoJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return;
			}

			this.companyGroupIndicator = data.COMPANY_GROUP_IND === 'Y' ? true : false;
		});
	}

	async _getCompanyGroupIndicator() {
		let getcompanyinfoJson = { "PROCEDURE": "getcompanyprofile", "USER_ID": parseInt(this.userId) };
		return new Promise<void>((resolve, reject) => {
			this.reportService.univeralService(JSON.stringify(getcompanyinfoJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data);
					reject();
				} else {
					this.companyGroupIndicator = data.COMPANY_GROUP_IND === 'Y' ? true : false;
					resolve();
				}
			});
		});
	}

	userGroups=[];
	getUserGroups() {
		let getusergroupsJson = {"PROCEDURE":"getusergroups", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(getusergroupsJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
				return;
			}
			
			// empty and push to userGroups to avoid changing reference of userGroups
			// because it refreshes the select element in add new report modal
			if (JSON.stringify(this.userGroups) !== JSON.stringify(data.GROUP_LIST)) {
				this.userGroups.length = 0;
				Array.prototype.push.apply(this.userGroups, data.GROUP_LIST);
			}
		});
	}

	// need to toggle after getting user's groups or it will go out of screen
	// i think this also happens to the status toggle if it's the last column which may need a fix
	toggleUserGroups(event: any, op1: any) {
		let getusergroupsJson = {"PROCEDURE":"getusergroups", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(getusergroupsJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data);
				return;
			}
			
			this.userGroups = data.GROUP_LIST;
			op1.toggle(event);
		});
	}

	changed=false;
	addSingleRptErrorMessage = ''
	displayAddSingleRptErrorMessage = null
	addSingleRpt(item){console.log('item',item)		//flag
		item['toAdd']=false;
		if(item.selectedSubCat&&item.selectedSubCat.typeId&&
			item.selectedTemplate&&item.selectedTemplate.TEMPLATE_TITLE!=null&&
			(!this.companyGroupIndicator || (item.selectedGroup && item.selectedGroup.GROUP_NAME != null))) {
			this.displayAddSingleRptErrorMessage = false
			console.log('selectedsubcat', item.selectedSubCat)
			console.log('typeID', item.selectedSubCat.typeId )
			console.log('allTypeRpt',this.allTypeRpt)
			console.log(this.allTypeRpt[0])
			//console.log(this.allTypeRpt[0].selectedSubCat.typeId)

			// for(let i = 0; i<this.allTypeRpt.length; i ++){
			// 	console.log('allTypeRpt typeID', this.allTypeRpt[i].selectedSubCat.typeId)
			// }
			let index=this.allTypeRpt.findIndex(rpt=>rpt.selectedSubCat!==null && rpt.selectedSubCat.typeId==item.selectedSubCat.typeId); console.log(index);
			if(index==-1){
				item['added']=false;
				item.selected=true;
				console.log(this.curTempCategories);
				item.REPORT_TITLE=this.curProject.PROJECT_NAME+item.selectedSubCat.subCategory;
				item['REPORT_ID'] = null
				let copy=JSON.parse(JSON.stringify(item));
				this.allTypeRpt.push(copy); console.log('addSingle', this.allTypeRpt);
				this.changed=true;
				this.setDisplaySections(7);
				this.clearInvite2(item.userList);console.log(item);
				//this.resetReport("N");
			}else{
				item['added']=true;
			}
		}else{
			this.displayAddSingleRptErrorMessage = true
			//console.log(this.displayAddSingleRptErrorMessage)
			item['toAdd']=true;
			if (!(item.selectedSubCat&&item.selectedSubCat.typeId)&&item.selectedTemplate.TEMPLATE_TITLE==null) {
				this.addSingleRptErrorMessage = '* Template Identifier and Template are required.'
			} else if (item.selectedTemplate==null || item.selectedTemplate.TEMPLATE_TITLE==null) {
				this.addSingleRptErrorMessage = '* Template is required.'
			} else if (this.companyGroupIndicator&&(item.selectedGroup==null || item.selectedGroup.GROUP_NAME==null)){
				this.addSingleRptErrorMessage = '* Group is required.'
			}
		}
			/*
			selectedSubCat:
				selected: false
				subCategory: "Construction Progress Monitoring (CPM)"
				typeId: 5
			
			let addedRpt
			(index,e, array=this.allTypeRpt){
		
		if($(e.target).prop('checked')){
			array[index].selected=true;
			if (array == this.allTypeRpt) {
				array[index].REPORT_TITLE=this.curProject.PROJECT_NAME+array[index].types.REPORT_TYPE;
			}
	for(let rpt of that.allTypeRpt){
					rpt.selected=true
					rpt.REPORT_TITLE=that.curProject.PROJECT_NAME+rpt.types.REPORT_TYPE;
			
				}
			(change)="selectType(i, $event, this.curTempCategories); 
			setDisplaySections(7); clearInvite2(cat.userList)*/
	}
	deleteTRpt(index){
		this.allTypeRpt.splice(index,1);
		console.log(this.allTypeRpt)
	}
	updatePM(rowdata){
		// console.log(rowdata)
		let inputJson = {
			"PROCEDURE":"updatereport",
			"USER_ID": parseInt(this.userId),
			"PROJECT_ID":rowdata.PROJECT_ID,
			'REPORT_ID':rowdata.REPORT_ID,
			"PROJECT_MANAGER_ID":rowdata.PROJECT_MANAGER[0]? rowdata.PROJECT_MANAGER[0].USER_ID : null
		};
		console.log("updatePM", inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			let Toast=Swal.mixin({
				toast: true,						
				position: 'center',
				showConfirmButton: false,
				timer: 3000
			})
			if(data.RESPONSE_STATUS=='Y'){
				Toast.fire({
					icon: 'success',
					title: data.MESSAGE
				})
				rowdata.flat['PROJECT_MANAGER_ID'] = rowdata.PROJECT_MANAGER[0]? rowdata.PROJECT_MANAGER[0].USER_ID : null; // this is for assignedtome search
				this.getStatusCounts();
			}else{
				this.throwError(data);
			}
			
		})
	}
	resetOriginalData(){
		this.originalData = undefined
		this.curSelectConsultant = null
		this.newReportPortfolio='';
		this.selectExisting=true;
		console.log(this.originalData)
	}
	getReports(){
		//
		console.log('ORIGINALDATA', this.originalData)
		if(!this.changed){
			this.allTypeRpt=[];
			if(this.originalData){ //FLAG //FLAG
				for(let i=0; i<this.originalData.RW_REPORTS.length;i++){

					// this was here before, preserving just in case
					// let index=this.curTempCategories.findIndex(cat=>cat.category==this.originalData.RW_REPORTS[i].REPORT_CATEGORY); console.log('index',index)
					// if(index>-1){
					// 	let cat=this.curTempCategories[index]; console.log('singlecat',cat);
					// 	let copy=JSON.parse(JSON.stringify(cat));console.log('singlecat1',copy);
					// 	this.allTypeRpt.push(copy);console.log('singlecats',this.allTypeRpt);
					// }

					let rpt;

					let index=this.curTempCategories.findIndex(cat=>cat.category==this.originalData.RW_REPORTS[i].REPORT_CATEGORY); console.log('index',index)
					if(index>-1){
						let cat=this.curTempCategories[index]; console.log('singlecat',cat);
						rpt=JSON.parse(JSON.stringify(cat));
					}

					rpt.userList = {
						assessor: this.originalData.RW_REPORTS[i].ASSESSOR[0]? this.originalData.RW_REPORTS[i].ASSESSOR[0] : "",
						reviewer: this.originalData.RW_REPORTS[i].REVIEWER[0]? this.originalData.RW_REPORTS[i].REVIEWER[0] : "",
						assessortitle: this.originalData.RW_REPORTS[i].ASSESSOR_TITLE[0]? this.originalData.RW_REPORTS[i].ASSESSOR_TITLE[0] : {},
						reviewertitle: this.originalData.RW_REPORTS[i].REVIEWER_TITLE[0]? this.originalData.RW_REPORTS[i].REVIEWER_TITLE[0] : {},
						assigned_user: this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0]? this.originalData.RW_REPORTS[i].ASSIGNED_USERS[0] : "",
						pm: this.originalData.RW_REPORTS[i].PROJECT_MANAGER[0]? this.originalData.RW_REPORTS[i].PROJECT_MANAGER[0] : ""
					}
					rpt['REPORT_ID'] = this.originalData.RW_REPORTS[i].REPORT_ID;

					if (this.originalData.RW_REPORTS[i].TEMPLATE[0]) {
						rpt.selectedSubCat = {
							'subCategory': this.originalData.RW_REPORTS[i].TEMPLATE[0].SUBCATEGORY_NAME,
							'typeId': this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_TYPE_ID,
						}
						rpt.selectedTemplate = {
							'TEMPLATE_TITLE': this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_TITLE,
							'TEMPLATE_ID': this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_ID
						}
						rpt.selectedGroup = this.originalData.RW_REPORTS[i].REPORT_GROUP;
					}

					// rpt.selectedSubCat['subCategory']['typeId'] = 

					// if(this.originalData.RW_REPORTS[i].TEMPLATE[0]){			
					// 	for(let j=0; j<rpt.subCategories.length;j++){
					// 		let subcat=rpt.subCategories[j];
					// 		if(subcat.typeId==this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_TYPE_ID ){
					// 			subcat.selected=true;
					// 			console.log('SELECTED FLAG')
					// 			rpt.selectedSubCat= subcat;
					// 			// this.setByTypeId2(rpt, ()=>{
					// 				// for(let template of rpt.typeIdTemplates){
					// 				for(let template of rpt.typeIdTemplates){
					// 					//console.log("templates", template.TEMPLATE_ID,this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_ID )
					// 					if(template.TEMPLATE_ID==this.originalData.RW_REPORTS[i].TEMPLATE[0].TEMPLATE_ID){
					// 						rpt.selectedTemplate=template;

					// 					}
					// 				}
					// 			// });
					// 		}
					// 	}
					// }

					console.log("rpttt", rpt);
					this.allTypeRpt.push(rpt);

				}
			}
		}
	}

	// afaik this is not used at all:
	getReports2(){
			//setTimeout(	()=>{
				if(!this.changed){
					this.allTypeRpt=[];
				if(this.originalData){
				for(let i=0; i<this.originalData.RW_REPORTS.length;i++){
					let index=this.curTempCategories.findIndex(cat=>cat.category==this.originalData.RW_REPORTS[i].REPORT_CATEGORY); console.log('index',index)
					if(index>-1){
						let cat=this.curTempCategories[index]; console.log('singlecat',cat);
						let copy=JSON.parse(JSON.stringify(cat));console.log('singlecat1',copy);
						this.allTypeRpt.push(copy);console.log('singlecats',this.allTypeRpt);
					}
				}
				}
				}
				
		//this.getErisInfo();
	//}, 1000);

	}
	resetReport(type){
		for (let obj of this.curTempCategories) {
			if(obj.subCategories&&type){
				obj.subCategories=null;
			}
			if(obj.typeIdTemplates){
				obj.typeIdTemplates=null;
			}
				//subCategories:null,
				//typeIdTemplates:null,
			if(obj.selectedSubCat){
				obj.selectedSubCat=null;
			}
			if(obj.selectedTemplate){
				obj.selectedTemplate="";
			}
			if(obj.selectedGroup){
				obj.selectedGroup=null;
			}
			obj.userList={
				assessor:"",
				assessortitle:{},
				reviewertitle:{},
				reviewer:"",
				assigned_user:"",
				pm:'',
			};
			if(obj.selected){
				obj.selected=false; 
			}
			if(type=='Y'){
				this.curTypeIndex=null;
			}
			//this.setSubCat(rpt);
			
		}
	}
	consoleLog(item){
		console.log(1)
		console.log(item)
		//console.log(this.erisData)
	}
	consoleLog1(item){
		console.log(2)
		console.log(2, item)
		//console.log(this.erisData)
	}
	checkErisData(){
		console.log(this.erisData)
		if(this.erisData===undefined || this.erisData === null){
			console.log(1)
			this.getErisInfo()
		} else {
			console.log(2)
		}
	}
	resetEmailForm(){
		this.shareEmail = ''
	}

	sideNavWidth = '66px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '66px'
			this.toggleSideBarVar = false
		}
	}
	orderNumberToInsert
	erisDataChange(user, index){
		console.log(user)
		console.log(index)
		console.log(this.erisData.length)
		for(let i = 0; i < this.erisData.length; i++){
			if($("#erisDataCheckBox"+i).prop('checked')==true){
				if(i!=index){
				($("#erisDataCheckBox"+i).prop('checked', false))
				}				
			}
		}
		this.orderNumberToInsert = user.ORDER_NUM
		console.log(this.orderNumberToInsert)
	}
	addOrder1(rowdata){ 
		// let orderno=$(e.target).prev('input').val()?$(e.target).prev('input').val().trim():$(e.target).parent().prev('input').val().trim();console.log(orderno);
		let orderno=this.orderNumberToInsert;
		rowdata.ORDER_NUM = orderno;
		console.log(rowdata);
		let inputJson={"PROCEDURE":"updatereport", "USER_ID":parseInt(this.userId), "PROJECT_ID":rowdata.PROJECT_ID, "PORTFOLIO_ID":rowdata.PORTFOLIO_ID, 'REPORT_ID':rowdata.REPORT_ID, "ORDER_NUM":orderno};
			console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("ORDERREPORTSHERE", data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			rowdata.ORDER_REPORTS=data.ORDER_REPORTS;
			rowdata.ORDER_NUM=data.ORDER_NUM;
			// this.getAllReportByGroup(this.groupkey);
			// let index=this.reports.findIndex(proj=>proj.PROJECT_ID==data.PROJECT_ID);console.log(index)
			// if(index>-1){
			// 	let rpts=this.reports[index].RW_REPORTS;
			// 	let index2=rpts.findIndex(rpt=>rpt.REPORT_ID==data.REPORT_ID);//console.log(index2)
			// 	this.reports[index].RW_REPORTS[index2].ORDER_NUM=data.ORDER_NUM;//console.log(this.reports)
			// 	this.reports[index].RW_REPORTS[index2].ORDER_REPORTS=data.ORDER_REPORTS;
			// 	this.toTreeData();
			// }
		})
	}
	getUserInfo(){
		console.log(this.userInfo);
		let inputJson={"PROCEDURE":"getrwuser","USER_ID":parseInt(this.userInfo.USER_ID),"REQUESTED_USER_ID":parseInt(this.userInfo.USER_ID)}
		console.log("getuserinfo", inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log("userinfo",data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
		  this.userInfo=data;
		})
	
	  }
	incorrect=false;
	ERIS_USERNAME;
	ERIS_PASSWORD;
	verifyErisLoading = false
	verifyEris(event, element){
	  let inputJson={"PROCEDURE":"verifyeriscustomer","USER_ID":parseInt(this.userInfo.USER_ID),"USERNAME":this.ERIS_USERNAME,"PASSWORD":this.ERIS_PASSWORD};
  
		  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			  console.log("verifyEris",data);
		if(data.RESPONSE_STATUS=='Y'){
  
		  this.userInfo.ERIS_CUSTOMER_ID=data.ERIS_CUSTOMER_ID
  
		  let inputJson2 = {
			"PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userInfo.USER_ID), "UPDATE_USER_ID":parseInt(this.userInfo.USER_ID), "ERIS_CUSTOMER_ID":data.ERIS_CUSTOMER_ID
		  }
		  this.verifyErisLoading = true
		  console.log(this.verifyErisLoading)
		  this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			this.verifyErisLoading = false

			console.log("updateuser",data);
			let swalMessage = data.MESSAGE
			let inputJson={"PROCEDURE":"geterisorders","USER_ID":parseInt(this.userId)};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log("getErisInfo", data);
				this.erisData=data.ORDERS
				element.hide(event)
				Swal.fire({
					icon:'success',
					title: swalMessage,
				})
			});			

		
		})


		}else{
		  this.incorrect=true;
		  this.throwError(data)
		}
	  })
	}
	activeData = [];
	numActiveReports = 0
	activeDataHolder
	getActiveReports(){
		this.loading = true;

		let inputJson={"PROCEDURE":"getactivereportsv2","USER_ID": parseInt(this.userInfo.USER_ID)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getactivereports", data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.activeData = data.REPORT_LIST
			this.numActiveReports = data.REPORT_TOTAL
			if(this.statusList[0]!=undefined){
				this.statusList[0].TOTAL = data.REPORT_TOTAL
			}
			for(let i =0; i<this.activeData.length; i ++){
				this.activeData[i]['flat']={};
				this.activeData[i].ASSESSORTITLE={"TITLE":this.activeData[i].ASSESSOR_TITLE};
				this.activeData[i].REVIEWERTITLE={"TITLE":this.activeData[i].REVIEWER_TITLE};
				this.activeData[i].flat.PROJECT_NUMBER=this.activeData[i].PROJECT_NUMBER;
				this.activeData[i].flat.PROPERTY_NAME=this.activeData[i].PROPERTY_NAME;
				this.activeData[i].flat.ADDRESS_LINE1= this.activeData[i].ADDRESS_LINE1;
				this.activeData[i].flat.ADDRESS_LINE2= this.activeData[i].ADDRESS_LINE2;
				this.activeData[i].flat.CITY= this.activeData[i].CITY;
				this.activeData[i].flat.PROVSTATE= this.activeData[i].PROVSTATE;
				this.activeData[i].flat.POSTALZIP= this.activeData[i].POSTALZIP;
				this.activeData[i].flat.REPORT_ID= this.activeData[i].REPORT_ID;
				// if(this.activeData[i].PORTFOLIO.length>0){
				// 	console.log("portfolio found", this.activeData[i])
				// }
				if(this.activeData[i].PROTOCOL&& this.activeData[i].PROTOCOL[0]){
					this.activeData[i].flat.PROTOCOL=this.activeData[i].PROTOCOL[0].PROTOCOL;
				}
				if(this.activeData[i].TRANSACTION_TYPE && this.activeData[i].TRANSACTION_TYPE[0]){
					this.activeData[i].flat.TRANSACTION_TYPE=this.activeData[i].TRANSACTION_TYPE[0].TRANSACTION_TYPE;
				}
				if(this.activeData[i].ASSESSOR && this.activeData[i].ASSESSOR[0]){
					this.activeData[i].flat.ASSESSOR=this.activeData[i].ASSESSOR[0].FULL_NAME? this.activeData[i].ASSESSOR[0].FULL_NAME : this.activeData[i].ASSESSOR[0].USER_EMAIL;
					this.activeData[i].flat.ASSESSOR_ID=this.activeData[i].ASSESSOR[0].USER_ID;
				}
				if(this.activeData[i].REVIEWER && this.activeData[i].REVIEWER[0]){
					this.activeData[i].flat.REVIEWER=this.activeData[i].REVIEWER[0].FULL_NAME? this.activeData[i].REVIEWER[0].FULL_NAME : this.activeData[i].REVIEWER[0].USER_EMAIL;
					this.activeData[i].flat.REVIEWER_ID=this.activeData[i].REVIEWER[0].USER_ID;
				}
				// if(this.activeData[i].ASSIGNED_USERS && this.activeData[i].ASSIGNED_USERS[0]){
				// 	this.activeData[i].flat.ASSIGNED_USERS=this.activeData[i].ASSIGNED_USERS[0].FULL_NAME? this.activeData[i].ASSIGNED_USERS[0].FULL_NAME : this.activeData[i].ASSIGNED_USERS[0].USER_EMAIL;
				// }
				if (this.activeData[i].ASSIGNED_USERS) {
					this.activeData[i].flat.ASSIGNED_USERS=this.activeData[i].ASSIGNED_USERS.map(user=>user.FULL_NAME);
					this.activeData[i].flat.ASSIGNED_USERS_ID=this.activeData[i].ASSIGNED_USERS.map(user=>user.USER_ID);
				}
				if(this.activeData[i].PROJECT_MANAGER && this.activeData[i].PROJECT_MANAGER[0]){
					this.activeData[i].flat.PROJECT_MANAGER_ID=this.activeData[i].PROJECT_MANAGER[0].USER_ID; // this is only needed for assigned to me filter
				}
				if(this.activeData[i].TEMPLATE && this.activeData[i].TEMPLATE[0]){
					this.activeData[i].flat.TEMPLATE=this.activeData[i].TEMPLATE[0].TEMPLATE_TITLE
				}
				if(!this.activeData[i].ASSESSOR){
					this.activeData[i].ASSESSOR=[];
				}
				if(!this.activeData[i].REVIEWER){
					this.activeData[i].REVIEWER=[];
				}
				if(!this.activeData[i].ASSIGNED_USERS){
					this.activeData[i].ASSIGNED_USERS=[];
				}
				let date=Date.now();
				//rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
				this.activeData[i].ASSESSOR_DATE=this.activeData[i].ASSESSOR_DUE_DATE ==""? null: new Date (this.activeData[i].ASSESSOR_DUE_DATE);
				this.activeData[i].ASSESSOR_DATE_RED= this.activeData[i].ASSESSOR_DATE? this.activeData[i].ASSESSOR_DATE<=date: false
				// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
				// vv since if report received date doesn't exist, instead of returning '', oracle just doesn't include the field for some reason???
				this.activeData[i].REPORT_RECEIVED_DATE_DATE=(this.activeData[i].REPORT_RECEIVED_DATE===undefined || this.activeData[i].REPORT_RECEIVED_DATE=="")? null: new Date (this.activeData[i].REPORT_RECEIVED_DATE);
				this.activeData[i].REVIEWER_DATE=this.activeData[i].REVIEWER_DUE_DATE==""? null: new Date (this.activeData[i].REVIEWER_DUE_DATE);
				this.activeData[i].REVIEWER_DATE_RED= this.activeData[i].REVIEWER_DATE? this.activeData[i].REVIEWER_DATE<=date : false
				this.activeData[i].REPORT_DATE=this.activeData[i].REPORT_DUE_DATE==""? null: new Date (this.activeData[i].REPORT_DUE_DATE);
				this.activeData[i].REPORT_DATE_RED= this.activeData[i].REPORT_DATE? this.activeData[i].REPORT_DATE<=date: false
				
				
				// console.log('here', this.activeData[i])
				this.activeData[i].REPORT_COMPANY_NAME = this.activeData[i].REPORT_COMPANY===undefined? null : this.activeData[i].REPORT_COMPANY.REPORT_COMPANY_NAME
				this.activeData[i].REPORT_GROUP = this.activeData[i].REPORT_GROUP===undefined? null : this.activeData[i].REPORT_GROUP;
			}

			this.loading = false;
			this.activeDataHolder = JSON.parse(JSON.stringify(this.activeData)); //creating a copy
			//console.log(this.activeDataHolder)
			this.getStatusCounts();
		})
		this.autoRefresh();

	}
	table = false
	setTable(){
		setTimeout(	()=>{
		
			this.table = true
		}, 1000);
	}
	private getActiveReportsRefresh(){
		let that = this;
		let refreshActiveData;
		let inputJson={"PROCEDURE":"getactivereportsv2","USER_ID": parseInt(that.userInfo.USER_ID)}
	
		that.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getactivereportsv2, from refresh", data)
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			refreshActiveData = data.REPORT_LIST
			console.log(that.statusList[0])
			that.statusList[0].TOTAL = data.REPORT_TOTAL

			// this is for exporting to excel
			for (let i = 0; i<refreshActiveData.length; i++) {
				//refreshActiveData[i].REPORT_ID = refreshActiveData.REPORT_ID.toString()
				refreshActiveData[i]['flat']={};
				refreshActiveData[i].ASSESSORTITLE={"TITLE":refreshActiveData[i].ASSESSOR_TITLE};
				refreshActiveData[i].REVIEWERTITLE={"TITLE":refreshActiveData[i].REVIEWER_TITLE};
				refreshActiveData[i].flat.PROJECT_NUMBER=refreshActiveData[i].PROJECT_NUMBER;
				refreshActiveData[i].flat.PROPERTY_NAME=refreshActiveData[i].PROPERTY_NAME;
				refreshActiveData[i].flat.ADDRESS_LINE1= refreshActiveData[i].ADDRESS_LINE1;
				refreshActiveData[i].flat.ADDRESS_LINE2= refreshActiveData[i].ADDRESS_LINE2;
				refreshActiveData[i].flat.CITY= refreshActiveData[i].CITY;
				refreshActiveData[i].flat.PROVSTATE= refreshActiveData[i].PROVSTATE;
				refreshActiveData[i].flat.POSTALZIP= refreshActiveData[i].POSTALZIP;
				refreshActiveData[i].flat.REPORT_ID= refreshActiveData[i].REPORT_ID;
				// if(refreshActiveData[i].PORTFOLIO.length>0){
				// 	console.log("portfolio found", refreshActiveData[i])
				// }
				if(refreshActiveData[i].PROTOCOL&& refreshActiveData[i].PROTOCOL[0]){
					refreshActiveData[i].flat.PROTOCOL=refreshActiveData[i].PROTOCOL[0].PROTOCOL;
				}
				if(refreshActiveData[i].TRANSACTION_TYPE && refreshActiveData[i].TRANSACTION_TYPE[0]){
					refreshActiveData[i].flat.TRANSACTION_TYPE=refreshActiveData[i].TRANSACTION_TYPE[0].TRANSACTION_TYPE;
				}
				if(refreshActiveData[i].ASSESSOR && refreshActiveData[i].ASSESSOR[0]){
					refreshActiveData[i].flat.ASSESSOR=refreshActiveData[i].ASSESSOR[0].FULL_NAME? refreshActiveData[i].ASSESSOR[0].FULL_NAME : refreshActiveData[i].ASSESSOR[0].USER_EMAIL;
					refreshActiveData[i].flat.ASSESSOR_ID=refreshActiveData[i].ASSESSOR[0].USER_ID;
				}
				if(refreshActiveData[i].REVIEWER && refreshActiveData[i].REVIEWER[0]){
					refreshActiveData[i].flat.REVIEWER=refreshActiveData[i].REVIEWER[0].FULL_NAME? refreshActiveData[i].REVIEWER[0].FULL_NAME : refreshActiveData[i].REVIEWER[0].USER_EMAIL;
					refreshActiveData[i].flat.REVIEWER_ID=refreshActiveData[i].REVIEWER[0].USER_ID;
				}
				// if(refreshActiveData[i].ASSIGNED_USERS && refreshActiveData[i].ASSIGNED_USERS[0]){
				// 	refreshActiveData[i].flat.ASSIGNED_USERS=refreshActiveData[i].ASSIGNED_USERS[0].FULL_NAME? refreshActiveData[i].ASSIGNED_USERS[0].FULL_NAME : refreshActiveData[i].ASSIGNED_USERS[0].USER_EMAIL;
				// }
				if (refreshActiveData[i].ASSIGNED_USERS) {
					refreshActiveData[i].flat.ASSIGNED_USERS=refreshActiveData[i].ASSIGNED_USERS.map(user=>user.FULL_NAME);
					refreshActiveData[i].flat.ASSIGNED_USERS_ID=refreshActiveData[i].ASSIGNED_USERS.map(user=>user.USER_ID);
				}
				if(refreshActiveData[i].PROJECT_MANAGER && refreshActiveData[i].PROJECT_MANAGER[0]){
					refreshActiveData[i].flat.PROJECT_MANAGER_ID=refreshActiveData[i].PROJECT_MANAGER[0].USER_ID; // this is only needed for assigned to me filter
				}
				if(refreshActiveData[i].TEMPLATE && refreshActiveData[i].TEMPLATE[0]){
					refreshActiveData[i].flat.TEMPLATE=refreshActiveData[i].TEMPLATE[0].TEMPLATE_TITLE
				}
				if(!refreshActiveData[i].ASSESSOR){
					refreshActiveData[i].ASSESSOR=[];
				}
				if(!refreshActiveData[i].REVIEWER){
					refreshActiveData[i].REVIEWER=[];
				}
				if(!refreshActiveData[i].ASSIGNED_USERS){
					refreshActiveData[i].ASSIGNED_USERS=[];
				}
				let date=Date.now();
				//rpt.size= report.GROUP_COUNT!="No Reports" ? report.RW_REPORTS.length: 0,
				refreshActiveData[i].ASSESSOR_DATE=refreshActiveData[i].ASSESSOR_DUE_DATE ==""? null: new Date (refreshActiveData[i].ASSESSOR_DUE_DATE);
				refreshActiveData[i].ASSESSOR_DATE_RED= refreshActiveData[i].ASSESSOR_DATE? refreshActiveData[i].ASSESSOR_DATE<=date: false
				// console.log("dates",rpt.ASSESSOR_DUE_DATE,  rpt.ASSESSOR_DATE)
				refreshActiveData[i].REPORT_RECEIVED_DATE_DATE=(refreshActiveData[i].REPORT_RECEIVED_DATE===undefined || refreshActiveData[i].REPORT_RECEIVED_DATE=="")? null: new Date (refreshActiveData[i].REPORT_RECEIVED_DATE);
				refreshActiveData[i].REVIEWER_DATE=refreshActiveData[i].REVIEWER_DUE_DATE==""? null: new Date (refreshActiveData[i].REVIEWER_DUE_DATE);
				refreshActiveData[i].REVIEWER_DATE_RED= refreshActiveData[i].REVIEWER_DATE? refreshActiveData[i].REVIEWER_DATE<=date : false
				refreshActiveData[i].REPORT_DATE=refreshActiveData[i].REPORT_DUE_DATE==""? null: new Date (refreshActiveData[i].REPORT_DUE_DATE);
				refreshActiveData[i].REPORT_DATE_RED= refreshActiveData[i].REPORT_DATE? refreshActiveData[i].REPORT_DATE<=date: false

				refreshActiveData[i].REPORT_COMPANY_NAME = refreshActiveData[i].REPORT_COMPANY===undefined? null : refreshActiveData[i].REPORT_COMPANY.REPORT_COMPANY_NAME
				refreshActiveData[i].REPORT_GROUP = refreshActiveData[i].REPORT_GROUP===undefined? null : refreshActiveData[i].REPORT_GROUP;

				//console.log(refreshActiveData[i])
			}
			that.activeDataHolder = JSON.parse(JSON.stringify(refreshActiveData));

			// check difference between old and new data that already exists
			for (let report of refreshActiveData) {
				let index;
				if (report.REPORT_ID !== undefined) {
					index = that.activeData.findIndex(old_report => (old_report.REPORT_ID !== undefined) && (old_report.REPORT_ID == report.REPORT_ID)); //console.log(index)
				} else {
					index = that.activeData.findIndex(old_report => (old_report.REPORT_ID === undefined) && (old_report.PROJECT_ID == report.PROJECT_ID));
				}

				if (index > -1) {
					that.activeData[index].PERCENT_COMPLETE = report.PERCENT_COMPLETE
					that.activeData[index].REVIEWER_PROGRESS = report.REVIEWER_PROGRESS
					that.activeData[index].PROJECT_NUMBER = report.PROJECT_NUMBER
					that.activeData[index].PROPERTY_NAME = report.PROPERTY_NAME
					that.activeData[index].FULL_ADDRESS = report.FULL_ADDRESS
					
					if ((that.activeData[index].TEMPLATE !== undefined && report.TEMPLATE !== undefined) &&
						(that.activeData[index].TEMPLATE[0] !== undefined && report.TEMPLATE[0] !== undefined)) {
						that.activeData[index].TEMPLATE[0].TEMPLATE_TITLE = report.TEMPLATE[0].TEMPLATE_TITLE
					}

					that.activeData[index].ASSESSOR_DUE_DATE = report.ASSESSOR_DATE
					that.activeData[index].ASSESSOR_DUE_DATE = report.ASSESSOR_DUE_DATE
					that.activeData[index].REPORT_RECEIVED_DATE = report.REPORT_RECEIVED_DATE_DATE
					that.activeData[index].REPORT_RECEIVED_DATE = report.REPORT_RECEIVED_DATE
					that.activeData[index].REVIEWER_DUE_DATE = report.REVIEWER_DATE
					that.activeData[index].REVIEWER_DUE_DATE = report.REVIEWER_DUE_DATE
					that.activeData[index].REPORT_DUE_DATE = report.REPORT_DATE
					that.activeData[index].REPORT_DUE_DATE = report.REPORT_DUE_DATE
					that.activeData[index].ASSESSOR_DATE_RED = report.ASSESSOR_DATE_RED
					that.activeData[index].REPORT_DATE_RED = report.REPORT_DATE_RED
					that.activeData[index].REPORT_RECEIVED_DATE_RED = report.REPORT_RECEIVED_DATE_RED
					that.activeData[index].ASSESSOR = JSON.parse(JSON.stringify(report.ASSESSOR));
					that.activeData[index].REVIEWER = JSON.parse(JSON.stringify(report.REVIEWER));
					that.activeData[index].ASSIGNED_USERS = JSON.parse(JSON.stringify(report.ASSIGNED_USERS));
					that.activeData[index].ORDER_NUM = report.ORDER_NUM
					if (report.ORDER_REPORTS !== undefined) {
						that.activeData[index].ORDER_REPORTS = JSON.parse(JSON.stringify(report.ORDER_REPORTS));
					}
					that.activeData[index].CONSULTANT_LOCATION.LOCATION_NAME = report.CONSULTANT_LOCATION.LOCATION_NAME
					that.activeData[index].STATUS = report.STATUS
					that.activeData[index].TRANSACTION_TYPE = JSON.parse(JSON.stringify(report.TRANSACTION_TYPE));
					that.activeData[index].PROTOCOL = JSON.parse(JSON.stringify(report.PROTOCOL));
					
					that.activeData[index].REPORT_COMPANY_NAME = report.REPORT_COMPANY===undefined? null : report.REPORT_COMPANY.REPORT_COMPANY_NAME
					that.activeData[index].REPORT_GROUP = report.REPORT_GROUP===undefined? null : report.REPORT_GROUP;
					// if(that.activeData[index].TRANSACTION_TYPE[0]!==undefined&&report.TRANSACTION_TYPE[0]!==undefined){
					// 	that.activeData[index].TRANSACTION_TYPE[0].TRANSACTION_TYPE = report.TRANSACTION_TYPE[0].TRANSACTION_TYPE
					// }
				}
			}

			// check if need to delete any reports from activeData
			for(let i = 0; i < that.activeData.length; i++){
				let match = false
				// in this case, it is an empty project
				if (that.activeData[i].REPORT_ID === undefined) {
					for (let j =0; j < refreshActiveData.length; j++) {
						if (that.activeData[i].PROJECT_ID == refreshActiveData[j].PROJECT_ID && refreshActiveData[j].REPORT_ID === undefined) {
							match = true;
						}
					}
					if (match == false) {
						console.log("FLAG2")
						that.activeData = that.removeNoReportID(that.activeData, that.activeData[i].PROJECT_ID);
						i--;
					}
				// in this case, it is a report
				} else {
					for (let j =0; j < refreshActiveData.length; j++) {
						if (that.activeData[i].REPORT_ID == refreshActiveData[j].REPORT_ID) {
							match = true
						}
					}
					if (match == false) {
						console.log("FLAG")
						that.activeData = that.remove(that.activeData, that.activeData[i].REPORT_ID);
						i--;
					}
				}
			}
			
			// check if need to add any reports to activeData
			for(let i = 0; i < refreshActiveData.length; i++){
				let match = false
				
				// empty project case
				if (refreshActiveData[i].REPORT_ID === undefined) {
					for (let j =0; j < that.activeData.length; j++) {
						if (that.activeData[j].REPORT_ID === undefined && that.activeData[j].PROJECT_ID == refreshActiveData[i].PROJECT_ID) {
							match = true
						}
					}
				// project has reports case
				} else {
					for (let j =0; j < that.activeData.length; j++) {
						if (that.activeData[j].REPORT_ID == refreshActiveData[i].REPORT_ID) {
							match = true
						}
					}
				}
				if (match == false) {
					// console.log("FLAG")
					// console.log(refreshActiveData[i])
					//that.activeData.unshift(refreshActiveData[i])
					//that.activeData = [...that.activeData, refreshActiveData[i]]
					that.activeData = [refreshActiveData[i],...that.activeData]
				}
			}
			
			that.getStatusCounts();
			// that.resetTableFilters1();

		})

		that.autoRefresh();
		
	}
	saveTimer:any;
	start:number;
	gap=60000;
	autoRefresh() {
		console.log('Auto-Refresh')
		let that=this;
		//let now=performance.now();
		//if(this.start){
		//	let last=now-this.start; console.log(last);
		//	if(last<this.gap){
		//		return
		//	}
		//}
		//this.getAllReportByGroup(that.groupkey);
		//this.getStatusCounts();
		window.clearInterval(that.saveTimer);
		this.saveTimer = window.setInterval(function () {
			if (that.cookieService.getCookie("userID")) {
				//that.getAllReportByGroup(that.groupkey);
				if (that.tabFromVar === 'PORTFOLIO') {
					that.getProjectforPortfolioRefresh();
				} else {
					that.getActiveReportsRefresh();
				}
			}else{
				//window.location.reload();
			}
		}, 60000);
	}
	deleteElementFromArray(key: number) {
		console.log(key)
		this.activeData.forEach((value,index)=>{
			console.log(value.REPORT_ID)
		if(value.REPORT_ID==key){
			this.activeData.splice(index,1);
			console.log('splice')
		}
		});
	}
	remove(dataList, key) { // dataList is either activeData or portfolioDataV2
		let index = dataList.findIndex(response => response.REPORT_ID==key); console.log(index)
		if (index > -1){
			return [
				// part of the array before the given item
				...dataList.slice(0, index),
		
				// part of the array after the given item
				...dataList.slice(index + 1)
			];
		}
	}
	// this function is remove() but takes PROJECT_ID instead of REPORT_ID
	// and only removes item with no REPORT_ID
	removeNoReportID(dataList, key) {
		let index = dataList.findIndex(response => response.REPORT_ID===undefined && response.PROJECT_ID==key); console.log(index)
		if (index > -1){
			return [
				// part of the array before the given item
				...dataList.slice(0, index),
		
				// part of the array after the given item
				...dataList.slice(index + 1)
			];
		}
	}

	hasPM
	PMname = 'test'
	checkPM(rowData){
		console.log(rowData)
		if(rowData.PROJECT_MANAGER.length==0){
			this.hasPM = false
		} else {
			this.hasPM = true
			this.PMname = rowData.PROJECT_MANAGER[0].FULL_NAME
		}
	}
	existingReports = []
	addNewToTable(newProject, projectNumber, inputJson){
		console.log('UPDATE')
		this.existingReports = []
		console.log(this.existingReports)
		console.log(newProject)
		console.log(newProject.PROJECT_ID)
		console.log(newProject.RW_REPORTS)
		if(newProject.RW_REPORTS.length==0){
			//add new if not existing reports
			console.log('NO REPORTS')

			let index = this.activeData.findIndex(response => response.PROJECT_ID==newProject.PROJECT_ID)
			console.log(index);

			if (index == -1) {
				this.activeData = [newProject,...this.activeData]
			} else {
				this.activeData[index].PROJECT_NUMBER = newProject.PROJECT_NUMBER
				this.activeData[index].PROPERTY_NAME = newProject.PROPERTY_NAME
				this.activeData[index].ADDRESS_LINE1 = newProject.ADDRESS_LINE1
				this.activeData[index].ADDRESS_LINE2 = newProject.ADDRESS_LINE2
				this.activeData[index].FULL_ADDRESS = newProject.FULL_ADDRESS

				// dashboard dates are report dates, not project dates:
				// this.activeData[index].ASSESSOR_DATE = (newProject.ASSESSOR_DUE_DATE=="")? null : new Date(newProject.ASSESSOR_DUE_DATE)
				// this.activeData[index].ASSESSOR_DUE_DATE = newProject.ASSESSOR_DUE_DATE
				// this.activeData[index].REPORT_DATE = (newProject.REPORT_DUE_DATE=="")? null : new Date(newProject.REPORT_DUE_DATE)
				// this.activeData[index].REPORT_DUE_DATE = newProject.REPORT_DUE_DATE
				// this.activeData[index].REPORT_RECEIVED_DATE_DATE = (newProject.REPORT_RECEIVED_DATE=="")? null : new Date(newProject.REPORT_RECEIVED_DATE)
				// this.activeData[index].REPORT_RECEIVED_DATE= newProject.REPORT_RECEIVED_DATE
				// this.activeData[index].REVIEWER_DATE = (newProject.REVIEWER_DUE_DATE=="")? null : new Date(newProject.REVIEWER_DUE_DATE)
				// this.activeData[index].REVIEWER_DUE_DATE = newProject.REVIEWER_DUE_DATE
				// this.activeData[index].ASSESSOR = newProject.ASSESSOR
				// this.activeData[index].REVIEWER = newProject.REVIEWER
				// this.activeData[index].ASSIGNED_USERS = newProject.ASSIGNED_USERS
				this.activeData[index].SOW = newProject.SOW
				this.activeData[index].TRANSACTION_TYPE = newProject.TRANSACTION_TYPE
				this.activeData[index].PROTOCOL = newProject.PROTOCOL
				this.activeData[index].STATUS = newProject.STATUS
				this.activeData[index].DATE_UPDATED = newProject.DATE_UPDATED
				// this.activeData[index].DATE_CREATED = newProject.DATE_CREATED

				this.activeData[index].INSPECTION_DATE = newProject.INSPECTION_DATE
				this.activeData[index].CONSULTANT_LOCATION.LOCATION_NAME = newProject.CONSULTANT_LOCATION.LOCATION_NAME
				// this.activeData[index].REPORT_COMPANY = newProject.REPORT_COMPANY /// i dont know if can add this
			}

		} else {
			// this.numActiveReports += newProject.RW_REPORTS.length;
			// update active reports count:
			newProject.RW_REPORTS.forEach(rpt => {
				if (this.activeData.findIndex(proj => proj.REPORT_ID!==undefined && proj.REPORT_ID == rpt.REPORT_ID) == -1) {
					this.numActiveReports += 1;
				}
			})

			//finding the project in the active table and tracking all the active data
			this.activeData.forEach((value,index)=>{
				// console.log(value.PROJECT_ID)
				if(value.PROJECT_ID==newProject.PROJECT_ID){
					this.existingReports.push(this.activeData[index])
					console.log(this.existingReports)
				}
			})
			//if empty project delete it 
			for(let i=0; i<this.existingReports.length;i++){

				console.log(this.existingReports[i].RW_REPORTS)
				if(this.existingReports[i].RW_REPORTS!=undefined){
					this.activeData = this.remove2(this.existingReports[i].PROJECT_ID)
					console.log('remove!')
					console.log(this.activeData)

				}
			}
		}
		console.log(this.existingReports)
		//add if not existing project
		console.log('HAS REPORTS', inputJson)
		for(let i=0;i<newProject.RW_REPORTS.length;i++){
			let index = this.activeData.findIndex(response => response.REPORT_ID==newProject.RW_REPORTS[i].REPORT_ID); console.log(index)
			if (index == -1){
				this.activeData = [newProject.RW_REPORTS[i],...this.activeData]
			}
			if(index > -1){ //updating existing project
				this.activeData[index].PROJECT_NUMBER = inputJson.PROJECT_NUMBER
				this.activeData[index].PROPERTY_NAME = inputJson.PROPERTY_NAME
				this.activeData[index].ADDRESS_LINE1 = inputJson.ADDRESS_LINE1
				this.activeData[index].ADDRESS_LINE2 = inputJson.ADDRESS_LINE2
				this.activeData[index].FULL_ADDRESS = newProject.FULL_ADDRESS // idk why the rest uses inputJson instead of newProject.... maybe can change
				
				// dashboard dates are report dates, not project dates:
				// this.activeData[index].ASSESSOR_DATE = (inputJson.ASSESSOR_DUE_DATE=="")? null : new Date(inputJson.ASSESSOR_DUE_DATE)
				// this.activeData[index].ASSESSOR_DUE_DATE = inputJson.ASSESSOR_DUE_DATE
				// this.activeData[index].REPORT_DATE = (inputJson.REPORT_DUE_DATE=="")? null : new Date(inputJson.REPORT_DUE_DATE)
				// this.activeData[index].REPORT_DUE_DATE = inputJson.REPORT_DUE_DATE
				// // vv this field not inputtable for creating new projects
				// // this.activeData[index].REPORT_RECEIVED_DATE_DATE = (newProject.REPORT_RECEIVED_DATE=="")? null : new Date(newProject.REPORT_RECEIVED_DATE)
				// // this.activeData[index].REPORT_RECEIVED_DATE= newProject.REPORT_RECEIVED_DATE
				// this.activeData[index].REVIEWER_DATE = (inputJson.REVIEWER_DUE_DATE=="")? null : new Date(inputJson.REVIEWER_DUE_DATE)
				// this.activeData[index].REVIEWER_DUE_DATE = inputJson.REVIEWER_DUE_DATE

				this.activeData[index].SOW = newProject.SOW
				this.activeData[index].TRANSACTION_TYPE = newProject.TRANSACTION_TYPE
				this.activeData[index].PROTOCOL = newProject.PROTOCOL
				this.activeData[index].INSPECTION_DATE = inputJson.INSPECTION_DATE
				this.activeData[index].CONSULTANT_LOCATION.LOCATION_NAME = newProject.CONSULTANT_LOCATION.LOCATION_NAME
				this.activeData[index].REPORT_COMPANY = newProject.REPORT_COMPANY

			}
		}
	// //updating fields
	// let index = this.activeData.findIndex(response => response.PROJECT_ID== projectNumber); console.log(index)
	// if (index < -1){
	// 	this.activeData[index].PROJECT_NUMBER = inputJson.PROJECT_NUMBER
	// }

  	}
	remove2(key) {
		let index = this.activeData.findIndex(response => response.PROJECT_ID==key); console.log(index)
		if (index > -1){
			return [
				// part of the array before the given item
				...this.activeData.slice(0, index),

				// part of the array after the given item
				...this.activeData.slice(index + 1)
			];
		}
	}
	
	updateShow=false;
	projectRpts=[];
	compareRpts=[];
	compareTitles=[];
	compareProject=[];
	compareSlots=[];
	loading3=false;
	getProjectRpts(){
		//this.projectRpts=this.portfolioDataV2;
		let inputJson={"PROCEDURE":"getprojectsforportfoliov2","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			if (response.RESPONSE_STATUS == 'Y') {
				this.projectRpts=response.REPORT_LIST; console.log(this.projectRpts);
			} else {
				this.throwError(response)		
			}			
		})	
	}
loading2=false;
addCompareRpt(e, rpt?){
	this.compareSlots=[];
	if(rpt){
		if(e.target.checked){
			//this.loading2=true;
			this.compareRpts.push(rpt.REPORT_ID);
			this.compareTitles.push(rpt.REPORT_TITLE);
			this.compareProject.push(rpt.PROJECT_NUMBER);
	
		}else{
			let index=this.compareRpts.indexOf(rpt.REPORT_ID);//console.log(index)
			if(index>-1){
				this.compareRpts.splice(index, 1);
				this.compareTitles.splice(index, 1);
				this.compareProject.splice(index, 1);				
			}
			/*let index1=this.projectRpts.findIndex(rpt=>rpt.REPORT_ID==id);//console.log(index)
			if(index1>-1){
				this.compareSlots[index1]=[];
				this.[index1]='';
			}*/
			}
	}else{
		this.compareRpts=[];
		this.compareTitles=[];
		this.compareProject=[];
		for(let pro of this.projectRpts){
			if(pro.REPORT_ID){
				this.compareRpts.push(pro.REPORT_ID)
				this.compareTitles.push(pro.REPORT_TITLE);
				this.compareProject.push(pro.PROJECT_NUMBER);
			}
		}

	}
}
	async getCompareRpts(type?){//console.log(this.compareTitles);
		this.loading2=true;
		let rpts='';
		if(type){
			rpts=this.summaryRpts.join(',');
		}else{
			rpts=this.compareRpts.join(',');
		}
		let inputJson={"PROCEDURE":"getrfcomparisontable", "USER_ID":parseInt(this.userId), "REPORT_LIST":rpts};
			//console.log(inputJson);
		let data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();//subscribe(data => {
			console.log(data);
			this.loading2=false;
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				if(type){
					this.summaryRFs=data.RF_TABLE_LIST;
					//this.selectedRFs=[];
					//this.selectedRFIds=[];
					this.summaryData={'cols':[],'rows':[]};
					for(let rpt of this.summaryRpts){
						let rowData=[];
						let colData=[];
						for(let rf of this.summaryRFs){
							//this.summaryData.cols.push(rf.SLOT_KEY);
							//console.log(rpt);
							//console.log(rf);
							if(this.summaryData.cols.length==0){
								colData.push(rf.SLOT_KEY);
							}
							let index=rf.REPORT_VALUE_LIST.findIndex(slot=>slot.REPORT_ID==rpt);
							if (index>-1){
								rowData.push(rf.REPORT_VALUE_LIST[index].RF_CONTENT)
							}else{
								rowData.push('');
							}
						}
						if(colData.length>0){
							this.summaryData.cols=colData;
						}
						this.summaryData.rows.push(rowData);	
					}
					console.log(this.summaryData);
				}else{
					this.compareSlots=data.RF_TABLE_LIST;console.log(this.compareSlots)
				}
				
			}
		//})
	}
	selectAll=false;
	selectedCell:any;
	updated=[];
	async updaterpts(e, index, list,i,j){
		let id=this.compareRpts[j];console.log(id);
		let content=list.REPORT_VALUE_LIST[index].RF_CONTENT;
		let slot={'SLOT_ID':list.SLOT_ID,'SLOT_KEY':list.SLOT_KEY,'SLOT_TYPE':list.SLOT_TYPE,'RF_CONTENT':content};//console.log(slot);
		this.updated=[];
		if(this.selectAll){
			this.setToUpdate(e);
			let rpts=this.compareSlots[i].REPORT_VALUE_LIST;
			for(let k=0; k<rpts.length; k++ ){
				if(rpts[k].RF_CONTENT!='Not Used'){console.log(k)
					await this.updateFunction(e, rpts[k].REPORT_ID, slot,k);
					//this.updated.push(k);		
				}
			}
			this.setUpdated(e,slot);
		}else{
			this.setToUpdate(e);
			await this.updateFunction(e, id, slot,j);
			this.setUpdated(e,slot);
		}
		
	}
	setToUpdate(e){
		$(e.target).next('span').css('display','inline-block');
		$(e.target).parent().addClass('disable');
	}
	setUpdated(e,slot){
		//console.log(this.selectedCell.target);
		$(e.target).next('span').css('display','none');
		$(e.target).parent().removeClass('disable');
		console.log(this.updated);
		if(this.selectAll){
			let eles=$(this.selectedCell.target).parents('tr').children('td').children('span');console.log(eles);
			for(let i=0; i<eles.length; i++){
				//if($(ele).text()!='Not Used'){
				if(this.updated.indexOf(i)>-1){
					$(eles[i]).css('color','#F78181');
					$(eles[i]).text(slot.RF_CONTENT);
				}
				
			}
			
			
		}else{
			$(this.selectedCell.target).prev('span').css('color','#F78181');
			$(this.selectedCell.target).prev('span').text(slot.RF_CONTENT);
		}	
	}
	checkstatus(e){
		console.log(e)
	}
	replaceSlotText(info, sec, key1, key2? ){
		let allPlaceholder=$(sec[key1]).find('.placeholder');
		let that = this; 
		allPlaceholder.each(function(){
			let id=$(this).data('id');
			if(id==info.SLOT_ID){	
				let test=$(this)[0].innerHTML;
				let test1=$(this)[0].outerHTML;	
				if(info.RF_CONTENT.length>0&&test!=info.RF_CONTENT){
					$(this)[0].innerHTML=info.RF_CONTENT;
					$(this).attr('data-status','Y');
					let test2=$(this)[0].outerHTML;
					sec[key1]=sec[key1].replaceAll(test1, test2);
					if(key2){
						sec[key2]=that.sanitizer.bypassSecurityTrustHtml(sec[key1]);
					}					
				}else if(info.RF_CONTENT.length==0&&test!=info.RF_CONTENT){
					$(this).attr('data-status','N');
					let text='{'+info.KEY+'}';
					$(this)[0].innerHTML=text;
					let test2=$(this)[0].outerHTML;	
					sec[key1]=sec[key1].replaceAll(test1, test2);
					if(key2){
						sec[key2]=that.sanitizer.bypassSecurityTrustHtml(sec[key1]);
					}
				}
			}
		})
		return sec
	}
	async updateFunction(e, id, slot,index){
		let inputJson1={"PROCEDURE":"updateslotcontent","USER_ID":parseInt(this.userId),"SLOT_ID":slot.SLOT_ID,"SLOT_CONTENT":slot.RF_CONTENT,'REPORT_ID':id};
		//const response = await this.reportService.univeralService(JSON.stringify(startJson)).toPromise();
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
			
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response)
			}
		})
		/*no sure if need to update pdf name slot?*/
		let inputJson2= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result => {;
			if (result.RESPONSE_STATUS=='N') {
				this.throwError(result)
				return							
			}
			if(result.PDF_FILE_NAME&&result.PDF_FILE_NAME.length>0){
				let pdfnameObj=JSON.parse(result.PDF_FILE_NAME);
				if(pdfnameObj['text'].length>0){
					let slotIds=this.getAllSlotId(pdfnameObj['text']);
					if(slotIds.indexOf(slot.SLOT_ID)>-1){
						pdfnameObj=this.replaceSlotText(slot, pdfnameObj, 'text');
						
						let val=$('<div>'+pdfnameObj['text']+'</div>')[0].innerText
						pdfnameObj['name']=val;
						let pdfInfo={'text':pdfnameObj['text'], "name":pdfnameObj.name};
						let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":id,"PDF_FILE_NAME":JSON.stringify(pdfInfo)};
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)														
							}
						});
					}
				}				
			}
		})
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
		//console.log(JSON.stringify(inputJson));
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.ERRORCODE){
					this.throwError(data)
					$(e.target).next('span').css('display','none');
					$(e.target).prop('disabled',false);
				return
			}
			let desContents=[];
			let desfronts=[];
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){
				desContents=JSON.parse(data.REPORT_DATA);
				for(let sec of desContents){
					if(sec.text&&sec.text.length>0){
						let ids=this.getAllSlotId(sec.text);
						if(ids.indexOf(slot.SLOT_ID>-1)){
							sec=this.replaceSlotText(slot, sec, 'text', 'htmltext');
						}
					}
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.text&&sec1.text.length>0){
							let ids=this.getAllSlotId(sec1.text);
							if(ids.indexOf(slot.SLOT_ID>-1)){
								sec1=this.replaceSlotText(slot, sec1, 'text', 'htmltext');
							}
						}
						if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data.erisName)){
							for(let row of sec1.data.rows){
								for(let cell of row.items){
									if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
										cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
									}								
								}
							}
						}
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.text&&sec2.text.length>0){
								let ids=this.getAllSlotId(sec2.text);
								if(ids.indexOf(slot.SLOT_ID>-1)){
									sec2=this.replaceSlotText(slot, sec2, 'text', 'htmltext');								
								}								
							}
							if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data.erisName)){
							for(let row of sec2.data.rows){
								for(let cell of row.items){
									if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
										cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
									}								
								}
							}
						}
						}
					}
				}				
			}
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				desfronts=JSON.parse(data.BEFORE_TOC); 
				for(let sec of desfronts){
					if(sec.text&&sec.text.length>0){
						let ids=this.getAllSlotId(sec.text);
						if(ids.indexOf(slot.SLOT_ID>-1)){
							sec=this.replaceSlotText(slot, sec, 'text', 'htmltext');
						}
					}
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.text&&sec1.text.length>0){
							let ids=this.getAllSlotId(sec1.text);
							if(ids.indexOf(slot.SLOT_ID>-1)){
								sec1=this.replaceSlotText(slot, sec1, 'text', 'htmltext');					
							}
						}
						if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data.erisName)){
							for(let row of sec1.data.rows){
								for(let cell of row.items){
									if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
										cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
									}
								}
							}
						}
					}
				}
			}
			//console.log(desfronts);
			//console.log(desContents);
			if((data.REPORT_DATA&&data.REPORT_DATA.length>0)||(data.BEFORE_TOC&&data.BEFORE_TOC.length>0)){	
				let beforeToc=JSON.stringify(desfronts)
				//let inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(desContents),"BEFORE_TOC":beforeToc};
				let inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(desContents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":data.APPENDIX_DATA,'PCA_DATA':data.PCA_DATA, 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'',"PERCENT_COMPLETE":data.PERCENT_COMPLETE,"REVIEWER_PROGRESS":data.REVIEWER_PROGRESS};
				//console.log('desJson', inputJson)
				//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				const result = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('savedData',result);
					if(result.RESPONSE_STATUS=='N'){
						this.throwError(data)
					}else{
						this.updated.push(index);
					}
			}else{
				this.updated.push(index);
			}
	}
	intext=false;
	comparisonTable() {
		this.loading=false;
		this.updateShow=true;
		this.compareRpts=[];
		this.compareSlots=[];
		this.compareTitles=[];
		this.compareProject=[];
		this.compareTitles=[];
		this.projectRpts=[];
		this.getProjectRpts();
	}
	private getIndices(str, substr){
		let indices=[];
		let index = str.indexOf(substr);
		while(index !== -1) {
			indices.push(index);
			index = str.indexOf(substr, index + 1);
		}
		////console.log(indices);
		return indices;
	}
	private getAllSlotId(str){////console.log(str)
		if(!str)return
		let indices1=this.getIndices(str,'data-id=');////console.log(indices1);
		let indices2=this.getIndices(str, 'data-type="text" data-status');////console.log(indices2);
		let ids=[];
		for(let i=0; i<indices1.length; i++){
			let text=str.substring(indices1[i],indices2[i]).split('"')[1]; ////console.log(text)
			let id=parseInt(text);
			if(id>-1&&ids.indexOf(id)==-1){
			ids.push(parseInt(text));
			}
		}
		////console.log(ids);
		return ids
	}
	/*getUpdateString(slots,slot){//console.log(slots,slot)
		let slotInfo:any
		let newContent:string;
		newContent=slot.RF_CONTENT;
		let id=slot.SLOT_ID;
		slots.each(function(){	//console.log($(this).data('id'))	;
			if($(this).data('id')==id){
				let text=$(this).prop("outerHTML").replace(' ck-widget','').replace(' ck-widget_selected','').replace(' contenteditable="false"','').replace('"','\"').trim(); //console.log(text);
				let replaceText="";
				if(newContent.length>0){
					let content=' data-status="Y">'+newContent+'<';////console.log(content);
					replaceText=text.replace(' data-status="N"','').replace(' data-status="Y"','').replace(/\>(.*?)\</, content); //console.log(replaceText);
					slotInfo={'SLOT_ID':id, 'oldText':text, 'replaceText':replaceText};
				}else if(newContent.length==0){
					slotInfo={'SLOT_ID':id, 'oldText':text, 'replaceText':''};//console.log(slotInfo);
				}
					//console.log(slotInfo)
				return false;
				}
			
			})
			console.log(slotInfo)
		return slotInfo
	}*/
	editName=false;
	editPName(e){
		let name=$(e.target).prev('input').val().trim();//console.log(name);
		if(name.length>0){
			let inputJson={"PROCEDURE":"updateportfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio,"PORTFOLIO_NAME":name};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				if(data.RESPONSE_STATUS=='N'){
					this.throwError(data)
				}else{
					//console.log(data)
					this.portfolioDisplayName=data.PORTFOLIO_NAME;
					let index=this.portfolioList.findIndex(portfolio=>portfolio.PORTFOLIO_ID==data.PORTFOLIO_ID); //console.log(index)
					if(index>-1){
						//console.log(this.portfolioList[index])
						this.portfolioList[index].PORTFOLIO_NAME=this.portfolioDisplayName;
						this.editName=false;						
					}
				}
			})
		}
	}
	
	targetRpts=[];
	srcFront=[];
	srcContents=[];
	selectedId=[];
	selectedTarget=[];
	otherTypes=['MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE','SEALS','SIGNS','PDFSEC'];
	loading4=false;
	intiCopy(){
		this.targetRpts=[];
		this.srcFront=[];
		this.srcContents=[];
		this.selectedId=[];
		this.selectedTarget=[];
		this.copyMsg=null;
		this.copyWarn=null;
		this.loading4=false;
	}
	getRptContent(e){
		this.srcFront=[];
		this.srcContents=[];
		this.selectedId=[];
		this.targetRpts=[];
		this.selectedTarget=[];
		let id=e.target.value;
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
			if(data.ERRORCODE){
					this.throwError(data)
				return
			}
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){
				this.srcContents=JSON.parse(data.REPORT_DATA);
			}
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				this.srcFront=JSON.parse(data.BEFORE_TOC);
			}
		})
	}
	getTemplateRpts(e){
		this.selectedTarget=[];
		this.targetRpts=[];
		this.copyMsg=null;
		this.copyWarn=null;
		let id=e.target.value;
		let inputJson={"PROCEDURE":"getreportlistbyportfoliotemplate","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio,"REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.targetRpts=data.RW_REPORTS;//console.log(this.targetRpts)
				
			}
		})
	}
	addTargetRpt(e, rpt?){
		if(rpt){
			if(e.target.checked){
				//this.loading2=true;
				this.selectedTarget.push(rpt.REPORT_ID);
			}else{
				let index=this.selectedTarget.indexOf(rpt.REPORT_ID);//console.log(index)
				if(index>-1){
					this.selectedTarget.splice(index, 1);				
				}
			}
		}else{
			this.selectedTarget=[];
			for(let pro of this.targetRpts){
				if(pro.REPORT_ID){
					this.selectedTarget.push(pro.REPORT_ID)
				}
			}
	
		}		
	}
	addsec(e, id?){
		if(id){
			if(e.target.checked){
				this.selectedId.push(id);
			}else{
				let index=this.selectedId.indexOf(id);
				if(index>-1){
					this.selectedId.splice(index, 1);
				}
			}
		}else{
			this.selectedId=[];
			if(e=='Y'){
				for(let doc of this.srcFront){
					let index=this.otherTypes.indexOf(doc.TYPE);
					if(index==-1){
						this.selectedId.push(doc.id)
					}
					for(let doc1 of doc.SUB_SECTIONS){
						let index1=this.otherTypes.indexOf(doc1.TYPE);
						if(!(index1>-1||(doc1.TYPE=='TABLE'&&doc1.data&&(doc1.data.erisName&&doc1.data.erisName.length>0)))){
							this.selectedId.push(doc1.id)
						}
					}
				}
				for(let doc of this.srcContents){
					let index=this.otherTypes.indexOf(doc.TYPE);
					if(index==-1){
						this.selectedId.push(doc.id)
					}
					for(let doc1 of doc.SUB_SECTIONS){
						let index1=this.otherTypes.indexOf(doc1.TYPE);
						if(!(index1>-1||(doc1.TYPE=='TABLE'&&doc1.data&&(doc1.data.erisName&&doc1.data.erisName.length>0)))){
							this.selectedId.push(doc1.id)
						}
						for(let doc2 of doc1.SUB_SECTIONS){
							let index2=this.otherTypes.indexOf(doc2.TYPE);
							if(!(index2>-1||(doc2.TYPE=='TABLE'&&doc2.data&&(doc2.data.erisName&&doc2.data.erisName.length>0)))){
								this.selectedId.push(doc2.id)
							}
						}
						
					}

				}
			}
		}
		
		//console.log(this.selectedId)
	}
	getSrcSec(){
		let srcGroup={};
			for(let sec of this.srcContents){
				let index=this.selectedId.indexOf(sec.id);
				if(index>-1){
					let secCopy=JSON.parse(JSON.stringify(sec))
					if(sec.SUB_SECTIONS){
						delete secCopy.SUB_SECTIONS;
					}
					srcGroup[sec.id]=secCopy;		
				}
				if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
					for(let sec1 of sec.SUB_SECTIONS){
						let index1=this.selectedId.indexOf(sec1.id);
						if(index1>-1){
							let secCopy=JSON.parse(JSON.stringify(sec1))
							if(sec1.SUB_SECTIONS){
								delete secCopy.SUB_SECTIONS;
							}
							srcGroup[sec1.id]=secCopy;		
						}
						if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){					
							for(let sec2 of sec1.SUB_SECTIONS){
								let index2=this.selectedId.indexOf(sec2.id);
								if(index2>-1){
									let secCopy=JSON.parse(JSON.stringify(sec2))
									if(sec2.SUB_SECTIONS){
										delete secCopy.SUB_SECTIONS;
									}
									srcGroup[sec2.id]=secCopy;		
								}
						
							}
						}
					}	
				}			
			}
			for(let sec of this.srcFront){
				let index=this.selectedId.indexOf(sec.id);
				if(index>-1){
					let secCopy=JSON.parse(JSON.stringify(sec))
					if(sec.SUB_SECTIONS){
						delete secCopy.SUB_SECTIONS;
					}
					srcGroup[sec.id]=secCopy;		
				}
				if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
					for(let sec1 of sec.SUB_SECTIONS){
						let index1=this.selectedId.indexOf(sec1.id);
						if(index1>-1){
							let secCopy=JSON.parse(JSON.stringify(sec1))
							if(sec1.SUB_SECTIONS){
								delete secCopy.SUB_SECTIONS;
							}
							srcGroup[sec1.id]=secCopy;		
						}						
					}	
				}			
			}
			console.log(srcGroup);
			return srcGroup;
	}
	startCopy(e){
		console.log(this.srcContents)
		console.log(this.selectedTarget)
		if(!this.copyPermission){
			return
		}
		if(this.selectedId.length==0){
			Swal.fire({
				icon:'info',
				text: 'Please Select Source Section',
			
			})
			return
		}
		if(this.selectedTarget.length==0){
			Swal.fire({
				icon:'info',
				text: 'Please Select Target Report(s)',			
			})
			return
		}
		Swal.fire({
			icon:'warning',
			html: "<span style='font-size:20px; font-weight:bold'>Warning! </span>The selected Sections will be overwritten. If there is a report currently being edited by a user, the content might be lost.",
			confirmButtonText: 'Copy all changes',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				this.copyTo(e);
			}
		})
	}
	copyMsg:any;
	copyWarn:any;
	tempReplace(data){

	}
	async copyTo(e){
		this.copyMsg={};
		this.copyWarn={};
		e.target.disabled=true;
		this.loading4=true;
		let srcData=this.getSrcSec();
		let datasrc='report';
		let tempData={'REPORT_DATA':'[]','BEFORE_TOC':'[]'};
		try {
		for(let rpt of this.selectedTarget){
			if(rpt>-1){
				let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":rpt,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
				let result = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('getData',result);
				
				if(result.RESPONSE_STATUS=='N'){
					this.throwError(result)
					e.target.disabled=false;
					this.loading4=false;

				}else{
					let desContents=[];
					let desfronts=[];
					let copied=[];
					if((result.REPORT_DATA.length==0||result.REPORT_DATA=='[]')&&(result.BEFORE_TOC.length==0||result.BEFORE_TOC=='[]')){
						datasrc='temp';
						let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":rpt};
						let result1 = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();	console.log(result1);
						if(result1.RESPONSE_STATUS=='N'){
							this.throwError(result1)
							e.target.disabled=false;
							this.loading4=false;
						}else{
							let inputJson2:any;
							let result2:any;
							if(result1.TEMP_REPORT_DATA=='N'){
							let tempid=result1.TEMPLATE[0].TEMPLATE_ID;
							 	inputJson2={"PROCEDURE":"gettemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":tempid};console.log(inputJson2);
							}else if(result1.TEMP_REPORT_DATA=='Y'){
								inputJson2={"PROCEDURE":"gettempreportdata","USER_ID":parseInt(this.userId),"REPORT_ID":rpt};// - this will return TEMP_REPORT_DATA with actual value in field
							}
							result2 = await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise();	console.log(result2);
							if(result2.RESPONSE_STATUS=='N'){
								this.throwError(result2)
								e.target.disabled=false;
								this.loading4=false;
							}else{
								if(result1.TEMP_REPORT_DATA=='N'){
									tempData.REPORT_DATA=result2.TEMPLATE_DATA;
									tempData.BEFORE_TOC=result2.BEFORE_TOC;
								}else if(result1.TEMP_REPORT_DATA=='Y'){
									tempData.REPORT_DATA=result2.TEMP_REPORT_DATA;
									tempData.BEFORE_TOC=result2.TEMP_BEFORE_TOC;
								}
								//tempData=result2;
								if(tempData.BEFORE_TOC&&tempData.BEFORE_TOC.length>0){
									desfronts=JSON.parse(tempData.BEFORE_TOC); 
								for(let sec of desfronts){
									if(srcData[sec.id]){
										let src=srcData[sec.id];
										if(src.pageSrc=="pdf"){
											sec['pageSrc']="pdf";
											sec['pdf']=src.pdf;
											sec['pdfName']=src.pdfName;;
											sec['header']=src.header;;
											sec['footer']=src.footer;
										}else{								
											if(src.libs){
												sec['libs']=src.libs;
											}
											if(src.slots){
												sec['slots']=src.slots;	
												sec.text=this.toTemp(src.text, src.slots);
												sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
											}else{
												sec.text=src.text;
												sec.htmltext=src.htmltext;
											}
											
										}
										if(sec.hash){
											delete sec.hash;
										}
										copied.push('Before TOC  '+src.SECTION_TITLE);
									}
									for(let sec1 of sec.SUB_SECTIONS){
										if(srcData[sec1.id]){
											let src=srcData[sec1.id];
											if(sec1.TYPE=='TABLE'){
												let tabledata=this.toTempTable(src.data);;
												sec1.data.rows=tabledata.rows;
												sec1.data.cols=tabledata.cols;	
											}else{
												if(src.libs){
													sec1['libs']=src.libs;
												}
												if(src.slots){
													sec1['slots']=src.slots;
													sec1.text=this.toTemp(src.text, src.slots);
													sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
												}else{
													sec1.text=src.text;
													sec1.htmltext=src.htmltext;
												}
													
											}
											if(sec1.hash){
												delete sec1.hash;
											}
											copied.push('Before TOC  '+src.SECTION_TITLE);
										}
								
									}
								}
						
							}
								if(tempData.REPORT_DATA&&tempData.REPORT_DATA.length>0){
									desContents=JSON.parse(tempData.REPORT_DATA);
									for(let sec of desContents){
										if(srcData[sec.id]){
											let src=srcData[sec.id];
											if(src.libs){
												sec['libs']=src.libs;
											}
											if(src.slots){
												sec['slots']=src.slots;
												sec.text=this.toTemp(src.text, src.slots);
												sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);	
											}else{
												sec.text=src.text;
												sec.htmltext=src.htmltext;
											}
																					
											if(sec.hash){
												delete sec.hash;
											}					
											copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
										}
										for(let sec1 of sec.SUB_SECTIONS){
											if(srcData[sec1.id]){
												let src=srcData[sec1.id];
												if(sec1.TYPE=='TABLE'){
													let tabledata=this.toTempTable(src.data);;
													sec1.data.rows=tabledata.rows;
													sec1.data.cols=tabledata.cols;																			
												}else{
													if(src.libs){//pageSrc,heade,footer
														sec1['libs']=src.libs;
													}
													if(src.slots){
														sec1['slots']=src.slots;
														sec1.text=this.toTemp(src.text, src.slots);;
													sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
													}else{
														sec1.text=src.text;
														sec1.htmltext=src.htmltext;
													}
													
												}
												if(sec1.hash){
													delete sec1.hash;
												}
												copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
											}
											for(let sec2 of sec1.SUB_SECTIONS){
												if(srcData[sec2.id]){
													let src=srcData[sec2.id];
													if(sec2.TYPE=='TABLE'){
														let tabledata=this.toTempTable(src.data);;
														sec2.data.rows=tabledata.rows;
														sec2.data.cols=tabledata.cols;	
													}else{
											
														if(src.libs){
															sec2['libs']=src.libs;
														}
														if(src.slots){
															sec2['slots']=src.slots;
															sec2.text=this.toTemp(src.text, src.slots);;
															sec2.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec2.text);
														}else{
															sec2.text=src.text;
															sec2.htmltext=src.htmltext;
														}
															
													}
													if(sec2.hash){
														delete sec2.hash;
													}	
													copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
												}
											}
								
										}				
									}
								}
								
							//save temp data to
							console.log(desContents);
							console.log(desfronts);
							let inputJson= {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":rpt,"TEMP_REPORT_DATA":JSON.stringify(desContents), "TEMP_BEFORE_TOC":JSON.stringify(desfronts)}	;							
							console.log(inputJson)
							let data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('savedData',data);
							if(data.RESPONSE_STATUS=='N'){
								this.throwError(data)
								this.copyWarn[result.REPORT_ID]=[data.MESSAGE]; 
							}else{
								e.target.disabled=false;
								this.loading4=false;
								this.copyMsg[result.REPORT_ID]=copied; 						
							}
						}
			
							
						}
					}else{
					//console.log(result);
					if(result.BEFORE_TOC&&result.BEFORE_TOC.length>0){
						desfronts=JSON.parse(result.BEFORE_TOC); 
						for(let sec of desfronts){
							if(srcData[sec.id]){
								let src=srcData[sec.id];
								if(src.pageSrc=="pdf"){
									sec['pageSrc']="pdf";
									sec['pdf']=src.pdf;;
									sec['pdfName']=src.pdfName;;
									sec['header']=src.header;;
									sec['footer']=src.footer;
								}else{								
									if(src.libs){//pageSrc,heade,footer
										sec['libs']=src.libs;
									}
									if(src.slots){
										sec['slots']=src.slots;
										let replaced=await this.replaceRFs(sec['slots'],rpt, src.text);
										sec['slots']=replaced.RF;
										sec.text=replaced.text;
										sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
										if(sec.RF_CONTENT){
											delete sec.RF_CONTENT;
										}
									}else{
										sec.text=src.text;
										sec.htmltext=src.htmltext;
									}
								}
								sec['hash']=this.getHash(sec);
								copied.push('Before TOC  '+src.SECTION_TITLE);
							}
							for(let sec1 of sec.SUB_SECTIONS){
								if(srcData[sec1.id]){
									let src=srcData[sec1.id];
									if(sec1.TYPE=='TABLE'){
										let tabledata=await this.replaceRFTable(src.data, rpt);
										sec1.data.rows=tabledata.rows;
										sec1.data.cols=tabledata.cols
									}else{
										//sec1.text=src.text;
										//sec1.htmltext=src.htmltext;
										if(src.libs){//pageSrc,heade,footer
											sec1['libs']=src.libs;
										}
										if(src.slots){
											sec1['slots']=src.slots;
											let replaced=await this.replaceRFs(sec1['slots'],rpt, src.text);
											sec1['slots']=replaced.RF;
											sec1.text=replaced.text;
											sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
											if(sec1.RF_CONTENT){
												delete sec1.RF_CONTENT;
											}
											
										}else{
											sec1.text=src.text;
											sec1.htmltext=src.htmltext;
										}
									}
									sec1['hash']=this.getHash(sec1);
									copied.push('Before TOC  '+src.SECTION_TITLE);
								}
						
							}
						}
					}
					if(result.REPORT_DATA&&result.REPORT_DATA.length>0){
						desContents=JSON.parse(result.REPORT_DATA);
						
						for(let sec of desContents){
							if(srcData[sec.id]){
								let src=srcData[sec.id];
								if(src.libs){
									sec['libs']=src.libs;
								}
								if(src.slots){
									sec['slots']=src.slots;
									let replaced=await this.replaceRFs(sec['slots'],rpt, src.text);
									sec['slots']=replaced.RF;
									sec.text=replaced.text;
									sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
									if(sec.RF_CONTENT){
										delete sec.RF_CONTENT;
									}
								}else{
									sec.text=src.text;
									sec.htmltext=src.htmltext;
								}
								sec['hash']=this.getHash(sec);							
						
								copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
							}
							for(let sec1 of sec.SUB_SECTIONS){
								if(srcData[sec1.id]){
									let src=srcData[sec1.id];
									if(sec1.TYPE=='TABLE'){
										if(src.data){
											let tabledata=await this.replaceRFTable(src.data, rpt);;
											sec1.data.rows=tabledata.rows;
											sec1.data.cols=tabledata.cols;
										}						
									}else{
										//sec1.text=src.text;
										//sec1.htmltext=src.htmltext;
										if(src.libs){//pageSrc,heade,footer
											sec1['libs']=src.libs;
										}
										if(src.slots){
											sec1['slots']=src.slots;
											let replaced=await this.replaceRFs(sec1['slots'],rpt, src.text);
											sec1['slots']=replaced.RF;
											sec1.text=replaced.text;
											sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
											if(sec1.RF_CONTENT){
												delete sec1.RF_CONTENT;
											}
											
										}else{
											sec1.text=src.text;
											sec1.htmltext=src.htmltext;
										}

									}
									sec1['hash']=this.getHash(sec1);
									copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
								}
								for(let sec2 of sec1.SUB_SECTIONS){
									if(srcData[sec2.id]){
										let src=srcData[sec2.id];
										if(sec2.TYPE=='TABLE'){console.log(src)
											if(src.data){
												let tabledata=await this.replaceRFTable(src.data, rpt);
												sec2.data.rows=tabledata.rows;
												sec2.data.cols=tabledata.cols;
											}
										}else{
											//sec2.text=src.text;
											//sec2.htmltext=src.htmltext;
											if(src.libs){
												sec2['libs']=src.libs;
											}
											if(src.slots){
												sec2['slots']=src.slots;
												let replaced=await this.replaceRFs(sec2['slots'],rpt, src.text);
												sec2['slots']=replaced.RF;
												sec2.text=replaced.text;
												sec2.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec2.text);
												if(sec2.RF_CONTENT){
													delete sec2.RF_CONTENT;
												}
											
											}else{
												sec2.text=src.text;
												sec2.htmltext=src.htmltext;
											}
										}
										sec2['hash']=this.getHash(sec2);
										copied.push(src.SECTION_SEQUENCE+'  '+src.SECTION_TITLE);
									}
								}
								
							}				
						}
					}
					
					console.log(desfronts);
					console.log(desContents);
					//this.copyMsg[result.REPORT_ID]=copied; 
					let beforeToc=JSON.stringify(desfronts)
					let inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":rpt,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(desContents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":result.APPENDIX_DATA,'PCA_DATA':result.PCA_DATA, 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'',"PERCENT_COMPLETE":result.PERCENT_COMPLETE,"REVIEWER_PROGRESS":result.REVIEWER_PROGRESS};
					//console.log('desJson', inputJson)
					let data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('savedData',data);
					if(data.RESPONSE_STATUS=='N'){
						this.throwError(data)
						//e.target.disabled=false;
						//this.loading4=false;
						this.copyWarn[result.REPORT_ID]=[data.MESSAGE]; 
					}else{
						e.target.disabled=false;
						this.loading4=false;
						//this.updated.push(index);
						//this.intiCopy();
						this.copyMsg[result.REPORT_ID]=copied; 						
					}
				}
			
				}
			}
		}
	} catch (e) {
		console.log('Copy Error: ' + e);
		
	}
		e.target.disabled=false;
		this.loading4=false;
	
	}

	getHash(doc){
		let newdoc=JSON.parse(JSON.stringify(doc));
		newdoc.SUB_SECTIONS=[];
		newdoc.hash='';
		let content=JSON.stringify(newdoc);
		let hash = Md5.hashStr(content);//console.log(hash)
		return hash;
	}
	getIds(slots){
		let ids='';
		for(let slot of slots){
			ids+=','+slot.SLOT_ID
		}
		ids=ids.slice(1);
		return ids
	}
	async replaceRFs(slots, id,content){
		let ids=this.getIds(slots);//console.log(slots,ids)
		let inputJson= {"PROCEDURE":"getslotsbyidlist","REPORT_ID":id,"USER_ID":parseInt(this.userId),"SLOT_LIST":ids,};
		let data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	//console.log('savedData',data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				this.copyWarn[id]=[data.MESSAGE];
				return
			}else{
				let info=data.RW_SLOTS;
				for(let slot of info){
					let index=slots.findIndex(rf=>rf.SLOT_ID==slot.SLOT_ID);
					if(index>-1){
						if(slots[index].CONTENT!=slot.CONTENT){
							slots[index].CONTENT=slot.CONTENT;
							slots[index].SHORT_CONTENT=slot.SHORT_CONTENT;
							content=this.replaceRFContent(content, slots[index]);
						}					
					}
				}
				return {'text':content,'RF':slots};		
			}
	}
	getCopyString(slots,slot){//console.log(slots,slot)
		let slotInfo:any
		let newContent:string;
		newContent=slot.CONTENT;
		let id=slot.SLOT_ID;
		slots.each(function(){	//console.log($(this).data('id'))	;
			if($(this).data('id')==id){
				let text=$(this).prop("outerHTML").replace(' ck-widget','').replace(' ck-widget_selected','').replace(' contenteditable="false"','').replace('"','\"').trim(); //console.log(text);
				let replaceText="";
				if(newContent.length>0){
					let content=' data-status="Y">'+newContent+'<';////console.log(content);
					replaceText=text.replace(' data-status="N"','').replace(' data-status="Y"','').replace(/\>(.*?)\</, content); //console.log(replaceText);
					slotInfo={'SLOT_ID':id, 'oldText':text, 'replaceText':replaceText};
				}else if(newContent.length==0){
					//slotInfo={'SLOT_ID':id, 'oldText':text, 'replaceText':''};//console.log(slotInfo);
					let content=' data-status="N">'+'{'+slot.KEY+'}<';////console.log(content);
					replaceText=text.replace(' data-status="N"','').replace(' data-status="Y"','').replace(/\>(.*?)\</, content); //console.log(replaceText);
					slotInfo={'SLOT_ID':id, 'oldText':text, 'replaceText':replaceText};

				}
					//console.log(slotInfo)
				return false;
				}
			
			})
			//console.log(slotInfo)
		return slotInfo
	}
	replaceRFContent(content, slot){//console.log(content); console.log(slot)
		let slots=$(content).find('.placeholder');
		let slotInfo:any;
		if(slots.length>0){
			slotInfo=this.getCopyString(slots, slot);
			if(slotInfo){
				content=content.replaceAll(slotInfo.oldText, slotInfo.replaceText);				
			}
		}
		//console.log(content)
		return content
	}
	async replaceRFTable(data, id){
		let tabledata=JSON.parse(JSON.stringify(data))
		for(let row of tabledata.rows){
			for(let cell of row.items){//console.log(cell)
				//if lib need update?
				if(cell.slots&&cell.slots.length>0){
					let replaced=await this.replaceRFs(cell.slots, id,cell.htmltext);
					cell.slots=replaced.RF
					cell.htmltext=replaced.text;
					cell.DATA=this.sanitizer.bypassSecurityTrustHtml(cell.htmltext);				
					//console.log(cell);
				}
			}
		}
		//console.log(tabledata);
		return tabledata;
		
	}
	toTemp(content, slots){
		for(let slot of slots){
			let index=slots.findIndex(rf=>rf.SLOT_ID==slot.SLOT_ID);
			if(index>-1){
				slots[index].CONTENT='';
				let changeSlot=JSON.parse(JSON.stringify(slots[index]))
				content=this.replaceRFContent(content, changeSlot);
			}
		}
		return content;		
	}
	toTempTable(data){
		let tabledata=JSON.parse(JSON.stringify(data))
		for(let row of tabledata.rows){
			for(let cell of row.items){//console.log(cell)
				//if lib need update?
				if(cell.slots&&cell.slots.length>0){
					cell.htmltext=this.toTemp(cell.htmltext, cell.slots);
					cell.DATA=this.sanitizer.bypassSecurityTrustHtml(cell.htmltext);					
				}
			}
		}
		console.log(tabledata)
		return tabledata;
	}
	selectedSRpts=[];
	addSRpt(e, id){
		if(e.target.checked){
			this.selectedSRpts.push(id);
		}else{
			let index=this.selectedSRpts.indexOf(id);
			if(index>-1){
				this.selectedSRpts.splice(index,1);
			}
			
		}
	}
	statusMsg:any;
	statussWarn:any;
	initStatus(){
		this.statusMsg={};
		this.statussWarn={};
		this.selectedSRpts=[];
	}
	selAll(type){
		if(type=='Y'){
			for(let rpt of this.projectRpts){
				this.selectedSRpts.push(rpt.REPORT_ID);
			}
			
		}else if(type=='N'){
			this.selectedSRpts=[];
		}
	}
	async changePStatus(e){
		console.log(this.selectedSRpts);
		if(this.selectedSRpts.length==0){
			Swal.fire({
				icon:'info',
				text:'Please select report(s) to change status.'
			})
			return
		}
		let status=$(e.target).prev().val(); //console.log(status);
		if(status=='Inactive'){
				Swal.fire({
					icon:'warning',
					html: '<span style="font-size:20px; font-weight:bold">Warning!</span><br>Once a report is INACTIVE, you may not change the status again. You will lose access to the report.<br>Only change a report to INACTIVE if you need to set up a new report using the same Template Identifier.',
					confirmButtonText: 'Confirm',
					showLoaderOnConfirm: true,
					showCancelButton: true,
					backdrop:false,
					preConfirm: () => {
						this.setStatus1(status);							
					}
				})
			}else{
				this.setStatus1(status)
			}				
	}
	async setStatus1(status){
		for(let rptid of this.selectedSRpts){
			let inputJson = { "PROCEDURE": "setreportstatus", "USER_ID": parseInt(this.userId), "REPORT_ID": rptid, "STATUS": status }; 
			//console.log(inputJson)   
    		let response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
      		if(response.RESPONSE_STATUS=='N'){
				this.statussWarn[rptid]=response.MESSAGE;
				this.throwError(response)
      		}else{
				this.statusMsg[rptid]=true;
				let index=this.portfolioDataV2.findIndex(rpt=>rpt.REPORT_ID==rptid);
				if(index>-1){
					this.portfolioDataV2[index].STATUS=response.STATUS;
				}
				let index1=this.activeData.findIndex(rpt=>rpt.REPORT_ID==rptid);
				if(index1>-1){
					this.activeData[index1].STATUS=response.STATUS;
				}
			}			
    		
		}
		this.getProjectRpts();
	}
	summaryShow=false;
	summaryRFs=[];
	summaryRpts=[];
	selectedRFs=[];
	selectedRFIds=[];
	summaryData={'cols':[],'rows':[]};;
	summaryTable() {
		this.loading=false;
		this.summaryShow=true;
		this.summaryRpts=[];
		this.summaryRFs=[];
		this.summaryData={'cols':[],'rows':[]};;
		this.selectedRFs=[];
		this.selectedRFIds=[];
		this.curProfile=-1;
		this.filteredSlot=[];
		this.filted=false;
		this.projectRpts=[];
		this.getProjectRpts();
		this.getAllSlots();
		this.getSummaryProfiles();
	}
	addSummaryRpts(e, rpt?){
		this.summaryRFs=[];
		if(rpt){
			if(e.target.checked){
				this.summaryRpts.push(rpt.REPORT_ID);
			}else{
				let index=this.summaryRpts.indexOf(rpt.REPORT_ID);//console.log(index)
				if(index>-1){
					this.summaryRpts.splice(index, 1);			
				}
			}
		}else{
		this.summaryRpts=[];
		for(let pro of this.projectRpts){
			if(pro.REPORT_ID){
				this.summaryRpts.push(pro.REPORT_ID)
			}
		}

		}
	}
	addSummaryRFs(e, rfId?){
		if(rfId){
			if(e.target.checked){
				this.selectedRFs.push(rfId);
				this.selectedRFIds.push(rfId.SLOT_ID);
			}else{
				let index=this.selectedRFs.indexOf(rfId);
				if(index>-1){
					this.selectedRFs.splice(index, 1);	
					this.selectedRFIds.splice(index, 1);		
				}
			}
		}else{
			this.selectedRFs=[];
			this.selectedRFIds=[];
			for(let rf of this.allSlots){
				this.selectedRFs.push(rf);
				this.selectedRFIds.push(rf.SLOT_ID);			
			}	

		}
		console.log(this.selectedRFs)
	}
	loading5=false;
	pcaInd=true;
	async createSummaryRpt(){
		if(this.summaryRpts.length==0){
			Swal.fire({
				text: 'Please select report(s) for summary',
				confirmButtonText: 'OK',
		  		showCancelButton: false,
		  		backdrop:false,
			})
			return
		}
		this.loading5=true;
		//await this.getCompareRpts('summary');console.log(this.summaryRFs);
		let summaryRF=await this.getSummaryResult();console.log(summaryRF);
		if (summaryRF){
		this.summaryData={'cols':[],'rows':[]};
		let colData=[];
					for(let rpt of this.summaryRpts){//console.log(rpt)
						let rowData=[];
						
						for(let rf of summaryRF){
								let index1=colData.indexOf(rf.SLOT_KEY);
								if(index1==-1){
									colData.push(rf.SLOT_KEY);
								}
								let index=rf.REPORT_VALUE_LIST.findIndex(slot=>slot.REPORT_ID==rpt);
								if (index>-1){
									//let obj={"col":rf.SLOT_KEY, "datavalue": rf.REPORT_VALUE_LIST[index].RF_CONTENT, "dtype":"string"};
									let obj={};
									obj[rf.SLOT_KEY]=rf.REPORT_VALUE_LIST[index].RF_CONTENT;
									rowData.push(obj);
								}else{
									//let obj={"col":rf.SLOT_KEY, "datavalue": '', "dtype":"string"};
									let obj={};
									obj[rf.SLOT_KEY]='';
									rowData.push(obj);
									//rowData.push('');
								}
													
						}
						/*console.log(this.selectedRFIds);
						for(let rf1 of this.selectedRFIds){
							let indexA=summaryRF.findIndex(slot=>slot.SLOT_ID==rf1);
							if(indexA>-1){
								let rf=summaryRF[indexA]
								let index1=colData.indexOf(rf.SLOT_KEY);
								if(index1==-1){
									colData.push(rf.SLOT_KEY);
								}
								let index=rf.REPORT_VALUE_LIST.findIndex(slot=>slot.REPORT_ID==rpt);
								if (index>-1){
									let obj={};
									obj[rf.SLOT_KEY]=rf.REPORT_VALUE_LIST[index].RF_CONTENT;
									rowData.push(obj);
								}else{
									let obj={};
									obj[rf.SLOT_KEY]='';
									rowData.push(obj);									
								}
							}							
						}*/
						//console.log(rowData);
						let index=this.projectRpts.findIndex(item=>item.REPORT_ID==rpt);
						let ifPCA='N';
						if(index>-1){
							/*let index6=colData.indexOf('Status');
							if(index6==-1){
								colData.push('Status');
							}	
							//let statusObj={"col":'Status', "datavalue": this.projectRpts[index].STATUS, "dtype":"string"};
							let statusObj={'Status': this.projectRpts[index].STATUS,};
							rowData.push(statusObj);
							let index7=colData.indexOf('Report Type');
							if(index7==-1){
								colData.push('Report Type');								
							}	
							let typeObj={'Report Type': this.projectRpts[index].REPORT_TITLE,};
							rowData=[typeObj, ...rowData];
							*/
							ifPCA=this.projectRpts[index].PCA_INDICATOR;
						}
						if(ifPCA=='Y'&&this.pcaInd){
							let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":rpt,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
							const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	//console.log('otherdata',data);
							if(data.ERRORCODE){
								this.throwError(data)
								return
							}
							if(data.REPORT_DATA&&data.REPORT_DATA.length>0){
								let contents=JSON.parse(data.REPORT_DATA);//console.log(contents)
								for(let doc of contents){
									if(doc.TYPE=='COST'){
										let immiData=doc.SUB_SECTIONS[0].data;console.log(immiData);
										if(immiData.rows.length>1){
											let detail='';
											for(let i=1; i<immiData.rows.length-1; i++){//console.log(immiData.rows[i][1].DATA)
												if(immiData.rows[i][1]&&immiData.rows[i][1].DATA.length>0){//console.log(immiData.rows[i][0].DATA)
													detail+=immiData.rows[i][0].DATA+';';
													//colData.push(immiData.cols[i].NAME);
													//let text=immiData[i].sign+immiData[i].DATA
													//rowData.push(text);
												}
											}
											/*let index3=colData.indexOf('Short Term Cost Details');
											if(index3==-1){
												colData.push('Short Term Cost Details');
											}											
											//let obj={"col":'Short Term Cost Details', "datavalue": detail, "dtype":"string"};
											rowData.push({'Short Term Cost Details':detail});
											index3=colData.indexOf('Immediate Cost Details');
											if(index3==-1){
												colData.push('Immediate Cost Details');
											}
											//obj={"col":'Immediate Cost Details', "datavalue": detail, "dtype":"string"};
											rowData.push({'Immediate Cost Details': detail});*/
											let colarray=immiData.cols;
											let lastsecondcolarray=colarray[colarray.length-2];
											let lastcolarray=colarray[colarray.length-1];
											let lastrow=immiData.rows[immiData.rows.length-1];//console.log(lastrow)
											let lastsecondcol=lastrow[lastrow.length-2];//console.log(lastsecondcol)
											let lastcol=lastrow[lastrow.length-1];//console.log(lastcol)
											let index3=colData.indexOf(lastcolarray.NAME);
											if(index3==-1){
												colData.push(lastcolarray.NAME);
											}
											//obj={"col":lastcolarray.NAME, "datavalue": lastcol.sign+lastcol.DATA, "dtype":"string"};
											let obj1={};
											obj1[lastcolarray.NAME]=lastcol.sign+lastcol.DATA;
											rowData.push(obj1);	
											index3=colData.indexOf('Short Term Details');
											if(index3==-1){
												colData.push('Short Term Details');
											}											
											//let obj={"col":'Short Term Cost Details', "datavalue": detail, "dtype":"string"};
											rowData.push({'Short Term Details':detail});
											
											index3=colData.indexOf(lastsecondcolarray.NAME);
											if(index3==-1){
												colData.push(lastsecondcolarray.NAME);
											}											
											//obj={"col":lastsecondcolarray.NAME, "datavalue": lastsecondcol.sign+lastsecondcol.DATA, "dtype":"string"};
											let obj={};
											obj[lastsecondcolarray.NAME]=lastsecondcol.sign+lastsecondcol.DATA;
											rowData.push(obj);
											index3=colData.indexOf('Immediate Details');
											if(index3==-1){
												colData.push('Immediate Details');
											}
											//obj={"col":'Immediate Cost Details', "datavalue": detail, "dtype":"string"};
											rowData.push({'Immediate Details': detail});										
										}/*else{
											let index3=colData.indexOf('Short Term Cost Details');
											if(index3==-1){
												colData.push('Short Term Cost Details');
											}											
											let obj={"col":'Short Term Cost Details', "datavalue": '', "dtype":"string"};
											rowData.push(obj);
											index3=colData.indexOf('Immediate Cost Details');
											if(index3==-1){
												colData.push('Immediate Cost Details');
											}
											obj={"col":'Immediate Cost Details', "datavalue": '', "dtype":"string"};
											rowData.push(obj);
											let lastrow=immiData.cols;
											let lastsecondcol=lastrow[lastrow.length-2];
											let lastcol=lastrow[lastrow.length-1];
											index3=colData.indexOf(lastsecondcol.NAME);
											if(index3==-1){
												colData.push(lastsecondcol.NAME);
											}											
											obj={"col":lastsecondcol.NAME, "datavalue":'', "dtype":"string"};
											rowData.push(obj);
											index3=colData.indexOf(lastcol.NAME);
											if(index3==-1){
												colData.push(lastcol.NAME);
											}
											obj={"col":lastcol.NAME, "datavalue": '', "dtype":"string"};
											rowData.push(obj);
										}*/
										let repairData=doc.SUB_SECTIONS[1].data;//console.log(repairData);
										if(repairData.rows.length>1){
											let lastrow=repairData.rows[repairData.rows.length-1];//console.log(lastrow)
											for(let i=1; i<lastrow.length-1; i++){
												if(lastrow[i].sign){
													let index4=colData.indexOf(repairData.cols[i].NAME);
													if(index4==-1){
														colData.push(repairData.cols[i].NAME);
													}
													let text=lastrow[i].sign+lastrow[i].DATA
													//let obj1={"col":repairData.cols[i].NAME, "datavalue": text, "dtype":"string"};
													let obj1={};
													obj1[repairData.cols[i].NAME]=text;
													rowData.push(obj1);
												}
											}
											let last3row=repairData.rows[repairData.rows.length-3];
											let index5=colData.indexOf('Reserve Uninflated Costs');
											if(index5==-1){
												colData.push('Reserve Uninflated Costs');
											}
											//let obj2={"col":'Reserve Uninflated Costs', "datavalue": last3row[lastrow.length-1].sign+last3row[lastrow.length-1].DATA, "dtype":"string"};
											rowData.push({'Reserve Uninflated Costs': last3row[lastrow.length-1].sign+last3row[lastrow.length-1].DATA});
											index5=colData.indexOf('Reserve Inflated Costs');
											if(index5==-1){
												colData.push('Reserve Inflated Costs');
											}
											//obj2={"col":'Reserve Inflated Costs', "datavalue": lastrow[lastrow.length-1].sign+lastrow[lastrow.length-1].DATA, "dtype":"string"};
											rowData.push({'Reserve Inflated Costs':lastrow[lastrow.length-1].sign+lastrow[lastrow.length-1].DATA});
										}
										if(immiData.rows.length>1||repairData.rows.length>1){
										let unitData=doc.SUB_SECTIONS[2].data;//console.log(unitData);
										if(unitData.rows.length>0){
											let keys=['Reserve Uninflated Costs / Unit or SF / Year','Reserve Inflated Costs / Unit or SF / Year'];
											let j=0;
											for(let row of unitData.rows){
												if(j==0){
													let index2=colData.indexOf('Reserve Term');
													if(index2==-1){
														colData.push('Reserve Term');
													}
													//let obj3={"col":'Reserve Term', "datavalue": row[1].DATA.toString(), "dtype":"string"};
													rowData.push({'Reserve Term': row[1].DATA.toString()});
												}else if(j>1){
													let index2=colData.indexOf(keys[j-2]);
													if(index2==-1){
														colData.push(keys[j-2]);
													}
													let text=row[1].sign+row[1].DATA
													//let obj3={"col":keys[j-2], "datavalue": text, "dtype":"string"};
													let obj3={};
													obj3[keys[j-2]]=text;
													rowData.push(obj3);
												}
												j++;												
											}
										}
									}
										
									}
								}
							}
							
						}
						if(colData.length>0){
							this.summaryData.cols=colData;
						}
						this.summaryData.rows.push(rowData);	
					}
					//console.log(this.summaryData);
					let rows=[];
					for(let row of this.summaryData.rows){
						let multi={};
						for(let obj of row){
							multi= Object.assign({}, multi, obj)
						}
						rows.push(multi)
					}
					//console.log(rows)
					/*let table={"header":[],"data":[],'tablename':''};
					let i=1;
					for(let col of this.summaryData.cols){
						table.header.push({"headername":col, "col": i.toString()})
						i++
					}
					for(let row of this.summaryData.rows){
						for(let cell of row){
							let index=this.summaryData.cols.indexOf(cell.col);
							if(index>-1){
								cell.col=(index+1).toString();
							}
						}
						//console.log(row)
						table.data.push({"row":row});
					}
					console.log(table);*/
					this.exportAsExcelFile(rows, 'Summary Report', this.summaryData.cols);
					/*let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":"Portfolio Summary Report", "exceljson":JSON.stringify(table)};
						console.log("exportExcel", inputJson);
						this.reportService.genExcel(JSON.stringify(inputJson)).subscribe(data => {

							console.log(data);
							this.loading5=false;
							if(data.status=='Y'){
								window.open(data.fileurl, "_blank");
							}else{
								this.throwError(data.emessage);
							}
							
			
						})*/
		}
	}
	deliverShow=false;
	portfolioTmps=[];
	deliverPortfolioId:number;
	deliverPortfolioInfo:any;
	portfolioDeliverable(){
		this.loading=false;
		this.deliverShow=true;
		this.delliverWarn=false;
		this.deliverRpts=[];
		this.deliverPortfolioId=this.selectedPortfolio;
		this.deliverPortfolioInfo=JSON.parse(JSON.stringify(this.portfolioDataV2));
		this.getProjectRpts();
		this.getPortfolioTmps()
	}
	getPortfolioTmps(){
		let inputJson={"PROCEDURE":"gettemplatesbyportfolio","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.selectedPortfolio};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.portfolioTmps=data.RW_TEMPLATES;//console.log(this.portfolioTmps)
				
			}
		})
	}
	deliverRpts=[];
	checkedTmps=[];
	addToOffTmps(e, id){
		if(e.target.checked){
			this.checkedTmps.push(id)
		}else{
			let index=this.checkedTmps.indexOf(id);
			if(index>-1){
				this.checkedTmps.splice(index, 1)
			}
			
		}
	}
	addDeliverRpts(e, rpt?, tmpId?){
		if(rpt){
			if(rpt=='Phase I'||rpt=='PCA'){
				this.deliverRpts=[];
				for(let pro of this.projectRpts){
					if(pro.REPORT_TITLE.indexOf(rpt)>-1){
						//let index=this.deliverRpts.indexOf(rpt.REPORT_ID);//console.log(index)
						//if(index==-1){
							this.deliverRpts.push(pro.REPORT_ID)
						//}
					}
				}
			}else if(rpt=='tmps'){
				this.deliverRpts=[];
				for(let pro of this.projectRpts){
					if(pro.TEMPLATE&&pro.TEMPLATE[0].TEMPLATE_ID){
						let tempId=pro.TEMPLATE[0].TEMPLATE_ID;
						if(this.checkedTmps.indexOf(tempId)>-1){
							//let index=this.deliverRpts.indexOf(pro.REPORT_ID);
							//if(index==-1){
								this.deliverRpts.push(pro.REPORT_ID);			
							//}
						}
						
					}
				}
			}else{
				if(e.target.checked){
					this.deliverRpts.push(rpt.REPORT_ID);
				}else{
					let index=this.deliverRpts.indexOf(rpt.REPORT_ID);
					if(index>-1){
						this.deliverRpts.splice(index, 1);			
					}
				}
			}
			
		}else{
			this.deliverRpts=[];
			for(let pro of this.projectRpts){
				if(pro.REPORT_ID){
					this.deliverRpts.push(pro.REPORT_ID)
				}
			}
		}
		//console.log(this.deliverRpts)
	}
	//deliveryRate=0;
	loading7=false;
	delliverWarn=false;
	deliverPortfolio(){
		if(this.deliverRpts.length==0){
			this.delliverWarn=true;
			return
			/*Swal.fire({
				icon:'info',
				title:'Please select report(s).',
			})
			return*/
		}
		//this.noPrint=true;
		this.deliverShow=false
		this.loading7=true;
		//this.deliveryRate=0;
		this.deliverResults=[];
		//this.toprintIndex++;
		//this.sharepdfType={'index':this.toprintIndex, 'type':this.deliverRpts};
		/*this.generatepdf(this.deliverRpts[0]);
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "REPORT_ID":this.deliverRpts[0], "FUNCTION_ID": 7};
		console.log(checkUserInputJson)
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N'||checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			}else {*/
				this.generatepdf(this.deliverRpts[0]);			
		//}
	//	})	
	}
	deliverResults=[];
	deliverInfo(e){
		//console.log(e);
		if(!this.loading7) return
		let id=e.id;
		let index=this.deliverRpts.indexOf(id);//console.log(index);
		if(index>-1){
			e=this.addRptInfoTo([e], this.deliverPortfolioInfo)[0];console.log(e)
			this.deliverResults.push(e);
			//this.deliveryRate=Math.round(this.deliverResults.length/this.deliverRpts.length*10000)/100;//console.log(this.deliveryRate);
		}
		if(index<this.deliverRpts.length-1){
			this.generatepdf(this.deliverRpts[index+1]);
		}else{
			this.deliverZip();
		}
	}
	deliverError(id, msg){
		let index=this.projectRpts.findIndex(data=>data.REPORT_ID==id);
		if(index>-1){
			let item={'id':id, "url":msg, 'title':this.projectRpts[index].REPORT_TITLE, 'status':'N'};
			this.deliverInfo(item);
		}
		
	}
	deliverZip(){
		let file_id=null;
		let p_reports=[];
		let ids='';
		for(let rpt of this.deliverResults){
			if(rpt.status=='Y'){
				let item={'fileurl':rpt.url};
				p_reports.push(item);
				ids+=rpt.id+',';
			}
		}
		
		//console.log(this.userInfo.COMPANY_ID?.toString(), this.userId, file_id, this.portfolioDisplayName,this.selectedPortfolio, p_reports)
		this.reportService.generatePortfolioZip(this.userInfo.COMPANY_ID?.toString(), this.userId, file_id, this.portfolioDisplayName,this.deliverPortfolioId.toString(), p_reports).subscribe(result => {
			//console.log('portfolio zip',result);
			this.loading7=false;
			this.noPrint=false;
			if(result.RESPONSE_STATUS=="N"){
				this.throwError(result);
			}else{
				/*Swal.fire({
					text: result.MESSAGE,
					confirmButtonText: 'OK',
					showCancelButton: false,
					backdrop:true,
				})*/
				let inputJson1={"PROCEDURE":"saveportfolioreportlist","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":this.deliverPortfolioId,"PORTFOLIO_INFO":JSON.stringify(this.deliverResults), "REPORT_ID_LIST":ids};
				//console.log(inputJson1);
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
					//console.log(data);
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
						//return										
					}else{
						//this.protfolioInfo=this.deliverResults;
					}					
				})
				if(this.deliverPortfolioId==this.selectedPortfolio){
					this.profolipZipUrl=result.PORTFOLIO_ZIP_URL;
				}
				
				let msg1='Portfolio Delivery Generated Succesfully!'
				let msg2='Share File';
				Swal.fire({
					icon:'success',
							title: msg1,
							html: 'Would you like to download it or get a link?',
							confirmButtonText: 'Download File',
							showLoaderOnConfirm: true,
							showCancelButton: true,
							cancelButtonText: msg2,
							backdrop:false,													
						}).then((response) => {
							if (response.isConfirmed) {
								//this.downloadFile(this.profolipZipUrl, this.portfolioDisplayName+ new Date().getTime()+'.zip');
								this.downloadFile(result.PORTFOLIO_ZIP_URL);
							} else {
								this.shareRpt(this.deliverPortfolioId);
							} 
						})		
			}
		})
   
	}
	async shareRpt(id){
		const { value: email } = await Swal.fire({
			title: 'Input email address',
			input: 'text',// 'email',
			inputLabel: 'Your email address',
			inputPlaceholder: 'Enter your email address',
			confirmButtonText: 'Share',
			inputValidator: (value) => {
				if (!value) {
				  return 'Email address is required!'
				}else if(value.indexOf('@')==-1||value.indexOf('.')==-1){
					return 'Please input a valid email'
				}
			},
		  })
		  
		  if (email) {//this.spinToggle.emit('start');
			let inputJson={"PROCEDURE":"shareportfoliodeliverybyemail","USER_ID":parseInt(this.userId),"PORTFOLIO_ID":id,"SHARE_EMAIL":email};
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{console.log(data)
				//this.spinToggle.emit('end');
				if(data.RESPONSE_STATUS=='Y'){						
					Swal.fire({
						title:"Success",
						html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
						showConfirmButton:true,
					})										
				}else{
					this.throwError(data);
				}
			}) 
			//Swal.fire(`Entered email: ${email}`)
		  }
	}
	downloadFile(url, name?){
		const link = document.createElement('a');
		link.setAttribute('target', '_blank');
		link.setAttribute('href', url);
		if(name){
			link.setAttribute('download', name);
		}		
		document.body.appendChild(link);
		link.click();
		link.remove();
	}
	public exportAsExcelFile(json: any[], excelFileName: string, headers:any): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);//, {header:headers, skipHeader:true});
		//console.log('worksheet',worksheet);
		//const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['Summary'] };
		let workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Summary')
		//const excelBuffer: any =XLSX.writeFile(workbook, 'Summary');
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		//const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	  }
	  saveAsExcelFile(buffer: any, fileName: string): void {
		//import("file-saver").then(FileSaver => {
		  let EXCEL_TYPE =
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
		  let EXCEL_EXTENSION = ".xlsx";
		  const data: Blob = new Blob([buffer], {
			type: EXCEL_TYPE
		  });
		  fileSaver.saveAs(
			data,
			fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
		  );
		  this.loading5=false;
		//});
	  }
	comparisonPermission = false;
	checkcomparisonPermission() {
		this.comparisonPermission = false;
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 30,"PORTFOLIO_ID":this.selectedPortfolio};
		//console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			//console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				this.comparisonPermission = false;
			} else {
				this.comparisonPermission = true;
			}

		});
	}
	portfolioPermission = false;
	checkPortfolioPermission() {
		this.comparisonPermission = false;
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 43,"PORTFOLIO_ID":this.selectedPortfolio};
		//console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			//console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				//this.throwError(checkResponse);
				this.portfolioPermission = false;
			} else {
				this.portfolioPermission = true;
			}

		});
	}
	updatePNamerPermission = false;
	checkupdatePNamerPermission() {
		this.updatePNamerPermission = false;
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 43,"PORTFOLIO_ID":this.selectedPortfolio};
		//console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			//console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				this.updatePNamerPermission = false;
			} else {
				this.updatePNamerPermission = true;
			}

		});
	}
	changeStatusPermission = false;
	checkchangeStatusPermission() {
		this.changeStatusPermission = false;
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 43,"PORTFOLIO_ID":this.selectedPortfolio};
		//console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			//console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				this.changeStatusPermission = false;
			} else {
				this.changeStatusPermission = true;
			}

		});
	}
	copyPermission = false;
	checkcopyPermission() {
		this.copyPermission = false;
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 30,"PORTFOLIO_ID":this.selectedPortfolio};
		//console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			//console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse);
				this.copyPermission = false;
			} else {
				this.copyPermission = true;
			}

		});
	}
	emailId="";
	showEmail(id){console.log(id)
		this.emailId=id
	}
	allSlots=[];
	async getAllSlots(){
		let inputJson={"PROCEDURE":"getportfolioslots", "USER_ID":parseInt(this.userId)};
		const response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		console.log('slots',response);
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response)
			this.allSlots=[];
			$('#overlay').css('display','none');
		}else{
			this.allSlots=response.RW_SLOTS; console.log(this.allSlots);			
		}
	}
	dropFItem(e: CdkDragDrop<string[]>){
		moveItemInArray(this.selectedRFs, e.previousIndex, e.currentIndex);		
		moveItemInArray(this.selectedRFIds, e.previousIndex, e.currentIndex);			
	}
	filteredSlot=[];
	filted=false;
	slotFilter(data){
		if(data.trim().length>0){
		let result = this.allSlots.filter(role => role.KEY.toUpperCase().indexOf(data.toUpperCase())>-1); console.log(result);
		this.filteredSlot=[];
		for(let slot of result){
			this.filteredSlot.push(slot.SLOT_ID);
		}
		this.filted=true;
		}else{
			this.filteredSlot=[];
			this.filted=false;
		}
	}
	deleteRFs(id){
		let index=this.selectedRFIds.indexOf(id); 
		if(index>-1){
			this.selectedRFs.splice(index, 1);
			this.selectedRFIds.splice(index, 1);
		}
		
	}
	summaryProfiles=[];
	curProfile=-1;
	getSummaryProfiles(){
		let inputJson={"PROCEDURE":"getcompanyportfoliosummary","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
		console.log('profiles',response);
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response)
			this.summaryProfiles=[];
			$('#overlay').css('display','none');
		}else{
			this.summaryProfiles=response.SUMMARY_LIST;//SUMMARY_ID: 1,SUMMARY_NAME:"Elaine Test Update"		
		}
	})
	}
	getSummaryProfile(){
		if(this.curProfile>-1){
			let reports=this.summaryRpts.join(','); console.log(reports);
			//let inputJson={"PROCEDURE":"getportfoliosummaryresult","USER_ID":parseInt(this.userId),"SUMMARY_ID":this.curProfile,"REPORT_LIST":reports};
			let inputJson={"PROCEDURE":"getportfoliosummary","USER_ID":parseInt(this.userId),"SUMMARY_ID":this.curProfile}
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				console.log('profile',response);
				if(response.RESPONSE_STATUS=="N"){
					this.throwError(response)
					this.selectedRFs=[];
					this.selectedRFIds=[];
					$('#overlay').css('display','none');
				}else{
					this.selectedRFs=[];
					this.selectedRFIds=[];
					let arr=response.SUMMARY_RF_FIELDS.split(',');
					for(let rf of arr){
						let id=parseInt(rf);
						this.selectedRFIds.push(parseInt(rf));
						let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
						if(index>-1){
							this.selectedRFs.push(this.allSlots[index])
						}									
					}		
				}
			})
		}else{
			this.selectedRFs=[];
			this.selectedRFIds=[];
		}
	}
	loading6=false;
	saveSummaryProfile(type?){
		let ids=this.selectedRFIds.join(','); console.log(ids);
		if(type){
			Swal.fire({
				title: 'Please input summary profile name',
				inputAttributes: {
					autocapitalize: 'off'
				},
		  		html: '<input type="text" #profilename id="covername" class="form-control mb-2" placeholder="Enter your profile name"></input>',
		  		confirmButtonText: 'Save',
		  		showLoaderOnConfirm: true,
		  		showCancelButton: true,
		  		backdrop:false,
		  		preConfirm: () => {
					this.loading6=true;
					let name = $('#covername').val().trim();
					if (name === '') {
			  			Swal.showValidationMessage(`Cover Page name empty`)
					}
					$('#overlay').css('display','block');
					let inputJson={"PROCEDURE":"insertportfoliosummary","USER_ID":parseInt(this.userId),"SUMMARY_NAME":name,"SUMMARY_RF_FIELDS":ids};
					console.log(inputJson);
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
						console.log(result);
						this.loading6=false
						if(result.RESPONSE_STATUS=='N'){
							this.throwError(result);					
						}else{
							this.curProfile=result.SUMMARY_ID;				
							let obj={'SUMMARY_ID': result.SUMMARY_ID,'SUMMARY_NAME':result.SUMMARY_NAME};
							this.summaryProfiles.push(obj);
						}
					})		
		 		 }
			})			
		}else{
			this.loading6=true;
			let index=this.summaryProfiles.findIndex(pro=>pro.SUMMARY_ID==this.curProfile);
			let name=this.summaryProfiles[index].SUMMARY_NAME;
			let inputJson={"PROCEDURE":"updateportfoliosummary","USER_ID":parseInt(this.userId),"SUMMARY_ID":this.curProfile,"SUMMARY_NAME":name,"SUMMARY_RF_FIELDS":ids};
			console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
				console.log(result);
				this.loading6=false;
				if(result.RESPONSE_STATUS=='N'){
					this.throwError(result);					
				}else{
					//this.selectedRFIds=result.SUMMARY_RF_FIELDS.split(',');
				}
			})	
		}
	}
	async getSummaryResult(){
		if(this.selectedRFIds.length==0){
			Swal.fire({
				text: 'Please choose RF(s) for summary',
				confirmButtonText: 'OK',
		  		showCancelButton: false,
		  		backdrop:false,
			})
			this.loading5=false;
			return null
		}
		let reports=this.summaryRpts.join(','); console.log(reports);
		let ids=this.selectedRFIds.join(','); console.log(ids);
		let inputJson={"PROCEDURE":"getportfoliosummaryresult","USER_ID":parseInt(this.userId),"SLOT_LIST":ids,"REPORT_LIST":reports};
		console.log(inputJson);
		const data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if(data.RESPONSE_STATUS=='N'){
			this.throwError(data);
			this.loading5=false;
			return null					
		}else{
			return data.SUMMARY_LIST
		}
			
	}
	ifLatLng(){
		let isLatLng=false;
		let input=this.mapInputAddress.split(',');
		let num1=input[0];
		let num2=input[1];
		if(input.length==2&&(!isNaN(parseFloat(num1)))&&(!isNaN(parseFloat(num2)))){
			const isLatitude = num1 => isFinite(num1) && Math.abs(num1) <= 90;
			const isLongitude = num2 => isFinite(num2) && Math.abs(num2) <= 180;
			if(isLatitude&&isLongitude){
				isLatLng=true;
			}			
		}
		return isLatLng
	 }
	 searchProjLoading=false;
	 copyProjShow=false;
	 srcProjects=[];
	 copyPRId:number;
	 allRptsInProject=[];
	 searchInfo="";
	 projKey="";
	 checkedRptsToProject=[];
	 selectedProjectId:number;
	 copyProWarn='';
	async resetCopyPR(){
		/*let uId=parseInt(this.userId);
		let fId=57;
		let permissionResult = await this.checkPermission(uId, fId);	
		if(!permissionResult){
			Swal.fire({
				icon:'error',
				title:permissionResult.MESSAGE,	
			})
			return
		}*/
		let inputJson1={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":57};
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION=="N"){
					Swal.fire({
						icon:'info',
						title:data.MESSAGE,	
					})
					this.copyProjShow=false;
					return
				}else if(data.USER_PERMISSION=="Y"){
					this.copyPRId=null;
					this.srcProjects=[];
					this.allRptsInProject=[];
					this.searchInfo="";
					this.projKey="";
					this.selectedProjectId=null;
					this.copyProjShow = true;
					this.copyProWarn = '';
					this.checkedRptsToProject=[];
				}				
			}else{
				this.throwError(data)
				this.copyProjShow=false;
				return
			}
		})
		
	}
	async searchProjectsByKey(){					
		if(this.projKey.length>0){
			this.searchProjLoading=true;
			let inputJson={"PROCEDURE":"searchprojectcopy","USER_ID":parseInt(this.userId),"SEARCH_BY":this.projKey};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				this.searchProjLoading=false;
				if(data.RESPONSE_STATUS=='N'){
					this.throwError(data)	
				}else{
					this.srcProjects=data.PROJECT_LIST;
					this.searchInfo=data.DISPLAY_MESSAGE;					
				}
				//console.log(this.srcProjects)	
			})
		}
	}
	checkPermission(uid, fid): Promise<boolean> {
		return new Promise(resolve => {
			let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":uid, "FUNCTION_ID": fid};
			this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {				
				if (checkResponse.RESPONSE_STATUS=='N') {
					this.throwError(checkResponse)
					resolve(false);
					return;						
				}
				if (checkResponse.USER_PERMISSION == 'N') {
					this.throwError(checkResponse);
					resolve(false);
				} else {
					resolve(true);
				}
			}, error => {
				this.throwError(error);
				resolve(false);
			});
		});
	}
	getProjRpts(proId){
		this.selectedProjectId=proId;
		this.allRptsInProject=[];		
		let inputJson={"PROCEDURE":"getreportsforcopyproject","USER_ID":parseInt(this.userId),"PROJECT_ID":proId};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {	
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)	
			}else{
				this.allRptsInProject=data.REPORT_LIST;				
			}
		})
	}
	allRptsToCopy(seclectAll){
		if(seclectAll){
			this.checkedRptsToProject=[];
			for(let pro of this.allRptsInProject){
				if(pro.REPORT_ID&&pro.COPY_REPORT_ALLOWED==='Y'){
					this.checkedRptsToProject.push(pro.REPORT_ID);
				}
			}			
		}else{
			this.checkedRptsToProject=[];
		}
	}
	addToCopyProj(e, id){
		this.copyProWarn = '';
		if(e.target.checked){
			this.checkedRptsToProject.push(id)
		}else{
			let index=this.checkedRptsToProject.indexOf(id);
			if(index>-1){
				this.checkedRptsToProject.splice(index, 1)	
			}
		}
	}
	async startCopyProj(){
		if(this.checkedRptsToProject.length==0){
			this.copyProWarn = 'Please select report(s) to copy.';
			return;
		}
		this.copyProWarn = '';
		this.loading4=true;
		let rpts=this.checkedRptsToProject.join(',');console.log(rpts)
		let inputJson={"PROCEDURE":"copyprojectandreports","USER_ID":parseInt(this.userId),"PROJECT_ID":this.selectedProjectId,"REPORT_LIST":rpts};
		await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise().then(data => {
			this.loading4=false;
			if(data.RESPONSE_STATUS=='N'){	
				this.throwError(data)
			}else{
				let rpts=data.RW_REPORTS;
				this.numActiveReports += rpts.length;
				for(let i=0;i<rpts.length;i++){			
					this.activeData = [rpts[i],...this.activeData];		
				}
				Swal.fire({
					icon:'success',
					title:'Project copied successfully.',
				})
				this.copyProjShow=false;
			}
		}).catch(error => {
			this.loading4=false;	
			this.copyProWarn = 'Error occurred while copying project.';
		})
	}
}




